export const translations = {
  fr: {
    // Navigation
    home: "Accueil",
    dashboard: "Tableau de bord",
    cookieConsentTitle: "Cookies et confidentialité",
    cookieConsentDescription: "Nous utilisons des cookies essentiels et, si vous acceptez, des cookies de mesure. Votre accord active aussi la proposition automatique de votre ville lorsque vous êtes connecté. Le navigateur demandera votre permission; sinon, vous pourrez choisir la ville par recherche.",
    cookieConsentDataPolicy: "Politique de données",
    cookieConsentAcceptLocation: "Accepter et activer",
    cookieConsentRejectLocation: "Refuser et rechercher",
    cookieConsentClose: "Fermer",
    contribute: "Contribuer",
    profile: "Profil",
    logout: "Déconnexion",
    navAudioSection: "Audio",
    navTextSection: "Texte",
    navImagesSection: "Images",
    navProgressSection: "Progression",
    navInitialData: "Données initiales",
    navContributionSuite: "Suite contribution",
    navContributionWorkspaceTitle: "Choisis ton espace de travail",
    navComingSoon: "Bientôt disponible",
    navCommunitySection: "Collecte terrain",
    collectorSpaceLabel: "Espace collecteur",
    collectorSpaceDescription: "Créer un code communautaire et rattacher audio, transcription et questionnaire.",
    accountingLabel: "Comptabilité",
    accountingDescription: "Tableau de bord comptable et paiements manuels.",
    leaderboard: "Classement",
    leaderboardError: "Erreur",
    leaderboardGlobalError: "Impossible de charger le classement global",
    leaderboardLoadError: "Impossible de charger le classement",
    searchContributor: "Rechercher un contributeur…",
    contributorsCount: "{count} contributeurs",
    periodWeek: "7j",
    periodMonth: "30j",
    periodAll: "Tout",
    noSearchResults: 'Aucun résultat pour "{query}"',
    nextRank: 'Vous êtes #{rank} · {gap} {metric} vous séparent de #{aboveRank} (@{aboveUser})',
    floatingRank: 'Vous êtes #{rank}',
    contributions: "Contributions",
    earnings: "Gains",
    rankingMode: "Mode de classement",
    global: "Global",
    byLanguage: "Par langue",
    language: "Langue",
    topContributors: "Top contributeurs",
    firstPlace: "Premier",
    runnerUp: "Finaliste",
    thirdPlace: "Troisième",
    globalRanking: "Classement Global",
    rankingLanguage: "Classement",
    noLeaderboard: "Aucun classement disponible",
    you: "Vous",
    leaderboardRank: "Rang",
    leaderboardContributor: "Contributeur",
    leaderboardContribShort: "Contrib",
    leaderboardGainsShort: "Gains",
    leaderboardDisplaying: "Afficher",
    leaderboardFirst: "Premier",
    leaderboardSecond: "Deuxième",
    leaderboardStatThird: "Troisième",
    leaderboardTotal: "Total",
    leaderboardPeriodWeek: "7j",
    leaderboardPeriodMonth: "30j",
    leaderboardPeriodAll: "Tout",
    leaderboardRetry: "Réessayer",
    leaderboardNoDataExport: "Aucune donnée à exporter",
    leaderboardSubtitle: "Classement des contributeurs",
    leaderboardContributorsCount: "{count} contributeurs",
    leaderboardVous: "· Vous",
    joinTheBest: "💪 Rejoignez les meilleurs!",
    joinTheBestDesc: "Continuez à contribuer et gravissez les échelons du classement. Chaque contribution vous rapproche de la première place!",
    backToDashboard: "📊 Retour au tableau de bord",
    complaints: "Signaler un problème / Suggestion",
    complaintsName: "Nom (optionnel)",
    complaintsEmail: "Email (optionnel)",
    complaintsPhone: "Téléphone (optionnel)",
    complaintsPhonePlaceholder: "Votre numéro de téléphone",
    complaintsType: "Type",
    complaintsBug: "Erreurs",
    complaintsSuggestion: "Suggestion",
    complaintsOther: "Autre",
    complaintsMessage: "Message",
    complaintsMessagePlaceholder: "Décrivez le problème ou la suggestion",
    complaintsNamePlaceholder: "Votre nom",
    complaintsEmailPlaceholder: "Votre email",
    complaintsSend: "Envoyer",
    complaintsSending: "Envoi...",
    complaintsMessageRequired: "Message requis",
    complaintsMessageRequiredDesc: "Veuillez écrire votre message.",
    complaintsThanks: "Merci",
    complaintsThanksDesc: "Votre message a été envoyé.",
    complaintsErrorDesc: "Impossible d'envoyer votre message, réessayez plus tard.",
    complaintsNew: "Nouveau signalement",
    complaintsHistory: "Mes signalements",
    complaintsNoHistory: "Aucun signalement pour le moment",
    complaintsCharCount: "{count} / {max} caractères",
    noAudioAvailable: "Aucun audio",
    retryLater: "Réessayez plus tard",
    noItemSelected: "Aucun élément sélectionné",
    validatedToast: "Validé",
    finalizedToast: "Finalisé",
    sessionEnded: "Session terminée",
    audioLoadError: "Impossible de charger les audios",
    validationFailed: "Erreur lors de la validation",
    finalizeError: "Erreur lors de la finalisation",
    progression: "Progression",
    validatedSuffix: "validés",
    validationCardTitle: "Validation",
    correctionPlaceholder: "Corrigez si nécessaire...",
    sectorsLoadError: "Impossible de charger les secteurs",
    sectorQuestionsLoadError: "Impossible de charger les questions du secteur",
    questionsExhausted: "Questions épuisées",
    questionsExhaustedDesc: "Toutes les questions disponibles ont déjà été ajoutées.",
    sectorRequired: "Secteur requis",
    sectorRequiredDesc: "Veuillez sélectionner un secteur.",
    audioContributionSubmitted: "Soumis",
    audioContributionSubmittedDesc: "Contribution audio envoyée avec succès.",
    audioContributionError: "Impossible d'envoyer la contribution.",
    languageRequiredTitle: "Langue requise",
    languageRequiredDesc: "Veuillez sélectionner une langue.",
    payment: "Paiement",
    paymentCardRequired: "Remplissez les informations de carte",
    paymentSuccess: "Paiement par carte simulé avec succès.",
    paymentFailed: "Le paiement a échoué",
    validation: "Validation",
    companyNameRequired: "Nom de l'entreprise requis",
    registrationNumberRequired: "Numéro d'identification requis",
    companyAddressRequired: "Adresse de l'entreprise requise",
    sectorActivityRequired: "Secteur d'activité requis",
    companyEmailRequired: "Email de l'entreprise requis",
    companyPhoneRequired: "Téléphone de l'entreprise requis",
    repNameRequired: "Nom du représentant requis",
    repEmailRequired: "Email du représentant requis",
    usernameRequired: "Nom d'utilisateur requis",
    passwordOrSSORequired: "Mot de passe requis ou activez SSO",
    documentsRequired: "Ajoutez au moins un document justificatif",
    termsAcceptRequired: "Vous devez accepter les conditions",
    rgpdAcceptRequired: "Vous devez accepter la politique de confidentialité (RGPD)",
    signedContractRequired: "Téléversez le contrat signé",
    submitted: "Soumis",
    adminRequestSent: "Votre demande a été envoyée.",
    submitFailed: "Échec de la soumission",
    userNotConnected: "Utilisateur non connecté",
    phoneRequired: "Veuillez saisir un numéro",
    invalidAmount: "Montant invalide",
    amountGreaterThanZero: "Saisissez un montant supérieur à 0",
    payoutRequestSent: "Demande envoyée",
    payoutRequestSentDesc: "Votre demande a été transmise aux administrateurs.",
    success: "Succès",
    contractSentSuccess: "Contrat envoyé avec succès",
    contractValidatedFinal: "Contrat validé définitivement",

    // ValidateAudio
    audioBatchLoaded: "Nouvelle série chargée",
    audioBatchLoadedDesc: "Page {page} chargée avec {count} audios",
    noAudioToValidate: "Aucun audio à valider",
    noAudioToValidateDesc: "Réessayez plus tard ou changez de langue",
    allTasksCompleted: "Toutes les tâches terminées",
    allTasksCompletedDesc: "Merci pour votre contribution !",
    audioLoadFailed: "Échec du chargement des audios",
    genderRequired: "Genre requis",
    genderRequiredDesc: "Veuillez sélectionner le genre",
    audioAccepted: "✓ Audio accepté",
    audioAcceptedDesc: "Enregistrement validé avec succès",
    audioAcceptedWithDuration: "Enregistrement validé ({duration}s)",
    audioValidationFailed: "Échec de la validation",
    reasonRequired: "Raison requise",
    reasonRequiredDesc: "Veuillez indiquer la raison",
    audioRejected: "✗ Audio rejeté",
    audioRejectedDesc: "Raison : {reason}",
    audioRejectedWithDuration: "Raison : {reason} ({duration}s)",
    audioRejectFailed: "Échec du rejet",
    detectedLanguage: "Langue détectée :",
    correct: "Corriger",
    correctLanguagePrompt: "Corriger la langue de cet audio",
    languageCorrected: "Langue corrigée",
    languageChangedTo: "Langue changée vers : {value}",
    selectActualLanguage: "Sélectionner la vraie langue",
    validations: "validations",
    rejections: "rejets",
    validatedByYou: "Vous avez validé",
    rejectedByYou: "Rejeté par vous",
    audioGender: "Genre de l'audio",
    selectGender: "Sélectionner le genre...",
    genderFemale: "👩 Femme",
    genderMale: "👨 Homme",
    genderRequiredError: "Le genre est obligatoire",

    // TranscriptionPhrase
    translateToFrench: "Traduire en français",
    translatePhraseToFrenchDesc: "Traduisez cette phrase du {language} vers le français",
    translatePhraseFromFrenchDesc: "Traduisez cette phrase du français vers la langue locale",
    translatePhrasesGeneralDesc: "Traduisez des phrases du français vers la langue sélectionnée",
    beginSession: "Commencer",
    backToRecording: "Retour à l'enregistrement",
    translationBadge: "Traduction",
    sourcePhraseTitle: "Phrase source",
    answerToQuestion: "Réponse à la question",
    answerToQuestionHint: "Transcrivez ce que la personne dit, dans sa langue. Ce n'est pas une traduction de la question.",
    phraseNumber: "Phrase {n}",
    phraseProgressTitle: "Progression des phrases",
    yourTranslationTitle: "Votre traduction",
    writeTranslationHere: "Écrivez la traduction ici...",
    africanKeyboard: "Clavier Africain",
    submitTranslation: "Soumettre",
    noPhraseAvailable: "Aucune phrase disponible",
    translationLoadError: "Erreur de chargement",
    phraseRetrieveError: "Impossible de récupérer les phrases",
    loginRequired: "Connexion requise",
    loginRequiredDesc: "Veuillez vous connecter pour continuer",
    textRequired: "Texte requis",
    textRequiredDesc: "Veuillez écrire la traduction",
    translationAdded: "Traduction ajoutée",
    translationSavedDesc: "La traduction a été enregistrée avec succès",
    sessionCompleted: "Session terminée",
    allPhrasesTranslated: "Toutes les phrases ont été traduites",
    phraseXofY: "Phrase {current}/{total}",
    pageLabel: "Page",
    progress: "Progression",
    done: "Fait",

    // ForgotPassword
    forgotPasswordTitle: "Mot de passe oublié ?",
    forgotPasswordSubtitle: "Pas de problème. Saisissez votre e-mail, votre téléphone ou votre nom d'utilisateur : vous recevrez un lien par e-mail ou un code par SMS.",
    passwordRecoveryIdentifierLabel: "E-mail, téléphone ou nom d'utilisateur",
    passwordRecoveryIdentifierPlaceholder: "ex. nom@domaine.com, +228… ou nom d'utilisateur",
    passwordRecoveryIdentifierHelp: "Avec un numéro de téléphone, vous recevez un code par SMS. Sinon, le lien part par e-mail, ou un code par SMS si le compte n'a pas d'e-mail.",
    passwordRecoveryEmailSentTitle: "Instruction envoyée",
    passwordRecoveryEmailSentDesc: "Si ce compte existe, un lien sécurisé vient d'être envoyé à l'adresse indiquée.",
    passwordRecoverySmsSentTitle: "Code envoyé par SMS",
    passwordRecoverySmsSentDesc: "Si ce numéro est lié à un compte, un code à 6 chiffres vient d'y être envoyé. Saisissez-le pour continuer.",
    passwordRecoveryUnknownTitle: "Demande prise en compte",
    passwordRecoveryUnknownDesc: "Si un compte correspond, vous recevrez un lien par e-mail ou, si le compte n'a pas d'e-mail, un code par SMS.",
    passwordRecoveryEnterSmsCode: "J'ai reçu un code par SMS",
    passwordRecoveryOtpLabel: "Code de vérification",
    passwordRecoveryOtpPlaceholder: "000000",
    passwordRecoveryVerifyOtp: "Vérifier le code",
    passwordRecoveryOtpVerifiedTitle: "Code vérifié",
    passwordRecoveryOtpVerifiedDesc: "Vous pouvez maintenant définir un nouveau mot de passe sécurisé.",
    passwordRecoveryResendCode: "Renvoyer le code",
    passwordRecoveryResendLink: "Recommencer la demande",
    passwordRecoveryExpiresIn: "Expire dans",
    passwordRecoveryNewPasswordTitle: "Nouveau mot de passe",
    passwordRecoveryNewPasswordDesc: "Définissez un mot de passe fort pour sécuriser votre compte.",
    resetPasswordHeading: "Réinitialisation du mot de passe",
    resetLinkSentToAddress: "Nous vous enverrons un lien de réinitialisation à cette adresse",
    sending: "Envoi en cours...",
    sendLink: "Envoyer le lien",
    backToLogin: "Retour à la connexion",
    signUpHere: "S'inscrire ici",
    securityNote: "Pour des raisons de sécurité, le lien expire au bout d'une heure.",
    emailInvalid: "Email invalide",
    emailInvalidDesc: "Veuillez entrer une adresse email valide",
    emailSentTitle: "Email envoyé",
    emailSentDesc: "Vérifiez votre boîte mail pour réinitialiser votre mot de passe",
    emailSentHeading: "Email envoyé !",
    resetLinkSentTo: "Nous avons envoyé un lien de réinitialisation à",
    nextSteps: "Étapes suivantes :",
    stepCheckMail: "Vérifiez votre boîte mail",
    stepClickLink: "Cliquez sur le lien de réinitialisation",
    stepCreatePassword: "Créez un nouveau mot de passe",
    noEmailReceived: "Vous n'avez pas reçu l'email ? Vérifiez vos spams ou",
    retry: "réessayez",

    // ResetPassword
    resetPasswordVerifying: "Vérification du lien...",
    resetPasswordInvalidTitle: "Lien invalide ou expiré",
    resetPasswordInvalidDesc: "Ce lien de réinitialisation n'est plus valide. Les liens expirent après 1 heure pour des raisons de sécurité.",
    resetPasswordRequestNewLink: "Demander un nouveau lien",
    resetPasswordSuccessTitle: "Mot de passe réinitialisé !",
    resetPasswordSuccessDesc: "Votre mot de passe a été changé avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    resetPasswordRedirecting: "Redirection vers la connexion...",
    resetPasswordGoToLogin: "Aller à la connexion",
    resetPasswordNewTitle: "Nouveau mot de passe",
    resetPasswordNewDesc: "Créez un nouveau mot de passe sécurisé pour votre compte.",
    resetPasswordFormTitle: "Réinitialisation du mot de passe",
    resetPasswordNewLabel: "Nouveau mot de passe",
    resetPasswordMinChars: "Minimum 8 caractères, avec majuscule, minuscule, chiffre et caractère spécial",
    resetPasswordConfirmLabel: "Confirmer le mot de passe",
    resetPasswordCriteria: "Critères du mot de passe :",
    resetPasswordAtLeast6: "Au moins 8 caractères",
    resetPasswordUpperLower: "Une majuscule et une minuscule",
    resetPasswordDigitSpecial: "Un chiffre et un caractère spécial",
    resetPasswordMatch: "Les mots de passe correspondent",
    resetPasswordLoading: "Réinitialisation...",
    resetPasswordSubmit: "Réinitialiser le mot de passe",
    resetPasswordSecurityNote: "Après avoir changé votre mot de passe, vous devrez vous reconnecter.",
    resetPasswordTooShort: "Mot de passe trop court",
    resetPasswordTooShortDesc: "Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial",
    resetPasswordMismatch: "Mots de passe différents",
    resetPasswordMismatchDesc: "Les deux mots de passe doivent être identiques",
    resetPasswordMissingToken: "Token manquant",
    resetPasswordMissingTokenDesc: "Le lien de réinitialisation est invalide",
    resetPasswordSuccessToast: "Mot de passe réinitialisé",
    resetPasswordSuccessToastDesc: "Votre mot de passe a été changé avec succès",
    resetPasswordError: "Erreur",
    resetPasswordErrorDesc: "Impossible de réinitialiser le mot de passe",

    // ForceChangePassword
    forceChangePassword: {
      title: "Changez votre mot de passe",
      description: "Votre compte a été créé avec un mot de passe temporaire. Veuillez en définir un nouveau pour continuer.",
      languageProfileTitle: "Complétez votre profil linguistique",
      languageProfileDescription: "Ces préférences permettent de vous proposer les contributions et les corrections adaptées, ainsi que de vous envoyer les notifications dans la bonne langue.",
      languageProfileRequired: "Sélectionnez au moins une langue dans chaque champ obligatoire.",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      tooShort: "Minimum 8 caractères",
      passwordRequirements: "Utilisez au moins 8 caractères avec une majuscule, une minuscule, un chiffre et un caractère spécial.",
      mismatch: "Les mots de passe ne correspondent pas",
      submit: "Confirmer",
      saving: "Enregistrement...",
      success: "Mot de passe mis à jour avec succès",
      error: "Impossible de changer le mot de passe",
      hint: "Choisissez un mot de passe fort que vous n'utilisez nulle part ailleurs.",
    },

    // KeyboardModal
    keyboardModalTitle: "Clavier {language}",
    keyboardModalHint: "Entrez le texte en {language}",
    keyboardModalInputLabel: "Texte saisi",
    keyboardModalPlaceholder: "Texte tapé apparaîtra ici...",
    keyboardModalClear: "Effacer",
    keyboardModalCancel: "Annuler",
    keyboardModalConfirm: "Valider",

    // MobileMenu
    mobileMenuOthers: "Autres",
    mobileMenuReport: "Signaler / Suggestion",
    mobileMenuAdmin: "Administration",
    mobileMenuModerator: "Moderator Panel",
    mobileMenuAccountant: "Dashboard comptable",

    // UserContracts
    userContractsMyContracts: "Mes Contrats",
    userContractsTitle: "Contrats",
    userContractsSubtitle: "Consultez le contrat envoyé, signez-le, puis attendez la validation finale pour débloquer vos gains.",
    userContractsRefresh: "Actualiser",
    userContractsToSign: "À signer",
    userContractsSigned: "Signés",
    userContractsToSignList: "Contrats à signer",
    userContractsNoPending: "Aucun contrat en attente",
    userContractsDownloadPdf: "Télécharger le PDF",
    userContractsSignThis: "Signer ce contrat",
    userContractsSignedWaiting: "Le contrat est signé. Il est maintenant en attente de validation finale par le modérateur.",
    userContractsValidated: "Le contrat est validé définitivement. Vos gains peuvent maintenant être pris en compte.",
    userContractsUserSignature: "Signature de l'utilisateur",
    userContractsSignatureDate: "Date de signature:",
    userContractsSelectContract: "Sélectionnez un contrat pour le consulter",
    userContractsSignedTitle: "Contrats signés",
    userContractsNoSigned: "Aucun contrat signé pour le moment",
    userContractsSignedOn: "Signé le",
    userContractsFinalized: "Finalisé",
    userContractsViewSigned: "Voir contrat signé",
    userContractsPreviewSigned: "Contrat signé",
    userContractsPreviewDesc: "Version signée du contrat avec preuve de signature et date.",
    userContractsSignTitle: "Signer le contrat",
    userContractsSignDesc: "Choisissez comment signer le contrat: dessinez votre signature ou téléchargez une image",
    userContractsDraw: "Dessiner",
    userContractsUpload: "Télécharger",
    userContractsText: "Texte",
    userContractsClear: "Effacer",
    userContractsSaveSignature: "Enregistrer la signature",
    userContractsPreview: "Prévisualisation:",
    userContractsClickToUpload: "Cliquez pour télécharger une signature",
    userContractsImageFormats: "PNG, JPG, ou GIF",
    userContractsTextSignPlaceholder: "Ex: Lu et approuvé - Jean Dupont",
    userContractsTextSignHint: "Saisissez le nom ou la mention qui servira de signature électronique.",
    userContractsCancel: "Annuler",
    userContractsSigning: "Signature...",
    userContractsConfirmSignature: "Confirmer la signature",
    userContractsSignatureRequired: "Veuillez renseigner une signature avant de confirmer",
    userContractsErrorLoad: "Erreur lors du chargement des contrats",
    userContractsErrorLoadContract: "Impossible de charger le contrat",
    userContractsErrorSign: "Erreur lors de la signature",
    userContractsSuccessSign: "Contrat signé avec succès. Le modérateur peut maintenant faire la validation finale.",
    userContractsErrorLoadSigned: "Impossible de charger le contrat signé",
    userContractsSuccessDrawn: "Signature enregistrée",
    userContractsSuccessUploaded: "Signature téléchargée",
    userContractsStatusDraft: "Brouillon",
    userContractsStatusUnpublished: "Non publié",
    userContractsStatusPublished: "Publié",
    userContractsStatusSent: "Envoyé",
    userContractsStatusViewed: "Consulté",
    userContractsStatusSigned: "Signé",
    userContractsStatusValidated: "Validé définitivement",
    userContractsTypeValidation: "Contrat de validation",
    userContractsTypeModerator: "Contrat modérateur",
    userContractsTypeAdmin: "Contrat administrateur",
    userContractsMethodDrawn: "Signature dessinée",
    userContractsMethodUploaded: "Image téléchargée",
    userContractsMethodText: "Signature texte",
    userContractsMethodDefault: "Signature",

    // ModeratorContracts
    modContractsBadge: "Modérateur - Gestion des Contrats",
    modContractsTitle: "Contrats",
    modContractsSubtitle: "Assignez les contrats aux utilisateurs éligibles et validez les contrats signés",
    modContractsAssignTab: "Assigner des contrats",
    modContractsValidateTab: "Contrats signés",
    modContractsAvailableList: "Contrats disponibles",
    modContractsNoAssign: "Aucun contrat à assigner",
    modContractsClickToSend: "Cliquez sur \"Envoyer le contrat\" pour l'assigner à chaque utilisateur éligible",
    modContractsNoEligible: "Aucun utilisateur éligible pour ce contrat",
    modContractsAssigned: "Assigné",
    modContractsSending: "Envoi...",
    modContractsSend: "Envoyer",
    modContractsSelectToSee: "Sélectionnez un contrat pour voir les utilisateurs éligibles",
    modContractsSignedToValidate: "Contrats signés à valider",
    modContractsSignedDesc: "Ces contrats ont été signés par les utilisateurs. Cliquez sur \"Final Validate\" pour les finaliser définitivement.",
    modContractsNoSignedPending: "Aucun contrat signé en attente de validation",
    modContractsAssignedTo: "Assigné à:",
    modContractsValidating: "Validation...",
    modContractsFinalValidate: "Final Validate",
    modContractsConfirmSend: "Confirmer l'envoi du contrat",
    modContractsConfirmValidate: "Confirmer la validation finale",
    modContractsSendDesc: "Voulez-vous envoyer le contrat \"{title}\" à {name} ? Il recevra une notification.",
    modContractsValidateDesc: "Voulez-vous finaliser définitivement le contrat \"{title}\" ? Cette action ne pourra pas être annulée.",
    modContractsCancel: "Annuler",
    modContractsErrorLoad: "Erreur lors du chargement des contrats",
    modContractsErrorLoadUsers: "Erreur lors du chargement des utilisateurs éligibles",
    modContractsErrorSend: "Erreur lors de l'envoi du contrat",
    modContractsErrorValidate: "Erreur lors de la validation",
    modContractsStatusDraft: "Brouillon",
    modContractsStatusUnpublished: "Non publié",
    modContractsStatusPublished: "Publié",
    modContractsStatusSent: "Envoyé",
    modContractsStatusViewed: "Consulté",
    modContractsStatusSigned: "Signé",
    modContractsStatusFinalValidated: "Finalisé",
    modContractsTotal: "Total",
    modContractsRefresh: "Actualiser",
    modContractsScore: "Score: {score}/10",
    modContractsNotAvailable: "N/A",
    modContractsThisUser: "cet utilisateur",

    collectorDashboard: {
      profileFound: "Profil retrouvé",
      profileFoundDesc: "Le profil {code} est prêt pour de nouvelles contributions.",
      lookupFailed: "Recherche impossible",
      profileRetrieveError: "Impossible de récupérer ce profil communautaire.",
      locationRequired: "Localité requise",
      locationRequiredDesc: "Saisissez la localité avant de créer le profil.",
      invalidPhone: "Numéro invalide",
      invalidPhoneDesc: "Le numéro doit être sans espace et au format international (ex: 22893462784 ou +22893462784).",
      profileCreated: "Profil créé",
      smsSentSuccess: "Code envoyé par SMS avec succès",
      smsNotSent: "SMS non envoyé : {reason}",
      noPhoneForSms: "Aucun numéro fourni pour SMS",
      creationFailed: "Création impossible",
      noActiveSession: "Aucune session active",
      noActiveSessionDesc: "Sélectionnez ou créez un profil avant de continuer.",
      moduleAudioTitle: "Lecture et enregistrement",
      moduleAudioDesc: "Lire les phrases et enregistrer la voix.",
      moduleTranscriptionTitle: "Transcription",
      moduleTranscriptionDesc: "Écouter et transcrire les phrases.",
      moduleQuestionnaireTitle: "Données initiales",
      moduleQuestionnaireDesc: "Ouvrir le module de saisie initiale.",
      moduleDefaultTitle: "Module",
      moduleDefaultDesc: "Choisissez un module.",
      ageMoins18: "Moins de 18 ans",
      age18_30: "18 - 30 ans",
      age31_45: "31 - 45 ans",
      age46_60: "46 - 60 ans",
      age61_plus: "61 ans et plus",
      genderFeminin: "Féminin",
      genderMasculin: "Masculin",
      contribTypeAudio: "Audio",
      contribTypeTranscription: "Transcription",
      contribTypeQuestionnaire: "Données initiales",
      collectorBadge: "Collecteur",
      communityCollectionTitle: "Collecte communautaire",
      statProfiles: "Profils",
      statContributions: "Contributions",
      statToday: "Aujourd'hui",
      statFeedback: "Retours",
      sessionCardTitle: "Session",
      sessionCardDesc: "Code existant ou nouveau profil.",
      codeLabel: "Code",
      useThisCode: "Utiliser ce code",
      searching: "Recherche...",
      newProfile: "Nouveau profil",
      newProfileTitle: "Nouveau profil",
      newProfileDesc: "Age, sexe, localité.",
      ageLabel: "Age",
      genderLabel: "Sexe",
      locationLabel: "Localité",
      locationPlaceholder: "Village ou quartier",
      phoneLabel: "Numéro (optionnel)",
      phoneHint: "Sans espace, idéalement avec indicatif pays.",
      networkLabel: "Réseau mobile money",
      networkPlaceholder: "Sélectionnez un réseau",
      networkFlooz: "Flooz (Moov)",
      networkTmoney: "T-Money (Togocom)",
      genderRequired: "Sexe requis",
      genderRequiredDesc: "Indiquez le sexe du contributeur avant de créer son profil.",
      genderPlaceholder: "Sélectionner…",
      networkRequired: "Réseau requis",
      networkRequiredDesc: "Le réseau mobile money (Flooz ou T-Money) est requis pour pouvoir payer ce profil.",
      creating: "Création...",
      create: "Créer",
      clickNewProfile: "Cliquez sur",
      codeCardTitle: "Code",
      codeCardDesc: "Identifiant unique.",
      continue: "Continuer",
      sessionActive: "Session · {code}",
      sessionPending: "Session en attente",
      noActiveProfile: "Aucun profil actif.",
      finish: "Terminer",
      inProgressBadge: "en cours",
      typeLabel: "Type",
      activeProfileLabel: "Profil actif : {code}",
      openModule: "Ouvrir le module",
      ageSexProgressTitle: "Progression âge / sexe",
      ageSexProgressDesc: "Répartition des profils créés par tranche d'âge et sexe.",
      noProfileForChart: "Aucun profil pour afficher le graphique.",
      femmes: "Femmes",
      hommes: "Hommes",
      autres: "Autres",
      sessionActiveStatus: "Session active",
      endSession: "Terminer",
      codeInstruction: "Code à communiquer au contributeur",
      noActiveCode: "Aucun code actif",
      contributionModules: "Modules de contribution",
      selectProfileFirst: "Sélectionnez d'abord un profil",
      addProfile: "Ajouter un profil",
      cancel: "Annuler",
      sessionActivity: "Activité de la session",
      sessionFor: "Session pour",
      noActiveSessionActivity: "Aucune session active",
      noContributionsYet: "Aucune contribution pour ce profil",
      start: "Commencer",
      done: "Terminé",
      noChartData: "Aucune donnée disponible",
      chatbotTab: "Assistant",
      chatbotTabDesc: "Poser une question à l'assistant",
      chatbotTitle: "Discuter avec HLlama",
      chatbotSubtitle: "Échangez avec HLlama sur votre santé et votre bien-être, avec ou sans numéro de téléphone.",
      chatbotPlaceholder: "Écrivez votre question...",
      chatbotSend: "Envoyer",
      chatbotThinking: "L'assistant répond...",
      chatbotEmpty: "Aucune conversation",
      chatbotEmptyDesc: "Posez votre première question pour démarrer la conversation.",
      chatbotErrorTitle: "Erreur",
      chatbotErrorDesc: "Impossible d'envoyer votre question pour le moment.",
      chatbotYou: "Vous",
      chatbotAssistant: "Assistant",
      chatbotPendingAnswer: "Réponse en cours de traitement...",
      chatbotVoiceError: "Impossible d'utiliser la reconnaissance vocale sur cet appareil.",
      chatbotQuestionInvalid: "Saisissez une question de 1 à 2 000 caractères.",
      chatbotUnavailable: "HLlama est momentanément indisponible. Votre question est conservée.",
      chatbotRateLimited: "Trop de demandes pour le moment. Patientez avant de réessayer.",
      chatbotBusy: "Une demande est déjà en cours. Patientez puis réessayez la même question.",
      chatbotRetryHistory: "Réessayer de charger la conversation",
      chatbotOffline: "Vous êtes hors ligne. Reconnectez-vous pour envoyer votre question.",
      chatbotAnswered: "La réponse de HLlama est disponible.",
      chatbotVoiceStart: "Dicter une question",
      chatbotVoiceStop: "Arrêter la dictée",
      noProfilesYet: "Aucun profil pour le moment",
      historyTitle: "Historique des paiements",
      historySent: "Envoyés aux profils",
      historyReceived: "Reçus",
      historyEmpty: "Aucun paiement pour l'instant.",
      historyError: "Impossible de charger l'historique.",
      historyRetry: "Réessayer",
      historyStatusPaid: "Payé",
      historyStatusPending: "En attente",
      historyStatusFailed: "Échoué",
      historyContributionsPaid: "{count} contribution(s) payée(s)",
      historyPageSummary: "Page {page} sur {pages}",
      historyPrevious: "Précédent",
      historyNext: "Suivant",
      paymentSectionTitle: "Paiement mobile money",
      paymentLoading: "Chargement du montant...",
      paymentAmountToPay: "{amount} FCFA à payer",
      paymentRecordedLabel: "Enregistrées",
      paymentValidatedLabel: "Validées",
      paymentPaidLabel: "Déjà payées",
      paymentToPayLabel: "À payer",
      paymentNoPhoneOrNetwork: "numéro ou réseau manquant",
      paymentRefresh: "Actualiser",
      paymentPayButton: "Payer",
      paymentInProgress: "Paiement en cours…",
      paymentSuccess: "Paiement confirmé avec succès",
      paymentPendingDesc: "Paiement en attente de confirmation par l'opérateur. Ne relancez pas le paiement : cliquez sur Actualiser dans quelques minutes pour voir le statut. S'il reste en attente, contactez un administrateur.",
      paymentLoadError: "Impossible de charger le montant à payer",
      paymentEditContact: "Renseigner numéro / réseau",
      paymentEditSave: "Enregistrer",
      paymentEditSaving: "Enregistrement...",
      paymentEditError: "Impossible d'enregistrer le numéro/réseau",
    },

    // Recording guidelines (politique de collecte)
    recordingGuidelines: {
      title: "Politique de collecte",
      subtitle: "Écoutez la politique de données vocale et les exemples audio de qualité par langue avant de contribuer.",
      languageLabel: "Langue",
      selectLanguage: "Sélectionnez une langue",
      loadingList: "Chargement des langues...",
      loadingListError: "Impossible de charger les langues disponibles.",
      empty: "Aucune politique de collecte active pour le moment.",
      loadingDetail: "Chargement de la politique...",
      detailError: "Impossible de charger cette politique.",
      detailNotFound: "Aucune politique active pour cette langue.",
      policyAudioTitle: "Audio de la politique",
      policyTextTitle: "Transcription",
      qualityCriteriaTitle: "Critères de qualité audio",
      qualityAudioTitle: "Exemple de qualité",
      examplesTitle: "Exemples audio",
      noExamples: "Aucun exemple disponible.",
      audioNotAvailable: "Audio non disponible.",

      // Gestion admin
      adminSectionTitle: "Gestion des politiques",
      adminAddNew: "Nouvelle politique",
      adminEdit: "Modifier",
      adminDelete: "Supprimer",
      adminLanguageColumn: "Langue",
      adminCodeColumn: "Code",
      adminStatusColumn: "Statut",
      adminExamplesColumn: "Exemples",
      adminActionsColumn: "Actions",
      adminActive: "Active",
      adminInactive: "Inactive",
      adminEmptyList: "Aucune politique enregistrée pour le moment.",
      adminLoadListError: "Impossible de charger les politiques.",
      adminFormTitleCreate: "Nouvelle politique de collecte",
      adminFormTitleEdit: "Modifier la politique",
      adminLanguageField: "Langue",
      adminSelectLanguagePlaceholder: "Choisir une langue",
      adminPolicyTextField: "Transcription de la politique",
      adminQualityCriteriaField: "Critères de qualité audio",
      adminIsActiveField: "Politique active",
      adminAutoAudioField: "Générer l'audio automatiquement",
      adminAutoAudioHint: "Pour un texte en français (2 000 caractères maximum par champ). L'audio suit chaque modification et remplace celui déjà enregistré, sauf si vous envoyez un fichier.",
      adminAutoAudioPending: "L'audio n'a pas pu être généré. Enregistrez à nouveau pour réessayer.",
      adminAutoAudioTooLong: "Un texte dépasse 2 000 caractères : raccourcissez-le ou envoyez un fichier audio.",
      adminPolicyAudioField: "Audio de la politique",
      adminQualityAudioField: "Audio de qualité (exemple)",
      adminKeepExistingAudio: "Laissez vide pour conserver l'audio existant.",
      adminSave: "Enregistrer",
      adminSaving: "Enregistrement...",
      adminCancel: "Annuler",
      adminSaved: "Politique enregistrée",
      adminSaveError: "Impossible d'enregistrer la politique.",
      adminLanguageRequired: "Sélectionnez une langue.",
      adminPolicyAudioRequired: "L'audio de la politique est requis pour une nouvelle langue.",
      adminAudioFormatHint: "Formats acceptés : mp3, wav, mp4/m4a (pas webm).",
      adminDeleteConfirmTitle: "Supprimer cette politique ?",
      adminDeleteConfirmBody: "Cette action supprime aussi les audios et exemples associés. Elle est irréversible.",
      adminDeleted: "Politique supprimée",
      adminDeleteError: "Impossible de supprimer la politique.",
      adminExamplesTitle: "Exemples audio",
      adminExamplesEmpty: "Aucun exemple pour cette langue.",
      adminAddExampleTitle: "Ajouter un exemple",
      adminExampleTitleField: "Titre",
      adminExampleDescriptionField: "Description (optionnel)",
      adminExampleOrderField: "Ordre d'affichage",
      adminExampleAudioField: "Fichier audio",
      adminExampleAdd: "Ajouter l'exemple",
      adminExampleAdding: "Ajout...",
      adminExampleAdded: "Exemple ajouté",
      adminExampleAddError: "Impossible d'ajouter l'exemple.",
      adminExampleFieldsRequired: "Titre et fichier audio requis.",
      adminExampleDeleteConfirmTitle: "Supprimer cet exemple ?",
      adminExampleDeleted: "Exemple supprimé",
      adminExampleDeleteError: "Impossible de supprimer l'exemple.",
      adminSaveFirstForExamples: "Enregistrez la politique avant d'ajouter des exemples.",
      adminManageTab: "Gestion",
      adminPreviewTab: "Aperçu collecteur",
    },

    // GetPaid
    getPaid: {
      budgetLoadError: "Impossible de charger les informations de budget",
      budgetConfirmed: "Budget confirmé",
      depositAdminOnly: "Seul un administrateur peut effectuer un dépôt",
      depositLaunched: "Dépôt lancé",
      depositFailed: "Impossible d'effectuer le dépôt",
      eligibleUsersLoadError: "Impossible de charger les utilisateurs éligibles",
      eligibleModeratorsLoadError: "Impossible de charger les modérateurs",
      phoneMissing: "Numéro de téléphone manquant",
      invalidNetwork: "Réseau invalide",
      chooseNetwork: "Veuillez choisir FLOOZ ou TMONEY",
      paymentLaunched: "Paiement lancé",
      paymentLaunchFailed: "Impossible de lancer le paiement",
      paymentsLaunched: "Paiements lancés",
      paymentsLaunchedDesc: "{success} réussi(s), {failed} échoué(s) sur {total} total",
      moderatorOnly: "Action réservée aux modérateurs",
      amountUnavailable: "Montant indisponible",
      monthlyFeeUnavailable: "Le forfait mensuel du modérateur n'est pas encore disponible pour ce mois.",
      requestSubmitFailed: "Impossible de soumettre la demande",
      myRequestsLoadError: "Impossible de charger vos demandes",
      requestsLoadError: "Impossible de charger les demandes",
      accessDenied: "Accès refusé",
      phoneRequiredTitle: "Téléphone requis",
      phoneRequiredDesc: "Renseignez le numéro de téléphone",
      settingsSaved: "Enregistré",
      settingsSavedDesc: "Paramètres de paiement mis à jour.",
      saveSettingsFailed: "Impossible d'enregistrer les paramètres",
      amountInsufficient: "Montant insuffisant",
      amountInsufficientDesc: "Vous ne pouvez demander que {amount}",
      operatorNotSupported: "Opérateur non supporté",
      operatorNotSupportedDesc: "Choisissez MTN MoMo ou Moov Money pour envoyer la demande.",
      requestCreated: "Demande créée",
      requestCreatedDesc: "Votre demande de paiement a été soumise.",
      createRequestFailed: "Impossible de créer la demande",
      pendingTestsLoadError: "Impossible de charger les tests en attente",
      completeResponse: "Veuillez compléter votre réponse",
      testSubmitted: "Succès",
      testSubmittedDesc: "Votre test a été soumis pour correction",
      loadTestFailed: "Impossible de charger le test. Réessayez.",
      requestApproved: "Demande approuvée",
      requestApprovedDesc: "{name} est maintenant prête pour paiement côté comptable.",
      approveFailed: "Impossible d'approuver la demande",
      approveForbidden: "Accès refusé : votre session ne porte pas le rôle ADMIN. Reconnectez-vous avec un compte admin.",
      bulkApproveModeratorsDone: "Approbations modérateurs terminées",
      bulkApproveContributorsDone: "Approbations contributeurs terminées",
      bulkApproveDesc: "{count} demande(s) approuvée(s), {failed} échec(s).",
      approveModeratorsFailed: "Impossible d'approuver les demandes modérateurs",
      approveContributorsFailed: "Impossible d'approuver les demandes contributeurs",
      requestValidateFailed: "Impossible de valider la demande",
      userTestTitle: "Test utilisateur",
      languageTestSubmission: "Soumission de test de langue",
      testTimeElapsedTitle: "Temps écoulé !",
      testTimeElapsedDesc: "Les 10 minutes du test sont terminées.",
      testFinished: "Le test est terminé.",
      recordingStoppedAuto: "L'enregistrement a été arrêté automatiquement.",
      microphoneUnavailable: "Micro non disponible",
      microphonePermissionRequired: "Autorisez l'accès au micro pour enregistrer.",
      statusPending: "En attente",
      statusApproved: "Approuvée",
      statusRejected: "Rejetée",
      networkPrompt: "Réseau (FLOOZ ou TMONEY)",
      phonePrompt: "Numéro de téléphone pour {name}",
      payoutDescription: "Paiement YODI - {count} tests validés",
      moderatorMonthlyPayout: "Paiement modérateur YODI - forfait mensuel",
      paymentReference: "Réf",
      payModeratorsConfirm: "Payer automatiquement {count} modérateurs ?\nMontant total : {amount}",
      launchPaymentsFailed: "Impossible de lancer les paiements",
      correctedTestsLoadError: "Impossible de charger les tests corrigés",
      scoresSaved: "Sauvegardé",
      scoresSavedDesc: "Scores enregistrés (brouillon).",
      incomplete: "Incomplet",
      scoreAllItems: "Veuillez noter tous les items.",
      testNotFound: "Test introuvable",
      rejectedTest: "Test rejeté",
      rejectedTestDesc: "Le test a été rejeté avec un score de {score}/10.",
      correctionCompleted: "Correction terminée",
      correctionCompletedDesc: "Le test est maintenant corrigé avec un score de {score}/10. Envoyez le contrat pour poursuivre.",
      saveCorrectionFailed: "Impossible d’enregistrer la correction",
      userNotFound: "Utilisateur introuvable",
      sendContractFailed: "Impossible d’envoyer le contrat.",
      contractSent: "Contrat envoyé",
      contractSentDesc: "Le contrat a été envoyé à {name}.",
      sendContractRequestFailed: "Impossible d’envoyer le contrat",
      finalValidationSuccess: "Validation finale réussie",
      finalValidationSuccessDesc: "Le test de {name} est maintenant validé.",
      finalValidationFailed: "Impossible de valider définitivement le test",
      contractToSend: "Contrat à envoyer",
      contractSentLabel: "Contrat envoyé",
      contractViewed: "Contrat consulté",
      readyForFinalValidation: "Prêt pour validation finale",
      alreadyFinalized: "Déjà finalisé",
      payoutRequestsLoadError: "Impossible de charger les demandes",
      requestRejected: "Demande rejetée",
      paymentCanProceed: "Le paiement pourra maintenant être effectué",
      requesterNotified: "Le demandeur a été notifié",
      inputCompleted: "La saisie est terminée.",
      completeAllItems: "Veuillez compléter tous les items avant de soumettre.",
      submitTestFailed: "Impossible de soumettre le test",
      testSubmissionInProgress: "La soumission est encore en cours. Réessayez dans un instant.",
      testSubmissionChanged: "Les réponses ont changé. Soumettez à nouveau ce test.",
      pendingTestExists: "Vous avez déjà un test en attente pour cette langue.",
      validatedTestExists: "Vous avez déjà un test validé pour cette langue.",
      testAlreadySubmitted: "Test déjà soumis",
      qualificationTest: "Test de qualification",
      testTimeRemaining: "Temps restant",
      attempt: "Tentative",
      recording: "Enregistrement en cours",
      submitTest: "Soumettre le test",
      submitting: "Soumission...",
      time: "Temps",
      translationPlaceholder: "Traduction...",
      moderation: "Modération",
      testCorrection: "Correction des tests",
      testCorrectionDesc: "Corrigez les tests soumis par les utilisateurs et attribuez des scores",
      pendingCorrectionDesc: "Tests en attente de correction",
      contractsToSendDesc: "Corrigés, contrat à envoyer",
      contractsSentDesc: "En attente de signature",
      contractsViewedDesc: "Consulté par l'utilisateur",
      contractsReadyFinalDesc: "Signé, prêt pour validation finale",
      contractsFinalizedDesc: "Tests finalisés et validés",
      correctingTestFor: "Correction du test de {name}",
      backToList: "Retour à la liste",
      saving: "Sauvegarde...",
      save: "Sauvegarder",
      finishCorrection: "Terminer la correction",
      phonemesWeight: "Phonèmes (30%)",
      phrasesWeight: "Phrases (30%)",
      translationsWeight: "Traductions (40%)",
      totalWeightedScore: "Score total pondéré",
      sectionPhonemes: "Section 1 : Phonèmes",
      sectionPhrases: "Section 2 : Phrases à prononcer",
      sectionTranslations: "Section 3 : Traduction",
      audioNotProvided: "Audio non fourni",
      score: "Score",
      scorePlaceholder: "0 - 10",
      audioTestValidation: "Validation des tests audio",
      toCorrect: "À corriger",
      correctedTests: "Tests corrigés",
      loading: "Chargement...",
      refresh: "Actualiser",
      details: "Détails",
      sendContract: "Envoyer contrat",
      sending: "Envoi...",
      permanentlyValidate: "Valider définitivement",
      validating: "Validation...",
      readOnly: "Lecture seule",
      finalized: "Finalisé",
      corrected: "Corrigé",
      validated: "Validé",
      confirmFinalValidation: "Confirmer la validation finale",
      confirmFinalValidationDesc: "Voulez-vous valider définitivement le test de {name} avec un score de {score} / 10 ?",
      confirmFinalValidationGeneric: "Confirmez la validation finale de ce test.",
      cancel: "Annuler",
      confirm: "Confirmer",
      moderatorPaymentRequest: "Demande de paiement modérateur",
      amountXof: "Montant (XOF)",
      phone: "Téléphone",
      network: "Réseau",
      chooseNetworkLabel: "Choisir un réseau",
      descriptionOptional: "Description (optionnel)",
      submitRequest: "Soumettre la demande",
      estimatedEarnings: "Gains estimés: {amount}",
      monthlyAmountAvailableEndOfMonth: "Le montant mensuel du modérateur sera disponible à la fin du mois.",
      statusLabel: "Statut: {status}",
      configuration: "Configuration",
      moderatorManagement: "Gestion Modérateurs",
      contributorManagement: "Gestion Contributeurs",
      noPendingTests: "Aucun test en attente",
      noCorrectedTests: "Aucun test corrigé",
      testRecycleBin: "Corbeille des tests",
      testRecycleBinDescription: "Les tests supprimés restent restaurables jusqu’à la date affichée.",
      testTrashTitle: "Mettre ce test à la corbeille ?",
      testTrashDescription: "Le test de {name} en {language} ({status}) sera retiré des files actives et pourra être restauré pendant 30 jours.",
      testTrashReason: "Motif (10 caractères minimum)",
      testTrashConfirm: "Mettre à la corbeille",
      testTrashRestore: "Restaurer",
      testTrashLoadMore: "Afficher les suivants",
      testTrashEmpty: "Aucun test dans la corbeille",
      testTrashSuccess: "Le test a été déplacé dans la corbeille.",
      testTrashError: "Impossible de déplacer ce test dans la corbeille.",
      testRestoreSuccess: "Le test a été restauré.",
      testRestoreError: "Impossible de restaurer ce test.",
      testTrashReasonRequired: "Saisissez un motif d’au moins 10 caractères.",
      lightMode: "Mode clair",
      darkMode: "Mode sombre",
      adminBadge: "Administration",
      adminPaymentManagementTitle: "Gestion Paiement",
      adminPaymentManagementDesc: "Gérez le budget, les paramètres et le traitement des paiements pour les modérateurs et contributeurs.",
      adminBudgetAvailable: "Budget disponible",
      adminTotalBudget: "Budget total",
      adminReserved: "Réservé",
      adminAvailable: "Disponible",
      adminBudgetLoading: "Chargement du budget...",
      adminBudgetFailed: "Échec du chargement du budget",
      adminTotalAllocatedBudget: "Budget total alloué",
      adminOfTotal: "% du total",
      adminHealthy: "Sain",
      adminInsufficient: "Insuffisant",
      adminPaidTotal: "Payé (total)",
      adminOpenRequests: "Demandes ouvertes",
      adminMakeDeposit: "Effectuer un dépôt",
      adminTransactionHistory: "Historique des transactions",
      adminPaymentSettings: "Paramètres de paiement",
      adminPaymentSettingsDesc: "Configurer les montants et limites de paiement",
      adminAmountPerContribution: "Montant par contribution",
      adminContributorCap: "Cap contributeurs",
      adminAmountPerModerator: "Montant par modérateur",
      adminSaveSettings: "Enregistrer les paramètres",
      adminLoadingSettings: "Chargement des paramètres...",
      adminEditSettings: "Modifier les paramètres",
      adminContributionsUnit: "contributions",
      adminAmountPerContributionXof: "Montant par contribution (XOF)",
      adminAmountPerContributionHelp: "Montant payé pour chaque contribution acceptée (maximum 1000 contributions par contributeur)",
      adminContributorCapXof: "Cap contributeur (nombre de contributions)",
      adminContributorCapHelp: "Nombre maximum de contributions payables par contributeur",
      adminModeratorAmountXof: "Montant fixe modérateur (XOF)",
      adminModeratorAmountHelp: "Montant mensuel fixe payé à chaque modérateur",
      adminSaving: "Enregistrement...",
      adminSaveChanges: "Enregistrer",
      adminCancel: "Annuler",
      adminPayoutContributorBtn: "Payer un contributeur",
      adminPayoutContributorTitle: "Payer un contributeur",
      adminPayoutContributorDesc: "Transférer des fonds à un contributeur",
      adminPayoutUserId: "ID utilisateur",
      adminPayoutAcceptedAudios: "Audios acceptés",
      adminPayoutPayableCount: "Nombre payable",
      adminPayoutMaxAvailable: "Maximum disponible",
      adminPayoutAmountXof: "Montant (XOF)",
      adminPayoutMax: "Max :",
      adminPayoutPhoneNumber: "Numéro de téléphone",
      adminPayoutNetwork: "Réseau",
      adminPayoutSelectUser: "Veuillez sélectionner un utilisateur",
      adminPayoutValidAmount: "Veuillez entrer un montant valide",
      adminPayoutValidPhone: "Veuillez entrer un numéro de téléphone",
      adminPayoutSingleModerator: "Payer un modérateur",
      adminPayoutAllModerators: "Payer tous les modérateurs",
      adminPayoutEligibleModerators: "Modérateurs éligibles",
      adminPayoutTotal: "Total :",
      adminPayoutNoModerators: "Aucun modérateur trouvé",
      adminPayoutTableId: "ID",
      adminPayoutTableName: "Nom",
      adminPayoutTableEmail: "Email",
      adminPayoutTablePhone: "Téléphone",
      adminPayoutTableValidations: "Validations",
      adminPayoutTableAction: "Action",
      adminPayoutPay: "Payer",
      adminPayoutPayModeratorTitle: "Payer un modérateur",
      adminPayoutValidated: "Validé :",
      adminPayoutAmountToPay: "Montant à payer :",
      adminPayoutPeriod: "Période :",
      adminPayoutNotYetDue: "Pas encore dû",
      adminPayoutAlreadyPaid: "Déjà payé ce mois-ci",
      adminPayoutSelectModerator: "Veuillez sélectionner un modérateur",
      adminPayoutConfirmAll: "Êtes-vous sûr de vouloir payer TOUS les modérateurs éligibles ? Cette action est irréversible.",
      adminPayoutConfirmBtn: "Confirmer le paiement",
      adminReqNoRequests: "Aucune demande",
      adminReqTableId: "ID",
      adminReqTableUser: "Utilisateur",
      adminReqTableAmount: "Montant",
      adminReqTablePhone: "Téléphone",
      adminReqTableNetwork: "Réseau",
      adminReqTableStatus: "Statut",
      adminReqTableCreated: "Créé",
      adminReqTableActions: "Actions",
      adminReqTotalPending: "Demandes en attente",
      adminReqModeratorsPending: "Modérateurs en attente",
      adminReqContributorsPending: "Contributeurs en attente",
      adminReqXofTotal: "XOF total",
      adminReqModeratorPayoutRequests: "Demandes de paiement modérateur",
      adminReqContributorPayoutRequests: "Demandes de paiement contributeur",
      adminReqApproveRequest: "Approuver la demande",
      adminReqRejectRequest: "Rejeter la demande",
      adminReqMarkAsPaid: "Marquer comme payé",
      adminReqUser: "Utilisateur :",
      adminReqNoteOptional: "Note (facultatif)",
      adminReqNotePlaceholder: "Ajouter une note...",
      adminReqConfirm: "Confirmer",
      adminDepositTitle: "Dépôt admin",
      adminDepositDescription: "Déposer des fonds dans le budget via FeexPay",
      adminDepositEnterEmail: "Veuillez entrer un email",
      adminDepositFirstName: "Prénom",
      adminDepositLastName: "Nom",
      adminDepositDescriptionOptional: "Description (facultatif)",
      adminDepositProceedToPayment: "Procéder au paiement",
      adminSectionModeratorRequests: "Section A · Demandes de paiement modérateur ({count})",
      adminApproveAll: "Approuver tout",
      adminNoModeratorRequests: "Aucun modérateur n'a encore fait de demande de paiement.",
      adminUserLabel: "Utilisateur",
      adminEmailLabel: "Email",
      adminPhoneLabel: "Numero",
      adminOperatorLabel: "Operateur",
      adminDateLabel: "Date",
      adminStatusLabel: "Status",
      adminAmountLabel: "Montant",
      adminActionLabel: "Action",
      adminEmailNotProvided: "Email non renseigné",
      adminAwaitingAccountant: "En attente comptable",
      adminPaymentConfirmed: "Paiement confirmé",
      adminNoAction: "Aucune action",
      adminSectionModeratorEarnings: "Modérateurs avec gains accumulés sans demande ({count})",
      adminNoModeratorEarnings: "Aucun modérateur avec gains accumulés sans demande.",
      adminCorrectedCount: "{count} tests corrigés",
      adminLastPayout: "Dernier paiement: {date}",
      adminMonthlyAmountReady: "Montant mensuel prêt",
      adminMonthlyAmountNotAvailable: "Montant mensuel non encore disponible",
      adminSectionContributorRequests: "Demandes de paiement contributeur ({count})",
      adminReloadEarnings: "Recharger les gains",
      adminApproveAllContributors: "Approuver tout",
      adminRequestCount: "{count} demande(s)",
      adminModeratorCount: "{count} modérateur(s)",
      adminNoContributorRequests: "Aucun contributeur n'a encore fait de demande de paiement.",
      adminSectionContributorEarnings: "Contributeurs éligibles au paiement ({count})",
      adminNoEligibleContributors: "Aucun contributeur éligible pour le moment.",
      adminValidatedTests: "{count} tests validés",
      adminPayNow: "Payer maintenant",
      adminApprove: "Approuver",
      adminReject: "Rejeter",
      depositBudgetTitle: "Dépôt de budget",
      depositBudgetDescription: "Renseignez les informations Mobile Money pour approvisionner le compte admin.",
      amountPlaceholder: "Ex : 50000",
      phonePlaceholder: "Ex : +22890000000",
      depositDescriptionPlaceholder: "Ex : Rechargement budget hebdomadaire",
      depositInProgress: "Dépôt en cours...",
      validateDeposit: "Valider le dépôt",
      bulkApproveConfirmTitle: "Confirmer l'approbation groupée",
      rejectRequestTitle: "Rejeter la demande",
      noteLabel: "Note",
      stop: "Stop",
      redo: "Refaire",
      submitEnabledWhenComplete: "Le bouton est actif quand tous les items sont complétés.",
      validatedAudioCountLabel: "Validées (audios)",
      pendingAudiosLabel: "En attente (audios)",
      totalPointsLabel: "Contributions au total",
      moderatorNoteLabel: "Note du modérateur :",
      requestPendingModerator: "En attente de validation par un modérateur",
      requestApprovedAdminSoon: "Approuvée ! Le paiement sera effectué prochainement par l'admin",
      contractSentSignRequired: "Un contrat vous a été envoyé et doit être signé.",
      signedContractAvailable: "Contrat déjà signé. Vous pouvez voir la version signée.",
      withdrawAmountLabel: "Montant à retirer (XOF)",
      transactionRefLabel: "Réf. transaction : {ref}",
      paidOnLabel: "Payé le {date}",
      refundedAmountTitle: "Montant restitué à votre compte",
      refundedAmountDesc: "{amount} a été restitué à votre montant disponible.",

      // Moderator Payout Tab
      modPayoutUserNotFound: "Utilisateur introuvable",
      modPayoutEnterPhone: "Veuillez entrer un numéro de téléphone",
      modPayoutCouldNotLoadStats: "Impossible de charger les statistiques du modérateur",
      modPayoutEarnings: "Gains du modérateur",
      modPayoutPeriod: "Période : {month}/{year}",
      modPayoutValidations: "Validations",
      modPayoutMonthlyAmount: "Montant mensuel",
      modPayoutStatus: "Statut",
      modPayoutNotDueYet: "Pas encore dû",
      modPayoutReadyToClaim: "Prêt à réclamer",
      modPayoutAlreadyPaid: "Déjà payé",
      modPayoutRequestInProgress: "Demande en cours",
      modPayoutClaimInfo: "Vous pouvez réclamer votre paiement mensuel à la fin du mois.",
      modPayoutAlreadyReceived: "Vous avez déjà reçu votre paiement pour {month}/{year}.",
      modPayoutRequestThisMonth: "Demander le paiement de ce mois",
      modPayoutInProgressInfo: "Vous avez une demande de paiement en cours ce mois-ci. Veuillez attendre qu'elle soit traitée.",
      modPayoutYourRequests: "Vos demandes de paiement",
      modPayoutNoRequests: "Aucune demande pour le moment",
      modPayoutTableId: "ID",
      modPayoutTableAmount: "Montant",
      modPayoutTablePeriod: "Période",
      modPayoutTableStatus: "Statut",
      modPayoutTableCreated: "Créé",
      modPayoutRequestTitle: "Demander un paiement",
      modPayoutRequestDesc: "Soumettez votre demande de paiement mensuel de modérateur",
      modPayoutYourMonthlyAmount: "Votre montant mensuel :",
      modPayoutPhoneNumber: "Numéro de téléphone",
      modPayoutMobileNetwork: "Réseau mobile",
      modPayoutCancel: "Annuler",
      modPayoutSubmitting: "Envoi en cours...",
      modPayoutSubmitRequest: "Soumettre la demande",

      // Contributor Payout Tab
      contribPayoutUserNotFound: "Utilisateur introuvable",
      contribPayoutValidAmount: "Veuillez entrer un montant valide",
      contribPayoutEnterPhone: "Veuillez entrer un numéro de téléphone",
      contribPayoutYourEarnings: "Vos gains",
      contribPayoutAcceptedAudios: "Audios acceptés",
      contribPayoutPayableCount: "Nombre payable",
      contribPayoutCap: "Cap",
      contribPayoutRate: "Tarif",
      contribPayoutMaximumClaimable: "Maximum réclamable",
      contribPayoutBasedOnInfo: "Basé sur {count} contributions payable à {rate} XOF chacune",
      contribPayoutRequestPayout: "Demander un paiement",
      contribPayoutOpenRequestInfo: "Vous avez une demande de paiement en attente. Veuillez attendre qu'elle soit traitée ou terminée avant d'en soumettre une nouvelle.",
      contribPayoutMinimumInfo: "Vous devez avoir au moins 1000 audios acceptés pour demander un paiement.",
      contribPayoutYourRequests: "Vos demandes de paiement",
      contribPayoutNoRequests: "Aucune demande pour le moment",
      contribPayoutTableId: "ID",
      contribPayoutTableAmount: "Montant",
      contribPayoutTableStatus: "Statut",
      contribPayoutTableCreated: "Créé",
      contribPayoutTableUpdated: "Mis à jour",
      contribPayoutRequestTitle: "Demander un paiement",
      contribPayoutRequestDesc: "Soumettez une demande de paiement pour vos gains",
      contribPayoutMaximumAvailable: "Maximum disponible :",
      contribPayoutAmountXof: "Montant (XOF)",
      contribPayoutPhoneNumber: "Numéro de téléphone",
      contribPayoutMobileNetwork: "Réseau mobile",
      contribPayoutCancel: "Annuler",
      contribPayoutSubmitting: "Envoi en cours...",
      contribPayoutSubmitRequest: "Soumettre la demande",
    },

    // Authentication
    login: "Connexion",
    signup: "Inscription",
    username: "Nom d'utilisateur",
    email: "Email",
    password: "Mot de passe",
    passwordHint: "Minimum 8 caractères, 1 majuscule, 1 minuscule, 1 chiffre, 1 caractère spécial",
    pwdMinLength: "Au moins 8 caractères",
    pwdUppercase: "Au moins 1 majuscule",
    pwdLowercase: "Au moins 1 minuscule",
    pwdDigit: "Au moins 1 chiffre",
    pwdSpecial: "Au moins 1 caractère spécial",
    pwdStrong: "Mot de passe fort",
    pwdWeak: "Mot de passe faible",
    name: "Nom",
    fullName: "Nom complet",
    orFillForm: "Ou remplir le formulaire",
    optionalLabel: "optionnel",
    languagePreferences: "Préférences linguistiques",

    // Dashboard
    contributionStatus: "Statut des contributions",
    userStatistics: "Statistiques des utilisateurs",
    target: "Objectif",
    collected: "Collecté",
    ageDistribution: "Répartition par âge",
    genderDistribution: "Répartition par genre",
    avgWords: "Mots moyens",
    avgAge: "Âge moyen",
    ageRange: "Tranche d'âge",
    country: "Pays",
    countryDistribution: "Répartition par pays",
    contributorMessage: "Grâce à votre participation, nous construisons ensemble l'avenir de l'IA pour les langues ouest-africaines. Chaque contribution compte pour préserver et développer notre patrimoine linguistique.",
    realTimeDashboard: "Tableau de bord en temps réel des contributions pour la collecte de données NLP en langues ouest-africaines",
    thisMonth: "ce mois-ci",
    countries: "6 pays",
    westAfrica: "Afrique de l'Ouest",
    globalProgress: "Progression Globale",
    inProgress: "En progression",
    demographicAnalysis: "Analyse démographique et répartition géographique des contributeurs",
    thanksContributors: "Merci aux Contributeurs !",
    thanksMessage: "Grâce à votre participation, nous construisons ensemble l'avenir de l'IA pour les langues ouest-africaines. Chaque contribution compte pour préserver et développer notre patrimoine linguistique.",
    supportedLanguagesCount: "Langues supportées",
    totalGoal: "Objectif total",
    openSourceLicense: "Open Source",
    nwuliteObodoLicense: "Licence Nwulite Obodo",

    // Contribution Page
    recordings: "Enregistrements",
    languageMenu: "Menu langues",
    word: "Mot",
    display: "Afficher",
    record: "Enregistrer",
    recordDescription: "Enregistrez votre voix pour enrichir les modèles d'IA",
    labelImages: "Étiqueter les images",
    labelImagesDescription: "Identifiez les caractères dans les images manuscrites",
    labelImagesTitle: "Étiqueter les Images",
    labelImagesSubtitle: "Identifiez les caractères manuscrits pour améliorer la reconnaissance d'écriture",
    startLabeling: "Commencer l'étiquetage",
    labelingSession: "Session d'étiquetage",
    labelingCompleteTitle: "Soumission réussie",
    labelingCompleteSubtitle: "Merci pour votre contribution, vos annotations améliorent la reconnaissance d'écriture",
    labelingAccuracy: "Précision",
    labelingCorrect: "Correctes",
    labelingPointsEarned: "Points gagnés",
    labelingTotalImages: "{total} images au total",
    labelingContinue: "Contribuer à nouveau",
    labelingContinueHint: "Chaque session génère de nouvelles images aléatoires",
    validationCompleteTitle: "Validation terminée",
    validationCompleteSubtitle: "Tous les audios de cette session ont été traités",
    validationCompleteValidated: "Validés",
    validationCompleteAccepted: "Acceptés",
    validationCompleteRejected: "Rejetés",
    validationCompletePointsEarned: "Points gagnés",
    validationCompleteContinue: "Valider d'autres audios",
    validationCompleteContinueHint: "De nouveaux audios peuvent être disponibles",
    transcribeAudio: "Transcrire audio",
    transcribeAudioDescription: "Écoutez et saisissez la transcription",
    transcribePhrases: "Traduire des phrases",
    transcribePhrasesDescription: "Traduisez les phrases françaises vers la langue choisie",
    validateAudio: "Valider les audios",
    validateAudioDescription: "Validez les enregistrements des autres contributeurs",
    validateTranscriptions: "Valider transcriptions",
    validateTranscriptionsDescription: "Vérifiez et validez les transcriptions proposées",
    deleteAudioButton: "Supprimer cet audio",
    deleteAudioTitle: "Supprimer cet audio ?",
    deleteAudioDescription: "Cette action est irréversible. L'audio sera définitivement supprimé du stockage.",
    audioDeleted: "Audio supprimé",
    audioDeletedDescription: "L'audio a été supprimé définitivement.",
    audioDeleteFailed: "Impossible de supprimer cet audio.",
    modelPerformance: "Performance Modèles",
    modelPerformanceDescription: "Évaluer les modèles Umbaji (TTS, ASR)",
    initialAudio: "Audio initial",
    initialAudioDescription: "Enregistrez des audios pour le jeu de données initial",
    initialText: "Texte initial",
    initialTextDescription: "Soumettez des phrases pour le jeu de données initial",
    initialTranscription: "Transcription initiale",
    initialTranscriptionDescription: "Transcrivez les réponses audio des données initiales",
    initialReview: "Relecture initiale",
    initialReviewDescription: "Relisez les transcriptions et les textes des données initiales",
    initialTextTitle: "Data initiale - Texte",
    initialAudioTitle: "Data initiale - Audio",
    selectLanguageLabel: "Sélection de la langue",
    selectThemeLabel: "Sélection du thème",
    phrasesAndRecordings: "Phrases & enregistrements",
    progressOverview: "Suivi des contributions",
    progressOverviewDescription: "Consultez votre progression et vos tâches en cours",
    getPaidLabel: "Recevoir mes gains",
    getPaidDescription: "Demandez votre paiement une fois les seuils atteints",
    paymentManagement: "Gestion Paiement",
    paymentManagementDescription: "Configurez le budget et traitez les paiements côté administration",
    adminStatus: "Admin",
    getPaidCtaEligible: "Éligible",
    getPaidCtaLocked: "Encore {count}",
    getPaidCtaHint: "Audios validés",
    getPaidPage: {
      title: "Recevoir mes gains",
      subtitle: "Vérifiez votre éligibilité, complétez les étapes et suivez le statut de vos paiements.",
      workspaceTitle: "Espace contributeur",
      workspaceEarnings: "Gains",
      workspaceEarningsDescription: "Suivez votre éligibilité et vos paiements.",
      workspaceOverview: "Vue d’ensemble",
      workspaceOverviewDescription: "Éligibilité et gains",
      workspaceTest: "Test de qualification",
      workspaceTestDescription: "Valider votre accès aux gains",
      workspaceRequests: "Demandes de paiement",
      workspaceRequestsDescription: "Suivre vos demandes",
      workspaceContracts: "Contrats",
      workspacePendingContracts: "À signer",
      workspacePendingContractsDescription: "Contrats en attente de signature",
      workspaceSignedContracts: "Signés",
      workspaceSignedContractsDescription: "Historique des contrats signés",
      workspaceCollection: "Collecte",
      workspaceCollectionTitle: "Espace collecteur",
      workspaceCollectionDashboard: "Tableau de bord",
      workspaceCollectionDashboardDescription: "Vue d'ensemble de la collecte",
      workspaceCollectionProfiles: "Profils",
      workspaceCollectionProfilesDescription: "Profils communautaires",
      workspaceCollectionContributions: "Contributions",
      workspaceCollectionContributionsDescription: "Historique de la collecte",
      workspaceCollectionInitialAudio: "Audio initial",
      workspaceCollectionInitialAudioDescription: "Enregistrer des réponses audio aux questions initiales",
      workspaceCollectionAssistant: "Assistant",
      workspaceCollectionAssistantDescription: "Poser une question",
      workspaceCollectionGuidelines: "Politique",
      workspaceCollectionGuidelinesDescription: "Règles d'enregistrement",
      statusEligible: "Éligible au paiement",
      statusPending: "Encore {remaining} contribution(s) validée(s) pour être éligible",
      requirementsTitle: "Conditions d'éligibilité",
      requirementOne: "Atteindre {threshold} contributions validées",
      requirementTwo: "Respecter les règles de qualité des tâches (taux d'acceptation ≥ 80%)",
      requirementThree: "Avoir rempli vos informations de profil et de paiement",
      stepsTitle: "Étapes pour recevoir un paiement",
      steps: {
        review: "Vérifier vos contributions validées",
        submit: "Soumettre une demande via le formulaire de paiement",
        payout: "Recevoir la confirmation de l'équipe Umbaji"
      },
      documentsTitle: "Documents requis",
      documentsDescription: "Préparez une pièce d'identité valide et les informations pour le transfert (Mobile Money ou compte bancaire).",
      contactSupport: "Contacter le support",
      goToContributions: "Voir mes contributions",
      requestPayout: "Demander un paiement",
      earningsCard: {
        estimatedTitle: "Gain estimé",
        estimatedDescription: "Calculé à 5 F CFA par contribution validée au-delà du seuil.",
        remainingTitle: "Montant restant",
        remainingContributions: "Encore {count} contribution(s) validée(s) pour atteindre le seuil.",
        remainingDescription: "Les gains démarrent une fois le seuil atteint.",
        readyDescription: "Seuil atteint ! Les nouvelles contributions rapportent 5 F.",
      },
      completeProfile: "Compléter mes informations",
      profileDialog: {
        title: "Compléter mes informations de paiement",
        description: "Avant d'envoyer votre paiement, nous avons besoin de vos coordonnées.",
        amountLabel: "Montant estimé à verser",
        phoneLabel: "Numéro de téléphone (Mobile Money)",
        phonePlaceholder: "Ex. +228 90 00 00 00",
        providerLabel: "Opérateur ou banque",
        providerPlaceholder: "Sélectionnez un opérateur",
        accountNameLabel: "Nom du titulaire du compte",
        accountNamePlaceholder: "Nom figurant sur le compte",
        submit: "Envoyer mes informations",
        cancel: "Annuler",
        successTitle: "Informations enregistrées",
        successDescription: "Notre équipe vérifiera vos informations et vous contactera sous peu.",
        missingInfo: "Complétez ces informations pour accélérer votre paiement.",
        errorTitle: "Informations manquantes",
        errorDescription: "Merci de remplir toutes les informations obligatoires.",
      },
      helpText: "Besoin d'aide ? Notre équipe vous accompagne pour valider votre paiement.",
      lastUpdated: "Mise à jour : {date}",
      myPaymentRequests: "Mes demandes de paiement",
      noPaymentRequests: "Vous n'avez aucune demande de paiement",
      requestedOn: "Demandé le",
      paid: "Payée",
      paymentStatusPending: "En attente de validation",
      paymentStatusApproved: "Approuvée - En attente de paiement",
      paymentStatusRejected: "Rejetée",
      validatedLabel: "Validées",
      pendingLabel: "En attente",
      pointsLabel: "Contributions validées",
      step1Title: "Étape 1/3 : Attendre {threshold} audios validés",
      step1Completed: "✓ Étape 1 complétée !",
      step2Title: "Étape 2/3 : Passer le test de validation",
      step2Pending: "⏳ En attente du test",
      step2Approved: "✓ Test approuvé !",
      step3Title: "Étape 3/3 : Gagner sur les nouvelles contributions",
      eligibleCreateRequest: "Vous êtes éligible ! Créez votre première demande ci-dessus.",
      eligibleForTest: "Vous êtes éligible!",
      canNowTakeTest: "Vous pouvez maintenant passer au test",
      testEligibilityTitle: "Vous êtes éligible au test!",
      testEligibilityMessage: "Vous avez atteint le seuil requis pour passer le test de validation.",
      congratulations: "Félicitations!",
      testInstructionMessage: "Vous pouvez maintenant passer le test de validation. Une fois réussi, vous pourrez commencer à gagner des revenus sur vos contributions futures.",
      nextSteps: "Prochaines étapes:",
      languageRequiredTitle: "Langue requise",
      languageRequiredDesc: "Veuillez choisir la langue du test.",
      testLanguageLabel: "Langue du test",
      chooseLanguage: "Choisir la langue",
      loadingLanguages: "Chargement des langues...",
      noLanguagesAvailable: "Aucune langue disponible",
      noTestContributionLanguage: "Aucune langue de contribution détectée",
      noTestContributionLanguageDescription: "Le test est proposé uniquement dans les langues où vous avez réellement envoyé au moins un audio.",
      testLanguageProgress: "Progression dans cette langue : {validated}/{threshold} audios validés",
      testLanguageContributionSummary: "{total} audios envoyés dans cette langue, dont {validated} validés par la communauté.",
      testLanguageRemaining: "Encore {remaining} audio(s) validé(s) dans la langue {language} avant de pouvoir commencer le test.",
      testLanguageEligible: "Vous êtes éligible au test dans cette langue",
      testLanguageEligibleDescription: "Le seuil de 50 audios validés par la communauté est atteint. Vous pouvez commencer le test.",
      communityValidationRule: "Règle : chaque audio doit obtenir au moins 2 points de validation et plus de validations que de rejets. Un contributeur vaut 1 point ; un modérateur vaut 2 points.",
      testStatusPending: "En attente de correction",
      testStatusValidated: "Validé",
      testStatusRejected: "Refusé",
      statusLabel: "Statut:",
      testAlreadySubmittedSignature: "Test déjà soumis pour une langue. Contrat envoyé, en attente de signature.",
      testAlreadySubmittedFinal: "Test déjà soumis pour une langue. Contrat signé, en attente de validation finale.",
      noTestSubmitted: "Aucun test soumis pour cette langue.",
      noTranslationItems: "Aucun item de traduction n'est disponible pour cette langue.",
      noPendingTests: "Aucun test en attente de correction",
      noValidatedTests: "Aucun test corrigé",
      startTest: "Commencer le test",
      selectTestLanguage: "Sélectionnez la langue du test",
      testApproved: "Test approuvé.",
      newValidatedContributions: "Faites de nouvelles contributions validées pour débloquer la demande de paiement",
      passValidationTest: "Passez le test de validation pour commencer à gagner",
      eligibleEarnPerContribution: "Vous êtes éligible ! Gagnez {rate}F par audio validé",
      noModeratorTests: "Aucun test en attente de correction",
      noCorrectedTests: "Aucun test corrigé",
      loading: "Chargement...",
      noPendingPayoutRequests: "Aucune demande de paiement en attente",
      clickStartTestDesc: "Cliquez sur 'Commencer le test' pour passer l'examen",
      mustReachContributions: "Vous devez atteindre {threshold} contributions. Il vous en reste {remaining}.",
      noPayoutRequestsSent: "Aucune demande envoyée pour le moment.",
      myPayoutRequests: "Mes demandes",
      clickStartTestInstruction: "Cliquez sur 'Commencer le test' pour passer l'examen",
      reachThresholdMessage: "Atteignez {threshold} contributions validées. Encore {remaining} à faire.",
      earnPerAudioAfterDate: "Gagner {rate}F par audio validé après cette date",
      audiosEarnedSoFar: "Audios gagnés jusqu'à présent: {count}",
      alreadySubmittedLanguage: "Vous avez déjà une soumission pour cette langue",
      contractAwaitingSignature: "Vous avez déjà soumis ce test. Le contrat doit être signé avant la validation finale.",
      awaitingFinalValidation: "Vous avez déjà soumis ce test. La validation finale est en attente.",
      alreadyPendingRequest: "Vous avez déjà une demande en attente",
      step2TakesAbout10Minutes: "Le test prend environ 10 minutes",
      step2AnswerQuestions: "Répondez aux questions audio et texte",
      step2GetScoreAndEarn: "Obtenez une note et passez à la collecte de revenus",
      actionsTitle: "Actions de paiement",
      actionsDescription: "Choisissez la langue du test, gérez vos contrats et envoyez votre demande de paiement.",
      refreshContracts: "Actualiser",
      signContract: "Signer le contrat",
      viewSignedContract: "Voir le contrat signé",
      myContracts: "Mes contrats",
      contractSignatureBlocked: "Tant que ce contrat n'est pas signé, votre validation finale reste bloquée.",
      newValidatedAfterTest: "Nouvelles contributions validées après test ({language}) : {count}",
      earnAfterTestApproval: "Gagnez après approbation du test",
      pendingRequestAmount: "{amount} en demande d’attente",
      availableAmount: "Montant disponible : {amount}",
      amountPlaceholder: "Ex. 10000",
    },
    upload: "Télécharger",
    save: "Enregistrer",
    label: "Étiquette",
    validate: "Valider",
    validateDescription: "Validez les contributions de la communauté",
    displayImage: "Afficher l'image",
    imageDisplayed: "Image affichée",
    dropAudio: "Déposez l'audio ici - ou - Cliquez pour télécharger un fichier",    // Contribution Page Content
    contributionSpaceTitle: "Espace de Contribution",
    contributionSpaceSubtitle: "Aidez à construire l'avenir de l'intelligence artificielle pour les langues ouest-africaines. Chaque contribution compte pour préserver notre patrimoine linguistique.",
    thanksForContributing: "Merci de contribuer à l'IA africaine",
    audioRecordings: "Enregistrements Audio",
    imageLabeling: "Étiquetage Images",
    audioRecordingsDesc: "Enregistrez des mots et phrases en langues ouest-africaines pour entraîner les modèles de reconnaissance vocale",
    imageLabelingDesc: "Étiquetez des caractères d'alphabet pour améliorer la reconnaissance optique de caractères (OCR)",
    dailyGoal: "Objectif journalier",
    yourProgress: "Votre progression",
    pointsEarned: "Points gagnés",
    community: "Communauté",
    achievements: "Succès & Récompenses",
    yourImpact: "Votre Impact",
    totalContributions: "Contributions totales",
    audio: "Audio",
    images: "Images",
    languagesContributed: "Langues contribuées :",
    noneYet: "Aucune pour l'instant",
    readyToMakeDifference: "Prêt à faire la différence ?",
    contributionImpactDesc: "Vos contributions aideront des millions de personnes à accéder aux technologies d'IA dans leur langue maternelle. Commencez dès maintenant et rejoignez une communauté passionnée !",
    languages: "Langues",
    contributors: "Contributeurs",
    data: "Données",
    myContributionSummary: "Suivi des contributions",
    myContributionSummaryDescription: "Consultez vos envois, vos validations et votre progression",
    myContributionsPage: {
      title: "Mes contributions",
      subtitle: "Analysez vos envois, vos validations et votre progression vers les récompenses.",
      totalSubmitted: "Contributions envoyées",
      totalApproved: "Validées",
      totalPending: "En attente",
      totalPoints: "Contributions au total",
      payoutProgressTitle: "Progression vers le paiement",
      payoutProgressDescription: "Atteignez {threshold} contributions validées pour pouvoir demander un paiement.",
      payoutEligible: "Félicitations ! Vous pouvez demander un paiement.",
      payoutMissing: "Encore {remaining} contribution(s) validée(s) avant d'être éligible.",
      payoutCta: "Demander un paiement",
      continueContributing: "Continuer à contribuer",
      tableTitle: "Détail par type de contribution",
      tableHeaders: {
        category: "Catégorie",
        submitted: "Soumises",
        approved: "Validées",
        pending: "En attente",
        rejected: "Rejetées",
        points: "Points"
      },
      statusBadges: {
        approved: "Validé",
        pending: "En attente",
        rejected: "Rejeté"
      },
      recentActivityTitle: "Activité récente",
      playAudio: "Écouter l'audio",
      audioPlayErrorTitle: "Lecture impossible",
      audioPlayError: "L'audio n'a pas pu être lu. Réessayez dans un instant.",
      audioPlayForbidden: "Vous n'avez pas accès à cet audio.",
      noActivity: "Aucune contribution enregistrée pour le moment.",
      lastUpdated: "Dernière mise à jour : {date}",
      eligibilityLabel: "Éligibilité",
      contributionGoalLabel: "Objectif",
      totalHours: "Heures estimées",
      seeTasks: "Voir les tâches disponibles",
      statsLoadError: "Erreur",
      statsLoadErrorDesc: "Impossible de charger vos statistiques. Veuillez réessayer.",
      refresh: "Actualiser",
      loadingStats: "Chargement de vos statistiques...",
      totalContributionsLabel: "Total contributions",
      uploadedAudioLabel: "Audio uploadé",
      validatedTranscriptionsLabel: "Transcriptions validées",
      submittedValidationLabel: "Soumises pour validation",
      contributionsLabel: "Contributions",
      contributionsCaption: "Vos contributions personnelles",
      audioCaption: "Clips audio envoyés à la plateforme",
      validatedCaption: "Transcriptions relues avec succès",
      moderationLabel: "Modération",
      moderationCaption: "Relectures effectuées sur d'autres contenus",
      activityEyebrow: "Votre activité",
      earningEyebrow: "Parcours de gain",
      detailEyebrow: "Détail",
      byLanguageEyebrow: "Par langue",
      recordingDurationLabel: "Durée d'enregistrement",
      recordingDurationCaption: "Temps total enregistré",
      journeyStep1: "Audios validés",
      journeyStep2: "Test de précision",
      journeyStep3: "Gains actifs",
      journeyHint: "50 audios validés, puis test de précision, puis gains",
      journeyDone: "Étape franchie",
      journeyRemaining: "Encore {remaining} pour débloquer le test",
      journeyReachedTitle: "Seuil atteint !",
      journeyReachedDesc: "Vous avez atteint {threshold} audios validés. Passez le test de précision pour débloquer vos gains.",
      journeyStartTest: "Passer le test",
      journeyGainsKicker: "Gains actifs",
      journeyAvailableLabel: "Gains disponibles",
      journeyAudiosAfterTestLabel: "Audios validés après le test",
      journeyRateLabel: "Taux par audio",
      journeyAccumulatedLabel: "Gains accumulés",
      journeyPendingNotice: "Versement en cours — {amount} F",
      journeyReadyLabel: "Vous pouvez demander un paiement",
      journeyContinueLabel: "Continuez à contribuer pour gagner",
      journeyCtaWithdraw: "Demander mon paiement",
      journeyCtaDetails: "Voir mes gains",
      audioPanelTitle: "Audio",
      transcriptionPanelTitle: "Transcription",
      validationPanelTitle: "Résumé de validation",
      rowUploaded: "Uploadé",
      rowAccepted: "Accepté",
      rowRejected: "Rejeté",
      rowSubmitted: "Soumise",
      rowValidated: "Validée",
      rowDuration: "Durée totale",
      rowValidatedAudio: "Audios validés",
      rowRejectedAudio: "Audios rejetés",
      rowValidatedTranscriptions: "Transcriptions validées",
      rowRejectedTranscriptions: "Transcriptions rejetées",
      emptyTitle: "Aucune contribution pour l'instant",
      emptyDescription: "Commencez à contribuer pour voir vos statistiques apparaître ici.",
      retry: "Réessayer",
      ctaContribute: "Contribuer",
      ctaWithdraw: "Retirer mes gains",
      ctaValidate: "Valider des contenus",
      ctaContributeDesc: "Enregistrez de nouveaux audios",
      ctaWithdrawDesc: "Demandez le paiement de vos gains",
      ctaValidateDesc: "Relisez les contenus de la communauté",
      profileEyebrow: "Profil de contribution",
      radarEmpty: "Pas encore assez de données",
      radarAudio: "Audio",
      radarAccepted: "Accepté",
      radarTranscription: "Transcription",
      radarValidated: "Validé",
      radarModeration: "Modération",
      radarDuration: "Durée",
      paginationRange: "{start}-{end} sur {total}",
      flowEyebrow: "Flux d'acceptation",
      flowAccepted: "Accepté",
      flowRejected: "Rejeté",
      flowPending: "En attente",
      flowEmpty: "Pas encore d'historique"
    },

    // SpeakContribute Page - Missing keys
    speakContributeTitle: "Session d'Enregistrement",
    speakContributeSubtitle: "Aidez à améliorer la reconnaissance vocale en enregistrant quelques phrases",
    phrasesToRead: "Phrases à lire",
    minutesRequired: "Minutes requises",
    sessionPointsEarned: "Points gagnés",
    instructionsTitle: "Instructions :",
    speakInstruction1: "Lisez chaque phrase clairement et naturellement",
    speakInstruction2: "Assurez-vous d'être dans un environnement silencieux",
    speakInstruction3: "Vous pouvez réécouter et refaire l'enregistrement si nécessaire",
    speakInstruction4: "Prenez votre temps, la qualité est plus importante que la vitesse",
    startSession: "Commencer la session",
    sessionRecording: "Session d'enregistrement",
    sentenceXofY: "Phrase {current} sur {total}",
    percentCompleted: "{percent}% complété",
    toRead: "À lire",
    phraseDomain: "Domaine",
    phraseFileOrder: "N° dans le fichier",
    phraseId: "ID",
    initialDataReview: {
      setup: {
        prepareEyebrow: "Préparer la session",
        transcriptionTitle: "Langue",
        reviewTitle: "Langue et contenu",
        typeLabel: "Contenu à relire",
        typeAudio: "Transcriptions audio",
        typeAudioHint: "Écoutez et jugez les transcriptions proposées",
        typeText: "Réponses écrites",
        typeTextHint: "Relisez les réponses saisies en texte",
        waiting: "{count} en attente",
        instructionsTitle: "Consignes",
        transcriptionInstruction1: "Écoutez la réponse en entier avant d'écrire.",
        transcriptionInstruction2: "Écrivez exactement ce qui est dit, dans la langue parlée, sans traduire.",
        transcriptionInstruction3: "La traduction française est facultative.",
        transcriptionInstruction4: "Passez un audio inaudible ou que vous ne comprenez pas.",
        reviewInstruction1: "Comparez chaque proposition à l'audio ou à la question posée.",
        reviewInstruction2: "Validez une proposition juste ; sinon rejetez-la en donnant un motif.",
        reviewInstruction3: "Corrigez quand vous connaissez le texte juste.",
        reviewInstruction4: "Vos propres réponses et transcriptions ne vous sont jamais proposées.",
        back: "Retour",
        start: "Commencer la session",
        changeSetup: "Changer de langue",
      },
      subNav: {
        label: "Données initiales",
        audio: "Audio initial",
        text: "Texte initial",
        transcription: "Transcription",
        review: "Relecture",
      },
      eyebrow: "Données initiales",
      languageLabel: "Langue",
      languagePlaceholder: "Choisissez une langue",
      noLanguage: "Aucune de vos langues de contribution n'est disponible ici. Ajoutez-en une dans vos paramètres.",
      ownDataNote: "Vous ne travaillez jamais sur vos propres réponses ni sur celles que vous avez collectées.",
      loading: "Chargement…",
      retry: "Réessayer",
      reload: "Recharger",
      skip: "Passer",
      cancel: "Annuler",
      questionLabel: "Question posée",
      remaining: "{count} en attente",
      hub: {
        toTranscribe: "Audios à transcrire",
        audioToReview: "Transcriptions à relire",
        textToReview: "Textes à relire",
      },
      transcription: {
        title: "Transcription des données initiales",
        subtitle: "Écoutez la réponse enregistrée et écrivez exactement ce qui est dit, dans la langue parlée.",
        textRequired: "Écrivez la transcription avant d'envoyer (2000 caractères au maximum).",
        previousRejections: "Vos transcriptions précédentes de cet audio ont été rejetées :",
        emptyTitle: "Aucun audio à transcrire",
        emptyBody: "Tous les audios de cette langue sont transcrits ou réservés par d'autres contributeurs. Revenez plus tard.",
      },
      review: {
        title: "Relecture des données initiales",
        subtitle: "Validez, rejetez ou corrigez les transcriptions et les réponses écrites des autres contributeurs.",
        tabAudio: "Audio",
        tabText: "Texte",
        candidatesLabel: "Propositions",
        answerLabel: "Réponse écrite",
        original: "Texte d'origine",
        correction: "Correction",
        votes: "{validations} validation(s) · {rejections} rejet(s)",
        selectCandidate: "Choisissez la proposition à évaluer.",
        accept: "Valider",
        reject: "Rejeter",
        correct: "Corriger",
        reasonLabel: "Motif du rejet",
        reasonPlaceholder: "Expliquez brièvement ce qui ne va pas",
        reasonHint: "Entre 3 et 300 caractères.",
        correctionLabel: "Texte corrigé",
        correctionPlaceholder: "Écrivez le texte juste",
        correctionHint: "Le texte corrigé doit être différent de la proposition (2000 caractères au maximum).",
        confirmReject: "Confirmer le rejet",
        confirmCorrect: "Envoyer la correction",
        correctionsLeft: "{count} correction(s) encore possible(s)",
        noCorrectionLeft: "Le nombre maximal de corrections est atteint.",
        gatedCorrection: "Corriger un audio compte comme une contribution : la validation croisée s'applique.",
        emptyAudioTitle: "Aucune transcription à relire",
        emptyTextTitle: "Aucun texte à relire",
        emptyBody: "Rien n'attend votre relecture dans cette langue pour le moment. Revenez plus tard.",
      },
      gate: {
        blockedTitle: "Validation croisée requise",
        blockedBody: "Vous devez relire le travail des autres avant de transcrire à nouveau. Valider ou rejeter ici compte pour votre déblocage.",
        goReview: "Aller à la relecture",
      },
      success: {
        INITIAL_AUDIO_TRANSCRIPTION_ADDED: "Transcription envoyée.",
        INITIAL_AUDIO_TRANSCRIPTION_VALIDATED: "Transcription validée.",
        INITIAL_AUDIO_TRANSCRIPTION_REJECTED: "Transcription rejetée.",
        INITIAL_AUDIO_TRANSCRIPTION_CORRECTED: "Correction envoyée.",
        INITIAL_TEXT_ACCEPTED: "Texte validé.",
        INITIAL_TEXT_REJECTED: "Texte rejeté.",
        INITIAL_TEXT_CORRECTION_PROPOSED: "Correction proposée.",
        finalized: "La transcription a atteint le nombre de validations requis.",
        textClosedAccepted: "La réponse est validée par la communauté.",
        textClosedRejected: "La réponse est transmise à un administrateur pour décision.",
      },
      errorTitle: "Action impossible",
      loadError: "Impossible de charger les éléments.",
      errors: {
        DEFAULT: "Une erreur est survenue. Réessayez dans un instant.",
        INITIAL_DATA_LANGUAGE_NOT_ALLOWED: "Cette langue ne fait pas partie de vos langues de contribution.",
        INITIAL_DATA_OWN_ITEM: "Vous ne pouvez pas travailler sur vos propres données.",
        CROSS_VALIDATION_REQUIRED: "Effectuez des validations croisées avant de contribuer à nouveau.",
        INITIAL_DATA_ITEM_NOT_FOUND: "Cet élément n'existe plus.",
        INITIAL_DATA_CANDIDATE_NOT_FOUND: "Cette proposition n'existe plus.",
        INITIAL_DATA_NOT_REVIEWABLE: "Cet élément n'est plus à relire.",
        INITIAL_DATA_ALREADY_REVIEWED: "Vous avez déjà donné votre avis sur cet élément.",
        INITIAL_DATA_TRANSCRIPTION_DUPLICATE: "Ce texte a déjà été proposé pour cet audio.",
        INITIAL_TEXT_CORRECTION_LIMIT: "Le nombre maximal de corrections est atteint pour cette réponse.",
        INITIAL_TEXT_CORRECTION_UNCHANGED: "La correction doit être différente du texte proposé.",
        CONFLICT: "D'autres relecteurs agissent en même temps. Réessayez.",
        VALIDATION_FAILED: "La demande est invalide. Vérifiez les champs saisis.",
        UNAUTHORIZED: "Votre session a expiré. Reconnectez-vous.",
        FORBIDDEN: "Vous n'avez pas accès à cette action.",
        NOT_FOUND: "Ressource introuvable.",
        INTERNAL_SERVER_ERROR: "Le service est momentanément indisponible.",
      },
    },
    phraseListErrors: {
      DEFAULT: "Impossible de charger les phrases pour cette langue.",
      VALIDATION_FAILED: "Paramètres de chargement invalides.",
      UNAUTHORIZED: "Votre session a expiré. Reconnectez-vous.",
      FORBIDDEN: "Vous n'avez pas accès à ces phrases.",
      NOT_FOUND: "Aucune donnée trouvée pour cette langue.",
      INTERNAL_SERVER_ERROR: "Le service des phrases est momentanément indisponible.",
    },
    readPhraseClearly: "Lisez cette phrase clairement et naturellement",
    startRecording: "Commencer l'enregistrement",
    pauseRecording: "Mettre en pause",
    resumeRecording: "Reprendre l'enregistrement",
    stopRecording: "Arrêter l'enregistrement",
    recordingSuccessful: "Enregistrement réussi !",
    previous: "Précédent",
    next: "Suivant",
    sessionProgress: "Progression de la session",
    sessionInProgress: "En cours",
    completed: "Terminé",
    waiting: "En attente",
    recordPhraseFirst: "Veuillez enregistrer la phrase avant de continuer",
    allPhrasesCompleted: "Félicitations ! Vous avez complété toutes les phrases.",
    chooseLanguageToRecord: "Choisissez la langue d'enregistrement",
    fileUrl: "URL du fichier",
    fileUrlPlaceholder: "Collez ici l'URL du fichier (Cloudinary)",
    reRecordMode: "Réenregistrement",
    translationLabel: "Traduction :",
    noFrenchTranslation: "Cette phrase n'a pas de traduction en français.",
    editAddFrenchTranslation: "Éditer/Ajouter la traduction française",
    addFrenchTranslation: "Ajouter la traduction française",
    noLocalTranslation: "Cette phrase n'a pas encore de texte en langue locale. Vous pouvez la traduire avant d'enregistrer.",
    editTranslatePhrase: "Éditer/Traduire cette phrase",
    translatePhrase: "Traduire cette phrase",
    optionalHint: "Optionnel — vous pouvez aussi enregistrer directement.",
    editPhraseAndTranslation: "Éditer cette phrase et sa traduction",
    editLocalPhrase: "Éditer la phrase locale",
    hideKeyboard: "Masquer le clavier",
    openAfricanKeyboard: "Ouvrir le clavier africain",
    cancel: "Annuler",
    phraseModified: "Modifié",
    phraseModifiedDesc: "La phrase a été mise à jour avec succès.",
    phraseUpdateError: "Erreur",
    phraseUpdateErrorDesc: "Impossible de mettre à jour la phrase.",
    connectionRequired: "Connexion requise",
    connectionRequiredDesc: "Veuillez vous connecter pour continuer.",
    noPhraseAvailableDesc: "Aucune phrase n'est disponible pour cette page.",
    phraseMissing: "Phrase manquante",
    phraseMissingDesc: "Vous devez fournir au moins une phrase (locale ou française).",
    durationMissing: "Durée manquante",
    durationMissingDesc: "La durée de l'enregistrement n'a pas pu être capturée. Veuillez réessayer.",
    uploadSuccess: "Parfait !",
    uploadSuccessAnonymized: "Audio envoyé et anonymisé avec succès",
    uploadSuccessWithTime: "Audio envoyé avec succès ({time}s)",
    sessionComplete: "Session terminée",
    sessionCompleteDesc: "Toutes les phrases ont été enregistrées.",
    genericError: "Erreur",
    localSaved: "Enregistré",
    localSavedDesc: "Phrase locale mise à jour",
    localSaveError: "Erreur",
    localSaveErrorDesc: "Échec de la mise à jour",
    noMorePhrases: "Aucune phrase supplémentaire",
    noMorePhrasesDesc: "Aucune nouvelle phrase n'est actuellement disponible pour cette langue et ce contributeur.",
    skipPhrase: "Passer cette phrase",
    phraseSkipped: "Phrase passée",
    phraseSkippedDesc: "Passé à la phrase suivante",
    loadingNewPhrases: "Chargement de nouvelles phrases...",
    audioskipped: "Audio passé",
    audioskippedDesc: "Passé au prochain audio",
    loadingNewAudios: "Chargement de nouveaux audios...",
    noMoreAudios: "Plus d'audios",
    noMoreAudiosDesc: "Aucun autre audio disponible pour le moment",
    loadError: "Erreur de chargement",
    // Model Performance / Assessment labels
    taskLabel: "Tâche",
    modelNameLabel: "Nom du modèle",
    startAssessment: "Commencer l'évaluation",
    modelPerformancePage: {
      selectTaskPlaceholder: "Sélectionner une tâche...",
      selectModelPlaceholder: "Sélectionner un modèle...",
      selectLanguagePlaceholder: "Choisir une langue...",
      taskOptions: {
        TTS: "TTS (Synthèse vocale)",
        ASR: "ASR (Reconnaissance vocale)",
        Text: "Texte (Génération de texte)"
      },
      taskBadges: {
        TTS: "🎤 Évaluation TTS",
        ASR: "🎧 Évaluation ASR",
        Text: "📝 Évaluation Texte"
      },
      taskDescriptions: {
        TTS: "Comparez l'audio généré par le modèle avec l'enregistrement original (ground truth). Évaluez la qualité, le naturel et la prononciation.",
        ASR: "Comparez les transcriptions générées avec le texte de référence (ground truth). Évaluez l'exactitude et la lisibilité.",
        Text: "Comparez le texte généré avec le texte de référence. Évaluez la cohérence, l'exactitude et la qualité."
      },
      availableModels: "{count} modèle(s) disponible(s) pour {task}",
      loadSuccessTitle: "✓ Échantillons chargés",
      loadSuccessDescription: "Échantillons chargés pour {model}",
      loadingError: "Erreur de chargement",
      fillAllFields: "Veuillez remplir tous les champs",
      rateAllCriteria: "Veuillez évaluer tous les critères",
      saveFailed: "Échec de l'enregistrement",
      userRequired: "Authentification requise",
      assessmentSavedTitle: "✓ Évaluation enregistrée",
      assessmentSavedTtsDescription: "Score global : {score}/5",
      assessmentSavedTextDescription: "Précision : {accuracy}% | Lisibilité : {readability}/5",
      sessionCompleteTitle: "🎉 Session terminée",
      sessionCompleteTTS: "{count} évaluations TTS effectuées",
      sessionCompleteGeneric: "{count} évaluations {task} effectuées",
      sessionMeta: "Langue : {language} | Modèle : {model}",
      taskNames: {
        TTS: "TTS",
        ASR: "ASR",
        Text: "Texte"
      },
      textToEvaluateTitle: "Texte à évaluer",
      audioOriginalTitle: "🎤 Audio original",
      audioGeneratedTitle: "🤖 Audio généré",
      humanEvaluationTitle: "Évaluation humaine",
      qualityRatingLabel: "Qualité globale",
      naturalnessLabel: "Naturel",
      pronunciationLabel: "Prononciation",
      commentsLabel: "Commentaires (optionnel)",
      commentsPlaceholderTts: "Remarques sur la qualité audio...",
      statsAssessmentsLabel: "Évaluations",
      statsCurrentScoreLabel: "Score actuel",
      ttsHeaderTitle: "Évaluation TTS",
      asrHeaderTitle: "Évaluation ASR",
      textHeaderTitle: "Évaluation Texte",
      referenceAudioTitle: "Audio de référence",
      audioUnsupported: "Votre navigateur ne supporte pas l'élément audio.",
      textGroundTruthTitle: "✓ Transcription de référence",
      textGeneratedTitle: "🤖 Texte généré",
      diffTitle: "Comparaison mot à mot",
      diffLegendMatch: "Identique",
      diffLegendDifferent: "Différent",
      diffLegendMissing: "Manquant",
      expertEvaluationTitle: "Évaluation humaine par experts",
      transcriptionAccuracyLabel: "Exactitude de la transcription",
      accuracyCorrect: "Correct",
      accuracyPartial: "Partiel",
      accuracyIncorrect: "Incorrect",
      readabilityLabel: "Lisibilité (1-5)",
      commentsPlaceholderText: "Remarques sur la qualité de transcription...",
      accuracyBadge: "Précision : {value}%",
      statsAccuracyLabel: "Précision",
      statsReadabilityLabel: "Lisibilité",
      readabilityValue: "{value}/5",
      noPhraseAvailableDb: "Aucune phrase disponible dans la base de données.",
      noPhraseAvailableTotal: "Aucune phrase disponible (Total dans DB: {total}).",
      warningTitle: "Attention",
      noValidPhraseAfterFilter: "Aucune phrase valide après filtrage.",
      loadingLanguages: "Chargement des langues...",
      noLanguagesAvailable: "Aucune langue disponible",
      phraseToSynthesizeTitle: "Phrase à synthétiser",
      generatingAudio: "Génération en cours...",
      generateAudio: "Générer l'audio",
      generatedModelAudioTitle: "Audio généré par le modèle",
      asrInputModeTitle: "Mode de saisie",
      asrRecordMode: "Lecture (micro)",
      asrTextMode: "Synthèse (TTS)",
      asrAudioMode: "Fichier (URL)",
      asrReferenceTextLabel: "Texte à lire (référence)",
      asrReferenceTextPlaceholder: "Entrez le texte que vous allez lire...",
      recordingInProgress: "Enregistrement en cours...",
      stopRecording: "Arrêter",
      restartRecording: "Recommencer",
      recordAudio: "Enregistrer",
      audioReadyForTranscription: "Audio prêt pour la transcription",
      asrTextInputLabel: "Saisissez le texte à transcrire",
      asrTextInputPlaceholder: "Entrez votre texte ici...",
      asrTextInputHint: "Le texte sera converti en audio puis transcrit par le modèle ASR",
      importAudioFile: "Importer un fichier audio",
      supportedAudioFormats: "Formats supportés : WAV, MP3, M4A...",
      audioUrlLabel: "Ou saisir une URL",
      referenceTextOptional: "Texte de référence (optionnel)",
      referenceTextPlaceholder: "Texte attendu pour comparer avec la transcription...",
      transcribing: "Transcription en cours...",
      transcribe: "Transcrire",
      transcriptionResultTitle: "Résultat de la transcription",
      comparisonTitle: "Comparaison",
      referenceLabel: "Référence",
      transcriptionLabel: "Transcription",
      errorDetailsLabel: "Détail des erreurs",
      diffCorrect: "Correct",
      diffSubstitution: "Substitution",
      diffInsertion: "Insertion",
      diffDeletion: "Suppression",
      referenceAudioLabel: "Audio de référence",
      pageLabel: "Page",
      microphoneError: "Impossible d'accéder au microphone",
      audioGeneratedSuccess: "Succès",
      audioGeneratedDesc: "Audio généré avec succès",
      audioGenerationError: "Erreur lors de la génération de l'audio",
      modelLangNotSupported: "Le modèle sélectionné ne supporte pas cette langue. Vérifiez les langues prises en charge par le modèle.",
      transcriptionSuccess: "Succès",
      transcriptionSuccessDesc: "Transcription effectuée avec succès",
      transcriptionError: "Erreur lors de la transcription",
      pageCompleteTitle: "Page terminée !",
      pageCompleteDesc: "Vous avez évalué {count} phrases. Chargement de la page suivante...",
      newPageLoaded: "Nouvelle page chargée",
      newPageLoadedDesc: "Page {page} - 10 nouvelles phrases à évaluer",
      sessionCompleteDesc: "Félicitations ! Vous avez terminé toutes les évaluations disponibles ({count} phrases).",
      fileTranscriptionError: "Échec de la transcription du fichier",
      nextPageError: "Erreur lors du chargement de la page suivante",
    },

    // ValidateContribute Page - Missing keys
    validateContributeTitle: "Session de Validation",
    validateContributeSubtitle: "Aidez à améliorer la reconnaissance optique en validant des caractères",
    imagesToValidate: "Images à valider",
    validateInstruction1: "Observez attentivement chaque caractère manuscrit",
    validateInstruction2: "Sélectionnez le caractère qui correspond le mieux à l'image",
    validateInstruction3: "Ne vous inquiétez pas si vous n'êtes pas sûr, votre opinion compte",
    validateInstruction4: "Vous pouvez passer une image si elle est illisible",
    startValidation: "Commencer la validation",
    sessionValidation: "Session de validation",
    imageXofY: "Image {current} sur {total}",
    toIdentify: "À identifier",
    whatCharacterDoYouSee: "Quel caractère voyez-vous dans cette image ?",
    selectCharacter: "Sélectionnez le caractère",
    selectedCharacter: "Caractère sélectionné:",
    validateAndContinue: "Valider et continuer",
    finishSession: "Terminer la session",
    skip: "Passer",
    currentAccuracy: "Précision actuelle: {accuracy}%",

    // NotFound Page - Missing keys  
    notFound: {
      title: "La page que vous recherchez n'existe pas ou a été déplacée.",
      pathLabel: "Chemin recherché :",
      whereTo: "Où souhaitez-vous aller ?",
      previousPage: "Page précédente",
      didYouKnow: "Le saviez-vous ?",
      helpAI: "Aider l'IA africaine",
      joinMovement: "Rejoindre le mouvement",
      explore: "Explorer",
      discoverLanguages: "Découvrir les langues"
    },

    // Moderator Panel
    moderatorPanel: {
      title: "Panel de Modération",
      subtitle: "Validez les contributions et les tests des utilisateurs",
      audioValidation: "Validation Audio",
      testValidation: "Validation Tests",
      pendingAudios: "Audios en attente",
      pendingTests: "Tests en attente",
      noPendingAudios: "Aucun audio en attente",
      noPendingTests: "Aucun test en attente",
      validate: "Valider",
      reject: "Rejeter",
      score: "Note",
      submitScore: "Valider la note",
      unknownUser: "Utilisateur inconnu",
      submittedOn: "Soumis le {date}",
      originalText: "Texte original",
      audio: "Audio",
      answers: "Réponses",
      refresh: "Actualiser",
      allCaughtUp: "Tout est à jour !",
      allCaughtUpDesc: "Aucun élément en attente de validation.",
      chooseLanguage: "Choisir une langue",
      validationSuccess: "Validé",
      rejectionSuccess: "Rejeté",
      processingSuccess: "L'audio a été traité avec succès",
      errorLoading: "Impossible de charger les données",
      errorProcessing: "Échec du traitement",
      audioValidationDesc: "Écouter, valider ou rejeter les audios en attente.",
      testValidationDesc: "Corriger les tests soumis par les contributeurs.",
      phrasesReadForReview: "{count} phrases lues. Vérifiez-les, puis cliquez sur « Importer les phrases » pour les enregistrer.",
      importsTab: "Imports",
      importsDesc: "Créer les définitions de tests et les phrases locales.",
      importsTitle: "Imports - Création de tests",
      paymentTab: "Paiement",
      paymentDesc: "Demander une numérotation et suivre vos demandes.",
      paymentDescription: "Demandez votre numérotation pour recevoir les paiements.",
      activateKeyboard: "Activer clavier à l'écran",
      phonemesLabel: "Phonèmes (séparés par virgule ou nouvelle ligne)",
      testPhrasesLabel: "Phrases de test",
      addPhrase: "Ajouter",
      localTextPlaceholder: "Texte local",
      frenchTranslationPlaceholder: "Traduction française",
      importTests: "Importer les tests",
      reset: "Réinitialiser",
      success: "Succès",
      definitionImported: "Définition importée.",
      error: "Erreur",
      errorImportingDefinition: "Impossible d'importer la définition",
      errorLoadingAudios: "Impossible de charger les audios",
      errorLoadingTests: "Impossible de charger les tests",
      reasonRequired: "Raison requise",
      rejectAudioReasonRequired: "Ajoutez une raison claire avant de rejeter cet audio.",
      rejectTestReasonRequired: "Ajoutez une raison claire avant de rejeter ce test.",
      validated: "Validé",
      rejected: "Rejeté",
      audioProcessed: "L'audio a été traité avec succès",
      processingFailed: "Échec du traitement",
      testModerated: "Test modéré avec succès",
      errorModeratingTest: "Impossible de modérer le test",
      rejectionReasonPlaceholder: "Raison du rejet si nécessaire",
      amountPlaceholder: "Montant (XOF)",
      phonePlaceholder: "Numéro de téléphone",
      notePlaceholder: "Note (optionnel)",
      sendRequest: "Envoyer la demande",
      sending: "Envoi...",
      myRequests: "Mes demandes",
      noRequests: "Aucune demande trouvée.",
      monthlyPlanUnavailable: "Forfait mensuel indisponible",
      monthlyPlanUnavailableDesc: "Les paiements modérateur ne sont disponibles que le dernier jour du mois.",
      moderatorAlreadyPaid: "Déjà payé ce mois-ci",
      existingRequestOrPayment: "Demande ou paiement existant",
      requestSendFailed: "Impossible d'envoyer la demande.",
      phrasesTab: "Phrases",
      phrasesDesc: "Importer et corriger les phrases en langue locale.",
      payoutReview: {
        tab: "Demandes de paiement",
        description: "Approuvez ou rejetez les demandes de paiement des contributeurs avant le versement.",
        statusFilter: "Statut",
        statuses: { PENDING: "En attente", APPROVED: "Approuvées", REJECTED: "Rejetées", PAID: "Payées" },
        requestedAmount: "Montant demandé",
        remainingAmount: "Reste à payer",
        payoutNumber: "Numéro de paiement",
        submittedOn: "Demandée le {date}",
        notePlaceholder: "Motif du rejet (obligatoire pour rejeter)",
        noteRequiredHint: "Indiquez un motif pour rejeter cette demande.",
        moderatorNote: "Note du modérateur",
        approve: "Approuver",
        reject: "Rejeter",
        approvedToast: "Demande approuvée, elle part au paiement.",
        rejectedToast: "Demande rejetée, le contributeur sera informé.",
        errorTitle: "Décision non enregistrée",
        decisionForbidden: "Vous ne pouvez pas décider de cette demande.",
        notPending: "Cette demande a déjà été traitée. La liste a été actualisée.",
        noteRequired: "Le motif est obligatoire et limité à 500 caractères.",
        decisionFailed: "Impossible d'enregistrer la décision. Réessayez.",
        loadError: "Impossible de charger les demandes de paiement.",
        loadErrorHint: "Vérifiez votre connexion, puis réessayez.",
        retry: "Réessayer",
        emptyTitle: "Aucune demande ici",
        emptyDescription: "Aucune demande de paiement ne correspond à ce statut.",
      },
      phrasesImportTitle: "Import des Phrases",
      downloadTemplate: "Télécharger le template",
      templateDescription: "Téléchargez le template Excel pour ajouter vos phrases",
      downloadTemplateBtn: "Télécharger Template",
      uploadExcel: "Importer le fichier Excel",
      uploadDescription: "Sélectionnez votre fichier Excel rempli",
      importedPhrases: "Phrases importées",
      french: "Français",
      actions: "Actions",
      edit: "Éditer",
      save: "Enregistrer",
      clear: "Effacer",
      importPhrases: "Importer les phrases",
      downloading: "Téléchargement...",
    },

    // Common
    back: "Retour",
    submit: "Soumettre",
    submitting: "Envoi…",

    // Achievements
    firstSteps: "Premiers pas",
    firstStepsDesc: "Première contribution",
    polyglot: "Polyglotte",
    polyglotDesc: "5 langues différentes",
    champion: "Champion",
    championDesc: "100 contributions",
    expert: "Expert",
    expertDesc: "500 contributions",
    unlocked: "Débloqué",
    locked: "Verrouillé",

    // Data Policy
    dataPolicyTitle: "Politique de Données - Umbaji",
    dataPolicySubtitle: "Chez Umbaji, nous attachons une grande importance à la confidentialité et à la confiance de nos utilisateurs et contributeurs. Notre politique de données est conçue pour garantir que toutes les données personnelles et contributions sont traitées avec transparence et respect, et en accord avec les objectifs de bien social et de développement communautaire. En participant à la communauté Umbaji, les utilisateurs et contributeurs acceptent les termes suivants concernant la collecte, l'utilisation et la gestion des données.",

    // 1. Objectif de la Collecte de Données
    dataPolicyDataCollection: "1. Objectif de la Collecte de Données",
    dataPolicyDataCollectionDesc: "Umbaji collecte et utilise des données afin de :",
    dataPolicyObjective1: "Développer et améliorer les modèles d'IA destinés à bénéficier aux communautés au Togo et à travers l'Afrique.",
    dataPolicyObjective2: "Construire des solutions d'IA open-source, garantissant le développement technologique au niveau local et régional.",
    dataPolicyObjective3: "Remédier à la rareté des données pour les applications d'IA axées sur le contexte africain.",
    dataPolicyObjective4: "Permettre des expériences personnalisées pour les services commerciaux, facilitant l'amélioration des services et un meilleur support client.",

    // 2. Utilisation des Données
    dataPolicyDataUsage: "2. Utilisation des Données",
    dataPolicyDataUsageDesc: "Les données collectées par Umbaji sont utilisées pour :",
    dataPolicyUsagePoint1: "Entraîner et améliorer des modèles d'IA vocale et textuelle pour les langues africaines sous-représentées.",
    dataPolicyUsagePoint2: "Développer des solutions technologiques open-source accessibles aux communautés locales.",
    dataPolicyUsagePoint3: "Créer des datasets de qualité pour la recherche académique et l'innovation en IA.",
    dataPolicyUsagePoint4: "Améliorer l'expérience utilisateur et personnaliser les services proposés aux contributeurs.",

    // 3. Vos Droits et Contrôle des Données
    dataPolicyRights: "3. Vos Droits et Contrôle des Données",
    dataPolicyRightsDesc: "En tant que contributeur, vous disposez des droits suivants :",
    dataPolicyRightsPoint1: "Accéder à vos contributions et données personnelles à tout moment depuis votre tableau de bord.",
    dataPolicyRightsPoint2: "Exporter l'ensemble de vos données dans un format structuré et réutilisable.",
    dataPolicyRightsPoint3: "Demander la suppression de vos contributions dans le respect de la licence Nwulite Obodo.",
    dataPolicyRightsPoint4: "Être informé de toute modification majeure de cette politique de données.",

    // 4. Engagement envers la Communauté : Licence Nwulite Obodo
    dataPolicyNwuliteLicense: "4. Engagement envers la Communauté : Licence Nwulite Obodo",
    dataPolicyNwuliteLicenseDesc: "Les contributions à Umbaji sont régies par la Licence Nwulite Obodo, qui :",
    dataPolicyNwulitePoint1: "Garantit que les données contribuent au bien commun et bénéficient aux contributeurs et aux communautés locales en Afrique.",
    dataPolicyNwulitePoint2: "Assure que toutes les contributions sous cette licence sont utilisées pour répondre aux besoins de la communauté et renforcer l'accès à l'IA et aux données pour les populations du Togo et de l'Afrique.",
    dataPolicyNwulitePoint3: "Favorise la transparence quant à l'utilisation des données contribué, instaurant un sentiment de responsabilité et de partage de propriété.",
    dataPolicyMoreInfo: "Pour plus d'informations, veuillez visiter www.umbaji.org/lang/fr/",

    // Validate Audio Page
    validateAudioTitle: "Vérifier la qualité des enregistrements",
    validateAudioSubtitle: "Écoutez et validez les enregistrements audio des autres contributeurs",
    totalValidations: "Total validations",
    totalLanguageValidations: "Validations par langue",
    loadAudios: "Charger",
    transcriptionSourceLabel: "Audios à traiter",
    transcriptionSources: { all: "Tous", phrase: "Phrases", initialAnswer: "Réponses orales" },
    reviewAnswerHint: "Réponse libre dans la langue locale : vérifiez que la transcription reprend ce qui est dit, pas une traduction de la question.",
    currentWord: "Expression actuelle",
    audioToValidate: "Audio à valider",
    audioExpectedFrench: "Texte français attendu",
    audioAnswerToQuestion: "Réponse à la question",
    audioAnswerToQuestionHint: "Réponse libre dans la langue locale : jugez si elle répond à la question, pas si elle la répète.",
    audioExpectedFrenchMissing: "—",
    initialDataDeletion: {
      title: "Suppression des données initiales",
      description: "Supprime les réponses d'une langue et d'un secteur, leurs copies envoyées en transcription et leurs fichiers audio. Seul un super admin supprime : la demande d'un admin attend sa décision.",
      chooseScope: "Choisissez une langue et un secteur dans les filtres ci-dessus pour demander une suppression.",
      scope: "Données concernées : {scope}",
      adminEffect: "Votre demande sera en attente : rien n'est supprimé tant qu'un super admin ne l'a pas approuvée.",
      superAdminEffect: "En tant que super admin, la suppression est immédiate et définitive.",
      reasonPlaceholder: "Motif de la suppression (5 caractères minimum)",
      confirm: "Je comprends que ces données seront supprimées définitivement après approbation.",
      requestDeletion: "Demander la suppression",
      deleteNow: "Supprimer maintenant",
      myRequests: "Mes demandes",
      allRequests: "Demandes de suppression",
      empty: "Aucune demande de suppression.",
      loadError: "Impossible de charger les demandes de suppression.",
      statuses: { pending: "En attente", rejected: "Refusée", executed: "Exécutée" },
      deletedSummary: "{answers} réponses, {copies} copies et {files} fichiers supprimés",
      failedFiles: "{count} fichiers non supprimés",
      rejectionNote: "Motif du refus : {note}",
      notePlaceholder: "Motif du refus",
      approve: "Approuver et supprimer",
      reject: "Refuser",
      requestedToast: "Demande envoyée : elle attend la décision d'un super admin.",
      executedToast: "Données supprimées.",
      rejectedToast: "Demande refusée.",
      errorTitle: "Action impossible",
      forbidden: "Vous n'avez pas le droit d'effectuer cette action.",
      notPending: "Cette demande a déjà été traitée.",
      invalid: "La demande est invalide : vérifiez le motif.",
      failed: "L'action a échoué. Réessayez.",
    },
    collectionPlace: {
      title: "Où collectez-vous ?",
      subtitle: "Chaque session est rattachée à la ville où vous enregistrez.",
      consentTitle: "Utiliser votre position pour remplir la ville ?",
      consentWhy: "Pourquoi : savoir d'où viennent les voix et les textes collectés, pour que chaque région et chaque langue soient bien représentées, et pour vérifier les collectes payées.",
      consentWhat: "À quoi ça sert : remplir automatiquement la ville au début de chaque session, sans la chercher à chaque fois.",
      consentKept: "Ce qui est gardé : uniquement le nom de la ville. Votre position exacte n'est jamais enregistrée ni partagée.",
      consentChoice: "Votre choix est enregistré sur votre compte et s'applique sur tous vos appareils. Vous pouvez le changer à tout moment.",
      accept: "Utiliser ma position",
      decline: "Je choisirai la ville moi-même",
      saving: "Enregistrement...",
      locating: "Recherche de votre ville...",
      detected: "Ville détectée",
      chosen: "Ville choisie",
      change: "Changer de ville",
      useMyPosition: "Utiliser ma position",
      searchLabel: "Ville de collecte",
      searchPlaceholder: "Tapez au moins 2 lettres (ex. Lomé, Montréal, Dakar)",
      searching: "Recherche...",
      noResult: "Aucune ville trouvée. Essayez une autre orthographe.",
      countryLabel: "Pays de cette localité",
      chooseCountry: "Choisir un pays",
      useTypedPlace: "Utiliser la localité saisie",
      previousPlaces: "Vos dernières localités choisies",
      previousPlacesLoading: "Recherche de vos localités précédentes...",
      required: "Choisissez la ville de collecte pour commencer.",
      attribution: "Recherche Photon avec repli Geoapify · données © contributeurs OpenStreetMap",
      positionDenied: "Position indisponible ou refusée par le navigateur : choisissez la ville dans la liste.",
      consentRequired: "La géolocalisation n'est pas autorisée sur votre compte : choisissez la ville dans la liste.",
      notFound: "Aucune ville trouvée à cette position : choisissez-la dans la liste.",
      rateLimited: "Trop de recherches en peu de temps. Réessayez dans un instant.",
      unavailable: "La recherche de villes est momentanément indisponible. Réessayez dans un instant.",
      consentSaveError: "Votre choix n'a pas pu être enregistré. Réessayez.",
    collectorPlaces: "Lieux de collecte",
    collectorPlacesEmpty: "Aucune contribution avec un lieu de collecte.",
    collectorPlacesError: "Impossible de charger les lieux de collecte.",
    unknownPlace: "Lieu inconnu",
    placesNotDisplayed: "{count} lieu(x) ne peuvent pas être affichés.",
      contributions: "Contributions",
      lastCollected: "Dernière collecte",
    },
    audioTextCorrection: {
      open: "Corriger le texte",
      title: "Corriger le texte de cet audio",
      hint: "La correction ne s'applique qu'à cet enregistrement. Le texte d'origine est conservé.",
      localLabel: "Phrase en langue locale",
      frenchLabel: "Texte français attendu",
      questionLabel: "Question posée",
      save: "Enregistrer",
      saving: "Enregistrement...",
      cancel: "Annuler",
      nothingChanged: "Aucun changement à enregistrer.",
      savedTitle: "Texte corrigé",
      savedDescription: "Le texte de cet audio a été mis à jour.",
      errorTitle: "Correction non enregistrée",
      invalid: "Chaque texte doit contenir entre 1 et 1000 caractères.",
      forbidden: "Seuls les modérateurs et les administrateurs peuvent corriger un texte.",
      notFound: "Cet audio n'existe plus.",
      changed: "Le texte a été modifié entre-temps. Rechargez la session puis réessayez.",
      failed: "Impossible d'enregistrer la correction. Réessayez.",
    },
    rejectionReason: "Raison de rejet",
    rejectionReasonPlaceholder: "ex: bruit de fond, mauvaise prononciation, etc.",
    reject: "Rejeter",
    playAudio: "Écouter l'audio",
    pauseAudio: "Pause",
    contributorPrefix: "Contributeur:",
    validateThisAudio: "Valider cet audio",
    audioValidationSession: "Session de validation audio",
    audioXofY: "Audio {current} sur {total}",
    audioValidationInstruction1: "Écoutez attentivement chaque enregistrement",
    audioValidationInstruction2: "Vérifiez que la prononciation correspond au mot affiché",
    audioValidationInstruction3: "Acceptez si la qualité et la prononciation sont correctes",
    audioValidationInstruction4: "Rejetez et indiquez la raison si problématique",
    reRecordPhrase: "Réenregistrer cette phrase",
    reRecordPhraseDescription: "Aller sur la page d'enregistrement pour cette phrase",
    rejectionReasonOptional: "Raison du rejet (optionnel)",
    rejectionReasonDetailedPlaceholder: "Décrivez pourquoi cet audio ne convient pas...",
    audioQualityPoor: "Qualité audio médiocre",
    incorrectPronunciation: "Prononciation incorrecte",
    backgroundNoise: "Bruit de fond",
    doesNotMatchText: "Ne correspond pas au texte",
    rejectAndReRecord: "Rejeter et réenregistrer",
    transcriptionRejectionReason: "Raison du rejet",
    transcriptionQualityPoor: "Mauvaise qualité de la transcription",
    transcriptionDoesNotMatchAudio: "Ne correspond pas à l'audio",
    transcriptionIncomplete: "Transcription incomplète",
    transcriptionContainsErrors: "Contient des erreurs",

    dataPolicyAccept: "Accepter et Contribuer",
    dataPolicyDecline: "Refuser",
    dataPolicyAcceptedToast: "Politique acceptée",
    dataPolicyAcceptedToastDesc: "Merci d'accepter notre politique de données. Bienvenue !",
    dataPolicyDeclinedToast: "Politique refusée",
    dataPolicyDeclinedToastDesc: "Vous avez choisi de ne pas accepter notre politique de données.",
    dataPolicyAlreadyAccepted: "Politique déjà acceptée",
    dataPolicyAlreadyAcceptedDesc: "Vous pouvez la relire à tout moment depuis la barre de navigation.",
    continentalImpact: "Impact Continental",
    continentalImpactDesc: "Développement d'IA pour l'Afrique par l'Afrique",
    communityFirst: "Communauté First",
    communityFirstDesc: "Vos données bénéficient directement aux communautés locales",
    guaranteedSecurity: "Sécurité Garantie",
    guaranteedSecurityDesc: "Protection maximale de vos informations personnelles",
    ethicsTransparency: "Éthique & Transparence",
    ethicsTransparencyDesc: "Utilisation responsable selon la Licence Nwulite Obodo",
    dataCollectionObjective: "Objectif de la Collecte de Données",
    nwuliteObodoLicenseDesc: "Engagement envers la Communauté : Licence Nwulite Obodo",
    importantInformation: "Information Importante",
    importantInfoDesc: "En acceptant cette politique, vous contribuez activement à la démocratisation de l'IA en Afrique. Vos données aideront à construire des technologies qui respectent et valorisent la diversité culturelle et linguistique du continent.",
    learnMoreUmbaji: "En savoir plus sur Umbaji",
    dataProtected: "Données protégées selon les standards internationaux de sécurité",
    accept: "Accepter",
    decline: "Refuser",
    acceptAndContribute: "J'accepte et je contribue",

    // Login Page
    welcomeBack: "Bon retour, {name} !",
    loginSubtitle: "Connectez-vous à votre espace contributeur",
    authEditorialTitle: "Intelligence linguistique africaine construite collectivement.",
    authEditorialDescription: "Infrastructure collaborative pour datasets multilingues, recherche IA et préservation linguistique africaine.",
    authBrandEyebrow: "Contributions Umbaji",
    authAccessPortal: "Portail d'accès",
    authContinueContribution: "Continuez à contribuer aux données multilingues qui font avancer l'IA en Afrique.",
    authLanguagesLabel: "Langues",
    authLanguagesValue: "—",
    authDatasetGoalLabel: "Audios collectés",
    authDatasetGoalValue: "—",
    authResearchLabel: "Écosystème de recherche",
    authResearchValue: "Open",
    connectionTitle: "Connexion",
    demoAccount: "Compte de démonstration",
    useCredentials: "Utiliser",
    emailAddress: "Adresse e-mail",
    connect: "Se connecter",
    connecting: "Connexion...",
    loggingIn: "Connexion en cours...",
    loginSuccess: "Connexion réussie",
    loginIdentifier: "E-mail, nom d'utilisateur ou téléphone",
    loginFailedTitle: "Connexion impossible",
    invalidCredentials: "Identifiants incorrects. Vous pouvez vous connecter avec votre e-mail, votre nom d'utilisateur ou votre numéro de téléphone.",
    loginNetworkError: "Impossible de joindre le serveur. Vérifiez votre connexion internet puis réessayez.",
    firstLoginWelcomeTitle: "Bienvenue {name} sur Umbaji",
    firstLoginWelcomeIntro: "Votre compte est prêt. Chaque contribution aide à construire des données ouvertes pour les langues africaines.",
    firstLoginWelcomeStepTask: "Commencez par enregistrer quelques phrases dans votre langue, ou validez celles des autres contributeurs.",
    firstLoginWelcomeStepProgress: "Retrouvez votre progression à tout moment dans « Suivi des contributions ».",
    firstLoginWelcomeCta: "Commencer à contribuer",
    firstLoginWelcomeCtaWorkspace: "Ouvrir mon espace",
    firstLoginWelcomeLater: "Plus tard",
    registerSuccess: "Inscription réussie",
    authError: "Erreur",
    accountStatusEyebrow: "Accès au compte",
    accountSuspendedTitle: "Compte suspendu",
    accountBannedTitle: "Compte désactivé",
    accountSuspendedDescription: "Votre compte est temporairement suspendu. Vous ne pouvez pas accéder à la plateforme pendant cette période.",
    accountBannedDescription: "Votre compte a été désactivé. L’accès à la plateforme n’est plus disponible.",
    accountStatusNextStep: "Que faire maintenant ?",
    accountStatusContactDescription: "Si vous pensez qu’il s’agit d’une erreur, contactez l’équipe d’administration afin de demander une vérification de votre compte.",
    accountStatusContact: "Contacter l’administration",
    accountStatusBack: "Retour",
    accountStatusSecurityNote: "Pour protéger votre compte, toutes les sessions actives ont été fermées.",
    unexpectedError: "Une erreur inattendue est survenue",
    usernameExists: "Le nom d'utilisateur \"{username}\" existe déjà. Veuillez en choisir un autre.",
    usernameExistsGeneric: "Ce nom d'utilisateur existe déjà. Veuillez en choisir un autre.",
    forgotPassword: "Mot de passe oublié ?",
    noAccount: "Pas encore de compte ?",
    signupLink: "S'inscrire",
    backToHomeArrow: "← Retour à l'accueil",
    acceptTerms: "En vous connectant, vous acceptez notre politique de données",
    usernamePlaceholder: "E-mail, nom d'utilisateur ou téléphone",
    emailPlaceholder: "votre@email.com",

    // Signup Page
    joinCommunity: "Rejoignez la communauté",
    signupSubtitle: "Contribuez à la création de technologies d'IA inclusives pour préserver et développer les langues ouest-africaines.",
    createAccount: "Créer votre compte",
    startContributing: "Commencez votre contribution en quelques secondes",
    contributeToAfricanAI: "Contribuez à l'IA africaine",
    contributeToAfricanAIDesc: "Aidez à développer des modèles IA pour les langues ouest-africaines",
    joinContributors: "Rejoignez la communauté",
    joinContributorsDesc: "Faites partie d'une communauté internationale de contributeurs",
    positiveSocialImpact: "Impact social positif",
    positiveSocialImpactDesc: "Préservez et numérisez le patrimoine linguistique africain",
    supportedLanguages: "Langues",
    dataCollected: "Données",
    phoneNumber: "Numéro de téléphone",
    phoneNumberOptional: "Numéro de téléphone (optionnel)",
    phoneNumberPlaceholder: "+228 90 00 00 00",
    profileCompletionBanner: "Complétez votre profil en ajoutant votre numéro de téléphone pour recevoir les alertes par SMS.",
    profileCompletionDismiss: "Plus tard",
    profileCompletionAction: "Compléter mon profil",
    termsAccept: "En créant un compte, vous acceptez de contribuer au développement de l'IA pour l'Afrique sous la",
    nwuliteLicense: "Licence Nwulite Obodo",
    alreadyMember: "Déjà membre ?",
    secured: "Sécurisé",
    openSource: "Open Source",
    socialImpact: "Impact social",
    spokenLanguages: "Langue(s) parlée(s)",
    contributionLanguages: "Dans quelles langues allez-vous contribuer ?",
    moderationLanguages: "Langues que vous pouvez modérer",
    selectLanguagesModerate: "Sélectionner les langues à modérer",
    settingsLanguagePreferencesDescription: "Gérez les langues que vous parlez, celles dans lesquelles vous contribuez et, si applicable, celles que vous pouvez modérer.",
    preferredCommunicationLanguage: "Langue des communications",
    preferredCommunicationLanguageDescription: "Les notifications internes, SMS et emails seront envoyés dans cette langue lorsqu'une traduction est disponible.",
    languagePreferencesRequired: "Sélectionnez au moins une langue parlée et une langue de contribution.",
    requiredFieldsTitle: "Champs requis",
    signupIdentityRequired: "Le nom d'utilisateur et le nom complet sont obligatoires.",
    signupCountryRequired: "Veuillez sélectionner votre pays.",
    signupGenderRequired: "Veuillez sélectionner votre genre.",
    languageProfileCompletionBanner: "Complétez vos préférences linguistiques pour recevoir les tâches et notifications correspondant à vos langues.",
    languageProfileCompletionAction: "Définir mes langues",
    selectLanguagesSpoken: "Sélectionnez les langues que vous parlez",
    selectLanguagesContribute: "Sélectionnez les langues dans lesquelles vous souhaitez contribuer",
    confirmPassword: "Confirmez votre mot de passe",
    passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
    stepAccount: "Compte",
    stepProfile: "Profil",
    stepAccountDesc: "Informations essentielles",
    stepProfileDesc: "Profil et préférences",
    optionalProfileHint: "Ces champs sont optionnels mais nous aident à mieux vous connaître.",
    nextStep: "Continuer",
    previousStep: "Retour",
    linguisticProfileLabel: "Profil linguistique",
    linguisticProfileDesc: "Configurez vos langues parlées et vos cibles de contribution.",
    spokenShort: "Parlée(s)",
    contributionShort: "Contribution",
    noLanguageSelected: "Aucune langue sélectionnée",
    searchLanguage: "Rechercher une langue...",
    noLanguageFound: "Aucune langue trouvée.",
    xSelected: "{count} sélectionné(s)",
    communityLicense: "Licence communautaire",

    // 404 Page
    pageNotFound: "Page non trouvée",
    pageNotFoundDesc: "Oups ! Il semble que cette page ait disparu dans les méandres du web. Ne vous inquiétez pas, nous sommes là pour vous ramener sur le bon chemin.",
    searchedPath: "Chemin recherché :",
    whereToGo: "Où souhaitez-vous aller ?",
    backToHome: "Retour à l'accueil",
    previousPage: "Page précédente",
    explore: "Explorer",
    discoverLanguages: "Découvrir les langues",
    joinMovement: "Rejoindre le mouvement",
    helpAfricanAI: "Aider l'IA africaine",
    funFact: "💡 Le saviez-vous ? Yodi Data Hub aide à préserver 11 langues ouest-africaines grâce à l'IA !",

    // Access Denied / Forbidden (403)
    accessDeniedTitle: "Accès réservé",
    accessDeniedGeneric: "Vous n'avez pas les droits d'accès à cette page.",
    accessDeniedDesc: "Votre compte ne dispose pas des permissions nécessaires pour accéder à cette section. Contactez un administrateur si vous pensez qu'il s'agit d'une erreur.",
    accessDeniedYourRole: "Votre rôle",
    accessDeniedContactAdmin: "Contacter un administrateur",
    backToHomeCta: "Retour à l'accueil",

    // Language
    selectLanguage: "Choisir la langue",
    selectLanguagePrompt: "Sélectionnez une langue",
    correctionLanguage: "Langue à corriger",
    equivalent: "Équivalent",
    transcribeAudioIntoFrench: "Écoutez l'audio et écrivez la traduction en français",
    languageSelectionRequired: "Sélection de langue requise",
    selectLanguageFirst: "Veuillez d'abord sélectionner une langue",
    french: "Français",
    english: "Anglais",
    localLanguage: "Langue locale",
    languageChanged: "Langue changée en français",

    // New Navigation Items
    dataPolicy: "Politique de données",

    // Protected Access
    protectedAccess: "Accès Protégé",
    protectedAccessDesc: "Vous devez être connecté et avoir accepté la politique de données pour accéder à l'espace de contribution.",
    contributeAfricanAI: "Contribuez à l'IA africaine",
    joinPlusContributors: "Rejoignez la communauté des contributeurs",
    joinContributorsCount: "Rejoignez {count} contributeurs inscrits",
    preserveWestAfricanLanguages: "Préservez les langues ouest-africaines",
    preserveLanguagesCount: "Préservez {count} langues ouest-africaines",

    // Data Policy Required
    dataPolicyRequired: "Politique de données requise",
    dataPolicyRequiredDesc: "Veuillez lire et accepter notre politique de données pour accéder à l'espace de contribution.",
    whyThisStep: "Pourquoi cette étape ?",
    privacyRespect: "Nous respectons votre vie privée et voulons que vous compreniez comment vos contributions seront utilisées pour améliorer l'IA africaine.",
    readDataPolicy: "Lire la politique de données",

    // Section invalid / session expired
    sectionInvalid: "Section invalide",
    sectionInvalidDesc: "Votre session n'est plus valide ou a été révoquée. Veuillez vous reconnecter pour continuer.",
    reEnterPasswordHint: "Saisissez votre mot de passe pour reprendre",
    reconnect: "Se reconnecter",
    orGoToLogin: "Ou retourner à la connexion",
    loginFailed: "Échec de la connexion",
    loginFailedDesc: "Identifiants incorrects. Veuillez réessayer.",

    // Common
    loading: "Chargement...",
    error: "Erreur",
    confirm: "Confirmer",
    logoutConfirmTitle: "Se déconnecter ?",
    logoutConfirmDescription: "Vous devrez saisir à nouveau vos identifiants pour revenir.",
    logoutConfirmAction: "Se déconnecter",

    // Footer
    // Charts and statistics (specific)
    contributionStatusChart: "Statut des Contributions",
    overallProgress: "Progression globale",
    totalCollected: "Total collecté",
    activeLanguages: "Langues actives",
    ageDistributionChart: "Répartition par Âge",
    genderDistributionChart: "Répartition par Genre",
    countryDistributionChart: "Répartition par Pays",
    averageAge: "Âge moyen",
    averageWords: "Mots moyens",

    // Average Cards specific translations
    wordsPerContribution: "mots par contribution",
    yearsOnAverage: "ans en moyenne",
    goal: "Objectif",
    words: "mots",
    years: "ans",
    vsLastYear: "vs l'année dernière",
    dominantGeneration: "Génération dominante",
    genZ: "Gen Z",
    min: "Min",
    avg: "Moy",
    max: "Max",
    dataUpdatedToday: "Données mises à jour aujourd'hui",

    totalUsers: "Total utilisateurs",
    activeCountries: "Pays actifs",
    contributorMapChart: "Carte des Contributeurs",
    contributorMapSubtitle: "Réseau de contribution africain",
    contributorMapActiveRegions: "régions actives",
    contributorMapContributors: "contributeurs",
    contributorMapShare: "du total",
    contributorMapNoData: "aucune contribution",
    contributorMapLow: "peu",
    contributorMapHigh: "beaucoup",
    contributorMapOutsideAfrica: "Hors de la carte",
    contributorMapZoomIn: "Zoomer",
    contributorMapZoomOut: "Dézoomer",
    contributorMapReset: "Revoir tout le continent",
    contributorMapFit: "Cadrer les pays actifs",
    totalContributors: "Total contributeurs",
    topContributor: "Top contributeur",
    dominance: "Dominance",
    geographicOverview: "Vue d'ensemble géographique",
    detailedDistribution: "Répartition détaillée",
    rank: "Rang",
    male: "Homme",
    female: "Femme",
    other: "Autre",
    gender: "Genre",
    people: "personnes",
    users: "utilisateurs",
    // Gender keys for dynamic data
    maleKey: "Homme",
    femaleKey: "Femme",
    otherKey: "Autre",
    // Header/Navbar specific
    aiForWestAfrica: "IA pour l'Afrique de l'Ouest",
    newBadge: "Nouveau",
    contributor: "Contributeur",
    myContributions: "Mes Contributions",
    myProfile: "Mon Profil",
    compteUmbaji: "Compte Umbaji",
    collectorRole: "Collecteur",
    accountEyebrow: "Compte",
    leaderboardEyebrow: "Classement",
    activityEyebrow: "Activité",
    terrainEyebrow: "Terrain",
    qualityEyebrow: "Qualité",
    financeEyebrow: "Finance",
    pilotageEyebrow: "Pilotage",
    moderatorPanelLabel: "Panneau modérateur",
    accountantDashboardLabel: "Tableau de bord comptable",
    adminSpacesLabel: "Espaces",

    // Settings Page
    settings: "Paramètres",
    settingsTitle: "Paramètres",
    settingsSubtitle: "Gérez vos informations personnelles et vos préférences",
    profileTab: "Profil",
    privacyTab: "Confidentialité (RGPD)",
    geolocationConsentTitle: "Géolocalisation",
    geolocationConsentDescription: "Choisissez si l’application peut utiliser votre position pour proposer automatiquement une ville de collecte. Seul le nom de la ville est conservé.",
    geolocationConsentGranted: "Votre consentement est activé.",
    geolocationConsentDenied: "Votre consentement est désactivé. Vous pouvez choisir une ville manuellement.",
    grantGeolocationConsent: "Autoriser la géolocalisation",
    withdrawGeolocationConsent: "Retirer mon consentement",
    geolocationConsentSaveError: "Votre choix n’a pas pu être enregistré. Votre préférence actuelle reste inchangée.",
    savingGeolocationConsent: "Enregistrement…",
    notificationsTab: "Notifications",

    // Profile Tab
    personalInformation: "Informations personnelles",
    personalInformationDesc: "Vos informations de compte",
    userId: "ID Utilisateur",
    role: "Rôle",
    memberSince: "Membre depuis",
    settingsUsername: "Nom d'utilisateur",
    settingsPhone: "Téléphone",
    settingsCountry: "Pays",
    settingsGender: "Genre",
    settingsCurrentPassword: "Mot de passe actuel",
    settingsNewPassword: "Nouveau mot de passe",
    settingsConfirmPassword: "Confirmer",
    settingsPasswordHint: "Laissez ces champs vides pour conserver votre mot de passe actuel.",
    settingsBecomeAdmin: "Devenir administrateur",
    settingsAdminAccessTitle: "Accès administrateur actif",
    settingsAdminAccessDescription: "Votre compte dispose déjà d’un accès vérifié à l’espace d’administration.",
    settingsAdminAccessBadge: "Rôle autorisé : votre niveau d’accès est géré par les permissions de votre espace.",
    settingsAdminAccessAction: "Ouvrir l’espace admin",
    becomeAdminEyebrow: "Accès organisation",
    becomeAdminTitle: "Demande d'accès administrateur",
    becomeAdminSubtitle: "Soumettez les informations de votre organisation, le représentant responsable et les pièces contractuelles pour ouvrir un espace administrateur vérifié.",
    becomeAdminStepCompany: "Entreprise & contacts",
    becomeAdminStepCompanyDesc: "Identité légale, coordonnées et périmètre d'activité.",
    becomeAdminStepRepresentative: "Représentant & compte",
    becomeAdminStepRepresentativeDesc: "Personne responsable et paramètres d'accès initial.",
    becomeAdminStepDocuments: "Documents & validation",
    becomeAdminStepDocumentsDesc: "Pièces justificatives, contrat signé et consentements.",
    becomeAdminCompanyName: "Nom de l'entreprise",
    becomeAdminRegistrationNumber: "Numéro d'enregistrement",
    becomeAdminSector: "Secteur d'activité",
    becomeAdminSectorPlaceholder: "Ex : technologie, recherche, institution",
    becomeAdminCompanyAddress: "Adresse complète",
    becomeAdminCompanyEmail: "Email officiel",
    becomeAdminCompanyPhone: "Téléphone",
    becomeAdminCompanyWebsite: "Site web",
    becomeAdminOptional: "facultatif",
    becomeAdminRepName: "Nom du représentant",
    becomeAdminRepRole: "Fonction",
    becomeAdminRepPhone: "Téléphone",
    becomeAdminRepEmail: "Email professionnel",
    becomeAdminAccountSection: "Paramètres de compte",
    becomeAdminUsername: "Nom d'utilisateur",
    becomeAdminPassword: "Mot de passe",
    becomeAdminUseSso: "Utiliser l'authentification SSO si elle est activée pour votre organisation.",
    becomeAdminDocumentsTitle: "Documents justificatifs",
    becomeAdminDocumentsDesc: "Ajoutez les documents qui prouvent l'existence de l'organisation et l'autorité du représentant.",
    becomeAdminUploadDocuments: "Ajouter des documents",
    becomeAdminFilesAttached: "Fichiers ajoutés",
    becomeAdminFileSizeUnit: "Ko",
    becomeAdminRemoveFile: "Retirer",
    becomeAdminContractTitle: "Contrat administrateur",
    becomeAdminDownloadContract: "Télécharger le contrat",
    becomeAdminUploadSignedContract: "Ajouter le contrat signé",
    becomeAdminSignedContractSelected: "Contrat sélectionné :",
    becomeAdminContractInstruction: "Téléchargez le modèle, signez-le physiquement ou électroniquement, puis ajoutez le fichier signé avant l'envoi.",
    becomeAdminContractPreview: "Aperçu du contrat",
    becomeAdminContractPreviewEmpty: "Remplissez les informations de l'organisation pour générer un contrat prérempli.",
    becomeAdminContractIntro: "Ce document formalise la demande d'ouverture d'un espace administrateur vérifié sur Umbaji Data Hub.",
    becomeAdminContractTermsTitle: "Conditions principales",
    becomeAdminContractClauseAccess: "L'organisation demande l'accès à un espace administrateur soumis à validation préalable par Umbaji.",
    becomeAdminContractClauseResponsibility: "Le représentant légal confirme l'exactitude des informations fournies et assume la responsabilité des actions réalisées depuis l'espace administrateur.",
    becomeAdminContractClauseData: "Les données transmises sont utilisées uniquement pour la vérification, l'audit, la sécurité et la gestion du service.",
    becomeAdminContractClausePayment: "Les frais administratifs ou paiements éventuels sont traités via le moyen de paiement configuré et confirmé par le demandeur.",
    becomeAdminContractSignature: "Signature du représentant légal",
    becomeAdminContractDate: "Date",
    becomeAdminTermsConsent: "J'ai lu et j'accepte les conditions applicables à l'espace administrateur.",
    becomeAdminRgpdConsent: "J'accepte la politique de confidentialité et le traitement des données nécessaires à la vérification.",
    becomeAdminPayVisa: "Payer avec Visa",
    becomeAdminPaymentTitle: "Paiement par carte",
    becomeAdminCardNumber: "Numéro de carte",
    becomeAdminCardExpiry: "MM/AA",
    becomeAdminCardCvc: "CVC",
    becomeAdminCancel: "Annuler",
    becomeAdminProcessing: "Traitement...",
    becomeAdminPrevious: "Précédent",
    becomeAdminNext: "Suivant",
    becomeAdminSubmit: "Soumettre la demande",
    becomeAdminProgress: "Progression",
    becomeAdminSecureReview: "Chaque demande est revue avant activation. Les documents servent uniquement à vérifier l'organisation et les accès demandés.",
    settingsDataExportSuccess: "Vous recevrez un email avec vos données dans {time}.",
    settingsDataExportEmailed: "Votre copie de données a été envoyée à {email}.",
    settingsDataExportDownloaded: "Votre copie de données a été téléchargée.",
    settingsAccountDeleted: "Votre compte a été supprimé.",
    settingsWrongPassword: "Mot de passe incorrect.",
    settingsConfirmWithPassword: "Confirmez avec votre mot de passe",
    settingsDataExportError: "Impossible de traiter la demande",
    settingsUsernameEmpty: "Le nom d'utilisateur ne peut pas être vide.",
    settingsPasswordRequired: "Veuillez saisir votre mot de passe actuel.",
    settingsPasswordMismatch: "Les nouveaux mots de passe ne correspondent pas.",
    settingsProfileUpdated: "Profil mis à jour",
    settingsUpdateError: "Erreur",
    settingsDeletionRequest: "Demande de suppression enregistrée{date}.",
    settingsDeletionRequestEn: "Deletion request registered{date}.",
    settingsDeleteProcessError: "Impossible de traiter la demande",

    // Privacy Tab (RGPD)
    yourDataRights: "Vos Droits sur vos Données",
    yourDataRightsDesc: "Conformément au RGPD, vous avez le contrôle complet sur vos données",
    downloadMyData: "Télécharger Mes Données",
    downloadDataDesc: "Recevez une copie complète de toutes vos données dans un format portable",
    whatIsIncluded: "Ce qui est inclus :",
    includedAudioRecordings: "Vos informations de compte et vos langues",
    includedImages: "Vos statistiques de contribution par langue",
    includedTranscriptions: "Vos validations et transcriptions (comptes)",
    includedValidations: "Vos paiements",
    includedMetadata: "Vos consentements (conditions, géolocalisation)",
    estimatedTime: "Disponible tout de suite",
    emailDelivery: "Envoyée par e-mail si votre compte a une adresse, sinon téléchargée directement. Les fichiers audio et images ne sont pas joints : écrivez à privacy@yodi.tg pour les obtenir.",
    requestDataExport: "Demander l'export de données",
    requesting: "Demande en cours...",
    deleteMyAccount: "Supprimer Mon Compte",
    deleteAccountWarning: "Action irréversible",
    deleteAccountDesc: "La suppression de votre compte efface vos informations personnelles. Cette action ne peut pas être annulée.",
    deleteAccountConsequences: "Conséquences :",
    consequenceAllData: "Votre compte et vos informations personnelles sont supprimés ; vos contributions validées restent dans le corpus, de façon anonyme",
    consequenceNoRecovery: "Aucune récupération possible",
    consequenceImmediate: "Effet immédiat après confirmation du mot de passe",
    requestAccountDeletion: "Supprimer mon compte",
    deleting: "Suppression...",
    yourGDPRRights: "Vos Droits RGPD",
    gdprRightsDesc: "En tant qu'utilisateur, vous bénéficiez de tous les droits prévus par le RGPD",
    rightOfAccess: "Droit d'accès : Accédez à toutes vos données personnelles",
    rightToRectification: "Droit de rectification : Corrigez vos données inexactes",
    rightToErasure: "Droit à l'effacement : Supprimez définitivement vos données",
    rightToPortability: "Droit à la portabilité : Recevez vos données dans un format lisible",
    rightToObject: "Droit d'opposition : Refusez certains traitements",
    questionsContact: "Des questions ? Contactez-nous à",

    // Delete Account Dialog
    deleteAccountTitle: "Supprimer définitivement le compte ?",
    deleteAccountDialogDesc: "Cette action est irréversible. Votre compte et vos informations personnelles seront supprimés immédiatement ; vos contributions validées restent dans le corpus, de façon anonyme.",
    understandConsequences: "Je comprends que cette action est irréversible",
    cancelDeletion: "Annuler",
    confirmDeletion: "Oui, supprimer mon compte",

    // Notifications Tab
    notificationPreferences: "Préférences de Notifications",
    notificationPreferencesDesc: "Gérez la manière dont vous souhaitez être notifié",
    comingSoon: "Fonctionnalité à venir...",

    // Contribution page headings
    contributionAudioEyebrow: "Contribution audio",
    contributionTextEyebrow: "Contribution texte",
    transcribeAudioIntroTitle: "Transcrire des audios avec précision.",
    transcribeAudioIntroDesc: "Écoutez l’enregistrement, saisissez la transcription, puis ajoutez si besoin une traduction française pour améliorer la qualité du corpus.",
    prepareSessionTitle: "Préparer la session",
    prepareAudioSessionDesc: "Choisissez la langue de travail. Les audios seront chargés sans modifier votre progression existante.",
    prepareBatchTitle: "Préparer le lot",
    prepareBatchDesc: "Choisissez la langue, écoutez chaque audio, puis acceptez ou refusez avec un motif clair.",
    prepareTranslationTitle: "Préparer la traduction",
    prepareTranslationDesc: "La session conserve la page et les phrases déjà traitées. Le retour depuis l’enregistrement reste actif.",
    sourceMetricTitle: "Source",
    sourceMetricDesc: "Lire la phrase originale",
    keyboardMetricTitle: "Clavier",
    keyboardMetricDesc: "Utiliser les caractères locaux",
    sessionMetricTitle: "Session",
    sessionMetricDesc: "Reprendre la progression",
    //transcription Audio
    availableAudios: "Audios disponibles",
    optionalFrenchTranslationLabel: "Traduction en français (optionnel)",
    optionalFrenchTranslationPlaceholder: "Écrivez la traduction en français",
    closeKeyboard: "Fermer le clavier",
    validateThisText: "Valider cette transcription",
    soumettreTranscriptionAudio: "Soumettre la transcription",
    placehoderTranscriptionAudio: "Ecrire ici la transcrition exacte ",
    rejectedToast: "Transcription rejetée",
    rejectFailed: "Erreur lors du rejet",
    rejectionReasonRequired: "La raison du rejet est requise",
    rejectedAttemptBannerTitle: "Réessayez cette transcription",
    rejectedAttemptBannerDesc: "Votre transcription précédente a été rejetée. Vous pouvez proposer une nouvelle version.",
    rejectedAttemptReasonsLabel: "Raisons du rejet",


    //transcription Phrases
    transcription: "Transcrire",
    navAdminSection: "Admin",
    admin: {
      scopeNotice: {
        loading: "Lecture de vos langues administrateur...",
        error: "Impossible de lire vos langues administrateur.",
        retry: "Réessayer",
      },
      layout: {
        sectionTitle: "Espace administrateur",
        productName: "Yodi Data Hub",
        backToApp: "Retour à l'application",
        breadcrumbHome: "Admin",
        logout: "Déconnexion",
        nav: {
          dashboard: "Tableau de bord",
          uploads: "Imports",
          audio: "Audio",
          text: "Texte",
          phrases: "Phrases",
          images: "Images",
          importedFiles: "Fichiers importés",
          audioContributions: "Contributions audio",
          textContributions: "Contributions texte",
          audioTranscriptContributions: "Transcriptions",
          initialDataContributions: "Réponses aux questions",
          users: "Utilisateurs",
          contributions: "Contributions",
          audios: "Audios",
          texts: "Textes",
          transcriptions: "Transcriptions",
          configuration: "Configuration",
          api: "API",
          models: "Modèles",
          languages: "Langues",
          theme: "Thème",
          excelUploads: "Thèmes et phrases",
          contracts: "Contrats",
          complaints: "Signalements",
          logs: "Journal technique",
          recordingGuidelines: "Politique de collecte",
          excelTranslations: "Traductions",
        },
        modules: {
          comingSoonTitle: "Coming soon",
          audioTranscriptContributionsDescription: "Cette page servira a recuperer et suivre les contributions audio transcript des administrateurs et super administrateurs.",
          initialDataContributionsDescription: "Cette page servira a recuperer et suivre les contributions initial data des administrateurs et super administrateurs.",
        },
        roles: {
          super_admin: "Super Admin",
          admin: "Administrateur",
          accountant: "Comptable",
          collector: "Collecteur",
          moderator: "Modérateur",
          user: "Utilisateur",
        },
      },
      logs: {
        badge: "Monitoring",
        title: "Journal technique",
        description: "Toutes les entrées techniques de la plateforme, filtrables par type, utilisateur ou période. Les administrateurs ne voient que les entrées des langues qu'ils gèrent.",
        exportCsv: "Exporter CSV",
        exportForbidden: "L'export des logs est réservé aux super administrateurs",
        exportError: "Impossible d'exporter les logs",
        filterTitle: "Filtres",
        filterDescription: "Affinez la liste par niveau, catégorie, utilisateur ou période.",
        listTitle: "Registre des événements",
        listDescription: "Dernières entrées de la plateforme, triables et paginées.",
        searchPlaceholder: "Rechercher par message ou chemin…",
        searchUserPlaceholder: "Rechercher un utilisateur (nom, id, username, téléphone, email)…",
        searchUserEmpty: "Tapez au moins 2 caractères",
        searchUserNoResults: "Aucun utilisateur trouvé",
        levels: "Niveaux",
        categories: "Catégories",
        dateFrom: "Du",
        dateTo: "Au",
        resetFilters: "Réinitialiser",
        noUserFiltered: "Aucun utilisateur filtré",
        columnTimestamp: "Horodatage",
        columnLevel: "Niveau",
        columnCategory: "Catégorie",
        columnMessage: "Message",
        columnUser: "Utilisateur",
        columnMethod: "Méthode",
        columnPath: "Chemin",
        columnStatus: "Statut",
        columnDuration: "Durée",
        columnRequestId: "Requête",
        totalLogs: "Logs totaux",
        errors: "Erreurs",
        warnings: "Avertissements",
        info: "Infos",
        activity: "Activité",
        noLogs: "Aucun log ne correspond à ces filtres",
        loadError: "Impossible de charger les logs",
        retry: "Réessayer",
        detailTitle: "Détail du log",
        requestTimeline: "Timeline de la requête",
        metadata: "Métadonnées",
        userAgent: "User agent",
        ipAddress: "Adresse IP",
        emptyMetadata: "Aucune métadonnée",
        copy: "Copier",
        copyEntry: "Copier l'entrée",
        copied: "Copié",
        copyFailed: "Copie impossible",
        pageOf: "Page {current} sur {total}",
        previousPage: "Page précédente",
        nextPage: "Page suivante",
        noUser: "Anonyme",
        userLogCount: "logs",
        level: {
          debug: "Debug",
          info: "Info",
          warn: "Avertissement",
          error: "Erreur",
          critical: "Critique",
        },
        category: {
          auth: "Authentification",
          http: "HTTP",
          contribution: "Contribution",
          validation: "Validation",
          admin: "Administration",
          payment: "Paiement",
          security: "Sécurité",
          system: "Système",
          database: "Base de données",
        },
      },
      dashboard: {
        badge: "Administration",
        title: "Panel administrateur",
        subtitle: "Gérez les contenus, validations, rappels et paiements",
        superAdminSubtitle: "Hub centralisé super admin pour piloter les admins, utilisateurs et contributions.",
        themeConfig: "Configuration thème",
        superAdminView: "Vue super admin centralisée",
        adminScope: "Périmètre admin",
        superAdminScopeDesc: "Toutes les langues et toutes les données admin sont centralisées sur ce dashboard.",
        adminScopeDesc: "Les données et exports sont limités aux langues que vous avez créées.",
        noLanguageAssigned: "Aucune langue admin ne vous est encore attribuée. Les vues admin restent vides tant qu'une langue ne vous appartient pas.",
        teamSize: "Équipe admin",
        teamSizeDesc: "{superAdmins} super admin, {admins} admins",
        managedLanguages: "Langues gérées",
        managedLanguagesDesc: "{count} langues actives",
        coveredCountries: "Pays couverts",
        coveredCountriesDesc: "{count} comptes admin actifs",
        totalUsers: "Utilisateurs",
        totalUsersDesc: "{active} actifs, {newUsers} nouveaux",
        scopedUsers: "Utilisateurs",
        scopedActiveContributors: "Actifs",
        scopedTotalAudio: "Audios",
        radarTitle: "Vue d'ensemble",
        radarDescription: "Performance multidimensionnelle de votre périmètre admin : qualité, couverture, engagement, modération et réactivité.",
        statusDonutTitle: "Répartition statuts",
        statusDonutDescription: "Distribution des audios par statut de validation",
        adminsTitle: "Liste des admins",
        adminsDescription: "Vue d'ensemble de l'équipe administrative et de leurs périmètres.",
        viewManagement: "Ouvrir la gestion",
        adminsByCountry: "Admins par pays",
        adminsByCountryDescription: "Répartition géographique de l'équipe administrative.",
        noCountryData: "Aucune répartition pays disponible.",
        adminsCount: "{count} admins",
        adminsCountDesc: "{total} admins, {active} actifs, {languages} langues gérées",
        languagesPerAdmin: "Langues par admin",
        languagesPerAdminDescription: "Affectation des langues à chaque membre de l'équipe.",
        langCount: "{count} langues",
        noAdminData: "Aucune donnée admin disponible.",
        noLanguageAssignment: "Aucune langue attribuée.",
        languageCoverage: "Couverture des langues admin",
        languageCoverageDescription: "Détail des langues et de leurs affectations admin.",
        noLanguageData: "Aucune affectation de langue disponible.",
        countryUndefined: "Pays non défini",
        adminCount: "{count} admins affectés",
        usersAndLeaders: "Utilisateurs et leaders",
        topContributors: "Top contributeurs",
        topValidators: "Top validateurs",
        contributionsLabel: "{count} contributions",
        validationsLabel: "{count} validations",
        noData: "Aucune donnée disponible.",
        contributionsByLanguage: "Contributions par langue",
        contributionsByLanguageDescription: "Répartition des contributions par langue suivie.",
        globalRead: "Lecture globale",
        globalReadDesc: "{languages} langues suivies, {pendingValidations} validations en attente et {pendingContributions} contributions à traiter.",
        noLanguageLoaded: "Aucune langue chargée pour le moment.",
        recentActivity: "Activité récente centralisée",
        noActivity: "Aucune activité récente.",
        actionOn: "Action sur {target}",
        uploadsTitle: "Accès rapide",
        openAdmins: "Voir les admins",
        openUsers: "Voir les utilisateurs",
        openAudios: "Voir les audios",
        openLanguages: "Voir les langues",
      },
      languageConfig: {
        badge: "Langues",
        title: "Langues",
        subtitle: "Gérez les langues disponibles dans l'application",
        description: "Configurez, approuvez et supprimez les langues utilisées dans l'application.",
        refresh: "Actualiser",
        createdBy: "Créé par",
        data: "Données",
        colIndicator: "Indicateur",
        colCode: "Code",
        colName: "Nom",
        colCreatedBy: "Créé par",
        colData: "Données",
        colStatus: "Statut",
        colApproval: "Approbation",
        colActions: "Actions",
        readOnly: "Lecture seule",
        pageSummary: "{count} langue(s)",
        addLanguage: "Ajouter une langue",
        availableLanguages: "Langues disponibles",
        modulesCount: "{count} module",
        modulesCountPlural: "{count} modules",
        empty: "Aucune langue configurée",
        indicator: "Indicateur",
        code: "Code",
        displayName: "Nom d'affichage",
        status: "Statut",
        actions: "Actions",
        active: "Actif",
        inactive: "Inactif",
        edit: "Modifier",
        delete: "Supprimer",
        deleteConfirmTitle: "Confirmer la suppression",
        deleteConfirmDescription: "Êtes-vous sûr de vouloir supprimer cette langue ? Cette action est irréversible.",
        editLanguage: "Modifier une langue",
        addLanguageTitle: "Ajouter une langue",
        editLanguageDescription: "Mettez à jour les informations de la langue",
        addLanguageDescription: "Créez une nouvelle langue",
        codeLabel: "Code de la langue *",
        codePlaceholder: "ex: ewe, mina, fr",
        codeHint: "Format: 2-3 caractères minuscules",
        nameLabel: "Nom de la langue *",
        namePlaceholder: "ex: Ewe, Mina, Français",
        countryLabel: "Pays associé (ccTLD)",
        countryPlaceholder: "Sélectionner un pays",
        noCountry: "Aucun",
        countryHint: "Le ccTLD sera préfixé au nom d'affichage (ex: .tg Ewe)",
        displayNameLabel: "Nom d'affichage *",
        displayNamePlaceholder: "ex: .tg Ewe, .bj Mina",
        displayNameHint: "Peut inclure un indicateur pays",
        flagLabel: "Drapeau du pays *",
        noCodeEntered: "Entrez un code de langue pour voir le drapeau",
        countryNotFound: "Pays non trouvé pour ce code de langue",
        flagCode: "Code : {code}",
        flagHint: "Le drapeau est automatiquement défini selon le pays de la langue",
        activeLabel: "Langue active",
        saving: "Enregistrement...",
        validationTitle: "Validation",
        allFieldsRequired: "Tous les champs sont obligatoires",
        loadingError: "Erreur lors du chargement",
        invalidIdentifier: "Identifiant invalide pour la langue {code}",
        updateSuccess: "Langue mise à jour avec succès",
        createSuccess: "Langue créée avec succès",
        saveError: "Erreur lors de l'enregistrement",
        deleteSuccess: "Langue supprimée avec succès",
        deleteError: "Erreur lors de la suppression",
        createdByYou: "Seules les langues que vous avez créées sont visibles et modifiables ici.",
        loadingPendingLanguages: "Chargement des langues en attente...",
        pendingApprovalCount: "{count} langue(s) en attente d'approbation super admin.",
        approvalStatus: {
          approved: "Approuvée",
          rejected: "Rejetée",
          pending: "En attente",
        },
        approvalMessages: {
          approvalSuccess: "Langue approuvée avec succès",
          rejectionSuccess: "Langue rejetée avec succès",
          approvalError: "Erreur lors de la mise à jour du statut d'approbation",
          loadingError: "Impossible de charger les langues en attente",
        },
        pendingApprovals: "Approbations en attente",
        noPendingApprovals: "Aucune approbation en attente",
      },
      users: {
        badge: "Administration",
        title: "Utilisateurs",
        description: "Consultez, filtrez et gérez l'ensemble des comptes utilisateurs, leurs rôles et leur statut.",
        totalUsers: "{count} utilisateur",
        totalUsersPlural: "{count} utilisateurs",
        totalActive: "Actifs",
        totalSuspended: "Suspendus",
        totalContributors: "Contributeurs",
        edit: "Modifier",
        save: "Enregistrer",
        cancel: "Annuler",
        never: "Jamais",
        refresh: "Actualiser",
        export: "Exporter",
        exporting: "Export...",
        filters: "Filtres",
        searchPlaceholder: "Rechercher par nom ou email...",
        allRoles: "Tous les rôles",
        allStatuses: "Tous les statuts",
        resetFilters: "Réinitialiser les filtres",
        user: "Utilisateur",
        email: "Email",
        role: "Rôle",
        status: "Statut",
        contributions: "Contributions",
        registration: "Inscription",
        actions: "Actions",
        loading: "Chargement...",
        noUsers: "Aucun utilisateur trouvé",
        unavailableDate: "Non disponible",
        notAvailable: "N/A",
        unknownStatus: "Statut inconnu",
        idPrefix: "ID : {id}",
        successRoleUpdated: "Rôle modifié avec succès",
        roleUpdateForbiddenTitle: "Modification du rôle non autorisée",
        roleUpdateForbiddenDescription: "Un administrateur ne peut modifier que les rôles modérateur, collecteur ou utilisateur.",
        unavailableStatusTitle: "Statut indisponible",
        unavailableStatusDescription: "Impossible de modifier le statut de cet utilisateur pour le moment.",
        userActivated: "Utilisateur activé avec succès",
        userSuspended: "Utilisateur suspendu avec succès",
        userDeleted: "Utilisateur supprimé avec succès",
        unexpectedError: "Une erreur inattendue est survenue",
        suspend: "Suspendre",
        activate: "Activer",
        delete: "Supprimer",
        pageSummary: "Page {page} sur {totalPages} ({total} utilisateurs)",
        previous: "Précédent",
        next: "Suivant",
        phone: "Téléphone",
        phoneNotSet: "Non renseigné",
        phoneUpdateSuccess: "Numéro de téléphone mis à jour",
        phoneDeleteSuccess: "Numéro de téléphone supprimé",
        confirmDeleteTitle: "Confirmer la suppression",
        confirmDeleteDescription: "Êtes-vous sûr de vouloir supprimer l'utilisateur {username} ?\n\nCette action est irréversible et supprimera également toutes les contributions de cet utilisateur.",
        confirmStatusSuspendTitle: "Suspendre l'utilisateur",
        confirmStatusSuspendDescription: "Êtes-vous sûr de vouloir suspendre {username} ? L'utilisateur ne pourra plus se connecter tant que son statut n'est pas réactivé.",
        confirmStatusActivateTitle: "Réactiver l'utilisateur",
        confirmStatusActivateDescription: "Êtes-vous sûr de vouloir réactiver {username} ? L'utilisateur pourra de nouveau se connecter.",
        confirm: "Confirmer",
        abort: "Annuler",
        createUser: "Créer un utilisateur",
        createUserTitle: "Nouvel utilisateur",
        createUserDescription: "Créez un compte avec un mot de passe temporaire. L'utilisateur sera notifié par email ou SMS.",
        createUsername: "Nom d'utilisateur",
        createName: "Nom complet",
        createEmail: "Email",
        createPhone: "Téléphone",
        createCountry: "Pays",
        createGender: "Genre",
        createAge: "Âge",
        createRole: "Rôle",
        createLang: "Langue de notification",
        createSubmit: "Créer le compte",
        createSubmitting: "Création...",
        createSuccess: "Utilisateur créé avec succès",
        createSuccessDesc: "Notification envoyée par {channel}",
        createError: "Erreur lors de la création",
        createEmailOrPhone: "Email ou téléphone requis",
        createEmailUsed: "Cet email est déjà utilisé",
        createPhoneUsed: "Ce numéro de téléphone est déjà utilisé",
        createUsernameTaken: "Ce nom d'utilisateur est déjà pris",
        usernameInvalid: "Le nom d'utilisateur doit contenir uniquement des lettres, chiffres, points, tirets ou underscores.",
        phoneInvalid: "Le numéro de téléphone est incomplet.",
        genderMale: "Homme",
        genderFemale: "Femme",
        active: "Actif",
        revoked: "Révoqué",
        cannotActOnSelf: "Vous ne pouvez pas effectuer cette action sur votre propre compte",
        onlySuperAdmin: "Seul un super administrateur peut effectuer cette action",
        country: "Pays",
        language: "Langue",
        allCountries: "Tous les pays",
        allLanguages: "Toutes les langues",
        validationBlocked: "Bloqué (validation)",
        validationBlockedProgress: "{done}/{required} validations",
        validationBlockedProgressUnknown: "{done} validations",
        validationBlockedOnly: "Bloqués (validation)",
        unblockValidation: "Débloquer",
        confirmUnblockTitle: "Débloquer {username} ?",
        confirmUnblockDescription: "{username} pourra de nouveau contribuer tout de suite. Ses compteurs de contributions et de validations repartiront de zéro.",
        unblocking: "Déblocage…",
        unblockSuccess: "{username} peut de nouveau contribuer.",
        scopeAction: "Langues gérées",
        scopeTitle: "Langues gérées par {username}",
        scopeDescription: "Cet administrateur ne voit et ne modifie que les contributeurs et contenus de ces langues. Les collecteurs d'une langue ne lui sont visibles, en lecture seule, que si vous l'autorisez.",
        scopeLanguage: "Langue",
        scopeManaged: "Gérée",
        scopeCollectors: "Peut voir les collecteurs",
        scopeEmpty: "Aucune langue n'est disponible.",
        scopeNone: "Aucune langue gérée",
        scopeSave: "Enregistrer",
        scopeSaving: "Enregistrement…",
        scopeSuccess: "Langues de {username} mises à jour.",
        statsAction: "Stats",
      },
      userStats: {
        badge: "Contributions",
        title: "Statistiques de {username}",
        description: "Temps enregistré, audios et historique de ce contributeur, toutes périodes confondues.",
        refresh: "Actualiser",
        loading: "Chargement des statistiques…",
        error: "Impossible de charger les statistiques.",
        retry: "Réessayer",
        recordedTime: "Temps enregistré",
        recordedTimeHint: "Phrases enregistrées et réponses orales. Le temps passé dans l'application n'est pas mesuré.",
        contributions: "Contributions",
        audiosAccepted: "Audios acceptés",
        audiosRejected: "Audios rejetés",
        audiosPending: "Audios en attente",
        moderation: "Actions de modération",
        moderationHint: "Validations et rejets effectués par cet utilisateur sur les contributions des autres.",
        moderationAudiosValidated: "Audios validés",
        moderationAudiosRejected: "Audios rejetés",
        moderationTranscriptionsValidated: "Transcriptions validées",
        moderationTranscriptionsRejected: "Transcriptions rejetées",
        reviews: "Données modérées",
        reviewsHint: "Les enregistrements et les transcriptions que ce compte a validés ou rejetés. Les contributeurs restent anonymes.",
        reviewsAll: "Toutes",
        reviewsValidated: "Validées",
        reviewsRejected: "Rejetées",
        reviewsEmpty: "Aucune décision de modération.",
        reviewsError: "Impossible de charger les décisions de modération.",
        reviewsMore: "Afficher plus",
        reviewsTargetTranscription: "Transcription",
        reviewsDecisionValidated: "Validé",
        reviewsDecisionRejected: "Rejeté",
        reviewsDecidedAt: "Décidé le {date}",
        reviewsRecordedAt: "Enregistré le {date}",
        reviewsNoDate: "Date non enregistrée",
        reviewsReason: "Motif :",
        byLanguage: "Par langue",
        language: "Langue",
        audios: "Audios",
        duration: "Durée",
        noLanguage: "Aucune contribution pour l'instant.",
        history: "Historique",
        date: "Date",
        type: "Type",
        status: "Statut",
        typeAudio: "Audio",
        typeText: "Texte",
        statusValidated: "Validée",
        statusRejected: "Rejetée",
        statusPending: "En attente",
        noHistory: "Aucune contribution dans l'historique.",
        historyError: "Impossible de charger l'historique.",
        pageSummary: "Page {page} sur {pages}",
        previous: "Précédent",
        next: "Suivant",
        playContribution: "Écouter",
        stopContribution: "Arrêter la lecture",
        playRefused: "Lecture impossible pour cet enregistrement.",
        fileOrder: "N° dans le fichier",
      },
      importedFiles: {
        badge: "Imports",
        title: "Fichiers importés",
        subtitle: "Textes et images importés depuis le gestionnaire d'imports. Téléchargez-les ou supprimez-les.",
        kindFilter: "Type de fichier",
        kindAll: "Tous",
        kindText: "Textes",
        kindImage: "Images",
        languageFilter: "Langue",
        allLanguages: "Toutes les langues",
        refresh: "Actualiser",
        colFile: "Fichier",
        colLanguage: "Langue",
        colUploader: "Importé par",
        colSize: "Taille",
        colDate: "Importé le",
        colActions: "Actions",
        scopeFilter: "Portée",
        scopeMine: "Mes imports",
        scopeAll: "Tous les imports",
        scopeTrash: "Corbeille",
        unknownUploader: "Compte supprimé",
        unknownDate: "—",
        validate: "Valider l'import",
        validated: "Validé",
        rejected: "Rejeté",
        pending: "En attente",
        reject: "Rejeter l'import",
        rejectTitle: "Rejeter l'import",
        rejectDescription: "Le fichier est conservé, avec la raison du rejet.",
        rejectReasonPlaceholder: "Pourquoi cet import est-il rejeté ?",
        restore: "Restaurer l'import",
        restoreUntil: "Restaurable jusqu'au {date}",
        actionError: "Impossible de faire cette action.",
        validatedToast: "Import validé.",
        rejectedToast: "Import rejeté.",
        restoredToast: "Import restauré.",
        deletedToast: "Import mis à la corbeille.",
        deletedPermanentlyToast: "Import supprimé définitivement.",
        deleteRecoverable: "Mettre à la corbeille",
        deleteRecoverableHint: "Le fichier est conservé et peut être restauré pendant {days} jours.",
        deleteRecoverableDays: "30",
        deletePermanentWarning: "La suppression est immédiate et irréversible : le fichier et son contenu sont détruits.",
        deletePermanentConfirm: "Je comprends que cette suppression est irréversible.",
        deletePassword: "Votre mot de passe",
        deleteToBin: "Mettre à la corbeille",
        deleteImmediately: "Supprimer définitivement",
        colActions: "Actions",
        loading: "Chargement des fichiers…",
        empty: "Aucun fichier importé pour ces filtres.",
        loadError: "Impossible de charger les fichiers importés.",
        retry: "Réessayer",
        download: "Télécharger",
        downloadError: "Le téléchargement a échoué.",
        delete: "Supprimer",
        deleteTitle: "Supprimer ce fichier ?",
        deleteDescription: "« {name} » et son contenu stocké seront définitivement supprimés.",
        deleted: "Fichier supprimé.",
        deleteError: "La suppression a échoué.",
        cancel: "Annuler",
      },
      excelPhrases: {
        recordingsLoading: "Comptage des enregistrements…",
        neverRecorded: "Jamais enregistrée",
        recordingsLabel: "enregistrements",
        contributorsLabel: "contributeurs",
        recordingStatus: "validés {validated}, en attente {pending}, rejetés {rejected}",
        recordingsUnavailable: "Le nombre d'enregistrements par phrase n'a pas pu être chargé.",
        neverRecordedSummary: "{count} phrases sur {total} n'ont encore aucun enregistrement.",
        recordingSort: "Enregistrements",
        sortFile: "Ordre du fichier",
        sortMost: "Les plus enregistrées",
        sortLeast: "Les moins enregistrées",
        sortNever: "Jamais enregistrées",
        action: "Phrases",
        title: "Phrases de {file}",
        description: "Ajoutez ou retirez des phrases de ce fichier. Les contributeurs voient le changement à leur prochain chargement. Les enregistrements déjà faits ne sont pas touchés.",
        loading: "Chargement des phrases…",
        error: "Impossible de lire ce fichier.",
        retry: "Réessayer",
        search: "Rechercher une phrase",
        allDomains: "Tous les domaines",
        count: "{count} phrases",
        selected: "{count} sélectionnée(s)",
        selectionLimit: "La sélection est limitée à 200 phrases par retrait.",
        selectAllVisible: "Sélectionner les phrases visibles",
        selectPhrase: "Sélectionner cette phrase",
        noMatch: "Aucune phrase ne correspond.",
        empty: "Ce fichier ne contient aucune phrase.",
        addTitle: "Ajouter une phrase",
        local: "Phrase en langue nationale",
        fr: "Équivalent en français",
        domain: "Domaine (facultatif)",
        domainMissing: "Domaine non renseigné",
        phraseIdMissing: "ID de phrase indisponible",
        phraseId: "ID de phrase",
        source: "Source (facultatif)",
        add: "Ajouter",
        adding: "Ajout…",
        added: "Phrase ajoutée.",
        addError: "La phrase n'a pas pu être ajoutée.",
        importFile: "Ajouter depuis un fichier",
        importingFile: "Import du fichier…",
        imported: "{added} phrase(s) ajoutée(s), {skipped} doublon(s) ignoré(s).",
        importError: "Le fichier n'a pas pu être ajouté.",
        fileRequirements: "Fichier .xlsx ou .xls contenant les colonnes de phrases utilisées sur la plateforme.",
        serverErrors: {
          DEFAULT: "L'opération n'a pas pu aboutir.",
          VALIDATION_FAILED: "Vérifiez les informations et le format du fichier.",
          UNAUTHORIZED: "Votre session a expiré. Reconnectez-vous.",
          FORBIDDEN: "Vous n'avez pas accès à cette action.",
          NOT_FOUND: "Le fichier ou certaines phrases n'existent plus.",
          CONFLICT: "Le fichier a changé. Rechargez les phrases avant de réessayer.",
          PAYLOAD_TOO_LARGE: "Le fichier dépasse la taille autorisée.",
          UNSUPPORTED_MEDIA_TYPE: "Utilisez un fichier Excel .xlsx ou .xls valide.",
          PHRASE_SELECTION_STALE: "Le fichier a changé. Rechargez les phrases avant de réessayer.",
          FILE_REQUIRED: "Sélectionnez un fichier Excel.",
          NO_SUPPORTED_PHRASES: "Le fichier ne contient aucune phrase reconnue.",
          PHRASE_IMPORT_LIMIT_EXCEEDED: "Le fichier dépasse la limite de phrases autorisée.",
          FORMULA_INJECTION_DETECTED: "Le fichier contient une valeur Excel non autorisée.",
          INTERNAL_SERVER_ERROR: "Une erreur serveur est survenue. Réessayez plus tard.",
        },
        remove: "Retirer",
        removeSelected: "Retirer la sélection",
        confirmSelected: "Confirmer le retrait",
        cancelSelection: "Annuler",
        confirmRemove: "Retirer ?",
        removing: "Retrait…",
        removed: "Phrase retirée.",
        removedMany: "{count} phrase(s) retirée(s).",
        removeError: "La phrase n'a pas pu être retirée.",
        onlyApproved: "Seuls les fichiers approuvés peuvent être modifiés phrase par phrase.",
        previous: "Précédent",
        next: "Suivant",
        pageSummary: "Page {page} sur {pages}",
      },
      excelFiles: {
        workspaceTitle: "Thèmes et phrases",
        workspaceDescription: "Les thèmes et leurs questions, l'ajout d'un nouveau thème et les fichiers de phrases à enregistrer, au même endroit.",
        themeImportsTab: "Thèmes et questions",
        newThemeTab: "Ajouter un thème",
        phraseFilesTab: "Fichiers de phrases",
        title: "Fichiers de phrases",
        subtitle: "Suivez les fichiers de phrases importés et gérez les phrases actives.",
        importAction: "Importer des phrases",
        importTitle: "Importer un fichier de phrases",
        importDescription: "Sélectionnez une langue et un fichier Excel. Un import administrateur attend l'approbation d'un super-administrateur.",
        selectLanguage: "Sélectionner une langue",
        noLanguages: "Aucune langue autorisée n'est disponible.",
        fileRequirements: "Fichier .xlsx ou .xls, non vide, jusqu'à 10 Mo.",
        invalidFile: "Sélectionnez un fichier Excel .xlsx ou .xls valide de 10 Mo maximum.",
        importing: "Import en cours...",
        importSubmit: "Importer",
        importPendingSuccess: "Import envoyé. Il sera activé après approbation d'un super-administrateur.",
        importActiveSuccess: "Import activé et phrases ajoutées au corpus.",
        importError: "Impossible d'importer le fichier de phrases.",
        loadError: "Impossible de charger le suivi des imports. Vérifiez votre connexion puis réessayez.",
        retry: "Réessayer",
        totalImports: "Imports",
        pendingImports: "En attente",
        activeImports: "Actifs",
        filtersAndActions: "Filtres et actions globales",
        filterByLanguage: "Filtrer par langue",
        allLanguages: "Toutes les langues",
        filterByStatus: "Filtrer par statut",
        allStatuses: "Tous les statuts",
        deleteAll: "Supprimer tout ({lang})",
        confirmTitle: "Êtes-vous sûr ?",
        deleteAllDescription: "Cette action supprimera définitivement tous les fichiers Excel pour la langue \"{lang}\".",
        fileName: "Nom du fichier",
        language: "Langue",
        author: "Auteur",
        uploadDate: "Date d'upload",
        actions: "Actions",
        fileUnknown: "Inconnu",
        loading: "Chargement...",
        noFiles: "Aucun fichier trouvé.",
        updateFile: "Mettre à jour le fichier",
        excelFile: "Fichier Excel",
        updating: "Mise à jour...",
        update: "Mettre à jour",
        deleteFileTitle: "Supprimer le fichier ?",
        deleteFileDescription: "Cette action est irréversible. Le fichier sera définitivement supprimé.",
        confirm: "Confirmer",
        downloadError: "Impossible de télécharger le fichier.",
        updateSuccess: "Fichier mis à jour avec succès.",
        updateError: "Impossible de mettre à jour le fichier.",
        deleteSuccess: "Fichier supprimé avec succès.",
        deleteError: "Impossible de supprimer le fichier.",
        deleteAllSuccess: "Tous les fichiers pour la langue {lang} ont été supprimés.",
        deleteAllError: "Impossible de supprimer les fichiers.",
        refresh: "Rafraîchir",
        colFile: "Fichier",
        colLanguage: "Langue",
        colAuthor: "Auteur",
        colDate: "Date",
        colActions: "Actions",
pageSummary: "{total} fichier(s) au total",
        status: "Statut",
        pending: "En attente",
        approved: "Approuvé",
        rejected: "Rejeté",
        approve: "Approuver",
        reject: "Rejeter",
        rejectPrompt: "Indiquez la raison du rejet",
        previewSummary: "Aperçu limité : {visible} lignes affichées sur {total}.",
        approveSuccess: "Import approuvé et activé.",
        approveError: "Impossible d approuver l import.",
        rejectSuccess: "Import rejeté.",
        rejectError: "Impossible de rejeter l import.",
        themes: {
          badge: "Thèmes et questions",
          title: "Imports de thèmes",
          description: "Fichiers de thèmes importés et questions créées. Les classeurs originaux ne sont pas conservés.",
          totalImports: "Imports",
          activeImports: "Actifs",
          inactiveImports: "Inactifs",
          importAction: "Importer des thèmes",
          refresh: "Rafraîchir",
          filterBySector: "Filtrer par secteur",
          allSectors: "Tous les secteurs",
          filterByStatus: "Filtrer par statut",
          allStatuses: "Tous les statuts",
          active: "Actif",
          inactive: "Inactif",
          searchPlaceholder: "Rechercher un thème ou un fichier",
          colFile: "Fichier",
          colTheme: "Thème",
          colSector: "Domaine",
          colQuestions: "Questions importées",
          colAuthor: "Importé par",
          colDate: "Date",
          colStatus: "Statut",
          colActions: "Actions",
          unknownAuthor: "Compte indisponible",
          loadedCount: "{count} imports chargés",
          more: "Afficher la suite",
          loadingMore: "Chargement...",
          loading: "Chargement...",
          noFiles: "Aucun import Excel de thème à afficher.",
          loadError: "Impossible de charger les imports.",
          retry: "Réessayer",
          previewQuestions: "Voir les questions",
          editQuestions: "Modifier les questions",
          updateQuestions: "Mettre à jour par fichier",
          deleteTitle: "Désactiver cet import ?",
          deleteDescription: "Cette action désactive l’import et retire ses questions actives du corpus. Les contributions et les identifiants restent conservés.",
          delete: "Désactiver",
          cancel: "Annuler",
          deleteSuccess: "Import désactivé.",
          deleteError: "Impossible de désactiver l’import.",
          errors: {
            DEFAULT: "Impossible de charger les imports.",
            VALIDATION_FAILED: "La demande d’imports est invalide.",
            UNAUTHORIZED: "Veuillez vous reconnecter.",
            FORBIDDEN: "Vous n’avez pas accès à ces imports.",
            NOT_FOUND: "Cet historique est introuvable.",
            IMPORT_INACTIVE: "Cet import est déjà désactivé.",
            INTERNAL_SERVER_ERROR: "Le service est momentanément indisponible.",
          },
          questions: {
            title: "Questions — {theme}",
            description: "Questions importées depuis le fichier Excel de ce thème.",
            editTitle: "Modifier les questions — {theme}",
            updateTitle: "Mettre à jour les questions — {theme}",
            editDescription: "Ajoutez une question ou désactivez celles qui ne doivent plus apparaître. Les contributions existantes restent associées à leurs identifiants.",
            importTitle: "Ajouter des questions depuis un fichier",
            importDescription: "Fichier Excel .xlsx ou .xls, 500 questions maximum. La langue renseignée ci-dessous s’applique aux nouvelles questions. Les questions existantes sont conservées, les doublons actifs ignorés.",
            importFile: "Choisir un fichier Excel",
            importing: "Import en cours...",
            importSuccess: "{added} question(s) ajoutée(s), {skipped} doublon(s) ignoré(s).",
            invalidFile: "Choisissez un fichier Excel .xlsx ou .xls non vide de 5 Mo maximum.",
            invalidLanguage: "Renseignez un code de langue valide avant l’import.",
            addTitle: "Ajouter une question",
            questionText: "Question en français",
            language: "Langue",
            domain: "Domaine",
            source: "Source",
            add: "Ajouter",
            adding: "Ajout...",
            addSuccess: "Question ajoutée à l’import.",
            search: "Rechercher une question",
            loadedSearchHint: "La recherche et les filtres portent sur les questions chargées. Utilisez « Afficher la suite » pour parcourir le reste.",
            allDomains: "Tous les domaines",
            selectAllVisible: "Sélectionner les questions visibles",
            selectQuestion: "Sélectionner la question",
            selected: "{count} question(s) sélectionnée(s)",
            selectionLimit: "Sélection limitée à 200 questions.",
            deactivateSelected: "Désactiver la sélection",
            deactivateConfirmTitle: "Désactiver les questions sélectionnées ?",
            deactivateConfirmDescription: "{count} question(s) ne seront plus proposées. Les contributions restent conservées et vous pourrez réactiver ces questions dans l’onglet Désactivées.",
            confirmDeactivate: "Confirmer la désactivation",
            cancelSelection: "Annuler",
            deactivateSuccess: "{count} question(s) désactivée(s).",
            deleteSelected: "Supprimer la sélection",
            deleteConfirmTitle: "Supprimer définitivement ces questions ?",
            deleteConfirmDescription: "{count} question(s) seront retirées définitivement des listes. Leurs identifiants et données historiques restent conservés pour les contributions existantes. Cette action ne peut pas être annulée.",
            deleteAcknowledge: "Je comprends que cette suppression ne peut pas être annulée.",
            deletePassword: "Votre mot de passe actuel",
            confirmDelete: "Supprimer définitivement",
            deleteSuccess: "{count} question(s) supprimée(s).",
            reactivateSelected: "Réactiver la sélection",
            confirmReactivate: "Confirmer la réactivation",
            reactivateSuccess: "{count} question(s) réactivée(s).",
            statusFilter: "État des questions",
            activeView: "Actives",
            inactiveView: "Désactivées",
            inactiveEmpty: "Aucune question désactivée pour ce thème.",
            loading: "Chargement des questions...",
            empty: "Aucune question active pour ce thème.",
            retry: "Réessayer",
            more: "Afficher la suite",
            loadingMore: "Chargement...",
            count: "{count} question(s)",
            error: "Impossible de charger les questions.",
            colText: "Question",
            colLanguage: "Langue",
            colDomain: "Domaine",
            colOrder: "Ordre",
            unknownLanguage: "Non précisée",
            unknownDomain: "Non précisé",
            questionDomainSource: "Domaine de la question",
            themeDomainSource: "Domaine du thème",
            errors: {
              DEFAULT: "Impossible de charger les questions.",
              VALIDATION_FAILED: "La demande de questions est invalide.",
              UNAUTHORIZED: "Veuillez vous reconnecter.",
              FORBIDDEN: "Vous n’avez pas accès à ces questions.",
              NOT_FOUND: "Cet import est introuvable.",
              IMPORT_INACTIVE: "Cet import est désactivé et ne peut plus être modifié.",
              QUESTION_CONFLICT: "La sélection a changé. Rechargez les questions.",
              REAUTHENTICATION_FAILED: "Mot de passe incorrect. Aucune question n’a été supprimée.",
              INTERNAL_SERVER_ERROR: "Le service est momentanément indisponible.",
            },
          },
        },
      },
      contracts: {
        badge: "Admin - Gestion des contrats",
        title: "Contrats",
        subtitle: "Créez et gérez les modèles de contrats pour les utilisateurs",
        create: "Créer un contrat",
        createTitle: "Créer un nouveau contrat",
        createDescription: "Définissez le titre et le contenu du contrat. Le contenu sera ensuite personnalisé pour chaque utilisateur.",
        contractTitle: "Titre du contrat",
        selectContractType: "Sélectionnez un type de contrat",
        contentHtml: "Contenu HTML",
        personalizationHint: "Utilisez les variables: {{name}}, {{email}}, {{user_id}} pour la personnalisation",
        contentPlaceholder: "Saisissez le contenu HTML. Exemple: <h1>Contrat avec {{name}}</h1><p>Email: {{email}}</p>",
        pdfUrl: "URL PDF (optionnel)",
        pdfPlaceholder: "https://example.com/contract.pdf",
        creating: "Création...",
        createAction: "Créer le contrat",
        previewFallbackTitle: "Prévisualisation du contrat",
        previewDescription: "Prévisualisation du contenu du contrat.",
        openPdf: "Ouvrir le PDF",
        editTitle: "Modifier le contrat",
        editDescription: "Mettez à jour le titre et le contenu du contrat.",
        updating: "Mise à jour...",
        saveChanges: "Enregistrer les modifications",
        createdContracts: "Contrats créés",
        empty: "Aucun contrat créé pour le moment",
        createdOn: "Créé le {date}",
        preview: "Prévisualiser",
        edit: "Modifier",
        publish: "Publier",
        unpublish: "Dépublier",
        loadError: "Erreur lors du chargement des contrats",
        titleRequired: "Le titre est requis",
        htmlRequired: "Le contenu HTML est requis",
        createSuccess: "Contrat créé avec succès",
        createError: "Erreur lors de la création du contrat",
        previewError: "Erreur lors du chargement de la prévisualisation",
        contractLoadError: "Erreur lors du chargement du contrat",
        titleAndHtmlRequired: "Le titre et le contenu HTML sont requis",
        updateSuccess: "Contrat modifié avec succès",
        updateError: "Erreur lors de la modification du contrat",
        publishSuccess: "Template publié avec succès",
        publishError: "Erreur lors de la publication du template",
        unpublishSuccess: "Template non publié",
        unpublishError: "Erreur lors de la dépublication du template",
        contractWriteForbidden: "Seul le super administrateur peut gérer les templates de contrats",
        colTitle: "Titre",
        colStatus: "Statut",
        colDate: "Date",
        colActions: "Actions",
        refresh: "Rafraîchir",
        pageSummary: "{total} contrat(s) au total",
      },
      theme: {
        title: "Configuration thème (Data initiale)",
        themeTitle: "Titre du thème",
        description: "Description",
        examples: "Exemples de phrases (une par ligne)",
        reset: "Réinitialiser",
        save: "Enregistrer le thème",
        titleRequired: "Titre requis",
        titleRequiredDescription: "Veuillez saisir un titre de thème.",
        savedTitle: "Enregistré",
        savedDescription: "Thème envoyé au backend et sauvegardé.",
        saveError: "Impossible de créer le thème",
        resetTitle: "Réinitialisé",
        resetDescription: "Aucun thème actif.",
      },
      themesManagement: {
        title: "Gestion des Thèmes et Secteurs",
        subtitle: "Gérez les thèmes, secteurs, questions et validez les contributions utilisateur",
        tabs: {
          themes: "Thèmes",
          sectors: "Secteurs",
          excel: "Excel",
          contributions: "Validations",
        },
      },
      themesList: {
        title: "Gestion des Thèmes",
        addNew: "Nouveau Thème",
        searchPlaceholder: "Rechercher des thèmes...",
        noResults: "Aucun thème trouvé",
        colTitle: "Titre",
        colDescription: "Description",
        colExamples: "Exemples",
        colDate: "Date",
        colActions: "Actions",
        createTitle: "Créer un Nouveau Thème",
        createDescription: "Créez un nouveau thème pour votre collection",
        editTitle: "Modifier le Thème",
        editDescription: "Modifiez les détails du thème",
        labelTitle: "Titre *",
        labelDescription: "Description *",
        labelExamples: "Exemples (séparés par des virgules)",
        titlePlaceholder: "Ex: Vocabulaire de santé",
        descriptionPlaceholder: "Décrivez le thème...",
        examplesPlaceholder: "Ex: santé, maladie, médicament",
        cancel: "Annuler",
        save: "Sauvegarder",
        saving: "Sauvegarde...",
        viewDescription: "Description",
        viewExamples: "Exemples",
        viewCreatedAt: "Date de création",
        deleteTitle: "Supprimer le Thème",
        deleteDescription: "Êtes-vous sûr de vouloir supprimer ce thème ? Cette action est irréversible.",
        deleteConfirm: "Supprimer",
        deleting: "Suppression...",
        pageSummary: "Page {page} sur {totalPages}",
        successCreate: "Thème créé avec succès",
        successUpdate: "Thème mis à jour avec succès",
        successDelete: "Thème supprimé avec succès",
        errorLoad: "Erreur lors du chargement des thèmes",
        errorCreate: "Erreur lors de la création du thème",
        errorUpdate: "Erreur lors de la mise à jour du thème",
        errorDelete: "Erreur lors de la suppression du thème",
        requiredError: "Veuillez remplir tous les champs requis",
      },
      sectorsList: {
        title: "Gestion des Secteurs",
        addNew: "Nouveau Secteur",
        searchPlaceholder: "Rechercher des secteurs...",
        noResults: "Aucun secteur trouvé",
        colName: "Nom",
        colDescription: "Description",
        colQuestions: "Questions",
        colDate: "Date",
        colActions: "Actions",
        createTitle: "Créer un Nouveau Secteur",
        createDescription: "Créez un nouveau secteur",
        editTitle: "Modifier le Secteur",
        editDescription: "Modifiez les détails du secteur",
        labelName: "Nom du Secteur *",
        labelDescription: "Description *",
        descriptionPlaceholder: "Décrivez le secteur...",
        cancel: "Annuler",
        save: "Sauvegarder",
        saving: "Sauvegarde...",
        viewDescription: "Description",
        viewQuestionsCount: "Nombre de questions",
        viewCreatedAt: "Date de création",
        deleteTitle: "Supprimer le Secteur",
        deleteDescription: "Êtes-vous sûr de vouloir supprimer ce secteur ? Cette action est irréversible.",
        deleteConfirm: "Supprimer",
        deleting: "Suppression...",
        pageSummary: "Page {page} sur {totalPages}",
        successCreate: "Secteur créé avec succès",
        successUpdate: "Secteur mis à jour avec succès",
        successDelete: "Secteur supprimé avec succès",
        errorLoad: "Erreur lors du chargement des secteurs",
        errorCreate: "Erreur lors de la création du secteur",
        errorUpdate: "Erreur lors de la mise à jour du secteur",
        errorDelete: "Erreur lors de la suppression du secteur",
        requiredError: "Veuillez remplir tous les champs requis",
      },
      contributionsValidation: {
        title: "Validation des Contributions",
        searchPlaceholder: "Rechercher (utilisateur, phrase)...",
        filterStatus: "Filtrer par statut",
        sectorPlaceholder: "ID Secteur (optionnel)",
        all: "Tous",
        statusPending: "En attente",
        statusApproved: "Approuvée",
        statusRejected: "Rejetée",
        statusUnknown: "Inconnu",
        noResults: "Aucune contribution trouvée",
        colUser: "Utilisateur",
        colPhraseFr: "Phrase (FR)",
        colLanguage: "Langue",
        colStatus: "Statut",
        colDate: "Date",
        colActions: "Actions",
        playAudio: "Écouter l'audio",
        viewTitle: "Détails de la Contribution",
        labelUser: "Utilisateur",
        labelPhraseFr: "Phrase (FR)",
        labelPhraseLocal: "Phrase (Local)",
        labelLanguage: "Langue",
        labelDuration: "Durée",
        labelAudio: "Audio",
        labelCreatedAt: "Date de création",
        labelStatus: "Statut",
        durationNA: "N/A",
        audioUnsupported: "Votre navigateur ne supporte pas l'audio.",
        validateTitle: "Valider la Contribution",
        validateDescription: "Évaluez et approuvez ou rejetez cette contribution",
        actionLabel: "Action *",
        actionApprove: "Approuver",
        actionReject: "Rejeter",
        qualityScore: "Score de qualité ({score}%)",
        rejectReason: "Raison du rejet",
        rejectPlaceholder: "Expliquez pourquoi vous rejetez cette contribution...",
        cancel: "Annuler",
        processing: "Traitement...",
        successApproved: "Contribution approuvée avec succès",
        successRejected: "Contribution rejetée avec succès",
        errorLoad: "Erreur lors du chargement des contributions",
        errorValidate: "Erreur lors de la validation",
        durationSeconds: "{seconds}s",
      },
      uploads: {
        title: "Imports {type}",
        subtitle: "Déposez des fichiers, configurez leurs métadonnées puis lancez le transfert. Tous les imports sont journalisés.",
        settings: "Paramètres",
        settingsDescription: "Définissez la langue cible et la note interne.",
        targetLanguage: "Langue cible *",
        selectLanguage: "Sélectionnez une langue",
        internalNote: "Note interne",
        internalNotePlaceholder: "Contexte, source, instructions...",
        frenchTextOptional: "Texte en français (optionnel)",
        frenchTextPlaceholder: "Texte correspondant en français",
        localTranscriptionOptional: "Transcription en langue locale (optionnelle)",
        openKeyboard: "Cliquez pour ouvrir le clavier...",
        acceptedFormats: "Formats acceptés",
        importZone: "Zone d'import",
        importZoneDescription: "Glissez vos fichiers ou parcourez votre disque.",
        dropFiles: "Déposez les fichiers ici",
        browseComputer: "parcourez votre ordinateur",
        queueTitle: "File d'attente",
        queueSummary: "{count} fichier en attente",
        queueSummaryPlural: "{count} fichiers en attente",
        queueEmptyDescription: "Aucun fichier. Ajoutez des éléments via la zone d'import.",
        startAll: "Lancer tout",
        clearCompleted: "Nettoyer terminés",
        resetQueue: "Réinitialiser",
        file: "Fichier",
        language: "Langue",
        description: "Description",
        progress: "Progression",
        status: "Statut",
        actions: "Actions",
        emptyQueue: "Aucun fichier dans la file d'attente",
        notePlaceholder: "Note",
        start: "Lancer",
        cancelUpload: "Annuler",
        retry: "Relancer",
        statsPending: "En attente",
        statsUploading: "En cours",
        statsCompleted: "Terminés",
        statsFailed: "Échecs / Annulés",
        loadLanguagesError: "Erreur lors du chargement des langues",
        extensionNotSupported: "Extension {extension} non prise en charge",
        missingExtension: "Ce fichier ne possède pas d'extension reconnue",
        fileTooLarge: "Fichier trop volumineux ({size} > {limit} MB)",
        cannotAddFile: "Impossible d'ajouter {name}",
        addedTitle: "{count} fichier ajouté",
        addedTitlePlural: "{count} fichiers ajoutés",
        addedDescription: "Vérifiez la file d'attente avant de lancer l'upload.",
        uploadFailed: "Échec de l'upload",
      },
      models: {
        badge: "Modèles",
        title: "Modèles et performances",
        subtitle: "Vue d'ensemble des modèles et de leurs métriques",
        refresh: "Actualiser",
        modelsLabel: "Modèles",
        endpointsLabel: "Endpoints",
        evaluationsLabel: "Évaluations",
        loadError: "Impossible de charger les modèles",
        loading: "Chargement...",
        emptyTitle: "Aucun modèle {type} trouvé",
        emptyDescription: "Créez un nouveau modèle depuis la page Configuration API",
        supportedLanguages: "Langues supportées",
        noLanguages: "Aucune langue configurée",
        apiEndpoints: "Endpoints API",
        noEndpoints: "Aucun endpoint configuré",
        auth: "Auth",
        performanceMetrics: "Métriques de performance",
        evaluations: "{count} évaluation",
        evaluationsPlural: "{count} évaluations",
        mosDescription: "Mean Opinion Score - Qualité perçue",
        cmosDescription: "Comparative Mean Opinion Score",
        werDescription: "Word Error Rate - Taux d'erreur de mots",
        cerDescription: "Character Error Rate - Taux d'erreur de caractères",
        noEvaluation: "Aucune évaluation disponible pour ce modèle",
        createdOn: "Créé le {date}",
      },
      requests: {
        title: "Demandes d'accès administrateur",
        loading: "Chargement...",
        empty: "Aucune demande",
        documents: "Documents : {count}",
        approve: "Approuver",
        deny: "Refuser",
        loadError: "Impossible de charger les demandes",
        approvePrompt: "Commentaire (optionnel)",
        denyPrompt: "Raison du refus (obligatoire)",
        approveTitle: "Approuvé",
        approveDescription: "Demande approuvée.",
        approveError: "Impossible d'approuver",
        denyTitle: "Refusé",
        denyDescription: "Demande refusée.",
        denyError: "Impossible de refuser",
      },
      complaints: {
        badge: "Signalements",
        title: "Signalements",
        subtitle: "Gérez les retours, bugs et suggestions soumis par les utilisateurs",
        refresh: "Actualiser",
        all: "Tous les signalements",
        stats: "Statistiques",
        empty: "Aucune soumission pour le moment.",
        anonymous: "Anonyme",
        noPage: "—",
        allTypes: "Tous les types",
        allStatuses: "Tous les statuts",
        clearFilters: "Effacer les filtres",
        tableDate: "Date",
        tableType: "Type",
        tableUser: "Utilisateur",
        tableMessage: "Message",
        tableStatus: "Statut",
        tableActions: "Actions",
        statusNew: "Nouveau",
        statusInProgress: "En cours",
        statusResolved: "Résolu",
        typeBug: "Bug",
        typeSuggestion: "Suggestion",
        typeOther: "Autre",
        markResolved: "Marquer résolu",
        delete: "Supprimer",
        updated: "Statut mis à jour",
        updateFailed: "Échec de la mise à jour",
        deleted: "Signalement supprimé",
        deleteFailed: "Échec de la suppression",
        statsTotal: "Total",
        statsOpen: "Ouverts",
        statsOverview: "Vue d'ensemble",
        statsResolutionRate: "Taux de résolution",
        statsCategory: "Catégorie",
        statsLabel: "Libellé",
        statsCount: "Nombre",
        statsPercent: "Part",
        statsByType: "Par type",
        statsByStatus: "Par statut",
        statsDetailedBreakdown: "Répartition détaillée",
        chartByType: "Répartition par type",
        chartByTypeDesc: "Profil des signalements selon leur catégorie",
        chartByStatus: "Répartition par statut",
        chartByStatusDesc: "Progression du traitement des signalements",
        chartTrend: "Tendance des signalements",
        chartTrendDesc: "Volume de signalements sur les 14 derniers jours",
        chartTrendTotal: "Total période",
        chartTrendPeriod: "14 derniers jours",
        chartTrendPeak: "Pic journalier",
        noData: "Aucune donnée disponible",
        pageOf: "Page",
        viewMessage: "Voir le message",
        viewFull: "Message complet",
        replyTitle: "Répondre",
        replyDescription: "Envoyer une réponse à l'utilisateur",
        replyMessage: "Votre réponse",
        replyMessagePlaceholder: "Écrivez votre réponse...",
        replyChannel: "Canal d'envoi",
        replyViaEmail: "Email",
        replyViaSms: "SMS",
        replyNoContact: "Aucun contact disponible",
        replySend: "Envoyer",
        replySending: "Envoi...",
        replySuccess: "Réponse envoyée",
        replyFailed: "Échec de l'envoi",
        close: "Fermer",
        phone: "Téléphone",
      },
      panels: {
        uploadsTitle: "Imports de contenu",
        statsTitle: "Statistiques",
        contributionsPerLanguage: "Contributions par langue",
        contributionBreakdownTitle: "Répartition des contributions",
        textContributions: "Réponses écrites aux questions",
        audioTranslationContributions: "Audios transcrits",
        initialDataContributions: "Réponses aux questions",
        earningsPerLanguage: "Gains par langue",
        noData: "Aucune donnée",
        remindersTitle: "Rappels",
        newReminder: "Nouveau rappel",
        noReminders: "Aucun rappel envoyé pour l'instant.",
        reminderDialogTitle: "Envoyer un rappel",
        reminderDialogDesc: "Le rappel apparaît dans les notifications des destinataires.",
        reminderDialogDescScoped: "Le rappel est limité aux langues qui vous sont attribuées.",
        reminderAudience: "Destinataires",
        reminderTargetUsers: "Contributeurs",
        reminderTargetModerators: "Modérateurs",
        reminderTargetAdmins: "Administrateurs",
        reminderLanguages: "Langues",
        reminderAllLanguages: "Aucune langue sélectionnée : tout votre périmètre.",
        reminderSelectedLanguages: "Restreint aux langues sélectionnées.",
        reminderTitleField: "Titre",
        reminderTitlePlaceholder: "Rappel : contributions du mois",
        reminderMessageField: "Message",
        reminderMessagePlaceholder: "Détaillez ce que vous attendez des destinataires…",
        reminderSubmit: "Envoyer",
        reminderSending: "Envoi…",
        reminderSent: "Rappel envoyé à {count} destinataire(s).",
        reminderMissingFields: "Le titre et le message sont obligatoires.",
        reminderError: "L'envoi du rappel a échoué.",
        reminderRecipients: "{count} destinataire(s)",
        reminderReadCount: "{count} lu(s)",
        reminderChannels: "Canaux",
        reminderChannelInApp: "In-app",
        reminderChannelSms: "SMS",
        reminderChannelEmail: "Email",
        reminderChannelsHint: "La notification in-app est toujours créée ; SMS et email s'ajoutent pour les destinataires joignables.",
        reminderActivity: "Activité",
        reminderActivityAll: "Tous",
        reminderActivityActive: "Actifs (14 j)",
        reminderActivityInactive: "Inactifs",
        reminderGender: "Sexe",
        reminderGenderAll: "Tous",
        reminderGenderFemale: "Femmes",
        reminderGenderMale: "Hommes",
        reminderGenderUnset: "Profil à compléter",
        reminderCountries: "Pays",
        reminderCountriesPlaceholder: "Togo, BJ (vide = tous)",
        reminderSectors: "Secteurs",
        reminderSectorsHint: "Contributeurs ayant répondu à au moins une question du secteur. Vide = tous.",
        reminderSectorsUnavailable: "Secteurs indisponibles pour le moment.",
        reminderPlaces: "Lieux de collecte",
        reminderPlacesPlaceholder: "Rechercher une ville (ex. Lomé)",
        reminderPlacesHint: "Personnes ayant enregistré ou collecté au moins une fois dans ce lieu. Vide = partout.",
        reminderPlacesSearching: "Recherche…",
        reminderPlacesNoResult: "Aucun lieu trouvé.",
        reminderPlacesUnavailable: "Recherche de lieux indisponible.",
        reminderPlaceRemove: "Retirer {city}",
        reminderErrorNoRecipient: "Aucun contributeur actif ne correspond à ce ciblage.",
        reminderErrorTargetRequired: "Choisissez au moins un critère de ciblage.",
        reminderErrorSendAt: "Date d'envoi invalide.",
        reminderErrorSendAtTooFar: "La date d'envoi dépasse l'horizon de 90 jours.",
        reminderErrorNoScope: "Aucune langue ne vous est attribuée : diffusion impossible.",
        reminderErrorOutOfScope: "Une des langues choisies est hors de votre périmètre.",
        reminderErrorAdminTarget: "Seul un super admin peut écrire aux administrateurs.",
        reminderErrorInvalid: "Le ciblage contient une valeur invalide.",
        reminderSendAt: "Envoi différé",
        reminderScheduled: "Campagne planifiée pour {date} ({count} destinataire(s) au ciblage actuel).",
        reminderDelivery: "SMS : {sms} envoyés / Email : {email} envoyés.",
        reminderSendingExternal: "Les SMS et emails partent en arrière-plan : le résultat s'affichera dans Campagnes.",
        reminderAlreadySent: "Ce rappel est déjà parti à {count} destinataire(s) : il n'a pas été renvoyé.",
        reminderDeliveryInProgress: "SMS et emails en cours d'envoi",
        reminderDeliverySms: "SMS : {sent} envoyé(s)",
        reminderDeliveryEmail: "Email : {sent} envoyé(s)",
        reminderDeliveryFailures: "{count} échec(s)",
        reminderDeliveryStopped: "Envoi externe interrompu",
        campaignsTitle: "Campagnes",
        campaignsDescription: "Les rappels envoyés aux contributeurs et aux modérateurs, avec leurs canaux et le résultat de l'envoi.",
        campaignsSeeAll: "Toutes les campagnes",
        reminderTemplate: "Modèle",
        reminderTemplateNone: "Sans modèle",
        reminderTemplateSave: "Enregistrer comme modèle",
        reminderTemplateName: "Nom du modèle",
        reminderTemplateSaved: "Modèle « {name} » enregistré.",
        scheduledTitle: "Campagnes planifiées",
        scheduledEmpty: "Aucune campagne planifiée.",
        scheduledCancel: "Annuler",
        scheduledCancelled: "Planification annulée.",
        scheduledCancelError: "Impossible d'annuler cette planification.",
        scheduledStatusPending: "En attente",
        scheduledStatusSent: "Envoyée",
        scheduledStatusFailed: "Échouée",
        scheduledStatusCancelled: "Annulée",
        paymentsTitle: "Paiements",
        noPayments: "Aucun paiement en attente.",
        status: "Statut : {status}",
        markPaid: "Marquer payé",
        finalValidationTitle: "Validation finale",
        noValidation: "Aucun test prêt pour validation.",
        validate: "Valider",
        moderationTitle: "Modération des tests",
        testsTab: "Tests",
        numerationTab: "Demande de numérotation",
        noModeration: "Aucun test en attente de modération.",
        open: "Ouvrir",
        numerationDescription: "Demandez votre numérotation pour les paiements.",
        amountPlaceholder: "Montant (XOF)",
        phonePlaceholder: "Numéro de téléphone",
        notePlaceholder: "Note (optionnel)",
        sendRequest: "Envoyer la demande",
        sending: "Envoi...",
        myRequests: "Mes demandes",
        noRequests: "Aucune demande trouvée.",
        userNotConnected: "Utilisateur non connecté",
        enterPhone: "Veuillez saisir un numéro",
        invalidAmount: "Montant invalide",
        invalidAmountDescription: "Saisissez un montant supérieur à 0",
        requestSent: "Demande envoyée",
        requestSentDescription: "Votre demande a bien été prise en compte.",
        requestError: "Impossible d'envoyer la demande.",
      },
      collectionOverview: {
        nav: "Suivi de la collecte",
        title: "Suivi de la collecte",
        description: "Tout ce que la plateforme a collecté sur la période, tous types de contributions confondus, dans vos langues.",
        period: "Période",
        periods: { "7d": "7 jours", "30d": "30 jours", "90d": "90 jours", "12m": "12 mois", all: "Tout" },
        language: "Langue",
        allLanguagesOption: "Toutes les langues",
        refresh: "Actualiser",
        exportCsv: "Exporter CSV",
        loading: "Chargement du suivi de la collecte",
        errorTitle: "Impossible d'afficher le suivi de la collecte",
        errors: {
          outOfScope: "Cette langue ne fait pas partie de votre périmètre. Choisissez une de vos langues.",
          failed: "Le serveur n'a pas répondu. Actualisez dans un instant.",
        },
        empty: "Aucune contribution sur cette période.",
        totalLabel: "Contributions collectées",
        vsPrevious: "par rapport aux {period} précédents",
        noTrend: "Pas de comparaison sur toute la durée",
        hoursRecorded: "Heures enregistrées",
        validatedShare: "Part validée",
        composition: "Répartition par type",
        types: {
          phraseAudio: "Audios de phrases",
          spokenAnswer: "Réponses orales",
          writtenAnswer: "Réponses écrites",
          transcription: "Transcriptions",
          translation: "Traductions",
          image: "Images",
        },
        byTypeTitle: "Par type de contribution",
        byTypeNote: "Volume, évolution et validation de chaque type. Les heures ne concernent que les enregistrements.",
        colType: "Type",
        colTotal: "Total",
        colTrend: "Évolution",
        colStatus: "Validation",
        colHours: "Heures",
        colContributors: "Contributeurs",
        colLanguage: "Langue",
        statusLine: "{validated} validé, {pending} en attente, {rejected} rejeté",
        openList: "Voir la liste",
        openListOf: "Voir la liste : {type}",
        allLanguages: "Toutes langues",
        allLanguagesHint: "Les images n'ont pas de langue : ce chiffre couvre toute la plateforme.",
        trendTitle: "Évolution de la collecte",
        perDay: "Par jour",
        perMonth: "Par mois",
        measure: "Mesure",
        measureCount: "Nombre",
        measureHours: "Heures",
        hoursNote: "Seuls les audios de phrases et les réponses orales ont une durée.",
        languagesTitle: "Par langue",
        languagesNote: "Ce que chaque langue a collecté, type par type. Les images n'ont pas de langue et n'y figurent pas.",
        unknownLanguage: "Langue non renseignée",
        originsTitle: "D'où vient la collecte",
        originsNote: "Secteurs, lieux de collecte et personnes qui collectent, sur la même période et dans vos langues.",
        sectorsTitle: "Par secteur",
        noSector: "Sans secteur",
        placesTitle: "Lieux de collecte",
        noPlace: "Aucun lieu de collecte renseigné sur cette période.",
        unknownPlace: "{count} contributions sans lieu de collecte (enregistrées avant la saisie du lieu, ou sans lieu).",
        collectorsTitle: "Collecteurs les plus actifs",
        noCollector: "Aucune collecte de terrain sur cette période.",
        colCollector: "Collecteur",
        colItems: "Contributions",
        collectorFallback: "Collecteur n° {id}",
        communityCodesTitle: "Codes communautaires",
        targets: {
          title: "Objectifs",
          note: "Avancement mesuré sur les contributions validées, aux mêmes définitions que le reste de la page.",
          add: "Nouvel objectif",
          addFirst: "Fixer un premier objectif",
          empty: "Aucun objectif pour l'instant. Fixez une cible par langue ou par type, en contributions ou en heures, avec une échéance : la page suivra le rythme et la projection.",
          loadFailed: "Les objectifs n'ont pas pu être chargés. Le reste de la page reste à jour.",
          scope: "{type}, {language}",
          allLanguages: "toutes les langues",
          allLanguagesOption: "Toutes les langues",
          allTypes: "Toutes les contributions",
          allRecordings: "Tous les enregistrements",
          units: { count: "contributions", hours: "h" },
          statuses: { upcoming: "À venir", onTrack: "Dans les temps", behind: "En retard", done: "Atteint", missed: "Manqué" },
          paceMarker: "Rythme attendu aujourd'hui",
          expectedNow: "Attendu aujourd'hui",
          projected: "Projection à l'échéance",
          collected: "Collecté au total",
          notYet: "pas encore",
          window: "Du {start} au {due}.",
          daysLeft: "{days} jours restants.",
          edit: "Modifier l'objectif",
          delete: "Supprimer",
          deleteTitle: "Supprimer cet objectif ?",
          deleteDescription: "« {name} » disparaîtra de la page. Les contributions ne sont pas touchées.",
          deleteFailed: "La suppression a échoué. Réessayez.",
          newTitle: "Nouvel objectif",
          editTitle: "Modifier l'objectif",
          formHint: "Seules les contributions validées font avancer un objectif.",
          metric: "Mesure",
          metrics: { count: "Contributions", hours: "Heures" },
          valueCount: "Nombre de contributions validées",
          valueHours: "Heures d'enregistrement validées",
          validatedOnly: "Les contributions en attente ou rejetées sont affichées à part, sans compter.",
          language: "Langue",
          type: "Type",
          startsOn: "Début",
          dueOn: "Échéance",
          label: "Nom (facultatif)",
          labelPlaceholder: "Ex. Ewe, fin d'année",
          cancel: "Annuler",
          save: "Enregistrer",
          saving: "Enregistrement…",
          formErrors: {
            value: "Indiquez un nombre entier supérieur à 0.",
            dates: "L'échéance doit tomber après la date de début.",
            hoursType: "Les heures ne se mesurent que sur les enregistrements.",
          },
          serverErrors: {
            TARGET_HOURS_NEED_RECORDINGS: "Les heures ne se mesurent que sur les enregistrements.",
            TARGET_DATES_INVALID: "L'échéance doit tomber au moins un jour après le début.",
            TARGET_LIMIT_REACHED: "50 objectifs au plus : supprimez-en un avant d'en créer un autre.",
            TARGET_NOT_FOUND: "Cet objectif n'existe plus. Rechargez la page.",
            LANGUAGE_OUT_OF_SCOPE: "Cette langue ne fait pas partie de celles que vous gérez.",
            failed: "L'enregistrement a échoué. Réessayez.",
          },
        },
        sources: { phrase: "dont audios de phrases", initialAnswer: "dont réponses orales" },
        sourceValidated: ", {validated} validées",
        othersTitle: "Autres activités",
        othersNote: "Comptées à part : elles n'entrent ni dans le total ni dans les graphiques ci-dessus.",
        otherActivities: {
          imageAnnotation: {
            title: "Annotations d'images",
            hint: "Réponses aux sessions d'annotation, toutes langues",
            status: "correctes {validated}, sans réponse {pending}, fausses {rejected}",
            empty: "Aucune annotation sur cette période.",
          },
          textCollection: {
            title: "Collecte texte hors ligne",
            hint: "Textes envoyés depuis la collecte hors connexion",
            status: "validés {validated}, en attente {pending}, rejetés {rejected}",
            empty: "Aucun texte collecté hors ligne sur cette période.",
          },
          qualificationTest: {
            title: "Tests de qualification",
            hint: "Tests de qualification passés par les contributeurs",
            status: "validés {validated}, en attente {pending}, rejetés {rejected}",
            empty: "Aucun test sur cette période.",
          },
        },
      },
      contributionStats: {
        nav: "Statistiques",
        badge: "Contributions",
        title: "Statistiques des contributions",
        accuracyTitle: "Précision des transcriptions",
        accuracyNote: "Taux d'acceptation : part des transcriptions décidées qui ont été validées. Accord : part des transcriptions décidées avec au moins 2 votes où tous les validateurs ont voté dans le même sens.",
        accuracyOverall: "Toutes langues",
        accuracyTotal: "Transcriptions",
        accuracyAcceptance: "Acceptation",
        accuracyAgreement: "Accord",
        accuracyEmpty: "Aucune transcription sur cette période.",
        accuracyError: "Impossible de charger la précision des transcriptions.",
        accuracySource: "Audios transcrits",
        accuracySourceAll: "Tous",
        accuracySourcePhrase: "Phrases",
        accuracySourceInitialAnswer: "Réponses orales",
        description: "Volumes par type, statut, langue et période. Les chiffres suivent les langues que vous gérez.",
        period: "Période",
        p7d: "7 jours",
        p30d: "30 jours",
        p90d: "90 jours",
        p12m: "12 mois",
        pall: "Tout",
        allLanguages: "Toutes les langues",
        refresh: "Actualiser",
        loading: "Chargement…",
        error: "Impossible de charger les statistiques.",
        retry: "Réessayer",
        hoursPeriod: "Heures enregistrées",
        hoursInitialDataNote: "dont {hours} de réponses aux questions",
        hoursValidatedAllTime: "Heures validées (toutes périodes)",
        texts: "Textes et traductions",
        transcriptions: "Transcriptions audio",
        images: "Images",
        initialData: "Réponses aux questions",
        total: "Total",
        validated: "Validées",
        pending: "En attente",
        rejected: "Rejetées",
        contributors: "Contributeurs",
        language: "Langue",
        byLanguage: "Par langue",
        evolution: "Évolution",
        perDay: "par jour",
        perMonth: "par mois",
        noData: "Aucune contribution sur cette période.",
        textsNote: "Une ligne par phrase traduite, avec le statut de sa meilleure traduction.",
        transcriptionsNote: "Tous les audios transcrits, y compris ceux qui attendent encore une validation.",
        imagesNote: "Les images n'ont pas de langue : ces chiffres couvrent toute la plateforme.",
        initialDataBySector: "Réponses aux questions par secteur",
        initialDataNote: "Réponses aux questions, audio et texte, par secteur et par langue.",
        audiosBySector: "Audios collectés par secteur",
        audiosBySectorNote: "Phrases enregistrées par secteur : volume, heures et avancement de la validation. Toutes périodes confondues.",
        sector: "Secteur",
        noSector: "Sans secteur",
        answers: "Réponses",
        audio: "Audio",
        text: "Texte",
        hours: "Heures",
        qualityTitle: "Qualité des audios par langue",
        qualityNote: "Toutes périodes. Taux d'acceptation des enregistrements et durée moyenne.",
        acceptance: "Acceptation",
        avgDuration: "Durée moyenne",
        recordings: "Enregistrements",
        openList: "Voir la liste",
      },
      contributionTimeByLanguage: {
        badge: "Temps par langue",
        title: "Temps d'enregistrement par langue",
        description: "Somme du temps enregistré sur les phrases et sur les réponses audio aux questions, pour les langues de votre périmètre.",
        columnLanguage: "Langue",
        columnContributors: "Contributeurs",
        columnAudios: "Enregistrements",
        columnDuration: "Temps total",
        columnShare: "Part",
        totalRow: "Total",
        loading: "Chargement du temps par langue…",
        empty: "Aucun enregistrement pour le moment.",
        error: "Impossible de charger le temps par langue.",
        retry: "Réessayer",
        refresh: "Actualiser",
        missingDuration: "{count} enregistrement sans durée enregistrée|{count} enregistrements sans durée enregistrée",
      },
      contributionsCommon: {
        badge: "Contributions",
        description: "Consultez, filtrez et gérez l'ensemble des contributions audio.",
        pageTitle: "Audios",
        totalContributions: "Contributions",
        uploadDate: "Date de téléchargement",
        validations: "Validations",
        rejections: "Rejets",
        date: "Date",
        language: "Langue",
        phraseFr: "Phrase (FR)",
        phraseLocal: "Phrase (Local)",
        duration: "Durée",
        durationMs: "Durée (ms)",
        durationSeconds: "Durée (s)",
        gender: "Genre",
        blobName: "Fichier",
        transcriptionRetenue: "Transcription retenue",
        score: "Score",
        status: "Statut",
        source: "Source",
        domain: "Domaine",
        retained: "Retenue",
        pending: "En attente",
        rejected: "Rejetée",
        refresh: "Actualiser",
        downloadAll: "Télécharger tous",
        exporting: "Export...",
        searchPlaceholder: "Filtrer par langue",
        allLanguages: "Toutes les langues",
        allStatuses: "Tous les statuts",
        resetFilters: "Réinitialiser les filtres",
        loading: "Chargement...",
        noResults: "Aucune contribution audio trouvée",
        actions: "Actions",
        play: "Écouter",
        download: "Télécharger",
        openLink: "Ouvrir le lien",
        previous: "Précédent",
        next: "Suivant",
        pageSummary: "Page {page} sur {totalPages} ({total} contributions)",
        downloadError: "Impossible de télécharger le fichier",
        noAudioToDownload: "Aucun audio à télécharger",
        exportJsonError: "Impossible d'exporter en JSON",
        exportExcelError: "Impossible d'exporter en Excel",
        bulkDownloadError: "Impossible de télécharger les fichiers",
        downloadSuccess: "{count} fichier(s) téléchargé(s)",
        downloadPartial: "{success} téléchargé(s), {failed} erreur(s)",
        downloadFailed: "Impossible de télécharger les {count} fichier(s)",
        exportSuccess: "{count} contributions exportées",
        fileOrder: "N° dans le fichier",
        fileOrderFilter: "N° dans le fichier",
        fileOrderPlaceholder: "Tous",
        noFileOrder: "—",
        openSourceRow: "Ouvrir la ligne dans le fichier",
      },
      sourceFileRow: {
        title: "Ligne {row} du fichier {file}",
        description:
          "La ligne de l'enregistrement, dans le fichier depuis lequel il vient. Lecture seule.",
        loading: "Chargement du fichier...",
        error: "Impossible de charger le fichier",
        retry: "Réessayer",
        notFound: "Cette ligne n'existe pas dans le fichier",
        columnNumber: "N°",
        columnLocal: "Phrase (Local)",
        columnFrench: "Phrase (FR)",
        columnDomain: "Domaine",
        empty: "Le fichier ne contient aucune ligne",
      },
      initialData: {
        badge: "Contributions initiales",
        title: "Réponses",
        description: "Consultez les contributions initiales réalisées par les administrateurs et super administrateurs, filtrables par type, secteur et langue.",
        signalSectors: "Secteurs",
        signalLanguages: "Langues",
        signalTotal: "Contributions",
        filtersBadge: "Filtres",
        filtersDescription: "Les résultats se mettent à jour dès qu'un filtre change. Sans secteur ni langue, toutes vos langues sont affichées.",
        type: "Type",
        audio: "Audio initial",
        text: "Texte initial",
        sector: "Secteur",
        selectSector: "Tous les secteurs",
        language: "Langue",
        selectLanguage: "Toutes les langues",
        apply: "Appliquer les filtres",
        loadingFilters: "Chargement des filtres...",
        resetFilters: "Réinitialiser les filtres",
        listBadge: "Contributions",
        listDescription: "Résultats pour les filtres choisis, paginés par lots de dix.",
        refresh: "Actualiser",
        question: "Question",
        questionAudio: "Audio de la question",
        responseAudio: "Audio de la réponse",
        duration: "Durée",
        questionLocal: "Question locale",
        responseLocal: "Réponse locale",
        date: "Date",
        noAudio: "Aucun audio",
        notAvailable: "N/A",
        loading: "Chargement...",
        errorTitle: "Erreur de chargement",
        noResults: "Aucune contribution ne correspond à ces filtres",
        selectFiltersMessage: "Sélectionnez un type, un secteur et une langue, puis cliquez sur « Appliquer les filtres » pour afficher les contributions.",
        signalHours: "Heures enregistrées",
        signalHoursMissing: "{count} audio(s) sans durée",
        signalHoursSuspect: "{count} durée(s) à vérifier",
        signalAudioText: "Audio / texte",
        status: "Statut",
        statusDefault: "Tous sauf rejetés",
        statusPending: "En attente",
        statusApproved: "Approuvés",
        statusRejected: "Rejetés",
        statusAll: "Tous les statuts",
        from: "Du",
        to: "Au",
        contributor: "Contributeur",
        contributorPlaceholder: "ID du contributeur",
        communityCode: "Profil communautaire",
        communityCodePlaceholder: "Code du profil",
        search: "Recherche",
        searchPlaceholder: "Rechercher dans les questions et réponses",
        updating: "Mise à jour...",
        contributorColumn: "Contributeur",
        statusColumn: "Statut",
        transcription: "Transcription",
        transcriptionWaiting: "En attente de transcription",
        transcriptionProposed: "{count} proposition(s) en revue",
        transcriptionFinal: "Transcription validée",
        transcriptionRejected: "Retirée des files",
        transcriptionNone: "Pas encore dans le circuit de transcription",
        durationMissing: "Durée inconnue",
        durationSuspect: "Durée à vérifier",
        approvedByVote: "Approuvée par vote",
        approvedByReview: "Approuvée par relecture",
        breakdownBadge: "Répartition",
        breakdownDescription: "Contributions et heures enregistrées par secteur et par langue, pour les mêmes filtres (audio et texte confondus).",
        breakdownSector: "Secteur",
        breakdownLanguage: "Langue",
        breakdownCount: "Contributions",
        breakdownAudio: "Audio",
        breakdownText: "Texte",
        breakdownHours: "Heures",
        breakdownMissing: "Sans durée",
        breakdownEmpty: "Aucune donnée pour ces filtres",
        unknownSector: "Secteur inconnu",
        unknownLanguage: "Langue inconnue",
      },
      textContributions: {
        badge: "Contributions texte",
        title: "Textes",
        description: "Consultez, filtrez et gérez les contributions texte issues des transcriptions retenues pour chaque audio.",
        totalLabel: "Total",
        refresh: "Actualiser",
        exportCsv: "CSV",
        exportJson: "JSON",
        exportExcel: "Excel",
        exporting: "Export...",
        allLanguages: "Toutes les langues",
        resetFilters: "Réinitialiser les filtres",
        loading: "Chargement...",
        noResults: "Aucune contribution texte trouvée",
        date: "Date",
        phraseFr: "Phrase (FR)",
        phraseLocal: "Phrase (Local)",
        transcriptionRetenue: "Transcription retenue",
        validations: "Validations",
        rejections: "Rejets",
        status: "Statut",
        score: "Score",
        actions: "Actions",
        previous: "Précédent",
        next: "Suivant",
        pageSummary: "Page {page} sur {totalPages} ({total} résultats)",
        contributor: "Contributeur",
        language: "Langue",
        lastActivity: "Dernière activité",
        detailTitle: "Détail de la transcription",
        detailDescription: "La proposition affichée correspond au meilleur résultat disponible pour cet audio.",
        noSelection: "Sélectionnez une contribution pour voir le détail.",
        sourceText: "Phrase source",
        localReference: "Référence locale",
        bestTranscription: "Meilleure transcription retenue",
        sourceAudio: "Audio source",
        noAudio: "Aucun audio disponible pour cette contribution.",
        createdAt: "Créée le",
        updatedAt: "Mise à jour",
        pending: "En attente",
        retained: "Retenue",
        rejected: "Rejetée",
        searchPlaceholder: "Transcription, phrase source, utilisateur...",
        sortPlaceholder: "Trier par...",
        loadError: "Impossible de charger les contributions",
        success: "Succès",
        error: "Erreur",
        exportSuccess: "{count} contributions exportées",
        exportJsonError: "Impossible d'exporter en JSON",
        exportExcelError: "Impossible d'exporter en Excel",
      },
      images: {
        badge: "Images",
        title: "Images",
        subtitle: "Identifiez les lettres visibles sur chaque image avant validation finale.",
        refresh: "Actualiser",
        totalLabel: "Total",
        pending: "À labelliser",
        validated: "Validées",
        rejected: "Illisibles",
        resetFilters: "Réinitialiser les filtres",
        loading: "Chargement...",
        noResults: "Aucune contribution trouvée",
        selectToBegin: "Sélectionnez une image dans la liste pour commencer.",
        characterAttribution: "Attribution du caractère",
        contributor: "Contributeur",
        createdAt: "Créée le",
        currentLabel: "Étiquette",
        noLabel: "Non attribuée",
        characterLabel: "Caractère",
        characterPlaceholder: "Saisissez le caractère",
        save: "Enregistrer",
        saving: "Enregistrement...",
        approve: "Valider",
        reject: "Illisible",
        delete: "Supprimer",
        rejectTitle: "Marquer comme illisible",
        rejectDescription: "Indiquez brièvement pourquoi le caractère n'est pas reconnaissable.",
        rejectPlaceholder: "Exemple : Image trop floue / caractère manquant",
        cancel: "Annuler",
        confirmReject: "Confirmer",
        deleteTitle: "Supprimer l'image",
        deleteDescription: "Cette action est irréversible. L'image sera définitivement supprimée de la plateforme.",
        confirmDelete: "Supprimer",
    loadError: "Erreur de chargement",
    micAccessError: "Impossible d'accéder au micro",
    updateFailed: "Échec de la mise à jour",
        saveSuccess: "Étiquette enregistrée",
        saveSuccessDesc: "Le caractère « {character} » a été associé à l'image.",
        saveError: "Impossible d'enregistrer",
        approveSuccess: "Image validée",
        approveSuccessDesc: "La contribution est maintenant confirmée.",
        approveError: "Validation impossible",
        rejectSuccess: "Contribution marquée",
        rejectSuccessDesc: "L'image a été classée comme illisible.",
        rejectError: "Action impossible",
        reasonRequired: "Motif requis",
        reasonRequiredDesc: "Précisez pourquoi l'image est illisible avant de confirmer.",
        deleteSuccess: "Contribution supprimée",
        deleteSuccessDesc: "L'image a été retirée de la file.",
        deleteError: "Suppression impossible",
        labelRequired: "Étiquette requise",
        labelRequiredDesc: "Sélectionnez ou saisissez le caractère reconnu avant d'enregistrer.",
        count: "{count} contribution|{count} contributions",
      },
      initialDataSession: {
        eyebrow: "Données initiales",
        audioTitle: "Réponses audio",
        textTitle: "Réponses écrites",
        audioSubtitle: "Lisez chaque question en français puis enregistrez la réponse dans votre langue, une question à la fois.",
        textSubtitle: "Lisez chaque question en français puis écrivez la réponse dans votre langue, une question à la fois.",
        metricQuestions: "Questions",
        metricMinutes: "Minutes estimées",
        metricRemaining: "À traiter",
        prepareEyebrow: "Préparer la session",
        prepareTitle: "Langue et secteur",
        languageLabel: "Langue de réponse",
        languagePlaceholder: "Choisir la langue",
        languagesLoading: "Chargement des langues…",
        languagesEmpty: "Aucune langue disponible",
        sectorLabel: "Secteur",
        sectorQuestions: "{count} questions",
        sectorsLoading: "Chargement des secteurs…",
        sectorsEmpty: "Aucun secteur disponible pour le moment.",
        sectorsError: "Impossible de charger les secteurs.",
        instructionsTitle: "Consignes",
        audioInstruction1: "Installez-vous dans un endroit calme.",
        audioInstruction2: "Lisez la question, puis répondez naturellement, comme dans une conversation.",
        audioInstruction3: "Réécoutez votre réponse et refaites-la si besoin avant de valider.",
        audioInstruction4: "Vos enregistrements sont gardés sur cet appareil jusqu'à leur envoi.",
        textInstruction1: "Répondez dans la langue choisie, pas en français.",
        textInstruction2: "Utilisez le clavier de la langue pour les caractères spéciaux (ŋ, ɖ, ɛ, ɔ…).",
        textInstruction3: "Une réponse complète et naturelle vaut mieux qu'une traduction mot à mot.",
        textInstruction4: "Vous pouvez passer une question et y revenir plus tard.",
        back: "Retour",
        start: "Commencer la session",
        sessionEyebrow: "Session en cours",
        questionXofY: "Question {current} sur {total}",
        percentDone: "Complété",
        doneLabel: "Envoyées",
        questionEyebrow: "Question",
        questionFileOrder: "N° dans le fichier",
        frenchLabel: "En français",
        localVersionLabel: "Version existante",
        answerAudioEyebrow: "Votre réponse audio",
        answerTextEyebrow: "Votre réponse écrite",
        answerIn: "Réponse en {language}",
        audioHint: "Appuyez sur Enregistrer, répondez, puis arrêtez.",
        record: "Enregistrer",
        stop: "Arrêter",
        redo: "Refaire",
        recordingLive: "Enregistrement en cours",
        recordingPause: "Pause",
        recordingResume: "Reprendre",
        recordingPaused: "En pause",
        pauseHint: "Le temps en pause n'est pas compté dans la durée.",
        recorded: "Réponse enregistrée",
        micError: "Micro indisponible. Autorisez l'accès au microphone dans votre navigateur.",
        textPlaceholder: "Écrivez la réponse en {language}…",
        keyboard: "Clavier",
        charCount: "{count} caractères",
        translationToggle: "Proposer une traduction de la question (optionnel)",
        translationPlaceholder: "La question en {language}…",
        previous: "Précédente",
        skip: "Passer",
        submitNext: "Valider et continuer",
        submitting: "Envoi…",
        alreadyDone: "Réponse déjà envoyée pour cette question.",
        submitted: "Réponse envoyée",
        submitError: "L'envoi a échoué. Réessayez.",
        audioRequired: "Enregistrez une réponse avant de valider.",
        qualityMeasuring: "Vérification de la qualité du son...",
        qualityOk: "Qualité du son correcte.",
        qualityIssuesTitle: "Cet enregistrement ne peut pas être envoyé :",
        qualityRedoHint: "Réenregistrez dans un endroit calme, à une vingtaine de centimètres du micro.",
        qualityClipped: "le son sature (trop fort ou trop près du micro)",
        qualityMostlySilent: "l'enregistrement est presque entièrement silencieux",
        qualityTooQuiet: "la voix est trop faible",
        qualityNoisy: "le bruit de fond couvre la voix",
        qualityRejected: "Enregistrement refusé",
        textRequired: "Écrivez une réponse avant de valider.",
        progressEyebrow: "Progression du secteur",
        legendCurrent: "En cours",
        legendDone: "Envoyées",
        legendSkipped: "Passées",
        legendWaiting: "En attente",
        questionsLoading: "Chargement des questions…",
        noQuestionsTitle: "Aucune question dans ce secteur",
        noQuestionsBody: "Ce secteur n'a pas encore de questions pour cette langue. Choisissez-en un autre.",
        changeSector: "Choisir un autre secteur",
        loadErrorTitle: "Impossible de charger les questions",
        retry: "Réessayer",
        completeEyebrow: "Session terminée",
        completeTitle: "Merci pour votre contribution",
        completeBody: "{count} réponse(s) envoyée(s) pendant cette session.",
        allDoneBody: "Toutes les questions de ce secteur ont déjà une réponse dans cette langue.",
        skippedLeft: "{count} question(s) passée(s) restent disponibles.",
        reviewSkipped: "Reprendre les questions passées",
        newSession: "Choisir un autre secteur",
        pause: "Mettre en pause",
        pausedToast: "Session mise en pause",
        pausedToastBody: "Vous pourrez reprendre là où vous vous êtes arrêté.",
        resumeTitle: "Reprendre là où vous vous êtes arrêté",
        resumeProgress: "{answered} sur {total} envoyées",
        resumeSkipped: "{count} passée(s)",
        resumePausedOn: "En pause depuis le {date}",
        resume: "Reprendre",
        restart: "Recommencer",
      },
      initialAudio: {
        parameters: "PARAMETRES",
        chooseLanguageAndSector: "Choisissez la langue de soumission et le secteur de travail.",
        selectLanguageLabel: "Sélection de la langue",
        selectLanguagePlaceholder: "Choisir la langue",
        sectorLabel: "Secteur",
        sectorPlaceholder: "Choisir un secteur",
        phrasesLabel: "PHRASES",
        availableLabel: "DISPONIBLES",
        phrasePath: "Parcours des phrases",
        phraseOrderDesc: "Les phrases suivent automatiquement l'ordre du secteur choisi.",
        noPhrasesAvailable: "Aucune phrase disponible pour ce secteur.",
        nextPhrase: "Phrase suivante",
        freeReading: "Lecture libre puis réponse enregistrée sur la même carte.",
        alreadySubmitted: "Vous avez déjà soumis une contribution pour cette phrase. Vous pouvez ajouter une nouvelle phrase en cliquant sur « Phrase suivante ».",
        promptLabel: "Lecture (optionnel)",
        promptHint: "Lisez la phrase si vous souhaitez ajouter un repère audio.",
        responseLabel: "Réponse (obligatoire)",
        responseHint: "Enregistrez la réponse de l'utilisateur pour cette phrase.",
        submitPhrase: "Soumettre cette phrase",
        submitting: "Soumission...",
        loading: "Chargement...",
        submitAll: "Soumettre tout",
        recordingActive: "Enregistrement actif",
        stopRecordingMsg: "Arrêtez l'enregistrement avant de soumettre.",
        incompleteBlocks: "Blocs incomplets ou déjà soumis",
        verifyBlocks: "Vérifiez que tous les blocs ont l'audio réponse et ne sont pas déjà soumis.",
        incompleteBlock: "Bloc incomplet",
        recordResponseMsg: "Enregistrez l'audio réponse avant de soumettre.",
        recordingInProgress: "Enregistrement en cours: bloc {0} ({1})",
        frenchLabel: "FRANCAIS",
        localLabel: "LOCAL",
        alreadySubmittedMsg: "Déjà soumis",
        alreadySubmittedDesc: "Vous avez déjà soumis une contribution pour cette phrase.",
        languageRequiredMsg: "Langue requise",
        languageRequiredDesc: "Veuillez sélectionner une langue.",
        sectorRequiredMsg: "Secteur requis",
        sectorRequiredDesc: "Veuillez sélectionner un secteur.",
        recordingInUseMsg: "Enregistrement en cours",
        recordingStopDesc: "Arrêtez l'enregistrement actif avant d'en démarrer un autre.",
        micUnavailableMsg: "Micro indisponible",
        micAccessDesc: "Autorisez l'accès au microphone pour enregistrer.",
        directRecordingDesc: "Enregistrement direct et progression automatique: phrase 1, puis phrase 2, puis phrase 3.",
        submissionSuccessMsg: "Soumis",
        submissionSuccessDesc: "{0} contribution(s) audio envoyée(s) avec succès.",
        errorMsg: "Erreur",
        submissionErrorDesc: "Impossible d'envoyer les contributions.",
        loadingMsg: "Chargement...",
        noLanguagesAvailable: "Aucune langue disponible",
        noSectorsAvailable: "Aucun secteur disponible",
      },
      apiConfig: {
        badge: "Configuration",
        title: "Configuration API",
        subtitle: "Modèles et endpoints",
        description: "Configurez les modèles TTS, ASR et TEXT ainsi que leurs endpoints API.",
        refresh: "Actualiser",
        newModel: "Nouveau Modèle",
        modelsLabel: "Modèles",
        endpointsLabel: "Endpoints",
        languagesLabel: "Langues",
        createdOn: "Créé le",
        createModelTitle: "Créer un nouveau modèle",
        createModelDesc: "Configurez un nouveau modèle avec ses endpoints API",
        modelName: "Nom du modèle *",
        modelNamePlaceholder: "Ex: Umbaji TTS",
        version: "Version *",
        versionPlaceholder: "Ex: 1.0",
        modelType: "Type de modèle *",
        descriptionLabel: "Description",
        descriptionPlaceholder: "Description du modèle",
        supportedLanguages: "Langues supportées *",
        addLanguage: "Ajouter une langue",
        apiConfiguration: "Configuration API *",
        apiName: "Nom de l'API",
        apiNamePlaceholder: "Ex: tts, transcribe",
        method: "Méthode",
        url: "URL de l'endpoint",
        urlPlaceholder: "https://api.example.com/endpoint",
        authHeader: "Header d'authentification (optionnel)",
        authHeaderPlaceholder: "Authorization",
        authToken: "Variable d'environnement du token (optionnel)",
        authTokenPlaceholder: "TTS_API_KEY",
        addApi: "Ajouter cette API",
        cancel: "Annuler",
        createModel: "Créer le modèle",
        modelTypeLabel: "Type de modèle:",
        loading: "Chargement...",
        noModels: "Aucun modèle trouvé pour le type {type}",
        supportedLanguagesLabel: "Langues supportées:",
        noLanguages: "Aucune langue configurée",
        apiEndpoints: "Endpoints API configurés:",
        noEndpoints: "Aucun endpoint configuré",
        apiAdded: "API ajoutée",
        apiAddedDesc: "Configuration API ajoutée avec succès",
        fillFields: "Veuillez remplir tous les champs requis",
        success: "Succès",
        modelCreated: "Modèle créé avec succès",
        error: "Erreur",
        loadModelsError: "Impossible de charger les modèles",
        createModelError: "Impossible de créer le modèle",
      },
      themeConfig: {
        badge: "Thème",
        title: "Configuration du thème",
        subtitle: "Gérez les thèmes et les domaines de travail",
        description: "Créez des thèmes manuellement ou importez des questions depuis un fichier Excel.",
        refresh: "Actualiser",
        tabs: {
          manual: "Saisie manuelle",
          excel: "Import Excel",
        },
        history: {
          tab: "Historique",
          title: "Imports Excel des thèmes",
          description: "Fichiers importés et questions créées. Les classeurs originaux ne sont pas conservés pour téléchargement.",
          loadedCount: "{count} imports chargés",
          file: "Fichier",
          theme: "Thème",
          sector: "Domaine",
          questions: "Questions",
          author: "Importé par",
          date: "Date (UTC)",
          status: "Statut",
          active: "Actif",
          inactive: "Inactif",
          unknownAuthor: "Compte indisponible",
          loading: "Chargement de l’historique…",
          empty: "Aucun import Excel de thème à afficher.",
          loadError: "Impossible de charger la page suivante.",
          retry: "Réessayer",
          more: "Afficher la suite",
          errors: {
            DEFAULT: "Impossible de charger l’historique des imports.",
            VALIDATION_FAILED: "La demande d’historique est invalide.",
            UNAUTHORIZED: "Veuillez vous reconnecter.",
            FORBIDDEN: "Vous n’avez pas accès à cet historique.",
            NOT_FOUND: "Cet historique est introuvable.",
            INTERNAL_SERVER_ERROR: "Le service est momentanément indisponible.",
          },
        },
        manualForm: {
          themeTitle: "Titre du thème *",
          themeTitlePlaceholder: "Ex: Santé",
          description: "Description *",
          descriptionPlaceholder: "Description détaillée du thème",
          examples: "Exemples *",
          examplesLabel: "Exemples (un par ligne)",
          examplesPlaceholder: "Exemple 1\nExemple 2\nExemple 3",
          save: "Enregistrer le thème",
          saving: "Enregistrement...",
          clear: "Réinitialiser",
        },
        excelForm: {
          title: "Titre du thème *",
          titlePlaceholder: "Ex: Santé",
          description: "Description *",
          descriptionPlaceholder: "Description détaillée",
          sector: "Secteur",
          sectorPlaceholder: "Ex: health, education",
          language: "Langue",
          languagePlaceholder: "Sélectionner une langue",
          selectFile: "Sélectionner un fichier",
          selectFileButton: "Choisir un fichier Excel",
          downloadTemplate: "Télécharger le modèle Excel",
          fileSelected: "{filename} sélectionné",
          preview: "Aperçu",
          upload: "Importer",
          uploading: "Import en cours...",
          validationErrors: "Erreurs de validation",
          noFile: "Aucun fichier sélectionné",
          fileEmpty: "Le fichier Excel est vide",
          fileFormatError: "Veuillez sélectionner un fichier Excel (.xlsx, .xls) ou CSV",
          rowError: "Ligne {line}: \"{field}\" est requis",
          readError: "Erreur lors de la lecture du fichier: {error}",
          rowsFound: "{count} question(s) trouvée(s) dans le fichier",
          errorsFound: "{count} erreur(s) trouvée(s) dans le fichier",
          dragAndDrop: "Glissez-déposez un fichier ou cliquez pour sélectionner",
          changeFile: "Changer de fichier",
          maxSize: "Taille maximale: 10MB",
          excelFormatRequired: "Format Excel requis:",
          questionFrRequired: "questionFr (obligatoire) - Question ou réplique en français",
          previewTitle: "Aperçu des données ({count} questions)",
          viewDetails: "Voir les détails",
          fileValid: "✓ Fichier valide",
          readyToImport: "{count} question(s) prête(s) à être importée(s)",
          errorsDetected: "Erreurs détectées:",
          andMore: "...et {count} autre(s)",
          creatingInProgress: "Création en cours...",
          createAndImport: "Créer le Thème et Importer les Questions",
        },
        success: "Succès",
        themeSaved: "Thème enregistré avec succès",
        themeImported: "Thème importé avec succès",
        error: "Erreur",
        saveError: "Erreur lors de l'enregistrement du thème",
        importError: "Erreur lors de l'import du thème",
        loading: "Chargement...",
      },
    },
    accountant: {
      badge: "Espace comptable",
      title: "Dashboard",
      description: "Gestion des paiements manuels, suivi des demandes et historique des transactions.",
      refresh: "Actualiser",
      loading: "Chargement...",
      empty: "Aucune donnée disponible.",
      error: "Erreur",
      retry: "Réessayer",
      back: "Retour",
      save: "Enregistrer",
      cancel: "Annuler",
      confirm: "Confirmer",
      abort: "Annuler",
      exportCsv: "Export CSV",
      exporting: "Export...",

      dashboardBadge: "Espace comptable",
      dashboardTitle: "Dashboard",
      totalToPay: "Total à payer",
      totalPaid: "Total payé",
      paidToday: "Payé aujourd'hui",
      pendingRequests: "Demandes en attente",
      estimatedBudget: "Budget estimé",
      trendTitle: "Flux",
      trendDescription: "Montants à traiter - 7 jours",
      budgetTitle: "Budget",
      budgetEnvelope: "Enveloppe interne",
      budgetUsed: "Utilisé",
      budgetAllocated: "Disponible",
      budgetReserved: "Réservé",
      recentActivity: "Activité",
      recentActivityDescription: "Dernières transactions",
      noRecentTransactions: "Aucune transaction récente.",
      alertsTitle: "Alertes",
      alertsDescription: "Erreurs de paiement",
      alertsCount: "{count} à vérifier",
      noAlerts: "Aucun échec récent.",
      open: "Ouvrir",
      viewHistory: "Historique",
      treatRequests: "Traiter les demandes",

      requestsBadge: "Comptabilité",
      requestsTitle: "Demandes à payer",
      requestsDescription: "Liste des demandes approuvées en attente de traitement comptable.",
      amountAfterFilters: "Montant après filtres",
      requestsTableTitle: "Demandes approuvées",
      requestsTableDescription: "Cliquez sur une demande pour voir le détail et effectuer le paiement.",
      colUser: "Utilisateur",
      colRole: "Rôle",
      colRequested: "Demandé",
      colCalculated: "Calculé",
      colPhone: "Téléphone",
      colNetwork: "Réseau",
      colDate: "Date",
      colStatus: "Statut",
      colActions: "Actions",
      openRequest: "Ouvrir",
      payRequest: "Payer",
      viewDetail: "Voir détail",
      noRequests: "Aucune demande pour ces filtres",
      noRequestsHint: "Essayez un statut plus large ou une plage de dates différente.",
      loadError: "Impossible de récupérer les demandes",
      loadErrorHint: "Vérifiez votre connexion et réessayez.",

      detailBadge: "Détail",
      detailTitle: "Demande de paiement",
      detailDescription: "Contexte de la demande, validations et interface de paiement manuel.",
      infoTitle: "Informations complètes",
      infoDescription: "Utilisateur, contributions, validation admin et métadonnées de paiement.",
      infoUser: "Utilisateur",
      infoContributions: "Contributions",
      infoPhone: "Téléphone",
      infoBudget: "Budget estimé",
      infoRole: "Rôle",
      infoEmail: "Email",
      infoNoEmail: "Sans email fourni",
      infoNetwork: "Réseau",
      infoCalcAmount: "Montant calculé",
      infoBudgetHint: "Repère interne pour suivi comptable",
      timelineTitle: "Historique des validations",
      timelineDescription: "Timeline pour le modérateur, l'admin puis l'action comptable.",
      noTimeline: "Aucun historique transmis par le backend.",
      paymentTitle: "Interface de paiement manuel",
      paymentDescription: "Référence, méthode et note interne.",
      paymentAlreadyPaid: "Cette demande a déjà été payée. Les actions sont désactivées.",
      paymentMarkPaid: "Marquer comme payé",
      paymentRetry: "Réessayer le paiement",
      paymentProcessing: "Traitement...",
      paymentFlagIssue: "Annuler / problème",
      paymentLastReference: "Dernière référence",
      paymentMethod: "Méthode",
      paymentReference: "Référence manuelle",
      paymentNote: "Note interne",
      paymentAmount: "Montant",
      paymentPhone: "Téléphone",
      paymentSubmit: "Marquer comme payé",
      confirmPaymentTitle: "Confirmer le paiement manuel",
      confirmFlagTitle: "Confirmer le signalement du problème",
      confirmPaymentDescription: "Cette validation enverra la requête de paiement avec la référence manuelle et mettra à jour l'état de la demande.",
      confirmBeneficiary: "Bénéficiaire",
      confirmAmount: "Montant",
      confirmReference: "Référence",
      confirmMethod: "Méthode",

      historyBadge: "Historique",
      historyTitle: "Historique des paiements",
      historyDescription: "Table des transactions SUCCESS et FAILED, filtres avancés, export CSV et relance rapide depuis les échecs.",
      historySuccessTotal: "Succès filtres",
      historyAllTransactions: "Toutes les transactions",
      historyAllTransactionsDescription: "Cliquez sur un échec pour revenir à la demande et relancer le paiement manuel.",
      colTransactionUser: "Utilisateur",
      colTransactionRole: "Rôle",
      colTransactionAmount: "Montant",
      colTransactionMethod: "Méthode",
      colTransactionReference: "Référence",
      colTransactionStatus: "Statut",
      colTransactionDate: "Date",
      colTransactionActions: "Actions",
      retryPayment: "Réessayer",
      viewRequest: "Voir",
      noTransactions: "Aucune transaction disponible",
      noTransactionsHint: "L'historique se remplira après les premiers traitements comptables.",
      historyLoadError: "Impossible de charger l'historique",
      historyLoadErrorHint: "Contrôlez la disponibilité des endpoints et la pagination backend.",

      filterAllRoles: "Tous les rôles",
      filterAllStatuses: "Tous les statuts",
      filterAllMethods: "Toutes les méthodes",
      filterMinAmount: "Montant min",
      filterDateFrom: "Date début",
      filterDateTo: "Date fin",
      filterSearch: "Recherche par utilisateur, téléphone ou référence",
      filterStatusPending: "En attente",
      filterStatusApproved: "Approuvée",
      filterStatusRejected: "Rejetée",
      filterStatusPaid: "Payée",
      filterStatusCreated: "Créée",
      filterStatusSuccess: "Payé",
      filterStatusFailed: "Échec",

      statusPending: "En attente",
      statusApproved: "Approuvée",
      statusRejected: "Rejetée",
      statusPaid: "Payée",
      txStatusCreated: "Créée",
      txStatusPending: "En cours",
      txStatusSuccess: "Payé",
      txStatusFailed: "Échec",

      methodCash: "Cash",
      methodFlooz: "Flooz",
      methodTmoney: "TMoney",
      methodBankTransfer: "Virement",
      methodMobileMoney: "Mobile money",
      methodOther: "Autre",

      bulkPaymentBadge: "Paiement en lot",
      bulkPaymentTitle: "Payer plusieurs demandes",
      bulkPaymentDescription: "Sélectionnez les demandes approuvées et traitez-les en une seule opération.",
      bulkSelectAll: "Tout sélectionner",
      bulkSelected: "{count} sélectionnée(s)",
      bulkPay: "Payer la sélection",
      bulkConfirmTitle: "Confirmer le paiement en lot",
      bulkConfirmDescription: "{count} demandes seront marquées comme payées. Cette action est irréversible.",
      bulkNoSelection: "Sélectionnez au moins une demande",
      bulkSuccess: "{count} demandes payées avec succès",
      bulkError: "Erreur lors du paiement en lot",

      analyticsBadge: "Analyses",
      analyticsTitle: "Analyses avancées",
      analyticsDescription: "Répartition des paiements par méthode, rôle et période.",
      analyticsMethodBreakdown: "Par méthode de paiement",
      analyticsRoleBreakdown: "Par rôle",
      analyticsPeriodTrend: "Tendance sur 30 jours",
      analyticsTopRecipients: "Top bénéficiaires",
      analyticsNoData: "Pas encore de données suffisantes pour les analyses.",

      budgetAlertTitle: "Budget bas",
      budgetAlertDescription: "Le budget disponible est inférieur au seuil configuré.",
      budgetAlertThreshold: "Seuil : {amount}",
      budgetAlertDismiss: "Ignorer",

      exportPdf: "Exporter PDF",
      exportCsvFormatted: "CSV formaté",
      exportSuccess: "Export réussi",
      exportError: "Erreur lors de l'export",

      unknownUser: "Utilisateur inconnu",
      contributionsCount: "{count} contributions",
    },

    // Premium African Keyboard
    keyboard: {
      quickHint: "Ponctuation rapide • Appui long pour les variantes",
      toolbar: {
        expandMode: "Mode étendu",
        compactMode: "Mode compact",
        help: "Aide du clavier",
        close: "Fermer le clavier",
      },
      help: {
        title: "Guide du Clavier Premium",
        subtitle: "Guide complet des fonctionnalités",
        longPress: {
          title: "Appui long",
          description: "Maintenez enfoncée une voyelle ou un caractère spécial pendant 500ms pour voir toutes les variantes avec diacritiques.",
        },
        modes: {
          title: "Compact/Étendu",
          description: "Basculez entre la vue compacte (caractères essentiels) et la vue étendue (tous les caractères visibles).",
        },
        layers: {
          title: "6 Couches de clavier",
          african: "Caractères spéciaux africains",
          basic: "Alphabet latin de base",
          punctuation: "Nombres et symboles",
          diacritics: "Marques tonales",
        },
        punctuation: {
          title: "Ponctuation rapide",
          description: "Rangée fixe en bas avec accès instantané aux signes de ponctuation courants.",
        },
        characters: {
          title: "Caractères supportés",
          vowels: "Voyelles africaines :",
          consonants: "Consonnes africaines :",
          digraphs: "Digraphes :",
          tones: "Marques tonales :",
        },
        tips: {
          title: "Trucs et astuces",
          drag: "Faites glisser le clavier n'importe où sur l'écran à l'aide de la poignée",
          resize: "Redimensionnez la largeur du clavier en faisant glisser le bord droit",
          shift: "Utilisez Majuscule (⇧) pour taper des lettres majuscules",
          indicator: "Un petit point orange sur les touches indique que des variantes par appui long sont disponibles",
          persistence: "Vos préférences (largeur, mode) sont automatiquement sauvegardées",
        },
        languages: {
          title: "Langues supportées",
        },
        footer: {
          version: "Clavier Premium v2.0",
          powered: "Propulsé par Yodi",
        },
      },
    },

    // Validation croisée obligatoire (gate)
    validationGateWarningTitle: "Validation croisée bientôt requise",
    validationGateWarningDesc: "Encore {remaining} contribution(s) avant blocage. Validez le travail d'autres contributeurs pour réinitialiser votre compteur.",
    validationGateBlockedEyebrow: "Validation croisée requise",
    validationGateBlockedTitle: "Contributions suspendues",
    validationGateBlockedDesc: "Vous avez envoyé {threshold} contributions sans valider celles des autres. Effectuez {required} validations croisées pour reprendre vos contributions.",
    validationGateProgress: "{done}/{total} validations",
    validationGateRemaining: "Encore {remaining} validation(s)",
    validationGateGoValidateAudio: "Valider des audios",
    validationGateGoValidateTranscription: "Valider des transcriptions",
    validationGateWhyTitle: "Pourquoi cette règle ?",
    validationGateWhyDesc: "La validation croisée garantit la qualité du corpus : chaque contributeur relit le travail des autres.",
    validationGateBlockedToastTitle: "Contribution refusée",
    validationGateBlockedToastDesc: "Terminez vos validations croisées avant de contribuer à nouveau.",
    validationGateUnlockedTitle: "Contributions débloquées",
    validationGateUnlockedDesc: "Merci ! Vous pouvez de nouveau envoyer des contributions.",
    validationGatePartialSubmit: "{count} contribution(s) enregistrée(s) avant le blocage. Les suivantes n'ont pas été envoyées.",
    validationGateBackToContribute: "Retour aux contributions",
    offline: {
      statusOffline: "Hors ligne",
      statusPending: "{count} en attente",
      statusFailed: "{count} non envoyée(s)",
      buttonLabel: "Envoi des contributions : {status}",
      panelTitle: "Envoi des contributions",
      online: "Connecté",
      offlineLine: "Pas de réseau. Vos contributions restent sur cet appareil et partent dès le retour de la connexion.",
      pendingLine: "{count} contribution(s) en attente d'envoi",
      noPending: "Aucune contribution en attente.",
      syncing: "Envoi en cours...",
      syncNow: "Synchroniser",
      stopAuth: "Reconnectez-vous pour envoyer les contributions en attente.",
      stopGate: "Validation croisée requise : les contributions en attente partiront une fois vos validations faites.",
      stopServer: "Le serveur ne répond pas pour l'instant. Nouvel essai automatique.",
      stopOffline: "Réseau indisponible. Nouvel essai automatique.",
      failedTitle: "Non envoyées",
      failedHint: "Le serveur a refusé ces contributions. Réessayez ou supprimez-les.",
      retry: "Réessayer",
      delete: "Supprimer",
      deleteConfirmTitle: "Supprimer cette contribution ?",
      deleteConfirmDesc: "Elle n'existe que sur cet appareil : elle sera perdue.",
      kindSpeak: "Enregistrement",
      kindTranslate: "Traduction",
      reasonInvalid: "Données refusées par le serveur",
      reasonForbidden: "Non autorisé pour ce compte",
      reasonNotFound: "Phrase introuvable",
      reasonTooLarge: "Fichier trop volumineux",
      reasonOther: "Refusée par le serveur",
      savedTitle: "Gardé sur l'appareil",
      savedDesc: "Pas de réseau : la contribution partira automatiquement au retour de la connexion.",
      storageError: "Impossible de garder la contribution sur cet appareil (stockage plein ou navigation privée).",
      syncedTitle: "Contributions envoyées",
      syncedDesc: "{count} contribution(s) en attente ont été envoyées.",
      taskNoticeTitle: "Vous êtes hors ligne",
      taskNoticeBody: "Continuez : chaque contribution est gardée sur cet appareil et envoyée au retour du réseau.",
      reserveEmpty: "Aucune phrase gardée hors ligne pour cette langue. Reconnectez-vous pour en charger.",
      directTranslationOnline: "Hors ligne, une traduction appliquée directement ne peut pas être gardée. Réessayez une fois connecté.",
      appUpdatedTitle: "Nouvelle version disponible",
      appUpdatedDesc: "Rechargez la page quand vous voulez pour l'utiliser.",
      reload: "Recharger",
    },
  },
  en: {
    // Navigation
    home: "Home",
    dashboard: "Dashboard",
    cookieConsentTitle: "Cookies & privacy",
    cookieConsentDescription: "We use essential cookies and, if you accept, analytics cookies. Accepting also enables automatic city suggestions when you are signed in. Your browser will ask for permission; otherwise, you can search for a city manually.",
    cookieConsentDataPolicy: "Data Policy",
    cookieConsentAcceptLocation: "Accept and enable",
    cookieConsentRejectLocation: "Reject and search",
    cookieConsentClose: "Close",
    contribute: "Contribute",
    profile: "Profile",
    logout: "Logout",
    navAudioSection: "Audio",
    navTextSection: "Text",
    navImagesSection: "Images",
    navProgressSection: "Progress",
    navInitialData: "Initial data",
    navContributionSuite: "Contribution suite",
    navContributionWorkspaceTitle: "Choose your workspace",
    navComingSoon: "Coming soon",
    navCommunitySection: "Field collection",
    collectorSpaceLabel: "Collector space",
    collectorSpaceDescription: "Create a community code and attach audio, transcription, and questionnaire data.",
    accountingLabel: "Accounting",
    accountingDescription: "Accounting dashboard and manual payments.",
    leaderboard: "Leaderboard",
    leaderboardError: "Error",
    leaderboardGlobalError: "Failed to load global leaderboard",
    leaderboardLoadError: "Failed to load leaderboard",
    searchContributor: "Search contributor…",
    contributorsCount: "{count} contributors",
    periodWeek: "7d",
    periodMonth: "30d",
    periodAll: "All",
    noSearchResults: 'No results for "{query}"',
    nextRank: 'You are #{rank} · {gap} {metric} away from #{aboveRank} (@{aboveUser})',
    floatingRank: 'You are #{rank}',
    contributions: "Contributions",
    earnings: "Earnings",
    rankingMode: "Ranking mode",
    global: "Global",
    byLanguage: "By language",
    language: "Language",
    topContributors: "Top contributors",
    firstPlace: "First",
    runnerUp: "Runner-up",
    thirdPlace: "Third",
    globalRanking: "Global Ranking",
    rankingLanguage: "Ranking",
    noLeaderboard: "No leaderboard available",
    you: "You",
    leaderboardRank: "Rank",
    leaderboardContributor: "Contributor",
    leaderboardContribShort: "Contrib",
    leaderboardGainsShort: "Earnings",
    leaderboardDisplaying: "Show",
    leaderboardFirst: "First",
    leaderboardSecond: "Second",
    leaderboardStatThird: "Third",
    leaderboardTotal: "Total",
    leaderboardPeriodWeek: "7d",
    leaderboardPeriodMonth: "30d",
    leaderboardPeriodAll: "All",
    leaderboardRetry: "Retry",
    leaderboardNoDataExport: "No data to export",
    leaderboardSubtitle: "Contributors leaderboard",
    leaderboardContributorsCount: "{count} contributors",
    leaderboardVous: "· You",
    joinTheBest: "💪 Join the best!",
    joinTheBestDesc: "Keep contributing and climb the leaderboard. Every contribution brings you closer to the top!",
    backToDashboard: "📊 Back to dashboard",
    complaints: "Report an issue / Suggestion",
    complaintsName: "Name (optional)",
    complaintsEmail: "Email (optional)",
    complaintsPhone: "Phone (optional)",
    complaintsPhonePlaceholder: "Your phone number",
    complaintsType: "Type",
    complaintsBug: "Bugs",
    complaintsSuggestion: "Suggestion",
    complaintsOther: "Other",
    complaintsMessage: "Message",
    complaintsMessagePlaceholder: "Describe the issue or suggestion",
    complaintsNamePlaceholder: "Your name",
    complaintsEmailPlaceholder: "Your email",
    complaintsSend: "Send",
    complaintsSending: "Sending...",
    complaintsMessageRequired: "Message required",
    complaintsMessageRequiredDesc: "Please write your message.",
    complaintsThanks: "Thanks",
    complaintsThanksDesc: "Your message has been sent.",
    complaintsErrorDesc: "Unable to send your message, please try again later.",
    complaintsNew: "New report",
    complaintsHistory: "My reports",
    complaintsNoHistory: "No reports yet",
    complaintsCharCount: "{count} / {max} characters",
    noAudioAvailable: "No audio",
    retryLater: "Try again later",
    noItemSelected: "No item selected",
    validatedToast: "Validated",
    finalizedToast: "Finalized",
    sessionEnded: "Session ended",
    audioLoadError: "Failed to load audios",
    validationFailed: "Validation failed",
    finalizeError: "Finalization failed",
    progression: "Progress",
    validatedSuffix: "validated",
    validationCardTitle: "Validation",
    correctionPlaceholder: "Correct if necessary...",
    sectorsLoadError: "Failed to load sectors",
    sectorQuestionsLoadError: "Failed to load sector questions",
    questionsExhausted: "Questions exhausted",
    questionsExhaustedDesc: "All available questions have already been added.",
    sectorRequired: "Sector required",
    sectorRequiredDesc: "Please select a sector.",
    audioContributionSubmitted: "Submitted",
    audioContributionSubmittedDesc: "Audio contribution submitted successfully.",
    audioContributionError: "Failed to submit the contribution.",
    languageRequiredTitle: "Language required",
    languageRequiredDesc: "Please select a language.",
    payment: "Payment",
    paymentCardRequired: "Fill in the card information",
    paymentSuccess: "Card payment simulated successfully.",
    paymentFailed: "Payment failed",
    validation: "Validation",
    companyNameRequired: "Company name required",
    registrationNumberRequired: "Registration number required",
    companyAddressRequired: "Company address required",
    sectorActivityRequired: "Sector of activity required",
    companyEmailRequired: "Company email required",
    companyPhoneRequired: "Company phone required",
    repNameRequired: "Representative name required",
    repEmailRequired: "Representative email required",
    usernameRequired: "Username required",
    passwordOrSSORequired: "Password required or enable SSO",
    documentsRequired: "Add at least one supporting document",
    termsAcceptRequired: "You must accept the terms",
    rgpdAcceptRequired: "You must accept the privacy policy (GDPR)",
    signedContractRequired: "Upload the signed contract",
    submitted: "Submitted",
    adminRequestSent: "Your request has been sent.",
    submitFailed: "Submission failed",
    userNotConnected: "User not connected",
    phoneRequired: "Please enter a phone number",
    invalidAmount: "Invalid amount",
    amountGreaterThanZero: "Enter an amount greater than 0",
    payoutRequestSent: "Request sent",
    payoutRequestSentDesc: "Your request has been forwarded to the administrators.",
    success: "Success",
    contractSentSuccess: "Contract sent successfully",
    contractValidatedFinal: "Contract finally validated",

    // ValidateAudio
    audioBatchLoaded: "Loaded next batch",
    audioBatchLoadedDesc: "Page {page} loaded with {count} audios",
    noAudioToValidate: "No audio to validate",
    noAudioToValidateDesc: "Try later or change language",
    allTasksCompleted: "All tasks completed",
    allTasksCompletedDesc: "Thank you for your contribution!",
    audioLoadFailed: "Failed to load audios",
    genderRequired: "Gender required",
    genderRequiredDesc: "Please select gender",
    audioAccepted: "✓ Audio accepted",
    audioAcceptedDesc: "Recording validated successfully",
    audioAcceptedWithDuration: "Recording validated ({duration}s)",
    audioValidationFailed: "Validation failed",
    reasonRequired: "Reason required",
    reasonRequiredDesc: "Please indicate the reason",
    audioRejected: "✗ Audio rejected",
    audioRejectedDesc: "Reason: {reason}",
    audioRejectedWithDuration: "Reason: {reason} ({duration}s)",
    audioRejectFailed: "Rejection failed",
    detectedLanguage: "Detected language:",
    correct: "Correct",
    correctLanguagePrompt: "Correct the language of this audio",
    languageCorrected: "Language corrected",
    languageChangedTo: "Language changed to: {value}",
    selectActualLanguage: "Select the actual language",
    validations: "validations",
    rejections: "rejections",
    validatedByYou: "Validated by you",
    rejectedByYou: "Rejected by you",
    audioGender: "Audio gender",
    selectGender: "Select gender...",
    genderFemale: "👩 Female",
    genderMale: "👨 Male",
    genderRequiredError: "Gender is required",

    // TranscriptionPhrase
    translateToFrench: "Translate to French",
    translatePhraseToFrenchDesc: "Translate this phrase from {language} into French",
    translatePhraseFromFrenchDesc: "Translate this phrase from French into the local language",
    translatePhrasesGeneralDesc: "Translate phrases from French into the selected language",
    beginSession: "Start",
    backToRecording: "Back to recording",
    translationBadge: "Translation",
    sourcePhraseTitle: "Source phrase",
    answerToQuestion: "Answer to the question",
    answerToQuestionHint: "Write down what the person says, in their language. It is not a translation of the question.",
    phraseNumber: "Phrase {n}",
    phraseProgressTitle: "Phrase progress",
    yourTranslationTitle: "Your translation",
    writeTranslationHere: "Write the translation here...",
    africanKeyboard: "African Keyboard",
    submitTranslation: "Submit",
    noPhraseAvailable: "No phrase available",
    translationLoadError: "Loading error",
    phraseRetrieveError: "Unable to retrieve phrases",
    loginRequired: "Login required",
    loginRequiredDesc: "Please sign in to continue",
    textRequired: "Text required",
    textRequiredDesc: "Please write the translation",
    translationAdded: "Translation added",
    translationSavedDesc: "The translation has been saved successfully",
    sessionCompleted: "Session completed",
    allPhrasesTranslated: "All phrases have been translated",
    phraseXofY: "Phrase {current}/{total}",
    pageLabel: "Page",
    progress: "Progress",
    done: "Done",

    // ForgotPassword
    forgotPasswordTitle: "Forgot your password?",
    forgotPasswordSubtitle: "No problem. Enter your email, phone number, or username. You will get a link by email or a code by SMS.",
    passwordRecoveryIdentifierLabel: "Email, phone, or username",
    passwordRecoveryIdentifierPlaceholder: "e.g. name@domain.com, +228..., or username",
    passwordRecoveryIdentifierHelp: "With a phone number, you get a code by SMS. Otherwise the link goes by email, or a code by SMS when the account has no email.",
    passwordRecoveryEmailSentTitle: "Instructions sent",
    passwordRecoveryEmailSentDesc: "If this account exists, a secure link has been sent to the provided address.",
    passwordRecoverySmsSentTitle: "Code sent by SMS",
    passwordRecoverySmsSentDesc: "If this number belongs to an account, a 6-digit code has just been sent to it. Enter it to continue.",
    passwordRecoveryUnknownTitle: "Request accepted",
    passwordRecoveryUnknownDesc: "If an account matches, you will receive a link by email or, when the account has no email, a code by SMS.",
    passwordRecoveryEnterSmsCode: "I received a code by SMS",
    passwordRecoveryOtpLabel: "Verification code",
    passwordRecoveryOtpPlaceholder: "000000",
    passwordRecoveryVerifyOtp: "Verify code",
    passwordRecoveryOtpVerifiedTitle: "Code verified",
    passwordRecoveryOtpVerifiedDesc: "You can now set a new secure password.",
    passwordRecoveryResendCode: "Resend code",
    passwordRecoveryResendLink: "Start again",
    passwordRecoveryExpiresIn: "Expires in",
    passwordRecoveryNewPasswordTitle: "New password",
    passwordRecoveryNewPasswordDesc: "Set a strong password to secure your account.",
    resetPasswordHeading: "Password reset",
    resetLinkSentToAddress: "We will send a reset link to this address",
    sending: "Sending...",
    sendLink: "Send link",
    backToLogin: "Back to login",
    signUpHere: "Sign up here",
    securityNote: "For security reasons, the link will expire after 1 hour",
    emailInvalid: "Invalid email",
    emailInvalidDesc: "Please enter a valid email address",
    emailSentTitle: "Email sent",
    emailSentDesc: "Check your mailbox to reset your password",
    emailSentHeading: "Email sent!",
    resetLinkSentTo: "We have sent a reset link to",
    nextSteps: "Next steps:",
    stepCheckMail: "Check your mailbox",
    stepClickLink: "Click the reset link",
    stepCreatePassword: "Create a new password",
    noEmailReceived: "Didn't receive the email? Check your spam or",
    retry: "try again",

    // ResetPassword
    resetPasswordVerifying: "Verifying link...",
    resetPasswordInvalidTitle: "Invalid or expired link",
    resetPasswordInvalidDesc: "This reset link is no longer valid. Links expire after 1 hour for security reasons.",
    resetPasswordRequestNewLink: "Request a new link",
    resetPasswordSuccessTitle: "Password reset!",
    resetPasswordSuccessDesc: "Your password has been changed successfully. You can now log in with your new password.",
    resetPasswordRedirecting: "Redirecting to login...",
    resetPasswordGoToLogin: "Go to login",
    resetPasswordNewTitle: "New password",
    resetPasswordNewDesc: "Create a new secure password for your account",
    resetPasswordFormTitle: "Password reset",
    resetPasswordNewLabel: "New password",
    resetPasswordMinChars: "Minimum 8 characters, with uppercase, lowercase, digit and special character",
    resetPasswordConfirmLabel: "Confirm password",
    resetPasswordCriteria: "Password criteria:",
    resetPasswordAtLeast6: "At least 8 characters",
    resetPasswordUpperLower: "One uppercase and one lowercase letter",
    resetPasswordDigitSpecial: "One digit and one special character",
    resetPasswordMatch: "Passwords match",
    resetPasswordLoading: "Resetting...",
    resetPasswordSubmit: "Reset password",
    resetPasswordSecurityNote: "After changing your password, you will need to log in again",
    resetPasswordTooShort: "Password too short",
    resetPasswordTooShortDesc: "Password must contain at least 8 characters, one uppercase, one lowercase, one digit, and one special character",
    resetPasswordMismatch: "Passwords don't match",
    resetPasswordMismatchDesc: "Both passwords must match",
    resetPasswordMissingToken: "Missing token",
    resetPasswordMissingTokenDesc: "The reset link is invalid",
    resetPasswordSuccessToast: "Password reset",
    resetPasswordSuccessToastDesc: "Your password has been changed successfully",
    resetPasswordError: "Error",
    resetPasswordErrorDesc: "Unable to reset password",

    // ForceChangePassword
    forceChangePassword: {
      title: "Change your password",
      description: "Your account was created with a temporary password. Please set a new one to continue.",
      languageProfileTitle: "Complete your language profile",
      languageProfileDescription: "These preferences let us route relevant contributions and reviews to you and send notifications in the right language.",
      languageProfileRequired: "Select at least one language in each required field.",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      tooShort: "Minimum 8 characters",
      passwordRequirements: "Use at least 8 characters with an uppercase letter, a lowercase letter, a number, and a special character.",
      mismatch: "Passwords don't match",
      submit: "Confirm",
      saving: "Saving...",
      success: "Password updated successfully",
      error: "Unable to change password",
      hint: "Choose a strong password you don't use anywhere else.",
    },

    // KeyboardModal
    keyboardModalTitle: "{language} keyboard",
    keyboardModalHint: "Enter text in {language}",
    keyboardModalInputLabel: "Entered text",
    keyboardModalPlaceholder: "Typed text will appear here...",
    keyboardModalClear: "Clear",
    keyboardModalCancel: "Cancel",
    keyboardModalConfirm: "Confirm",

    // MobileMenu
    mobileMenuOthers: "Others",
    mobileMenuReport: "Report / Suggestion",
    mobileMenuAdmin: "Administration",
    mobileMenuModerator: "Moderator Panel",
    mobileMenuAccountant: "Accountant Dashboard",

    // UserContracts
    userContractsMyContracts: "My Contracts",
    userContractsTitle: "Contracts",
    userContractsSubtitle: "Review the sent contract, sign it, then wait for final validation to unlock your earnings.",
    userContractsRefresh: "Refresh",
    userContractsToSign: "To sign",
    userContractsSigned: "Signed",
    userContractsToSignList: "Contracts to sign",
    userContractsNoPending: "No pending contracts",
    userContractsDownloadPdf: "Download PDF",
    userContractsSignThis: "Sign this contract",
    userContractsSignedWaiting: "The contract is signed. It is now awaiting final validation by the moderator.",
    userContractsValidated: "The contract is definitively validated. Your earnings can now be taken into account.",
    userContractsUserSignature: "User signature",
    userContractsSignatureDate: "Signature date:",
    userContractsSelectContract: "Select a contract to view it",
    userContractsSignedTitle: "Signed contracts",
    userContractsNoSigned: "No signed contracts yet",
    userContractsSignedOn: "Signed on",
    userContractsFinalized: "Finalized",
    userContractsViewSigned: "View signed contract",
    userContractsPreviewSigned: "Signed contract",
    userContractsPreviewDesc: "Signed version of the contract with signature proof and date.",
    userContractsSignTitle: "Sign the contract",
    userContractsSignDesc: "Choose how to sign the contract: draw your signature or upload an image",
    userContractsDraw: "Draw",
    userContractsUpload: "Upload",
    userContractsText: "Text",
    userContractsClear: "Clear",
    userContractsSaveSignature: "Save signature",
    userContractsPreview: "Preview:",
    userContractsClickToUpload: "Click to upload a signature",
    userContractsImageFormats: "PNG, JPG, or GIF",
    userContractsTextSignPlaceholder: "e.g. Read and approved - John Doe",
    userContractsTextSignHint: "Enter the name or text that will serve as your electronic signature.",
    userContractsCancel: "Cancel",
    userContractsSigning: "Signing...",
    userContractsConfirmSignature: "Confirm signature",
    userContractsSignatureRequired: "Please provide a signature before confirming",
    userContractsErrorLoad: "Error loading contracts",
    userContractsErrorLoadContract: "Unable to load contract",
    userContractsErrorSign: "Error signing contract",
    userContractsSuccessSign: "Contract signed successfully. The moderator can now proceed with final validation.",
    userContractsErrorLoadSigned: "Unable to load signed contract",
    userContractsSuccessDrawn: "Signature saved",
    userContractsSuccessUploaded: "Signature uploaded",
    userContractsStatusDraft: "Draft",
    userContractsStatusUnpublished: "Unpublished",
    userContractsStatusPublished: "Published",
    userContractsStatusSent: "Sent",
    userContractsStatusViewed: "Viewed",
    userContractsStatusSigned: "Signed",
    userContractsStatusValidated: "Finalized",
    userContractsTypeValidation: "Validation contract",
    userContractsTypeModerator: "Moderator contract",
    userContractsTypeAdmin: "Admin contract",
    userContractsMethodDrawn: "Drawn signature",
    userContractsMethodUploaded: "Uploaded image",
    userContractsMethodText: "Text signature",
    userContractsMethodDefault: "Signature",

    // ModeratorContracts
    modContractsBadge: "Moderator - Contract Management",
    modContractsTitle: "Contracts",
    modContractsSubtitle: "Assign contracts to eligible users and validate signed contracts",
    modContractsAssignTab: "Assign contracts",
    modContractsValidateTab: "Signed contracts",
    modContractsAvailableList: "Available contracts",
    modContractsNoAssign: "No contracts to assign",
    modContractsClickToSend: "Click \"Send contract\" to assign it to each eligible user",
    modContractsNoEligible: "No eligible users for this contract",
    modContractsAssigned: "Assigned",
    modContractsSending: "Sending...",
    modContractsSend: "Send",
    modContractsSelectToSee: "Select a contract to view eligible users",
    modContractsSignedToValidate: "Signed contracts to validate",
    modContractsSignedDesc: "These contracts have been signed by users. Click \"Final Validate\" to finalize them permanently.",
    modContractsNoSignedPending: "No signed contracts awaiting validation",
    modContractsAssignedTo: "Assigned to:",
    modContractsValidating: "Validating...",
    modContractsFinalValidate: "Final Validate",
    modContractsConfirmSend: "Confirm contract send",
    modContractsConfirmValidate: "Confirm final validation",
    modContractsSendDesc: "Do you want to send the contract \"{title}\" to {name}? They will receive a notification.",
    modContractsValidateDesc: "Do you want to permanently finalize the contract \"{title}\"? This action cannot be undone.",
    modContractsCancel: "Cancel",
    modContractsErrorLoad: "Error loading contracts",
    modContractsErrorLoadUsers: "Error loading eligible users",
    modContractsErrorSend: "Error sending contract",
    modContractsErrorValidate: "Error validating contract",
    modContractsStatusDraft: "Draft",
    modContractsStatusUnpublished: "Unpublished",
    modContractsStatusPublished: "Published",
    modContractsStatusSent: "Sent",
    modContractsStatusViewed: "Viewed",
    modContractsStatusSigned: "Signed",
    modContractsStatusFinalValidated: "Finalized",
    modContractsTotal: "Total",
    modContractsRefresh: "Refresh",
    modContractsScore: "Score: {score}/10",
    modContractsNotAvailable: "N/A",
    modContractsThisUser: "this user",

    collectorDashboard: {
      profileFound: "Profile found",
      profileFoundDesc: "Profile {code} is ready for new contributions.",
      lookupFailed: "Lookup failed",
      profileRetrieveError: "Unable to retrieve this community profile.",
      locationRequired: "Location required",
      locationRequiredDesc: "Enter the location before creating the profile.",
      invalidPhone: "Invalid phone number",
      invalidPhoneDesc: "The number must have no spaces and use international format (e.g. 22893462784 or +22893462784).",
      profileCreated: "Profile created",
      smsSentSuccess: "Code sent by SMS successfully",
      smsNotSent: "SMS not sent: {reason}",
      noPhoneForSms: "No phone number provided for SMS",
      creationFailed: "Creation failed",
      noActiveSession: "No active session",
      noActiveSessionDesc: "Select or create a profile before continuing.",
      moduleAudioTitle: "Play and record",
      moduleAudioDesc: "Read phrases and record the voice.",
      moduleTranscriptionTitle: "Transcription",
      moduleTranscriptionDesc: "Listen and transcribe phrases.",
      moduleQuestionnaireTitle: "Initial data",
      moduleQuestionnaireDesc: "Open the initial entry module.",
      moduleDefaultTitle: "Module",
      moduleDefaultDesc: "Choose a module.",
      ageMoins18: "Under 18",
      age18_30: "18 - 30",
      age31_45: "31 - 45",
      age46_60: "46 - 60",
      age61_plus: "61 and over",
      genderFeminin: "Female",
      genderMasculin: "Male",
      contribTypeAudio: "Audio",
      contribTypeTranscription: "Transcription",
      contribTypeQuestionnaire: "Initial data",
      collectorBadge: "Collector",
      communityCollectionTitle: "Community collection",
      statProfiles: "Profiles",
      statContributions: "Contributions",
      statToday: "Today",
      statFeedback: "Feedback",
      sessionCardTitle: "Session",
      sessionCardDesc: "Existing code or new profile.",
      codeLabel: "Code",
      useThisCode: "Use this code",
      searching: "Searching...",
      newProfile: "New profile",
      newProfileTitle: "New profile",
      newProfileDesc: "Age, gender, location.",
      ageLabel: "Age",
      genderLabel: "Gender",
      locationLabel: "Location",
      locationPlaceholder: "Village or district",
      phoneLabel: "Phone (optional)",
      phoneHint: "No spaces, ideally with country code.",
      networkLabel: "Mobile money network",
      networkPlaceholder: "Select a network",
      networkFlooz: "Flooz (Moov)",
      networkTmoney: "T-Money (Togocom)",
      genderRequired: "Gender required",
      genderRequiredDesc: "State the contributor's gender before creating their profile.",
      genderPlaceholder: "Select…",
      networkRequired: "Network required",
      networkRequiredDesc: "The mobile money network (Flooz or T-Money) is required to be able to pay this profile.",
      creating: "Creating...",
      create: "Create",
      clickNewProfile: "Click on",
      codeCardTitle: "Code",
      codeCardDesc: "Unique identifier.",
      continue: "Continue",
      sessionActive: "Session · {code}",
      sessionPending: "Session pending",
      noActiveProfile: "No active profile.",
      finish: "Finish",
      inProgressBadge: "in progress",
      typeLabel: "Type",
      activeProfileLabel: "Active profile: {code}",
      openModule: "Open module",
      ageSexProgressTitle: "Age / gender progression",
      ageSexProgressDesc: "Breakdown of created profiles by age range and gender.",
      noProfileForChart: "No profile to display the chart.",
      femmes: "Women",
      hommes: "Men",
      autres: "Others",
      sessionActiveStatus: "Active session",
      endSession: "End session",
      codeInstruction: "Share this code with the contributor",
      noActiveCode: "No active code",
      contributionModules: "Contribution modules",
      selectProfileFirst: "Select a profile first",
      addProfile: "Add profile",
      cancel: "Cancel",
      sessionActivity: "Session activity",
      sessionFor: "Session for",
      noActiveSessionActivity: "No active session",
      noContributionsYet: "No contributions for this profile yet",
      start: "Start",
      done: "Done",
      noChartData: "No data available",
      chatbotTab: "Assistant",
      chatbotTabDesc: "Ask the assistant a question",
      chatbotTitle: "Chat with HLlama",
      chatbotSubtitle: "Talk to HLlama about your health and well-being, with or without a phone number.",
      chatbotPlaceholder: "Type your question...",
      chatbotSend: "Send",
      chatbotThinking: "The assistant is answering...",
      chatbotEmpty: "No conversation yet",
      chatbotEmptyDesc: "Ask your first question to start the conversation.",
      chatbotErrorTitle: "Error",
      chatbotErrorDesc: "Unable to send your question right now.",
      chatbotYou: "You",
      chatbotAssistant: "Assistant",
      chatbotPendingAnswer: "Answer being processed...",
      chatbotVoiceError: "Unable to use voice recognition on this device.",
      chatbotQuestionInvalid: "Enter a question between 1 and 2,000 characters.",
      chatbotUnavailable: "HLlama is temporarily unavailable. Your question has been kept.",
      chatbotRateLimited: "Too many requests right now. Please wait before trying again.",
      chatbotBusy: "A request is already in progress. Please wait and retry the same question.",
      chatbotRetryHistory: "Retry loading the conversation",
      chatbotOffline: "You are offline. Reconnect to send your question.",
      chatbotAnswered: "HLlama's reply is available.",
      chatbotVoiceStart: "Dictate a question",
      chatbotVoiceStop: "Stop dictation",
      noProfilesYet: "No profiles yet",
      historyTitle: "Payment history",
      historySent: "Sent to profiles",
      historyReceived: "Received",
      historyEmpty: "No payment yet.",
      historyError: "Could not load the history.",
      historyRetry: "Retry",
      historyStatusPaid: "Paid",
      historyStatusPending: "Pending",
      historyStatusFailed: "Failed",
      historyContributionsPaid: "{count} contribution(s) paid",
      historyPageSummary: "Page {page} of {pages}",
      historyPrevious: "Previous",
      historyNext: "Next",
      paymentSectionTitle: "Mobile money payment",
      paymentLoading: "Loading amount...",
      paymentAmountToPay: "{amount} FCFA to pay",
      paymentRecordedLabel: "Recorded",
      paymentValidatedLabel: "Validated",
      paymentPaidLabel: "Already paid",
      paymentToPayLabel: "To pay",
      paymentNoPhoneOrNetwork: "phone or network missing",
      paymentRefresh: "Refresh",
      paymentPayButton: "Pay",
      paymentInProgress: "Payment in progress…",
      paymentSuccess: "Payment confirmed successfully",
      paymentPendingDesc: "Payment waiting for confirmation from the operator. Do not pay again: click Refresh in a few minutes to check the status. If it stays pending, contact an administrator.",
      paymentLoadError: "Unable to load the amount to pay",
      paymentEditContact: "Add phone / network",
      paymentEditSave: "Save",
      paymentEditSaving: "Saving...",
      paymentEditError: "Unable to save the phone/network",
    },

    // Recording guidelines (collection policy)
    recordingGuidelines: {
      title: "Collection policy",
      subtitle: "Listen to the voice data policy and quality audio examples per language before contributing.",
      languageLabel: "Language",
      selectLanguage: "Select a language",
      loadingList: "Loading languages...",
      loadingListError: "Unable to load the available languages.",
      empty: "No active collection policy yet.",
      loadingDetail: "Loading the policy...",
      detailError: "Unable to load this policy.",
      detailNotFound: "No active policy for this language.",
      policyAudioTitle: "Policy audio",
      policyTextTitle: "Transcript",
      qualityCriteriaTitle: "Audio quality criteria",
      qualityAudioTitle: "Quality example",
      examplesTitle: "Audio examples",
      noExamples: "No example available.",
      audioNotAvailable: "Audio not available.",

      // Admin management
      adminSectionTitle: "Policy management",
      adminAddNew: "New policy",
      adminEdit: "Edit",
      adminDelete: "Delete",
      adminLanguageColumn: "Language",
      adminCodeColumn: "Code",
      adminStatusColumn: "Status",
      adminExamplesColumn: "Examples",
      adminActionsColumn: "Actions",
      adminActive: "Active",
      adminInactive: "Inactive",
      adminEmptyList: "No policy recorded yet.",
      adminLoadListError: "Unable to load the policies.",
      adminFormTitleCreate: "New collection policy",
      adminFormTitleEdit: "Edit the policy",
      adminLanguageField: "Language",
      adminSelectLanguagePlaceholder: "Choose a language",
      adminPolicyTextField: "Policy transcript",
      adminQualityCriteriaField: "Audio quality criteria",
      adminIsActiveField: "Policy active",
      adminAutoAudioField: "Generate audio automatically",
      adminAutoAudioHint: "For a French text (2,000 characters at most per field). The audio follows each edit and replaces the saved one, unless you upload a file.",
      adminAutoAudioPending: "The audio could not be generated. Save again to retry.",
      adminAutoAudioTooLong: "A text is over 2,000 characters: shorten it or upload an audio file.",
      adminPolicyAudioField: "Policy audio",
      adminQualityAudioField: "Quality audio (example)",
      adminKeepExistingAudio: "Leave empty to keep the existing audio.",
      adminSave: "Save",
      adminSaving: "Saving...",
      adminCancel: "Cancel",
      adminSaved: "Policy saved",
      adminSaveError: "Unable to save the policy.",
      adminLanguageRequired: "Select a language.",
      adminPolicyAudioRequired: "Policy audio is required for a new language.",
      adminAudioFormatHint: "Accepted formats: mp3, wav, mp4/m4a (not webm).",
      adminDeleteConfirmTitle: "Delete this policy?",
      adminDeleteConfirmBody: "This also deletes its audios and examples. This cannot be undone.",
      adminDeleted: "Policy deleted",
      adminDeleteError: "Unable to delete the policy.",
      adminExamplesTitle: "Audio examples",
      adminExamplesEmpty: "No example for this language.",
      adminAddExampleTitle: "Add an example",
      adminExampleTitleField: "Title",
      adminExampleDescriptionField: "Description (optional)",
      adminExampleOrderField: "Display order",
      adminExampleAudioField: "Audio file",
      adminExampleAdd: "Add example",
      adminExampleAdding: "Adding...",
      adminExampleAdded: "Example added",
      adminExampleAddError: "Unable to add the example.",
      adminExampleFieldsRequired: "Title and audio file are required.",
      adminExampleDeleteConfirmTitle: "Delete this example?",
      adminExampleDeleted: "Example deleted",
      adminExampleDeleteError: "Unable to delete the example.",
      adminSaveFirstForExamples: "Save the policy before adding examples.",
      adminManageTab: "Manage",
      adminPreviewTab: "Collector preview",
    },

    // GetPaid
    getPaid: {
      budgetLoadError: "Unable to load budget information",
      budgetConfirmed: "Budget confirmed",
      depositAdminOnly: "Only an administrator can make a deposit",
      depositLaunched: "Deposit initiated",
      depositFailed: "Unable to make the deposit",
      eligibleUsersLoadError: "Unable to load eligible users",
      eligibleModeratorsLoadError: "Unable to load moderators",
      phoneMissing: "Phone number missing",
      invalidNetwork: "Invalid network",
      chooseNetwork: "Please choose FLOOZ or TMONEY",
      paymentLaunched: "Payment initiated",
      paymentLaunchFailed: "Unable to initiate the payment",
      paymentsLaunched: "Payments initiated",
      paymentsLaunchedDesc: "{success} succeeded, {failed} failed out of {total} total",
      moderatorOnly: "Action reserved for moderators",
      amountUnavailable: "Amount unavailable",
      monthlyFeeUnavailable: "The moderator monthly fee is not yet available for this month.",
      requestSubmitFailed: "Unable to submit the request",
      myRequestsLoadError: "Unable to load your requests",
      requestsLoadError: "Unable to load the requests",
      accessDenied: "Access denied",
      phoneRequiredTitle: "Phone required",
      phoneRequiredDesc: "Provide the phone number",
      settingsSaved: "Saved",
      settingsSavedDesc: "Payment settings updated.",
      saveSettingsFailed: "Unable to save settings",
      amountInsufficient: "Insufficient amount",
      amountInsufficientDesc: "You can only request up to {amount}",
      operatorNotSupported: "Operator not supported",
      operatorNotSupportedDesc: "Choose MTN MoMo or Moov Money to send the request.",
      requestCreated: "Request created",
      requestCreatedDesc: "Your payment request has been submitted.",
      createRequestFailed: "Unable to create the request",
      pendingTestsLoadError: "Unable to load pending tests",
      completeResponse: "Please complete your response",
      testSubmitted: "Success",
      testSubmittedDesc: "Your test has been submitted for correction",
      loadTestFailed: "Unable to load the test. Please try again.",
      requestApproved: "Request approved",
      requestApprovedDesc: "{name} is now ready for accounting payment.",
      approveFailed: "Unable to approve the request",
      approveForbidden: "Access denied: your session does not carry the ADMIN role. Sign in again with an admin account.",
      bulkApproveModeratorsDone: "Moderator approvals completed",
      bulkApproveContributorsDone: "Contributor approvals completed",
      bulkApproveDesc: "{count} request(s) approved, {failed} failure(s).",
      approveModeratorsFailed: "Unable to approve moderator requests",
      approveContributorsFailed: "Unable to approve contributor requests",
      requestValidateFailed: "Unable to validate the request",
      userTestTitle: "User test",
      languageTestSubmission: "Language test submission",
      testTimeElapsedTitle: "Time elapsed!",
      testTimeElapsedDesc: "The 10-minute test has ended.",
      testFinished: "The test is finished.",
      recordingStoppedAuto: "Recording stopped automatically.",
      microphoneUnavailable: "Microphone unavailable",
      microphonePermissionRequired: "Allow microphone access to record.",
      statusPending: "Pending",
      statusApproved: "Approved",
      statusRejected: "Rejected",
      networkPrompt: "Network (FLOOZ or TMONEY)",
      phonePrompt: "Phone number for {name}",
      payoutDescription: "YODI payout - {count} validated tests",
      moderatorMonthlyPayout: "YODI moderator payout - monthly package",
      paymentReference: "Ref",
      payModeratorsConfirm: "Automatically pay {count} moderators?\nTotal amount: {amount}",
      launchPaymentsFailed: "Unable to launch payments",
      correctedTestsLoadError: "Unable to load corrected tests",
      scoresSaved: "Saved",
      scoresSavedDesc: "Scores saved as draft.",
      incomplete: "Incomplete",
      scoreAllItems: "Please score all items.",
      testNotFound: "Test not found",
      rejectedTest: "Test rejected",
      rejectedTestDesc: "The test was rejected with a score of {score}/10.",
      correctionCompleted: "Correction completed",
      correctionCompletedDesc: "The test is now corrected with a score of {score}/10. Send the contract to continue.",
      saveCorrectionFailed: "Unable to save the correction",
      userNotFound: "User not found",
      sendContractFailed: "Unable to send the contract.",
      contractSent: "Contract sent",
      contractSentDesc: "The contract was sent to {name}.",
      sendContractRequestFailed: "Unable to send the contract",
      finalValidationSuccess: "Final validation successful",
      finalValidationSuccessDesc: "The test for {name} is now validated.",
      finalValidationFailed: "Unable to permanently validate the test",
      contractToSend: "Contract to send",
      contractSentLabel: "Contract sent",
      contractViewed: "Contract viewed",
      readyForFinalValidation: "Ready for final validation",
      alreadyFinalized: "Already finalized",
      payoutRequestsLoadError: "Unable to load requests",
      requestRejected: "Request rejected",
      paymentCanProceed: "The payment can now be processed",
      requesterNotified: "The requester has been notified",
      inputCompleted: "Input is complete.",
      completeAllItems: "Please complete all items before submitting.",
      submitTestFailed: "Unable to submit the test",
      testSubmissionInProgress: "Your submission is still processing. Try again in a moment.",
      testSubmissionChanged: "The answers changed. Submit this test again.",
      pendingTestExists: "You already have a pending test for this language.",
      validatedTestExists: "You already have a validated test for this language.",
      testAlreadySubmitted: "Test already submitted",
      qualificationTest: "Qualification test",
      testTimeRemaining: "Time remaining",
      attempt: "Attempt",
      recording: "Recording",
      submitTest: "Submit test",
      submitting: "Submitting...",
      time: "Time",
      translationPlaceholder: "Translation...",
      moderation: "Moderation",
      testCorrection: "Test correction",
      testCorrectionDesc: "Review submitted user tests and assign scores",
      pendingCorrectionDesc: "Tests pending correction",
      contractsToSendDesc: "Corrected, contract to send",
      contractsSentDesc: "Awaiting signature",
      contractsViewedDesc: "Viewed by user",
      contractsReadyFinalDesc: "Signed, ready for final validation",
      contractsFinalizedDesc: "Finalized and validated tests",
      correctingTestFor: "Correcting test for {name}",
      backToList: "Back to list",
      saving: "Saving...",
      save: "Save",
      finishCorrection: "Finish correction",
      phonemesWeight: "Phonemes (30%)",
      phrasesWeight: "Phrases (30%)",
      translationsWeight: "Translations (40%)",
      totalWeightedScore: "Total weighted score",
      sectionPhonemes: "Section 1: Phonemes",
      sectionPhrases: "Section 2: Phrases to pronounce",
      sectionTranslations: "Section 3: Translation",
      audioNotProvided: "Audio not provided",
      score: "Score",
      scorePlaceholder: "0 - 10",
      audioTestValidation: "Audio test validation",
      toCorrect: "To correct",
      correctedTests: "Corrected tests",
      loading: "Loading...",
      refresh: "Refresh",
      details: "Details",
      sendContract: "Send contract",
      sending: "Sending...",
      permanentlyValidate: "Permanently validate",
      validating: "Validating...",
      readOnly: "Read only",
      finalized: "Finalized",
      corrected: "Corrected",
      validated: "Validated",
      confirmFinalValidation: "Confirm final validation",
      confirmFinalValidationDesc: "Do you want to permanently validate the test for {name} with a score of {score} / 10?",
      confirmFinalValidationGeneric: "Confirm the final validation of this test.",
      cancel: "Cancel",
      confirm: "Confirm",
      moderatorPaymentRequest: "Moderator payment request",
      amountXof: "Amount (XOF)",
      phone: "Phone",
      network: "Network",
      chooseNetworkLabel: "Choose a network",
      descriptionOptional: "Description (optional)",
      submitRequest: "Submit request",
      estimatedEarnings: "Estimated earnings: {amount}",
      monthlyAmountAvailableEndOfMonth: "The moderator monthly amount will be available at the end of the month.",
      statusLabel: "Status: {status}",
      configuration: "Configuration",
      moderatorManagement: "Moderator Management",
      contributorManagement: "Contributor Management",
      noPendingTests: "No pending tests",
      noCorrectedTests: "No corrected tests",
      testRecycleBin: "Test recycle bin",
      testRecycleBinDescription: "Trashed tests can be restored until the date shown.",
      testTrashTitle: "Move this test to the recycle bin?",
      testTrashDescription: "{name}'s {language} test ({status}) will leave active queues and can be restored for 30 days.",
      testTrashReason: "Reason (at least 10 characters)",
      testTrashConfirm: "Move to recycle bin",
      testTrashRestore: "Restore",
      testTrashLoadMore: "Load more",
      testTrashEmpty: "The recycle bin is empty",
      testTrashSuccess: "The test was moved to the recycle bin.",
      testTrashError: "Could not move this test to the recycle bin.",
      testRestoreSuccess: "The test was restored.",
      testRestoreError: "Could not restore this test.",
      testTrashReasonRequired: "Enter a reason with at least 10 characters.",
      lightMode: "Light mode",
      darkMode: "Dark mode",
      adminBadge: "Administration",
      adminPaymentManagementTitle: "Payment Management",
      adminPaymentManagementDesc: "Manage budget, settings, and payment processing for moderators and contributors.",
      adminBudgetAvailable: "Budget available",
      adminTotalBudget: "Total budget",
      adminReserved: "Reserved",
      adminAvailable: "Available",
      adminBudgetLoading: "Loading budget...",
      adminBudgetFailed: "Failed to load budget",
      adminTotalAllocatedBudget: "Total allocated budget",
      adminOfTotal: "% of total",
      adminHealthy: "Healthy",
      adminInsufficient: "Insufficient",
      adminPaidTotal: "Paid (total)",
      adminOpenRequests: "Open requests",
      adminMakeDeposit: "Make a deposit",
      adminTransactionHistory: "Transaction history",
      adminPaymentSettings: "Payment settings",
      adminPaymentSettingsDesc: "Configure payment amounts and limits",
      adminAmountPerContribution: "Amount/contribution",
      adminContributorCap: "Contributor cap",
      adminAmountPerModerator: "Amount/moderator",
      adminSaveSettings: "Save settings",
      adminLoadingSettings: "Loading settings...",
      adminEditSettings: "Edit settings",
      adminContributionsUnit: "contributions",
      adminAmountPerContributionXof: "Amount per contribution (XOF)",
      adminAmountPerContributionHelp: "Amount paid for each accepted contribution (maximum 1000 contributions per contributor)",
      adminContributorCapXof: "Contributor cap (number of contributions)",
      adminContributorCapHelp: "Maximum number of contributions that can be paid per contributor",
      adminModeratorAmountXof: "Moderator fixed amount (XOF)",
      adminModeratorAmountHelp: "Fixed monthly amount paid to each moderator",
      adminSaving: "Saving...",
      adminSaveChanges: "Save changes",
      adminCancel: "Cancel",
      adminPayoutContributorBtn: "Pay contributor",
      adminPayoutContributorTitle: "Pay contributor",
      adminPayoutContributorDesc: "Transfer funds to a contributor",
      adminPayoutUserId: "User ID",
      adminPayoutAcceptedAudios: "Accepted audios",
      adminPayoutPayableCount: "Payable count",
      adminPayoutMaxAvailable: "Maximum available",
      adminPayoutAmountXof: "Amount (XOF)",
      adminPayoutMax: "Max:",
      adminPayoutPhoneNumber: "Phone number",
      adminPayoutNetwork: "Network",
      adminPayoutSelectUser: "Please select a user",
      adminPayoutValidAmount: "Please enter a valid amount",
      adminPayoutValidPhone: "Please enter a phone number",
      adminPayoutSingleModerator: "Pay single moderator",
      adminPayoutAllModerators: "Pay all moderators",
      adminPayoutEligibleModerators: "Eligible moderators",
      adminPayoutTotal: "Total:",
      adminPayoutNoModerators: "No moderators found",
      adminPayoutTableId: "ID",
      adminPayoutTableName: "Name",
      adminPayoutTableEmail: "Email",
      adminPayoutTablePhone: "Phone",
      adminPayoutTableValidations: "Validations",
      adminPayoutTableAction: "Action",
      adminPayoutPay: "Pay",
      adminPayoutPayModeratorTitle: "Pay moderator",
      adminPayoutValidated: "Validated:",
      adminPayoutAmountToPay: "Amount to pay:",
      adminPayoutPeriod: "Period:",
      adminPayoutNotYetDue: "Not yet due",
      adminPayoutAlreadyPaid: "Already paid this month",
      adminPayoutSelectModerator: "Please select a moderator",
      adminPayoutConfirmAll: "Are you sure you want to pay ALL eligible moderators? This cannot be undone.",
      adminPayoutConfirmBtn: "Confirm payout",
      adminReqNoRequests: "No requests",
      adminReqTableId: "ID",
      adminReqTableUser: "User",
      adminReqTableAmount: "Amount",
      adminReqTablePhone: "Phone",
      adminReqTableNetwork: "Network",
      adminReqTableStatus: "Status",
      adminReqTableCreated: "Created",
      adminReqTableActions: "Actions",
      adminReqTotalPending: "Total pending requests",
      adminReqModeratorsPending: "Moderators pending",
      adminReqContributorsPending: "Contributors pending",
      adminReqXofTotal: "XOF total",
      adminReqModeratorPayoutRequests: "Moderator payout requests",
      adminReqContributorPayoutRequests: "Contributor payout requests",
      adminReqApproveRequest: "Approve request",
      adminReqRejectRequest: "Reject request",
      adminReqMarkAsPaid: "Mark as paid",
      adminReqUser: "User:",
      adminReqNoteOptional: "Note (optional)",
      adminReqNotePlaceholder: "Add a note...",
      adminReqConfirm: "Confirm",
      adminDepositTitle: "Admin deposit",
      adminDepositDescription: "Deposit funds to the budget using FeexPay",
      adminDepositEnterEmail: "Please enter an email",
      adminDepositFirstName: "First name",
      adminDepositLastName: "Last name",
      adminDepositDescriptionOptional: "Description (optional)",
      adminDepositProceedToPayment: "Proceed to payment",
      adminSectionModeratorRequests: "Section A · Moderator payment requests ({count})",
      adminApproveAll: "Approve all",
      adminNoModeratorRequests: "No moderator has made a payment request yet.",
      adminUserLabel: "User",
      adminEmailLabel: "Email",
      adminPhoneLabel: "Phone",
      adminOperatorLabel: "Operator",
      adminDateLabel: "Date",
      adminStatusLabel: "Status",
      adminAmountLabel: "Amount",
      adminActionLabel: "Action",
      adminEmailNotProvided: "Email not provided",
      adminAwaitingAccountant: "Awaiting accountant",
      adminPaymentConfirmed: "Payment confirmed",
      adminNoAction: "No action",
      adminSectionModeratorEarnings: "Moderators with accumulated earnings without request ({count})",
      adminNoModeratorEarnings: "No moderator with accumulated earnings without request.",
      adminCorrectedCount: "{count} corrected tests",
      adminLastPayout: "Last payout: {date}",
      adminMonthlyAmountReady: "Monthly amount ready",
      adminMonthlyAmountNotAvailable: "Monthly amount not yet available",
      adminSectionContributorRequests: "Contributor payment requests ({count})",
      adminReloadEarnings: "Reload earnings",
      adminApproveAllContributors: "Approve all",
      adminRequestCount: "{count} request(s)",
      adminModeratorCount: "{count} moderator(s)",
      adminNoContributorRequests: "No contributor has made a payment request yet.",
      adminSectionContributorEarnings: "Contributors eligible for payment ({count})",
      adminNoEligibleContributors: "No eligible contributors at the moment.",
      adminValidatedTests: "{count} validated tests",
      adminPayNow: "Pay now",
      adminApprove: "Approve",
      adminReject: "Reject",
      depositBudgetTitle: "Budget deposit",
      depositBudgetDescription: "Enter the Mobile Money details to top up the admin account.",
      amountPlaceholder: "e.g: 50000",
      phonePlaceholder: "e.g: +22890000000",
      depositDescriptionPlaceholder: "e.g: Weekly budget top-up",
      depositInProgress: "Deposit in progress...",
      validateDeposit: "Validate deposit",
      bulkApproveConfirmTitle: "Confirm bulk approval",
      rejectRequestTitle: "Reject request",
      noteLabel: "Note",
      stop: "Stop",
      redo: "Redo",
      submitEnabledWhenComplete: "The button becomes active when all items are completed.",
      validatedAudioCountLabel: "Validated (audios)",
      pendingAudiosLabel: "Pending (audios)",
      totalPointsLabel: "Total contributions",
      moderatorNoteLabel: "Moderator note:",
      requestPendingModerator: "Awaiting moderator validation",
      requestApprovedAdminSoon: "Approved! Payment will be processed by admin soon",
      contractSentSignRequired: "A contract has been sent to you and must be signed.",
      signedContractAvailable: "Contract already signed. You can view the signed version.",
      withdrawAmountLabel: "Amount to withdraw (XOF)",
      transactionRefLabel: "Transaction ref: {ref}",
      paidOnLabel: "Paid on {date}",
      refundedAmountTitle: "Amount returned to your account",
      refundedAmountDesc: "{amount} has been returned to your available amount.",

      // Moderator Payout Tab
      modPayoutUserNotFound: "User not found",
      modPayoutEnterPhone: "Please enter a phone number",
      modPayoutCouldNotLoadStats: "Could not load moderator stats",
      modPayoutEarnings: "Moderator Earnings",
      modPayoutPeriod: "Period: {month}/{year}",
      modPayoutValidations: "Validations",
      modPayoutMonthlyAmount: "Monthly Amount",
      modPayoutStatus: "Status",
      modPayoutNotDueYet: "Not Due Yet",
      modPayoutReadyToClaim: "Ready to Claim",
      modPayoutAlreadyPaid: "Already Paid",
      modPayoutRequestInProgress: "Request In Progress",
      modPayoutClaimInfo: "You can claim your monthly payout at the end of the month.",
      modPayoutAlreadyReceived: "You have already received your payout for {month}/{year}.",
      modPayoutRequestThisMonth: "Request This Month's Payout",
      modPayoutInProgressInfo: "You have a payout request in progress for this month. Please wait for it to be processed.",
      modPayoutYourRequests: "Your Payout Requests",
      modPayoutNoRequests: "No requests yet",
      modPayoutTableId: "ID",
      modPayoutTableAmount: "Amount",
      modPayoutTablePeriod: "Period",
      modPayoutTableStatus: "Status",
      modPayoutTableCreated: "Created",
      modPayoutRequestTitle: "Request Payout",
      modPayoutRequestDesc: "Submit your monthly moderator payout request",
      modPayoutYourMonthlyAmount: "Your Monthly Amount:",
      modPayoutPhoneNumber: "Phone Number",
      modPayoutMobileNetwork: "Mobile Network",
      modPayoutCancel: "Cancel",
      modPayoutSubmitting: "Submitting...",
      modPayoutSubmitRequest: "Submit Request",

      // Contributor Payout Tab
      contribPayoutUserNotFound: "User not found",
      contribPayoutValidAmount: "Please enter a valid amount",
      contribPayoutEnterPhone: "Please enter a phone number",
      contribPayoutYourEarnings: "Your Earnings",
      contribPayoutAcceptedAudios: "Accepted Audios",
      contribPayoutPayableCount: "Payable Count",
      contribPayoutCap: "Cap",
      contribPayoutRate: "Rate",
      contribPayoutMaximumClaimable: "Maximum Claimable",
      contribPayoutBasedOnInfo: "Based on {count} payable contributions at {rate} XOF each",
      contribPayoutRequestPayout: "Request Payout",
      contribPayoutOpenRequestInfo: "You have an open payout request. Please wait for it to be processed or completed before submitting another.",
      contribPayoutMinimumInfo: "You need at least 1000 accepted audio contributions to request a payout.",
      contribPayoutYourRequests: "Your Payout Requests",
      contribPayoutNoRequests: "No requests yet",
      contribPayoutTableId: "ID",
      contribPayoutTableAmount: "Amount",
      contribPayoutTableStatus: "Status",
      contribPayoutTableCreated: "Created",
      contribPayoutTableUpdated: "Updated",
      contribPayoutRequestTitle: "Request Payout",
      contribPayoutRequestDesc: "Submit a payout request for your earnings",
      contribPayoutMaximumAvailable: "Maximum available:",
      contribPayoutAmountXof: "Amount (XOF)",
      contribPayoutPhoneNumber: "Phone Number",
      contribPayoutMobileNetwork: "Mobile Network",
      contribPayoutCancel: "Cancel",
      contribPayoutSubmitting: "Submitting...",
      contribPayoutSubmitRequest: "Submit Request",
    },

    // Authentication
    login: "Login",
    signup: "Sign Up",
    username: "Username",
    email: "Email",
    password: "Password",
    passwordHint: "Minimum 8 characters, 1 uppercase, 1 lowercase, 1 digit, 1 special character",
    pwdMinLength: "At least 8 characters",
    pwdUppercase: "At least 1 uppercase",
    pwdLowercase: "At least 1 lowercase",
    pwdDigit: "At least 1 digit",
    pwdSpecial: "At least 1 special character",
    pwdStrong: "Strong password",
    pwdWeak: "Weak password",
    name: "Name",
    fullName: "Full name",
    orFillForm: "Or fill the form",
    optionalLabel: "optional",
    languagePreferences: "Language Preferences",

    // Dashboard
    contributionStatus: "Contribution Status",
    userStatistics: "User Statistics",
    target: "Target",
    collected: "Collected",
    ageDistribution: "Age Distribution",
    genderDistribution: "Gender Distribution",
    avgWords: "Average Words",
    avgAge: "Average Age",
    ageRange: "Age Range",
    country: "Country",
    countryDistribution: "Country Distribution",
    contributorMessage: "Thanks to your participation, we are building together the future of AI for West African languages. Every contribution counts to preserve and develop our linguistic heritage.",
    realTimeDashboard: "Real-time dashboard of contributions for NLP data collection in West African languages",
    thisMonth: "this month",
    countries: "6 countries",
    westAfrica: "West Africa",
    globalProgress: "Global Progress",
    inProgress: "In progress",
    demographicAnalysis: "Demographic analysis and geographical distribution of contributors",
    thanksContributors: "Thanks to Contributors!",
    thanksMessage: "Thanks to your participation, we are building together the future of AI for West African languages. Every contribution counts to preserve and develop our linguistic heritage.",
    supportedLanguagesCount: "Supported languages",
    totalGoal: "Total goal",
    openSourceLicense: "Open Source",
    nwuliteObodoLicense: "Nwulite Obodo License",

    // Contribution Page
    recordings: "Recordings",
    languageMenu: "Language Menu",
    word: "Word",
    display: "Display",
    record: "Record",
    recordDescription: "Record your voice to enrich AI models",
    labelImages: "Label Images",
    labelImagesDescription: "Identify characters in handwritten images",
    labelImagesTitle: "Label Images",
    labelImagesSubtitle: "Identify handwritten characters to improve writing recognition",
    startLabeling: "Start Labeling",
    labelingSession: "Labeling session",
    labelingCompleteTitle: "Submission successful",
    labelingCompleteSubtitle: "Thank you for your contribution, your annotations improve handwriting recognition",
    labelingAccuracy: "Accuracy",
    labelingCorrect: "Correct",
    labelingPointsEarned: "Points earned",
    labelingTotalImages: "{total} images in total",
    labelingContinue: "Contribute again",
    labelingContinueHint: "Each session generates new random images",
    validationCompleteTitle: "Validation complete",
    validationCompleteSubtitle: "All audios in this session have been processed",
    validationCompleteValidated: "Validated",
    validationCompleteAccepted: "Accepted",
    validationCompleteRejected: "Rejected",
    validationCompletePointsEarned: "Points earned",
    validationCompleteContinue: "Validate more audios",
    validationCompleteContinueHint: "New audios may be available",
    transcribeAudio: "Transcribe Audio",
    transcribeAudioDescription: "Listen and type the transcription",
    transcribePhrases: "Translate Phrases",
    transcribePhrasesDescription: "Translate French sentences into the selected language",
    validateAudio: "Validate Audio",
    validateAudioDescription: "Validate recordings from other contributors",
    validateTranscriptions: "Validate Transcriptions",
    validateTranscriptionsDescription: "Review and validate proposed transcriptions",
    deleteAudioButton: "Delete this audio",
    deleteAudioTitle: "Delete this audio?",
    deleteAudioDescription: "This action cannot be undone. The audio will be permanently deleted from storage.",
    audioDeleted: "Audio deleted",
    audioDeletedDescription: "The audio has been permanently deleted.",
    audioDeleteFailed: "Unable to delete this audio.",
    modelPerformance: "Model Performance",
    modelPerformanceDescription: "Assess Umbaji models (TTS, ASR)",
    initialAudio: "Initial audio",
    initialAudioDescription: "Record audio samples for the initial dataset",
    initialText: "Initial text",
    initialTextDescription: "Submit sentences for the initial dataset",
    initialTranscription: "Initial transcription",
    initialTranscriptionDescription: "Transcribe the audio answers of the initial data",
    initialReview: "Initial review",
    initialReviewDescription: "Review the transcriptions and texts of the initial data",
    initialTextTitle: "Initial data — Text",
    initialAudioTitle: "Initial data — Audio",
    selectLanguageLabel: "Select language",
    selectThemeLabel: "Select theme",
    phrasesAndRecordings: "Phrases & recordings",
    progressOverview: "Contribution Tracker",
    progressOverviewDescription: "Review your progress and ongoing tasks",
    getPaidLabel: "Get Paid",
    getPaidDescription: "Request your payment once thresholds are reached",
    paymentManagement: "Payment Management",
    paymentManagementDescription: "Configure budget settings and process payouts as admin",
    adminStatus: "Admin",
    getPaidCtaEligible: "Eligible",
    getPaidCtaLocked: "{count} left",
    getPaidCtaHint: "Approved audios",
    getPaidPage: {
      title: "Get Paid",
      subtitle: "Review your eligibility, complete the steps, and track the status of your payouts.",
      workspaceTitle: "Contributor space",
      workspaceEarnings: "Earnings",
      workspaceEarningsDescription: "Track your eligibility and payouts.",
      workspaceOverview: "Overview",
      workspaceOverviewDescription: "Eligibility and earnings",
      workspaceTest: "Qualification test",
      workspaceTestDescription: "Unlock access to your earnings",
      workspaceRequests: "Payout requests",
      workspaceRequestsDescription: "Track your requests",
      workspaceContracts: "Contracts",
      workspacePendingContracts: "To sign",
      workspacePendingContractsDescription: "Contracts awaiting your signature",
      workspaceSignedContracts: "Signed",
      workspaceSignedContractsDescription: "Your signed contract history",
      workspaceCollection: "Field collection",
      workspaceCollectionTitle: "Collector space",
      workspaceCollectionDashboard: "Dashboard",
      workspaceCollectionDashboardDescription: "Collection overview",
      workspaceCollectionProfiles: "Profiles",
      workspaceCollectionProfilesDescription: "Community profiles",
      workspaceCollectionContributions: "Contributions",
      workspaceCollectionContributionsDescription: "Collection history",
      workspaceCollectionInitialAudio: "Initial audio",
      workspaceCollectionInitialAudioDescription: "Record audio answers to initial questions",
      workspaceCollectionAssistant: "Assistant",
      workspaceCollectionAssistantDescription: "Ask a question",
      workspaceCollectionGuidelines: "Policy",
      workspaceCollectionGuidelinesDescription: "Recording rules",
      statusEligible: "Eligible for payout",
      statusPending: "{remaining} more approved contribution(s) needed to qualify",
      requirementsTitle: "Eligibility requirements",
      requirementOne: "Reach {threshold} approved contributions",
      requirementTwo: "Maintain task quality guidelines (acceptance rate ≥ 80%)",
      requirementThree: "Complete your profile and payout information",
      stepsTitle: "Steps to receive a payout",
      steps: {
        review: "Review your approved contributions",
        submit: "Submit a request via the payout form",
        payout: "Receive confirmation from the Umbaji team"
      },
      documentsTitle: "Required documents",
      documentsDescription: "Prepare a valid ID document and your transfer details (Mobile Money or bank account).",
      contactSupport: "Contact support",
      goToContributions: "View my contributions",
      requestPayout: "Request payout",
      earningsCard: {
        estimatedTitle: "Estimated earnings",
        estimatedDescription: "Calculated at 5 XOF per approved contribution after the threshold.",
        remainingTitle: "Remaining amount",
        remainingContributions: "{count} more approved contribution(s) needed to reach the threshold.",
        remainingDescription: "Earnings start only after you cross the threshold.",
        readyDescription: "Threshold reached! New contributions now earn 5 XOF each.",
      },
      completeProfile: "Complete my payout info",
      profileDialog: {
        title: "Complete payout information",
        description: "Before we send your payment, we need your contact details.",
        amountLabel: "Estimated amount to send",
        phoneLabel: "Phone number (Mobile Money)",
        phonePlaceholder: "e.g. +228 90 00 00 00",
        providerLabel: "Provider or bank",
        providerPlaceholder: "Choose a provider",
        accountNameLabel: "Account holder name",
        accountNamePlaceholder: "Name registered on the account",
        submit: "Submit information",
        cancel: "Cancel",
        successTitle: "Details saved",
        successDescription: "Our team will review your information and follow up shortly.",
        missingInfo: "Complete these details to receive your payout faster.",
        errorTitle: "Missing information",
        errorDescription: "Please fill in all required payout information.",
      },
      helpText: "Need help? Our team can guide you through the payout validation process.",
      lastUpdated: "Updated: {date}",
      myPaymentRequests: "My payment requests",
      noPaymentRequests: "You have no payment requests",
      requestedOn: "Requested on",
      paid: "Paid",
      paymentStatusPending: "Awaiting validation",
      paymentStatusApproved: "Approved - Awaiting payment",
      paymentStatusRejected: "Rejected",
      validatedLabel: "Approved",
      pendingLabel: "Pending",
      pointsLabel: "Validated contributions",
      step1Title: "Step 1/3: Reach {threshold} approved contributions",
      step1Completed: "✓ Step 1 completed!",
      step2Title: "Step 2/3: Pass the validation test",
      step2Pending: "⏳ Test pending",
      step2Approved: "✓ Test approved!",
      step3Title: "Step 3/3: Earn on new contributions",
      eligibleCreateRequest: "You're eligible! Create your first request above.",
      eligibleForTest: "You're eligible!",
      canNowTakeTest: "You can now take the test",
      testEligibilityTitle: "You're eligible for the test!",
      testEligibilityMessage: "You've reached the threshold to take the validation test.",
      congratulations: "Congratulations!",
      testInstructionMessage: "You can now take the validation test. Once passed, you'll start earning on your new contributions.",
      nextSteps: "Next steps:",
      languageRequiredTitle: "Language required",
      languageRequiredDesc: "Please select a test language.",
      testLanguageLabel: "Test language",
      chooseLanguage: "Choose language",
      loadingLanguages: "Loading languages...",
      noLanguagesAvailable: "No languages available",
      noTestContributionLanguage: "No contribution language detected",
      noTestContributionLanguageDescription: "The test is offered only in languages where you have actually submitted at least one audio.",
      testLanguageProgress: "Progress in this language: {validated}/{threshold} approved audios",
      testLanguageContributionSummary: "{total} audio contributions submitted in this language, including {validated} validated by the community.",
      testLanguageRemaining: "You need {remaining} more approved audio(s) in {language} before you can start the test.",
      testLanguageEligible: "You are eligible for the test in this language",
      testLanguageEligibleDescription: "You have reached 50 community-approved audios and can start the test.",
      communityValidationRule: "Rule: each audio needs at least 2 validation points and more validations than rejections. A contributor counts as 1 point; a moderator counts as 2 points.",
      testStatusPending: "Awaiting correction",
      testStatusValidated: "Validated",
      testStatusRejected: "Rejected",
      statusLabel: "Status:",
      testAlreadySubmittedSignature: "Test already submitted for a language. Contract sent, awaiting signature.",
      testAlreadySubmittedFinal: "Test already submitted for a language. Contract signed, awaiting final validation.",
      noTestSubmitted: "No test submitted for this language.",
      noTranslationItems: "No translation items are available for this language.",
      noPendingTests: "No tests awaiting correction",
      noValidatedTests: "No validated tests",
      startTest: "Start test",
      selectTestLanguage: "Select test language",
      testApproved: "Test approved.",
      newValidatedContributions: "Make new approved contributions to unlock payout request",
      passValidationTest: "Pass the validation test to start earning",
      eligibleEarnPerContribution: "You're eligible! Earn {rate} XOF per approved contribution",
      noModeratorTests: "No tests awaiting correction",
      noCorrectedTests: "No validated tests",
      loading: "Loading...",
      noPendingPayoutRequests: "No pending payout requests",
      clickStartTestDesc: "Click 'Start test' to take the exam",
      mustReachContributions: "You must reach {threshold} contributions. {remaining} remaining.",
      noPayoutRequestsSent: "No requests sent yet.",
      myPayoutRequests: "My requests",
      clickStartTestInstruction: "Click 'Start test' to take the exam",
      reachThresholdMessage: "Reach {threshold} validated contributions. {remaining} more to do.",
      earnPerAudioAfterDate: "Earn {rate} XOF per approved audio after this date",
      audiosEarnedSoFar: "Audios earned so far: {count}",
      alreadySubmittedLanguage: "You already have a submission for this language",
      contractAwaitingSignature: "You already submitted this test. Contract must be signed before final validation.",
      awaitingFinalValidation: "You already submitted this test. Final validation is pending.",
      alreadyPendingRequest: "You already have a pending request",
      step2TakesAbout10Minutes: "The test takes about 10 minutes",
      step2AnswerQuestions: "Answer audio and text questions",
      step2GetScoreAndEarn: "Get a score and move to earnings collection",
      actionsTitle: "Payout actions",
      actionsDescription: "Choose the test language, manage your contracts, and submit your payout request.",
      refreshContracts: "Refresh",
      signContract: "Sign contract",
      viewSignedContract: "View signed contract",
      myContracts: "My contracts",
      contractSignatureBlocked: "Final validation remains blocked until this contract is signed.",
      newValidatedAfterTest: "New approved contributions after test ({language}): {count}",
      earnAfterTestApproval: "Earn after test approval",
      pendingRequestAmount: "{amount} awaiting request",
      availableAmount: "Available amount: {amount}",
      amountPlaceholder: "e.g. 10000",
    },
    upload: "Upload",
    save: "Save",
    label: "Label",
    validate: "Validate",
    validateDescription: "Validate community contributions",
    displayImage: "Display Image",
    imageDisplayed: "Image Displayed",
    dropAudio: "Drop audio here - or - Click to upload file",    // Contribution Page Content
    contributionSpaceTitle: "Contribution Space",
    contributionSpaceSubtitle: "Help build the future of artificial intelligence for West African languages. Every contribution counts to preserve our linguistic heritage.",
    thanksForContributing: "Thank you for contributing to African AI",
    audioRecordings: "Audio Recordings",
    imageLabeling: "Image Labeling",
    audioRecordingsDesc: "Record words and phrases in West African languages to train speech recognition models",
    imageLabelingDesc: "Label alphabet characters to improve Optical Character Recognition (OCR)",
    dailyGoal: "Daily goal",
    yourProgress: "Your progress",
    pointsEarned: "Points earned",
    community: "Community",
    achievements: "Achievements & Rewards",
    yourImpact: "Your Impact",
    totalContributions: "Total contributions",
    audio: "Audio",
    images: "Images",
    languagesContributed: "Languages contributed:",
    noneYet: "None yet",
    readyToMakeDifference: "Ready to make a difference?",
    contributionImpactDesc: "Your contributions will help millions of people access AI technologies in their native language. Start now and join a passionate community!",
    languages: "Languages",
    contributors: "Contributors",
    data: "Data",
    myContributionSummary: "Contribution tracker",
    myContributionSummaryDescription: "Review your submissions, approvals and progress",
    myContributionsPage: {
      title: "My Contributions",
      subtitle: "Explore your submissions, approvals, and progress toward rewards.",
      totalSubmitted: "Submissions",
      totalApproved: "Approved",
      totalPending: "Pending",
      totalPoints: "Total contributions",
      payoutProgressTitle: "Payout progress",
      payoutProgressDescription: "Reach {threshold} approved contributions to request a payout.",
      payoutEligible: "Great news! You're eligible to request a payout.",
      payoutMissing: "{remaining} more approved contribution(s) to become eligible.",
      payoutCta: "Request a payout",
      continueContributing: "Keep contributing",
      tableTitle: "Breakdown by contribution type",
      tableHeaders: {
        category: "Category",
        submitted: "Submitted",
        approved: "Approved",
        pending: "Pending",
        rejected: "Rejected",
        points: "Points"
      },
      statusBadges: {
        approved: "Approved",
        pending: "Pending",
        rejected: "Rejected"
      },
      recentActivityTitle: "Recent activity",
      playAudio: "Play audio",
      audioPlayErrorTitle: "Playback failed",
      audioPlayError: "The audio could not be played. Please try again shortly.",
      audioPlayForbidden: "You do not have access to this audio.",
      noActivity: "No contributions recorded yet.",
      lastUpdated: "Last updated: {date}",
      eligibilityLabel: "Eligibility",
      contributionGoalLabel: "Goal",
      totalHours: "Estimated hours",
      seeTasks: "View available tasks",
      statsLoadError: "Error",
      statsLoadErrorDesc: "Unable to load your statistics. Please try again.",
      refresh: "Refresh",
      loadingStats: "Loading your statistics...",
      totalContributionsLabel: "Total contributions",
      uploadedAudioLabel: "Uploaded audio",
      validatedTranscriptionsLabel: "Validated transcriptions",
      submittedValidationLabel: "Submitted for validation",
      contributionsLabel: "Contributions",
      contributionsCaption: "Your personal contributions",
      audioCaption: "Audio clips submitted to the platform",
      validatedCaption: "Successfully reviewed transcriptions",
      moderationLabel: "Moderation",
      moderationCaption: "Reviews performed on other content",
      activityEyebrow: "Your activity",
      earningEyebrow: "Earning path",
      detailEyebrow: "Detail",
      byLanguageEyebrow: "By language",
      recordingDurationLabel: "Recording time",
      recordingDurationCaption: "Total recorded time",
      journeyStep1: "Approved audios",
      journeyStep2: "Accuracy test",
      journeyStep3: "Earnings active",
      journeyHint: "50 approved audios, then accuracy test, then earnings",
      journeyDone: "Step reached",
      journeyRemaining: "{remaining} more to unlock the test",
      journeyReachedTitle: "Threshold reached!",
      journeyReachedDesc: "You've reached {threshold} approved audios. Take the accuracy test to unlock your earnings.",
      journeyStartTest: "Take the test",
      journeyGainsKicker: "Earnings active",
      journeyAvailableLabel: "Available earnings",
      journeyAudiosAfterTestLabel: "Audios approved after the test",
      journeyRateLabel: "Rate per audio",
      journeyAccumulatedLabel: "Accumulated earnings",
      journeyPendingNotice: "Payout in progress — {amount} XOF",
      journeyReadyLabel: "You can request a payout",
      journeyContinueLabel: "Keep contributing to earn",
      journeyCtaWithdraw: "Request my payout",
      journeyCtaDetails: "View my earnings",
      audioPanelTitle: "Audio",
      transcriptionPanelTitle: "Transcription",
      validationPanelTitle: "Validation summary",
      rowUploaded: "Uploaded",
      rowAccepted: "Accepted",
      rowRejected: "Rejected",
      rowSubmitted: "Submitted",
      rowValidated: "Approved",
      rowDuration: "Total duration",
      rowValidatedAudio: "Validated audios",
      rowRejectedAudio: "Rejected audios",
      rowValidatedTranscriptions: "Validated transcriptions",
      rowRejectedTranscriptions: "Rejected transcriptions",
      emptyTitle: "No contributions yet",
      emptyDescription: "Start contributing to see your statistics appear here.",
      retry: "Try again",
      ctaContribute: "Contribute",
      ctaWithdraw: "Withdraw earnings",
      ctaValidate: "Validate content",
      ctaContributeDesc: "Record new audio clips",
      ctaWithdrawDesc: "Request payout of your earnings",
      ctaValidateDesc: "Review community content",
      profileEyebrow: "Contribution profile",
      radarEmpty: "Not enough data yet",
      radarAudio: "Audio",
      radarAccepted: "Accepted",
      radarTranscription: "Transcription",
      radarValidated: "Validated",
      radarModeration: "Moderation",
      radarDuration: "Duration",
      paginationRange: "{start}-{end} of {total}",
      flowEyebrow: "Acceptance flow",
      flowAccepted: "Accepted",
      flowRejected: "Rejected",
      flowPending: "Pending",
      flowEmpty: "No history yet"
    },

    // SpeakContribute Page - Missing keys
    speakContributeTitle: "Recording Session",
    speakContributeSubtitle: "Help improve speech recognition by recording a few sentences",
    phrasesToRead: "Phrases to read",
    minutesRequired: "Minutes required",
    sessionPointsEarned: "Points earned",
    instructionsTitle: "Instructions:",
    speakInstruction1: "Read each sentence clearly and naturally",
    speakInstruction2: "Make sure you are in a quiet environment",
    speakInstruction3: "You can replay and redo the recording if necessary",
    speakInstruction4: "Take your time, quality is more important than speed",
    startSession: "Start session",
    sessionRecording: "Recording session",
    sentenceXofY: "Sentence {current} of {total}",
    percentCompleted: "{percent}% completed",
    toRead: "To read",
    phraseDomain: "Domain",
    phraseFileOrder: "File #",
    phraseId: "ID",
    initialDataReview: {
      setup: {
        prepareEyebrow: "Prepare the session",
        transcriptionTitle: "Language",
        reviewTitle: "Language and content",
        typeLabel: "Content to review",
        typeAudio: "Audio transcriptions",
        typeAudioHint: "Listen and judge the proposed transcriptions",
        typeText: "Written answers",
        typeTextHint: "Proofread the answers typed as text",
        waiting: "{count} waiting",
        instructionsTitle: "Guidelines",
        transcriptionInstruction1: "Listen to the whole answer before writing.",
        transcriptionInstruction2: "Write exactly what is said, in the spoken language, without translating.",
        transcriptionInstruction3: "The French translation is optional.",
        transcriptionInstruction4: "Skip an audio you cannot hear or understand.",
        reviewInstruction1: "Compare each proposal with the audio or the question asked.",
        reviewInstruction2: "Accept a correct proposal; otherwise reject it with a reason.",
        reviewInstruction3: "Correct it when you know the right text.",
        reviewInstruction4: "You are never offered your own answers or transcriptions.",
        back: "Back",
        start: "Start the session",
        changeSetup: "Change language",
      },
      subNav: {
        label: "Initial data",
        audio: "Initial audio",
        text: "Initial text",
        transcription: "Transcription",
        review: "Review",
      },
      eyebrow: "Initial data",
      languageLabel: "Language",
      languagePlaceholder: "Choose a language",
      noLanguage: "None of your contribution languages is available here. Add one in your settings.",
      ownDataNote: "You never work on your own answers or on the ones you collected.",
      loading: "Loading…",
      retry: "Try again",
      reload: "Reload",
      skip: "Skip",
      cancel: "Cancel",
      questionLabel: "Question asked",
      remaining: "{count} waiting",
      hub: {
        toTranscribe: "Audio to transcribe",
        audioToReview: "Transcriptions to review",
        textToReview: "Texts to review",
      },
      transcription: {
        title: "Initial data transcription",
        subtitle: "Listen to the recorded answer and write exactly what is said, in the spoken language.",
        textRequired: "Write the transcription before sending (2000 characters at most).",
        previousRejections: "Your earlier transcriptions of this audio were rejected:",
        emptyTitle: "No audio to transcribe",
        emptyBody: "Every audio in this language is transcribed or reserved by other contributors. Come back later.",
      },
      review: {
        title: "Initial data review",
        subtitle: "Accept, reject or correct the transcriptions and written answers of other contributors.",
        tabAudio: "Audio",
        tabText: "Text",
        candidatesLabel: "Proposals",
        answerLabel: "Written answer",
        original: "Original text",
        correction: "Correction",
        votes: "{validations} validation(s) · {rejections} rejection(s)",
        selectCandidate: "Choose the proposal to assess.",
        accept: "Accept",
        reject: "Reject",
        correct: "Correct",
        reasonLabel: "Reason for rejection",
        reasonPlaceholder: "Briefly explain what is wrong",
        reasonHint: "Between 3 and 300 characters.",
        correctionLabel: "Corrected text",
        correctionPlaceholder: "Write the right text",
        correctionHint: "The corrected text must differ from the proposal (2000 characters at most).",
        confirmReject: "Confirm rejection",
        confirmCorrect: "Send correction",
        correctionsLeft: "{count} correction(s) still possible",
        noCorrectionLeft: "The maximum number of corrections has been reached.",
        gatedCorrection: "Correcting an audio counts as a contribution: cross-validation applies.",
        emptyAudioTitle: "No transcription to review",
        emptyTextTitle: "No text to review",
        emptyBody: "Nothing is waiting for your review in this language right now. Come back later.",
      },
      gate: {
        blockedTitle: "Cross-validation required",
        blockedBody: "Review other people's work before transcribing again. Accepting or rejecting here counts towards unblocking you.",
        goReview: "Go to review",
      },
      success: {
        INITIAL_AUDIO_TRANSCRIPTION_ADDED: "Transcription sent.",
        INITIAL_AUDIO_TRANSCRIPTION_VALIDATED: "Transcription accepted.",
        INITIAL_AUDIO_TRANSCRIPTION_REJECTED: "Transcription rejected.",
        INITIAL_AUDIO_TRANSCRIPTION_CORRECTED: "Correction sent.",
        INITIAL_TEXT_ACCEPTED: "Text accepted.",
        INITIAL_TEXT_REJECTED: "Text rejected.",
        INITIAL_TEXT_CORRECTION_PROPOSED: "Correction proposed.",
        finalized: "The transcription reached the required number of validations.",
        textClosedAccepted: "The answer is accepted by the community.",
        textClosedRejected: "The answer goes to an administrator for a decision.",
      },
      errorTitle: "Action not possible",
      loadError: "The items could not be loaded.",
      errors: {
        DEFAULT: "Something went wrong. Try again in a moment.",
        INITIAL_DATA_LANGUAGE_NOT_ALLOWED: "This language is not one of your contribution languages.",
        INITIAL_DATA_OWN_ITEM: "You cannot work on your own data.",
        CROSS_VALIDATION_REQUIRED: "Complete cross-validations before contributing again.",
        INITIAL_DATA_ITEM_NOT_FOUND: "This item no longer exists.",
        INITIAL_DATA_CANDIDATE_NOT_FOUND: "This proposal no longer exists.",
        INITIAL_DATA_NOT_REVIEWABLE: "This item no longer needs a review.",
        INITIAL_DATA_ALREADY_REVIEWED: "You already gave your opinion on this item.",
        INITIAL_DATA_TRANSCRIPTION_DUPLICATE: "This text was already proposed for this audio.",
        INITIAL_TEXT_CORRECTION_LIMIT: "This answer has reached the maximum number of corrections.",
        INITIAL_TEXT_CORRECTION_UNCHANGED: "The correction must differ from the proposed text.",
        CONFLICT: "Other reviewers are acting at the same time. Try again.",
        VALIDATION_FAILED: "The request is invalid. Check the fields you entered.",
        UNAUTHORIZED: "Your session has expired. Sign in again.",
        FORBIDDEN: "You do not have access to this action.",
        NOT_FOUND: "Resource not found.",
        INTERNAL_SERVER_ERROR: "The service is temporarily unavailable.",
      },
    },
    phraseListErrors: {
      DEFAULT: "Could not load phrases for this language.",
      VALIDATION_FAILED: "Invalid phrase loading parameters.",
      UNAUTHORIZED: "Your session has expired. Sign in again.",
      FORBIDDEN: "You cannot access these phrases.",
      NOT_FOUND: "No data was found for this language.",
      INTERNAL_SERVER_ERROR: "The phrase service is temporarily unavailable.",
    },
    readPhraseClearly: "Read this sentence clearly and naturally",
    startRecording: "Start recording",
    pauseRecording: "Pause",
    resumeRecording: "Resume recording",
    stopRecording: "Stop recording",
    recordingSuccessful: "Recording successful!",
    previous: "Previous",
    next: "Next",
    sessionProgress: "Session progress",
    sessionInProgress: "In progress",
    completed: "Completed",
    waiting: "Waiting",
    recordPhraseFirst: "Please record the sentence before continuing",
    allPhrasesCompleted: "Congratulations! You have completed all sentences.",
    chooseLanguageToRecord: "Choose a language to record",
    fileUrl: "File URL",
    fileUrlPlaceholder: "Paste the file URL here (Cloudinary)",
    reRecordMode: "Re-recording",
    translationLabel: "Translation:",
    noFrenchTranslation: "This phrase has no French translation.",
    editAddFrenchTranslation: "Edit/Add French translation",
    addFrenchTranslation: "Add French translation",
    noLocalTranslation: "This phrase has no local language text yet. You can translate it before recording.",
    editTranslatePhrase: "Edit/Translate this phrase",
    translatePhrase: "Translate this phrase",
    optionalHint: "Optional — you can also record directly.",
    editPhraseAndTranslation: "Edit this phrase and its translation",
    editLocalPhrase: "Edit local phrase",
    hideKeyboard: "Hide keyboard",
    openAfricanKeyboard: "Open African keyboard",
    phraseModified: "Modified",
    phraseModifiedDesc: "The phrase has been updated successfully.",
    phraseUpdateError: "Error",
    phraseUpdateErrorDesc: "Unable to update the phrase.",
    connectionRequired: "Login required",
    connectionRequiredDesc: "Please sign in to continue.",
    noPhraseAvailableDesc: "No phrase is available for this page.",
    phraseMissing: "Missing phrase",
    phraseMissingDesc: "You must provide at least one phrase (local or French).",
    durationMissing: "Missing duration",
    durationMissingDesc: "The recording duration could not be captured. Please try again.",
    uploadSuccess: "Perfect!",
    uploadSuccessAnonymized: "Audio sent and anonymized successfully",
    uploadSuccessWithTime: "Audio sent successfully ({time}s)",
    sessionComplete: "Session complete",
    sessionCompleteDesc: "All phrases have been recorded.",
    genericError: "Error",
    localSaved: "Saved",
    localSavedDesc: "Local phrase updated",
    localSaveError: "Error",
    localSaveErrorDesc: "Update failed",
    noMorePhrases: "No additional phrases",
    noMorePhrasesDesc: "No new phrases are currently available for this language and contributor.",
    skipPhrase: "Skip this phrase",
    phraseSkipped: "Phrase skipped",
    phraseSkippedDesc: "Moved to next phrase",
    loadingNewPhrases: "Loading new phrases...",
    audioskipped: "Audio skipped",
    audioskippedDesc: "Moved to next audio",
    loadingNewAudios: "Loading new audios...",
    noMoreAudios: "No more audios",
    noMoreAudiosDesc: "No other audio available at the moment",
    loadError: "Loading error",
    // Model Performance / Assessment labels
    taskLabel: "Task",
    modelNameLabel: "Model Name",
    startAssessment: "Start Assessment",
    modelPerformancePage: {
      selectTaskPlaceholder: "Select a task...",
      selectModelPlaceholder: "Select a model...",
      selectLanguagePlaceholder: "Choose a language...",
      taskOptions: {
        TTS: "TTS (Text-to-Speech)",
        ASR: "ASR (Speech Recognition)",
        Text: "Text (Text Generation)"
      },
      taskBadges: {
        TTS: "🎤 TTS Assessment",
        ASR: "🎧 ASR Assessment",
        Text: "📝 Text Assessment"
      },
      taskDescriptions: {
        TTS: "Compare the model-generated audio with the ground truth recording. Rate quality, naturalness, and pronunciation.",
        ASR: "Compare generated transcriptions with the ground truth text. Rate accuracy and readability.",
        Text: "Compare the generated text with the reference text. Rate coherence, accuracy, and overall quality."
      },
      availableModels: "{count} model(s) available for {task}",
      loadSuccessTitle: "✓ Samples loaded",
      loadSuccessDescription: "Samples loaded for {model}",
      loadingError: "Loading error",
      fillAllFields: "Please fill all fields",
      rateAllCriteria: "Please rate all criteria",
      saveFailed: "Failed to save",
      userRequired: "Authentication required",
      assessmentSavedTitle: "✓ Assessment saved",
      assessmentSavedTtsDescription: "Overall score: {score}/5",
      assessmentSavedTextDescription: "Accuracy: {accuracy}% | Readability: {readability}/5",
      sessionCompleteTitle: "🎉 Session completed",
      sessionCompleteTTS: "{count} TTS assessments completed",
      sessionCompleteGeneric: "{count} {task} assessments completed",
      sessionMeta: "Language: {language} | Model: {model}",
      taskNames: {
        TTS: "TTS",
        ASR: "ASR",
        Text: "Text"
      },
      textToEvaluateTitle: "Text to evaluate",
      audioOriginalTitle: "🎤 Ground truth audio",
      audioGeneratedTitle: "🤖 Generated audio",
      humanEvaluationTitle: "Human evaluation",
      qualityRatingLabel: "Overall quality",
      naturalnessLabel: "Naturalness",
      pronunciationLabel: "Pronunciation",
      commentsLabel: "Comments (optional)",
      commentsPlaceholderTts: "Notes about audio quality...",
      statsAssessmentsLabel: "Assessments",
      statsCurrentScoreLabel: "Current score",
      ttsHeaderTitle: "TTS Assessment",
      asrHeaderTitle: "ASR Assessment",
      textHeaderTitle: "Text Assessment",
      referenceAudioTitle: "Reference audio",
      audioUnsupported: "Your browser does not support the audio element.",
      textGroundTruthTitle: "✓ Ground truth transcription",
      textGeneratedTitle: "🤖 Generated text",
      diffTitle: "Word-by-word comparison",
      diffLegendMatch: "Match",
      diffLegendDifferent: "Different",
      diffLegendMissing: "Missing",
      expertEvaluationTitle: "Human evaluation by experts",
      transcriptionAccuracyLabel: "Transcription accuracy",
      accuracyCorrect: "Correct",
      accuracyPartial: "Partial",
      accuracyIncorrect: "Incorrect",
      readabilityLabel: "Readability (1-5)",
      commentsPlaceholderText: "Notes about transcription quality...",
      accuracyBadge: "Accuracy: {value}%",
      statsAccuracyLabel: "Accuracy",
      statsReadabilityLabel: "Readability",
      readabilityValue: "{value}/5",
      noPhraseAvailableDb: "No phrase available in the database.",
      noPhraseAvailableTotal: "No phrase available (Total in DB: {total}).",
      warningTitle: "Warning",
      noValidPhraseAfterFilter: "No valid phrase after filtering.",
      loadingLanguages: "Loading languages...",
      noLanguagesAvailable: "No languages available",
      phraseToSynthesizeTitle: "Phrase to synthesize",
      generatingAudio: "Generating audio...",
      generateAudio: "Generate audio",
      generatedModelAudioTitle: "Model-generated audio",
      asrInputModeTitle: "Input mode",
      asrRecordMode: "Read aloud (microphone)",
      asrTextMode: "Synthesis (TTS)",
      asrAudioMode: "File (URL)",
      asrReferenceTextLabel: "Text to read (reference)",
      asrReferenceTextPlaceholder: "Enter the text you will read...",
      recordingInProgress: "Recording...",
      stopRecording: "Stop",
      restartRecording: "Restart",
      recordAudio: "Record",
      audioReadyForTranscription: "Audio ready for transcription",
      asrTextInputLabel: "Enter the text to transcribe",
      asrTextInputPlaceholder: "Enter your text here...",
      asrTextInputHint: "The text will be converted to audio, then transcribed by the ASR model",
      importAudioFile: "Import an audio file",
      supportedAudioFormats: "Supported formats: WAV, MP3, M4A...",
      audioUrlLabel: "Or enter a URL",
      referenceTextOptional: "Reference text (optional)",
      referenceTextPlaceholder: "Expected text to compare with the transcription...",
      transcribing: "Transcribing...",
      transcribe: "Transcribe",
      transcriptionResultTitle: "Transcription result",
      comparisonTitle: "Comparison",
      referenceLabel: "Reference",
      transcriptionLabel: "Transcription",
      errorDetailsLabel: "Error details",
      diffCorrect: "Correct",
      diffSubstitution: "Substitution",
      diffInsertion: "Insertion",
      diffDeletion: "Deletion",
      referenceAudioLabel: "Reference audio",
      pageLabel: "Page",
      microphoneError: "Unable to access microphone",
      audioGeneratedSuccess: "Success",
      audioGeneratedDesc: "Audio generated successfully",
      audioGenerationError: "Error generating audio",
      modelLangNotSupported: "The selected model does not support this language. Check the model's supported languages.",
      transcriptionSuccess: "Success",
      transcriptionSuccessDesc: "Transcription completed successfully",
      transcriptionError: "Error during transcription",
      pageCompleteTitle: "Page complete!",
      pageCompleteDesc: "You evaluated {count} phrases. Loading next page...",
      newPageLoaded: "New page loaded",
      newPageLoadedDesc: "Page {page} - 10 new phrases to evaluate",
      sessionCompleteDesc: "Congratulations! You have completed all available evaluations ({count} phrases).",
      fileTranscriptionError: "File transcription failed",
      nextPageError: "Error loading next page",
    },

    // ValidateContribute Page - Missing keys
    validateContributeTitle: "Validation Session",
    validateContributeSubtitle: "Help improve optical recognition by validating characters",
    imagesToValidate: "Images to validate",
    validateInstruction1: "Carefully observe each handwritten character",
    validateInstruction2: "Select the character that best matches the image",
    validateInstruction3: "Don't worry if you're not sure, your opinion counts",
    validateInstruction4: "You can skip an image if it's illegible",
    startValidation: "Start validation",
    sessionValidation: "Validation session",
    imageXofY: "Image {current} of {total}",
    toIdentify: "To identify",
    whatCharacterDoYouSee: "What character do you see in this image?",
    selectCharacter: "Select the character",
    selectedCharacter: "Selected character:",
    validateAndContinue: "Validate and continue",
    finishSession: "Finish session",
    skip: "Skip",
    currentAccuracy: "Current accuracy: {accuracy}%",

    // NotFound Page - Missing keys  
    notFound: {
      title: "The page you are looking for does not exist or has been moved.",
      pathLabel: "Searched path:",
      whereTo: "Where would you like to go?",
      previousPage: "Previous page",
      didYouKnow: "Did you know?",
      helpAI: "Help African AI",
      joinMovement: "Join the movement",
      explore: "Explore",
      discoverLanguages: "Discover languages"
    },

    // Common
    back: "Back",
    submit: "Submit",
    submitting: "Sending…",

    // Achievements
    firstSteps: "First steps",
    firstStepsDesc: "First contribution",
    polyglot: "Polyglot",
    polyglotDesc: "5 different languages",
    champion: "Champion",
    championDesc: "100 contributions",
    expert: "Expert",
    expertDesc: "500 contributions",
    unlocked: "Unlocked",
    locked: "Locked",

    // Data Policy
    dataPolicyTitle: "Data Policy - Umbaji",
    dataPolicySubtitle: "At Umbaji, we place great importance on the privacy and trust of our users and contributors. Our data policy is designed to ensure that all personal data and contributions are processed with transparency and respect, in accordance with social good and community development objectives. By participating in the Umbaji community, users and contributors agree to the following terms regarding the collection, use, and management of data.",

    // 1. Purpose of Data Collection
    dataPolicyDataCollection: "1. Purpose of Data Collection",
    dataPolicyDataCollectionDesc: "Umbaji collects and uses data to:",
    dataPolicyObjective1: "Develop and improve AI models intended to benefit communities in Togo and across Africa.",
    dataPolicyObjective2: "Build open-source AI solutions, ensuring technological development at local and regional levels.",
    dataPolicyObjective3: "Address data scarcity for AI applications focused on the African context.",
    dataPolicyObjective4: "Enable personalized experiences for commercial services, facilitating service improvement and better customer support.",

    // 2. Data Usage
    dataPolicyDataUsage: "2. Data Usage",
    dataPolicyDataUsageDesc: "Data collected by Umbaji is used to:",
    dataPolicyUsagePoint1: "Train and improve voice and text AI models for underrepresented African languages.",
    dataPolicyUsagePoint2: "Develop open-source technological solutions accessible to local communities.",
    dataPolicyUsagePoint3: "Create quality datasets for academic research and AI innovation.",
    dataPolicyUsagePoint4: "Enhance user experience and personalize services offered to contributors.",

    // 3. Your Rights and Data Control
    dataPolicyRights: "3. Your Rights and Data Control",
    dataPolicyRightsDesc: "As a contributor, you have the following rights:",
    dataPolicyRightsPoint1: "Access your contributions and personal data at any time from your dashboard.",
    dataPolicyRightsPoint2: "Export all your data in a structured and reusable format.",
    dataPolicyRightsPoint3: "Request deletion of your contributions in accordance with the Nwulite Obodo license.",
    dataPolicyRightsPoint4: "Be informed of any major changes to this data policy.",

    // 4. Commitment to the Community: Nwulite Obodo License
    dataPolicyNwuliteLicense: "4. Commitment to the Community: Nwulite Obodo License",
    dataPolicyNwuliteLicenseDesc: "Contributions to Umbaji are governed by the Nwulite Obodo License, which:",
    dataPolicyNwulitePoint1: "Ensures that data contributes to the common good and benefits contributors and local communities in Africa.",
    dataPolicyNwulitePoint2: "Ensures that all contributions under this license are used to meet community needs and strengthen access to AI and data for populations in Togo and Africa.",
    dataPolicyNwulitePoint3: "Promotes transparency regarding the use of contributed data, fostering a sense of responsibility and shared ownership.",
    dataPolicyMoreInfo: "For more information, please visit www.umbaji.org/lang/en/",

    // Validate Audio Page
    validateAudioTitle: "Check the quality of recordings",
    validateAudioSubtitle: "Listen and validate audio recordings from other contributors",
    totalValidations: "Total validations",
    totalLanguageValidations: "Language validations",
    loadAudios: "Load",
    transcriptionSourceLabel: "Audios to process",
    transcriptionSources: { all: "All", phrase: "Phrases", initialAnswer: "Spoken answers" },
    reviewAnswerHint: "A free answer in the local language: check the transcription writes what is said, not a translation of the question.",
    currentWord: "Current Expression",
    audioToValidate: "Audio to Validate",
    audioExpectedFrench: "Expected French text",
    audioAnswerToQuestion: "Answer to the question",
    audioAnswerToQuestionHint: "A free answer in the local language: judge whether it answers the question, not whether it repeats it.",
    audioExpectedFrenchMissing: "—",
    initialDataDeletion: {
      title: "Initial data deletion",
      description: "Deletes the answers of one language and sector, their copies sent to transcription and their audio files. Only a super admin deletes: an admin's request waits for their decision.",
      chooseScope: "Choose a language and a sector in the filters above to request a deletion.",
      scope: "Data concerned: {scope}",
      adminEffect: "Your request will be pending: nothing is deleted until a super admin approves it.",
      superAdminEffect: "As a super admin, the deletion is immediate and permanent.",
      reasonPlaceholder: "Reason for the deletion (at least 5 characters)",
      confirm: "I understand this data will be permanently deleted once approved.",
      requestDeletion: "Request deletion",
      deleteNow: "Delete now",
      myRequests: "My requests",
      allRequests: "Deletion requests",
      empty: "No deletion request.",
      loadError: "Unable to load the deletion requests.",
      statuses: { pending: "Pending", rejected: "Rejected", executed: "Executed" },
      deletedSummary: "{answers} answers, {copies} copies and {files} files deleted",
      failedFiles: "{count} files not deleted",
      rejectionNote: "Rejection reason: {note}",
      notePlaceholder: "Rejection reason",
      approve: "Approve and delete",
      reject: "Reject",
      requestedToast: "Request sent: it waits for a super admin's decision.",
      executedToast: "Data deleted.",
      rejectedToast: "Request rejected.",
      errorTitle: "Action not possible",
      forbidden: "You are not allowed to do this.",
      notPending: "This request was already handled.",
      invalid: "The request is invalid: check the reason.",
      failed: "The action failed. Please try again.",
    },
    collectionPlace: {
      title: "Where are you collecting?",
      subtitle: "Each session is tied to the city where you record.",
      consentTitle: "Use your position to fill in the city?",
      consentWhy: "Why: to know where the collected voices and texts come from, so every region and language is fairly represented, and to check paid collections.",
      consentWhat: "What for: to fill in the city at the start of each session, instead of searching for it every time.",
      consentKept: "What is kept: only the city name. Your exact position is never stored or shared.",
      consentChoice: "Your choice is saved to your account and applies on all your devices. You can change it at any time.",
      accept: "Use my position",
      decline: "I'll choose the city myself",
      saving: "Saving...",
      locating: "Finding your city...",
      detected: "Detected city",
      chosen: "Chosen city",
      change: "Change city",
      useMyPosition: "Use my position",
      searchLabel: "Collection city",
      searchPlaceholder: "Type at least 2 letters (e.g. Lomé, Montréal, Dakar)",
      searching: "Searching...",
      noResult: "No city found. Try another spelling.",
      countryLabel: "Country for this place",
      chooseCountry: "Choose a country",
      useTypedPlace: "Use the place I entered",
      previousPlaces: "Your recently chosen places",
      previousPlacesLoading: "Looking up your previous places...",
      required: "Choose the collection city to start.",
      attribution: "Photon search with Geoapify fallback · data © OpenStreetMap contributors",
      positionDenied: "Position unavailable or blocked by the browser: choose the city from the list.",
      consentRequired: "Geolocation is not allowed on your account: choose the city from the list.",
      notFound: "No city found at this position: choose it from the list.",
      rateLimited: "Too many searches in a short time. Try again in a moment.",
      unavailable: "City search is temporarily unavailable. Try again in a moment.",
      consentSaveError: "Your choice could not be saved. Please try again.",
    collectorPlaces: "Collection places",
    collectorPlacesEmpty: "No contribution with a collection place.",
    collectorPlacesError: "Unable to load the collection places.",
    unknownPlace: "Unknown place",
    placesNotDisplayed: "{count} place(s) cannot be displayed.",
      contributions: "Contributions",
      lastCollected: "Last collected",
    },
    audioTextCorrection: {
      open: "Correct the text",
      title: "Correct this audio's text",
      hint: "The correction applies to this recording only. The original text is kept.",
      localLabel: "Local-language sentence",
      frenchLabel: "Expected French text",
      questionLabel: "Question asked",
      save: "Save",
      saving: "Saving...",
      cancel: "Cancel",
      nothingChanged: "Nothing to save.",
      savedTitle: "Text corrected",
      savedDescription: "This audio's text has been updated.",
      errorTitle: "Correction not saved",
      invalid: "Each text must be between 1 and 1000 characters.",
      forbidden: "Only moderators and admins can correct a text.",
      notFound: "This audio no longer exists.",
      changed: "The text was changed in the meantime. Reload the session and try again.",
      failed: "Unable to save the correction. Please try again.",
    },
    rejectionReason: "Label for Rejected Audio",
    rejectionReasonPlaceholder: "e.g., background noise, wrong pronunciation, etc.",
    reject: "Reject",
    playAudio: "Play Audio",
    pauseAudio: "Pause",
    contributorPrefix: "Contributor:",
    validateThisAudio: "Validate this audio",
    audioValidationSession: "Audio validation session",
    audioXofY: "Audio {current} of {total}",
    audioValidationInstruction1: "Listen carefully to each recording",
    audioValidationInstruction2: "Check that pronunciation matches the displayed word",
    audioValidationInstruction3: "Accept if quality and pronunciation are correct",
    audioValidationInstruction4: "Reject and indicate reason if problematic",
    reRecordPhrase: "Re-record this phrase",
    reRecordPhraseDescription: "Go to recording page for this phrase",
    rejectionReasonOptional: "Rejection reason (optional)",
    rejectionReasonDetailedPlaceholder: "Describe why this audio is not suitable...",
    audioQualityPoor: "Poor audio quality",
    incorrectPronunciation: "Incorrect pronunciation",
    backgroundNoise: "Background noise",
    doesNotMatchText: "Does not match text",
    rejectAndReRecord: "Reject and re-record",
    transcriptionRejectionReason: "Rejection reason",
    transcriptionQualityPoor: "Poor transcription quality",
    transcriptionDoesNotMatchAudio: "Does not match the audio",
    transcriptionIncomplete: "Incomplete transcription",
    transcriptionContainsErrors: "Contains errors",

    dataPolicyAccept: "Accept and Contribute",
    dataPolicyDecline: "Decline",
    dataPolicyAcceptedToast: "Policy accepted",
    dataPolicyAcceptedToastDesc: "Thank you for accepting our data policy. Welcome!",
    dataPolicyDeclinedToast: "Policy declined",
    dataPolicyDeclinedToastDesc: "You have chosen not to accept our data policy.",
    dataPolicyAlreadyAccepted: "Policy already accepted",
    dataPolicyAlreadyAcceptedDesc: "You can review it any time from the navigation bar.",
    continentalImpact: "Continental Impact",
    continentalImpactDesc: "AI development for Africa by Africa",
    communityFirst: "Community First",
    communityFirstDesc: "Your data directly benefits local communities",
    guaranteedSecurity: "Guaranteed Security",
    guaranteedSecurityDesc: "Maximum protection of your personal information",
    ethicsTransparency: "Ethics & Transparency",
    ethicsTransparencyDesc: "Responsible use according to the Nwulite Obodo License",
    dataCollectionObjective: "Data Collection Objective",
    nwuliteObodoLicenseDesc: "Community Commitment: Nwulite Obodo License",
    importantInformation: "Important Information",
    importantInfoDesc: "By accepting this policy, you actively contribute to the democratization of AI in Africa. Your data will help build technologies that respect and value the cultural and linguistic diversity of the continent.",
    learnMoreUmbaji: "Learn more about Umbaji",
    dataProtected: "Data protected according to international security standards",
    accept: "Accept",
    decline: "Decline",
    acceptAndContribute: "I accept and contribute",

    // Login Page
    welcomeBack: "Welcome back, {name}!",
    loginSubtitle: "Connect to your contributor space",
    authEditorialTitle: "African language intelligence built collaboratively.",
    authEditorialDescription: "Collaborative infrastructure for multilingual datasets, AI research, and African linguistic preservation.",
    authBrandEyebrow: "Umbaji Contributions",
    authAccessPortal: "Access portal",
    authContinueContribution: "Continue contributing to multilingual African AI datasets.",
    authLanguagesLabel: "Languages",
    authLanguagesValue: "—",
    authDatasetGoalLabel: "Audios collected",
    authDatasetGoalValue: "—",
    authResearchLabel: "Research ecosystem",
    authResearchValue: "Open",
    connectionTitle: "Login",
    demoAccount: "Demo account",
    useCredentials: "Use",
    emailAddress: "Email address",
    connect: "Log in",
    connecting: "Connecting...",
    loggingIn: "Connecting...",
    loginSuccess: "Logged in successfully",
    loginIdentifier: "Email, username or phone",
    loginFailedTitle: "Unable to sign in",
    invalidCredentials: "Incorrect credentials. You can sign in with your email, your username or your phone number.",
    loginNetworkError: "We could not reach the server. Check your internet connection and try again.",
    firstLoginWelcomeTitle: "Welcome to Umbaji, {name}",
    firstLoginWelcomeIntro: "Your account is ready. Every contribution helps build open data for African languages.",
    firstLoginWelcomeStepTask: "Start by recording a few sentences in your language, or validate what other contributors recorded.",
    firstLoginWelcomeStepProgress: "Follow your progress at any time under \"Contribution tracker\".",
    firstLoginWelcomeCta: "Start contributing",
    firstLoginWelcomeCtaWorkspace: "Open my workspace",
    firstLoginWelcomeLater: "Later",
    registerSuccess: "Registration successful",
    authError: "Error",
    accountStatusEyebrow: "Account access",
    accountSuspendedTitle: "Account suspended",
    accountBannedTitle: "Account disabled",
    accountSuspendedDescription: "Your account is temporarily suspended. You cannot access the platform during this period.",
    accountBannedDescription: "Your account has been disabled. Access to the platform is no longer available.",
    accountStatusNextStep: "What happens next?",
    accountStatusContactDescription: "If you believe this is a mistake, contact the administration team to request a review of your account.",
    accountStatusContact: "Contact administration",
    accountStatusBack: "Back",
    accountStatusSecurityNote: "To protect your account, all active sessions have been closed.",
    unexpectedError: "An unexpected error occurred",
    usernameExists: "Username \"{username}\" already exists. Please choose another one.",
    usernameExistsGeneric: "This username already exists. Please choose another one.",
    forgotPassword: "Forgot password?",
    noAccount: "No account yet?",
    signupLink: "Sign up",
    backToHomeArrow: "← Back to home",
    acceptTerms: "By logging in, you accept our data policy",
    usernamePlaceholder: "Email, username or phone",
    emailPlaceholder: "your@email.com",

    // Signup Page
    joinCommunity: "Join the community",
    signupSubtitle: "Contribute to creating inclusive AI technologies to preserve and develop West African languages.",
    createAccount: "Create your account",
    startContributing: "Start your contribution in seconds",
    contributeToAfricanAI: "Contribute to African AI",
    contributeToAfricanAIDesc: "Help develop AI models for West African languages",
    joinContributors: "Join the community",
    joinContributorsDesc: "Be part of an international community of contributors",
    positiveSocialImpact: "Positive social impact",
    positiveSocialImpactDesc: "Preserve and digitize African linguistic heritage",
    supportedLanguages: "Languages",
    dataCollected: "Data",
    phoneNumber: "Phone number",
    phoneNumberOptional: "Phone number (optional)",
    phoneNumberPlaceholder: "+228 90 00 00 00",
    profileCompletionBanner: "Complete your profile by adding your phone number to receive SMS alerts.",
    profileCompletionDismiss: "Later",
    profileCompletionAction: "Complete my profile",
    termsAccept: "By creating an account, you agree to contribute to AI development for Africa under the",
    nwuliteLicense: "Nwulite Obodo License",
    alreadyMember: "Already a member?",
    secured: "Secured",
    openSource: "Open Source",
    socialImpact: "Social impact",
    spokenLanguages: "Spoken Language(s)",
    contributionLanguages: "Which languages will you contribute in?",
    moderationLanguages: "Languages you can moderate",
    selectLanguagesModerate: "Select languages to moderate",
    settingsLanguagePreferencesDescription: "Manage the languages you speak, contribute in, and, when applicable, can moderate.",
    preferredCommunicationLanguage: "Communication language",
    preferredCommunicationLanguageDescription: "In-app notifications, SMS messages, and emails will use this language whenever a translation is available.",
    languagePreferencesRequired: "Select at least one spoken language and one contribution language.",
    requiredFieldsTitle: "Required fields",
    signupIdentityRequired: "Username and full name are required.",
    signupCountryRequired: "Please select your country.",
    signupGenderRequired: "Please select your gender.",
    languageProfileCompletionBanner: "Complete your language preferences to receive tasks and notifications matching your languages.",
    languageProfileCompletionAction: "Set my languages",
    selectLanguagesSpoken: "Select the languages you speak",
    selectLanguagesContribute: "Select the languages you want to contribute in",
    confirmPassword: "Confirm your password",
    passwordsDoNotMatch: "Passwords do not match",
    stepAccount: "Account",
    stepProfile: "Profile",
    stepAccountDesc: "Essential information",
    stepProfileDesc: "Profile and preferences",
    optionalProfileHint: "These fields are optional but help us know you better.",
    nextStep: "Continue",
    previousStep: "Back",
    linguisticProfileLabel: "Linguistic profile",
    linguisticProfileDesc: "Configure spoken languages and contribution targets.",
    spokenShort: "Spoken",
    contributionShort: "Contribution",
    noLanguageSelected: "No language selected",
    searchLanguage: "Search language...",
    noLanguageFound: "No language found.",
    xSelected: "{count} selected",
    communityLicense: "Community license",

    // 404 Page
    pageNotFound: "Page not found",
    pageNotFoundDesc: "Oops! It seems this page has disappeared into the web maze. Don't worry, we're here to get you back on track.",
    searchedPath: "Searched path:",
    whereToGo: "Where would you like to go?",
    backToHome: "Back to home",
    previousPage: "Previous page",
    explore: "Explore",
    discoverLanguages: "Discover languages",
    joinMovement: "Join the movement",
    helpAfricanAI: "Help African AI",
    funFact: "💡 Did you know? Yodi Data Hub helps preserve 11 West African languages through AI!",

    // Access Denied / Forbidden (403)
    accessDeniedTitle: "Access restricted",
    accessDeniedGeneric: "You do not have access to this page.",
    accessDeniedDesc: "Your account does not have the required permissions to access this section. Contact an administrator if you believe this is an error.",
    accessDeniedYourRole: "Your role",
    accessDeniedContactAdmin: "Contact an administrator",
    backToHomeCta: "Back to home",

    // Language
    selectLanguage: "Select language",
    selectLanguagePrompt: "Select a language",
    correctionLanguage: "Language to correct",
    equivalent: "Equivalent",
    transcribeAudioIntoFrench: "Listen to the audio and write the translation into French",
    languageSelectionRequired: "Language selection required",
    selectLanguageFirst: "Please select a language first",
    french: "French",
    english: "English",
    localLanguage: "Local language",
    languageChanged: "Language changed to English",

    // New Navigation Items
    dataPolicy: "Data Policy",

    // Protected Access
    protectedAccess: "Protected Access",
    protectedAccessDesc: "You must be logged in and have accepted the data policy to access the contribution space.",
    contributeAfricanAI: "Contribute to African AI",
    joinPlusContributors: "Join the contributor community",
    joinContributorsCount: "Join {count} registered contributors",
    preserveWestAfricanLanguages: "Preserve West African languages",
    preserveLanguagesCount: "Preserve {count} West African languages",

    // Data Policy Required
    dataPolicyRequired: "Data policy required",
    dataPolicyRequiredDesc: "Please read and accept our data policy to access the contribution space.",
    whyThisStep: "Why this step?",
    privacyRespect: "We respect your privacy and want you to understand how your contributions will be used to improve African AI.",
    readDataPolicy: "Read the data policy",

    // Section invalid / session expired
    sectionInvalid: "Section unavailable",
    sectionInvalidDesc: "Your session is no longer valid or has been revoked. Please log in again to continue.",
    reEnterPasswordHint: "Enter your password to resume",
    reconnect: "Log in again",
    orGoToLogin: "Or return to login",
    loginFailed: "Login failed",
    loginFailedDesc: "Incorrect credentials. Please try again.",

    // Moderator Panel
    moderatorPanel: {
      title: "Moderator Panel",
      subtitle: "Validate user contributions and tests",
      audioValidation: "Audio Validation",
      testValidation: "Test Validation",
      pendingAudios: "Pending Audios",
      pendingTests: "Pending Tests",
      noPendingAudios: "No pending audios",
      noPendingTests: "No pending tests",
      validate: "Validate",
      reject: "Reject",
      score: "Score",
      submitScore: "Submit Score",
      unknownUser: "Unknown User",
      submittedOn: "Submitted on {date}",
      originalText: "Original Text",
      audio: "Audio",
      answers: "Answers",
      refresh: "Refresh",
      allCaughtUp: "All caught up!",
      allCaughtUpDesc: "No items pending validation.",
      chooseLanguage: "Choose a language",
      validationSuccess: "Validated",
      rejectionSuccess: "Rejected",
      processingSuccess: "Audio processed successfully",
      errorLoading: "Unable to load data",
      errorProcessing: "Processing failed",
      audioValidationDesc: "Listen to, validate, or reject pending audios.",
      testValidationDesc: "Correct tests submitted by contributors.",
      phrasesReadForReview: "{count} phrases read. Review them, then click “Import phrases” to save them.",
      importsTab: "Imports",
      importsDesc: "Create test definitions and local phrases.",
      importsTitle: "Imports - Test Creation",
      paymentTab: "Payment",
      paymentDesc: "Request a numbering and track your requests.",
      paymentDescription: "Request your numbering to receive payments.",
      activateKeyboard: "Activate on-screen keyboard",
      phonemesLabel: "Phonemes (separated by comma or newline)",
      testPhrasesLabel: "Test phrases",
      addPhrase: "Add",
      localTextPlaceholder: "Local text",
      frenchTranslationPlaceholder: "French translation",
      importTests: "Import tests",
      reset: "Reset",
      success: "Success",
      definitionImported: "Definition imported.",
      error: "Error",
      errorImportingDefinition: "Unable to import definition",
      errorLoadingAudios: "Unable to load audios",
      errorLoadingTests: "Unable to load tests",
      reasonRequired: "Reason required",
      rejectAudioReasonRequired: "Please add a clear reason before rejecting this audio.",
      rejectTestReasonRequired: "Please add a clear reason before rejecting this test.",
      validated: "Validated",
      rejected: "Rejected",
      audioProcessed: "Audio processed successfully",
      processingFailed: "Processing failed",
      testModerated: "Test moderated successfully",
      errorModeratingTest: "Unable to moderate test",
      rejectionReasonPlaceholder: "Rejection reason if necessary",
      amountPlaceholder: "Amount (XOF)",
      phonePlaceholder: "Phone number",
      notePlaceholder: "Note (optional)",
      sendRequest: "Send request",
      sending: "Sending...",
      myRequests: "My requests",
      noRequests: "No requests found.",
      monthlyPlanUnavailable: "Monthly plan unavailable",
      monthlyPlanUnavailableDesc: "Moderator payouts are only available on the last day of the month.",
      moderatorAlreadyPaid: "Already paid this month",
      existingRequestOrPayment: "Existing request or payment",
      requestSendFailed: "Unable to send request.",
      phrasesTab: "Phrases",
      phrasesDesc: "Import and correct phrases in local language.",
      payoutReview: {
        tab: "Payout requests",
        description: "Approve or reject contributor payout requests before they are paid.",
        statusFilter: "Status",
        statuses: { PENDING: "Pending", APPROVED: "Approved", REJECTED: "Rejected", PAID: "Paid" },
        requestedAmount: "Requested amount",
        remainingAmount: "Left to pay",
        payoutNumber: "Payout number",
        submittedOn: "Requested on {date}",
        notePlaceholder: "Rejection reason (required to reject)",
        noteRequiredHint: "Give a reason to reject this request.",
        moderatorNote: "Moderator note",
        approve: "Approve",
        reject: "Reject",
        approvedToast: "Request approved, it moves on to payment.",
        rejectedToast: "Request rejected, the contributor will be notified.",
        errorTitle: "Decision not saved",
        decisionForbidden: "You cannot decide this request.",
        notPending: "This request was already handled. The list has been refreshed.",
        noteRequired: "A reason is required and limited to 500 characters.",
        decisionFailed: "Unable to save the decision. Please try again.",
        loadError: "Unable to load payout requests.",
        loadErrorHint: "Check your connection, then try again.",
        retry: "Retry",
        emptyTitle: "Nothing here",
        emptyDescription: "No payout request matches this status.",
      },
      phrasesImportTitle: "Phrase Import",
      downloadTemplate: "Download template",
      templateDescription: "Download the Excel template to add your phrases",
      downloadTemplateBtn: "Download Template",
      uploadExcel: "Import Excel file",
      uploadDescription: "Select your completed Excel file",
      importedPhrases: "Imported phrases",
      french: "French",
      actions: "Actions",
      edit: "Edit",
      save: "Save",
      clear: "Clear",
      importPhrases: "Import phrases",
      downloading: "Downloading...",
    },

    // Common
    loading: "Loading...",
    error: "Error",
    cancel: "Cancel",
    confirm: "Confirm",
    logoutConfirmTitle: "Log out?",
    logoutConfirmDescription: "You will need to sign in again to come back.",
    logoutConfirmAction: "Log out",

    // Footer
    // Charts and statistics (specific)
    contributionStatusChart: "Contribution Status",
    overallProgress: "Overall progress",
    totalCollected: "Total collected",
    activeLanguages: "Active languages",
    ageDistributionChart: "Age Distribution",
    genderDistributionChart: "Gender Distribution",
    countryDistributionChart: "Country Distribution",
    averageAge: "Average age",
    averageWords: "Average words",

    // Average Cards specific translations
    wordsPerContribution: "words per contribution",
    yearsOnAverage: "years on average",
    goal: "Goal",
    words: "words",
    years: "years",
    vsLastYear: "vs last year",
    dominantGeneration: "Dominant generation",
    genZ: "Gen Z",
    min: "Min",
    avg: "Avg",
    max: "Max",
    dataUpdatedToday: "Data updated today",

    totalUsers: "Total users",
    activeCountries: "Active countries",
    contributorMapChart: "Contributors Map",
    contributorMapSubtitle: "African contribution network",
    contributorMapActiveRegions: "active regions",
    contributorMapContributors: "contributors",
    contributorMapShare: "of the total",
    contributorMapNoData: "no contribution",
    contributorMapLow: "few",
    contributorMapHigh: "many",
    contributorMapOutsideAfrica: "Outside the map",
    contributorMapZoomIn: "Zoom in",
    contributorMapZoomOut: "Zoom out",
    contributorMapReset: "Back to the whole continent",
    contributorMapFit: "Frame the active countries",
    totalContributors: "Total contributors",
    topContributor: "Top contributor",
    dominance: "Dominance",
    geographicOverview: "Geographic overview",
    detailedDistribution: "Detailed distribution",
    rank: "Rank",
    male: "Male",
    female: "Female",
    other: "Other",
    gender: "Gender",
    people: "people",
    users: "users",
    // Gender keys for dynamic data
    maleKey: "Male",
    femaleKey: "Female",
    otherKey: "Other",
    // Header/Navbar specific
    aiForWestAfrica: "AI for West Africa",
    newBadge: "New",
    contributor: "Contributor",
    myContributions: "My Contributions",
    myProfile: "My Profile",
    compteUmbaji: "Umbaji Account",
    collectorRole: "Collector",
    accountEyebrow: "Account",
    leaderboardEyebrow: "Leaderboard",
    activityEyebrow: "Activity",
    terrainEyebrow: "Terrain",
    qualityEyebrow: "Quality",
    financeEyebrow: "Finance",
    pilotageEyebrow: "Pilotage",
    moderatorPanelLabel: "Moderator Panel",
    accountantDashboardLabel: "Accountant Dashboard",
    adminSpacesLabel: "Spaces",

    // Settings Page
    settings: "Settings",
    settingsTitle: "Settings",
    settingsSubtitle: "Manage your personal information and preferences",
    profileTab: "Profile",
    privacyTab: "Privacy (GDPR)",
    geolocationConsentTitle: "Geolocation",
    geolocationConsentDescription: "Choose whether the app may use your position to suggest a collection city automatically. Only the city name is retained.",
    geolocationConsentGranted: "Your consent is enabled.",
    geolocationConsentDenied: "Your consent is disabled. You can choose a city manually.",
    grantGeolocationConsent: "Allow geolocation",
    withdrawGeolocationConsent: "Withdraw my consent",
    geolocationConsentSaveError: "Your choice could not be saved. Your current preference remains unchanged.",
    savingGeolocationConsent: "Saving…",
    notificationsTab: "Notifications",

    // Profile Tab
    personalInformation: "Personal Information",
    personalInformationDesc: "Your account information",
    userId: "User ID",
    role: "Role",
    memberSince: "Member since",
    settingsUsername: "Username",
    settingsPhone: "Phone",
    settingsCountry: "Country",
    settingsGender: "Gender",
    settingsCurrentPassword: "Current password",
    settingsNewPassword: "New password",
    settingsConfirmPassword: "Confirm",
    settingsPasswordHint: "Leave these fields empty to keep your current password.",
    settingsBecomeAdmin: "Become admin",
    settingsAdminAccessTitle: "Administrator access is active",
    settingsAdminAccessDescription: "Your account already has verified access to the administration space.",
    settingsAdminAccessBadge: "Authorized role: your access level is governed by your workspace permissions.",
    settingsAdminAccessAction: "Open admin space",
    becomeAdminEyebrow: "Organization access",
    becomeAdminTitle: "Administrator access request",
    becomeAdminSubtitle: "Submit your organization details, responsible representative, and contractual files to open a verified administrator space.",
    becomeAdminStepCompany: "Company & contacts",
    becomeAdminStepCompanyDesc: "Legal identity, contact details, and activity scope.",
    becomeAdminStepRepresentative: "Representative & account",
    becomeAdminStepRepresentativeDesc: "Responsible person and initial access settings.",
    becomeAdminStepDocuments: "Documents & review",
    becomeAdminStepDocumentsDesc: "Supporting files, signed contract, and consent confirmations.",
    becomeAdminCompanyName: "Company name",
    becomeAdminRegistrationNumber: "Registration number",
    becomeAdminSector: "Activity sector",
    becomeAdminSectorPlaceholder: "E.g. technology, research, institution",
    becomeAdminCompanyAddress: "Full address",
    becomeAdminCompanyEmail: "Official email",
    becomeAdminCompanyPhone: "Phone",
    becomeAdminCompanyWebsite: "Website",
    becomeAdminOptional: "optional",
    becomeAdminRepName: "Representative name",
    becomeAdminRepRole: "Role",
    becomeAdminRepPhone: "Phone",
    becomeAdminRepEmail: "Professional email",
    becomeAdminAccountSection: "Account settings",
    becomeAdminUsername: "Username",
    becomeAdminPassword: "Password",
    becomeAdminUseSso: "Use SSO authentication if enabled for your organization.",
    becomeAdminDocumentsTitle: "Supporting documents",
    becomeAdminDocumentsDesc: "Add documents proving the organization exists and the representative is authorized.",
    becomeAdminUploadDocuments: "Add documents",
    becomeAdminFilesAttached: "Attached files",
    becomeAdminFileSizeUnit: "KB",
    becomeAdminRemoveFile: "Remove",
    becomeAdminContractTitle: "Administrator contract",
    becomeAdminDownloadContract: "Download contract",
    becomeAdminUploadSignedContract: "Add signed contract",
    becomeAdminSignedContractSelected: "Selected contract:",
    becomeAdminContractInstruction: "Download the template, sign it physically or electronically, then upload the signed file before submitting.",
    becomeAdminContractPreview: "Contract preview",
    becomeAdminContractPreviewEmpty: "Fill in the organization details to generate a prefilled contract.",
    becomeAdminContractIntro: "This document formalizes the request to open a verified administrator space on Umbaji Data Hub.",
    becomeAdminContractTermsTitle: "Main terms",
    becomeAdminContractClauseAccess: "The organization requests access to an administrator space subject to prior validation by Umbaji.",
    becomeAdminContractClauseResponsibility: "The legal representative confirms the accuracy of the submitted information and remains responsible for actions performed from the administrator space.",
    becomeAdminContractClauseData: "Submitted data is used only for verification, audit, security, and service management.",
    becomeAdminContractClausePayment: "Administrative fees or applicable payments are processed through the payment method configured and confirmed by the applicant.",
    becomeAdminContractSignature: "Legal representative signature",
    becomeAdminContractDate: "Date",
    becomeAdminTermsConsent: "I have read and accept the terms that apply to the administrator space.",
    becomeAdminRgpdConsent: "I accept the privacy policy and the data processing required for verification.",
    becomeAdminPayVisa: "Pay with Visa",
    becomeAdminPaymentTitle: "Card payment",
    becomeAdminCardNumber: "Card number",
    becomeAdminCardExpiry: "MM/YY",
    becomeAdminCardCvc: "CVC",
    becomeAdminCancel: "Cancel",
    becomeAdminProcessing: "Processing...",
    becomeAdminPrevious: "Previous",
    becomeAdminNext: "Next",
    becomeAdminSubmit: "Submit request",
    becomeAdminProgress: "Progress",
    becomeAdminSecureReview: "Each request is reviewed before activation. Documents are only used to verify the organization and requested access.",
    settingsDataExportSuccess: "You will receive an email with your data in {time}.",
    settingsDataExportEmailed: "Your data copy was sent to {email}.",
    settingsDataExportDownloaded: "Your data copy has been downloaded.",
    settingsAccountDeleted: "Your account has been deleted.",
    settingsWrongPassword: "Wrong password.",
    settingsConfirmWithPassword: "Confirm with your password",
    settingsDataExportError: "Failed to process request",
    settingsUsernameEmpty: "Username cannot be empty.",
    settingsPasswordRequired: "Please provide your current password.",
    settingsPasswordMismatch: "New passwords do not match.",
    settingsProfileUpdated: "Profile updated",
    settingsUpdateError: "Error",
    settingsDeletionRequest: "Demande de suppression enregistrée{date}.",
    settingsDeletionRequestEn: "Deletion request registered{date}.",
    settingsDeleteProcessError: "Failed to process request",

    // Privacy Tab (GDPR)
    yourDataRights: "Your Data Rights",
    yourDataRightsDesc: "In accordance with GDPR, you have full control over your data",
    downloadMyData: "Download My Data",
    downloadDataDesc: "Receive a complete copy of all your data in a portable format",
    whatIsIncluded: "What's included:",
    includedAudioRecordings: "Your account information and languages",
    includedImages: "Your contribution statistics per language",
    includedTranscriptions: "Your validations and transcriptions (counts)",
    includedValidations: "Your payments",
    includedMetadata: "Your consents (terms, geolocation)",
    estimatedTime: "Available right away",
    emailDelivery: "Sent by email when your account has an address, otherwise downloaded directly. Audio and image files are not attached: write to privacy@yodi.tg to get them.",
    requestDataExport: "Request Data Export",
    requesting: "Requesting...",
    deleteMyAccount: "Delete My Account",
    deleteAccountWarning: "Irreversible Action",
    deleteAccountDesc: "Deleting your account erases your personal information. This action cannot be undone.",
    deleteAccountConsequences: "Consequences:",
    consequenceAllData: "Your account and personal information are deleted; your validated contributions stay in the corpus, anonymously",
    consequenceNoRecovery: "No recovery possible",
    consequenceImmediate: "Immediate effect once the password is confirmed",
    requestAccountDeletion: "Delete my account",
    deleting: "Deleting...",
    yourGDPRRights: "Your GDPR Rights",
    gdprRightsDesc: "As a user, you benefit from all rights provided by GDPR",
    rightOfAccess: "Right of access: Access all your personal data",
    rightToRectification: "Right to rectification: Correct your inaccurate data",
    rightToErasure: "Right to erasure: Permanently delete your data",
    rightToPortability: "Right to portability: Receive your data in a readable format",
    rightToObject: "Right to object: Refuse certain processing",
    questionsContact: "Questions? Contact us at",

    // Delete Account Dialog
    deleteAccountTitle: "Permanently delete account?",
    deleteAccountDialogDesc: "This action is irreversible. Your account and personal information are deleted right away; your validated contributions stay in the corpus, anonymously.",
    understandConsequences: "I understand that this action is irreversible",
    cancelDeletion: "Cancel",
    confirmDeletion: "Yes, delete my account",

    // Notifications Tab
    notificationPreferences: "Notification Preferences",
    notificationPreferencesDesc: "Manage how you want to be notified",
    comingSoon: "Coming soon...",

    // Contribution page headings
    contributionAudioEyebrow: "Audio contribution",
    contributionTextEyebrow: "Text contribution",
    transcribeAudioIntroTitle: "Transcribe audio precisely.",
    transcribeAudioIntroDesc: "Listen to the recording, enter the transcription, then add a French translation when needed to improve corpus quality.",
    prepareSessionTitle: "Prepare the session",
    prepareAudioSessionDesc: "Choose the working language. Audios will be loaded without changing your existing progress.",
    prepareBatchTitle: "Prepare the batch",
    prepareBatchDesc: "Choose the language, listen to each audio, then accept or reject it with a clear reason.",
    prepareTranslationTitle: "Prepare translation",
    prepareTranslationDesc: "The session keeps the current page and already processed phrases. Return from recording stays active.",
    sourceMetricTitle: "Source",
    sourceMetricDesc: "Read the original phrase",
    keyboardMetricTitle: "Keyboard",
    keyboardMetricDesc: "Use local characters",
    sessionMetricTitle: "Session",
    sessionMetricDesc: "Resume progress",
    //transcriptionAudio
    availableAudios: "Available audios",
    optionalFrenchTranslationLabel: "French translation (optional)",
    optionalFrenchTranslationPlaceholder: "Write the French translation",
    closeKeyboard: "Close keyboard",
    validateThisText: "Validate this transcription",
    soumettreTranscriptionAudio: "Submit transcription",
    placehoderTranscriptionAudio: "Enter the exact transcription",
    rejectedToast: "Transcription rejected",
    rejectFailed: "Rejection failed",
    rejectionReasonRequired: "A rejection reason is required",
    rejectedAttemptBannerTitle: "Retry this transcription",
    rejectedAttemptBannerDesc: "Your previous transcription was rejected. You can submit a new version.",
    rejectedAttemptReasonsLabel: "Rejection reasons",

    //transcription Phrases
    transcription: "Transcribe",
    navAdminSection: "Admin",
    admin: {
      scopeNotice: {
        loading: "Reading your admin languages...",
        error: "Unable to read your admin languages.",
        retry: "Try again",
      },
      layout: {
        sectionTitle: "Admin area",
        productName: "Yodi Data Hub",
        backToApp: "Back to app",
        breadcrumbHome: "Admin",
        logout: "Log out",
        nav: {
          dashboard: "Dashboard",
          uploads: "Uploads",
          audio: "Audio",
          text: "Text",
          phrases: "Phrases",
          images: "Images",
          importedFiles: "Imported files",
          audioContributions: "Audio contributions",
          textContributions: "Text contributions",
          audioTranscriptContributions: "Transcriptions",
          initialDataContributions: "Answers to questions",
          users: "Users",
          contributions: "Contributions",
          audios: "Audios",
          texts: "Texts",
          transcriptions: "Transcriptions",
          configuration: "Configuration",
          api: "API",
          models: "Models",
          languages: "Languages",
          theme: "Theme",
          excelUploads: "Themes and phrases",
          contracts: "Contracts",
          complaints: "Reports",
          logs: "Technical log",
          recordingGuidelines: "Collection policy",
          excelTranslations: "Translations",
        },
        modules: {
          comingSoonTitle: "Coming soon",
          audioTranscriptContributionsDescription: "This page will be used to retrieve and monitor audio transcript contributions for admins and super admins.",
          initialDataContributionsDescription: "This page will be used to retrieve and monitor initial data contributions for admins and super admins.",
        },
        roles: {
          super_admin: "Super Admin",
          admin: "Administrator",
          accountant: "Accountant",
          collector: "Collector",
          moderator: "Moderator",
          user: "User",
        },
      },
      logs: {
        badge: "Monitoring",
        title: "Technical log",
        description: "Every technical entry of the platform, filterable by type, user or time range. Admins only see entries from the languages they manage.",
        exportCsv: "Export CSV",
        exportForbidden: "Log export is reserved to super admins",
        exportError: "Failed to export logs",
        filterTitle: "Filters",
        filterDescription: "Narrow the list by level, category, user or time range.",
        listTitle: "Event registry",
        listDescription: "Latest platform entries, sortable and paginated.",
        searchPlaceholder: "Search by message or path…",
        searchUserPlaceholder: "Search a user (name, id, username, phone, email)…",
        searchUserEmpty: "Type at least 2 characters",
        searchUserNoResults: "No user found",
        levels: "Levels",
        categories: "Categories",
        dateFrom: "From",
        dateTo: "To",
        resetFilters: "Reset",
        noUserFiltered: "No user filtered",
        columnTimestamp: "Timestamp",
        columnLevel: "Level",
        columnCategory: "Category",
        columnMessage: "Message",
        columnUser: "User",
        columnMethod: "Method",
        columnPath: "Path",
        columnStatus: "Status",
        columnDuration: "Duration",
        columnRequestId: "Request",
        totalLogs: "Total logs",
        errors: "Errors",
        warnings: "Warnings",
        info: "Info",
        activity: "Activity",
        noLogs: "No log matches these filters",
        loadError: "Failed to load logs",
        retry: "Retry",
        detailTitle: "Log detail",
        requestTimeline: "Request timeline",
        metadata: "Metadata",
        userAgent: "User agent",
        ipAddress: "IP address",
        emptyMetadata: "No metadata",
        copy: "Copy",
        copyEntry: "Copy entry",
        copied: "Copied",
        copyFailed: "Copy failed",
        pageOf: "Page {current} of {total}",
        previousPage: "Previous page",
        nextPage: "Next page",
        noUser: "Anonymous",
        userLogCount: "logs",
        level: {
          debug: "Debug",
          info: "Info",
          warn: "Warning",
          error: "Error",
          critical: "Critical",
        },
        category: {
          auth: "Auth",
          http: "HTTP",
          contribution: "Contribution",
          validation: "Validation",
          admin: "Admin",
          payment: "Payment",
          security: "Security",
          system: "System",
          database: "Database",
        },
      },
      dashboard: {
        badge: "Administration",
        title: "Administrator panel",
        subtitle: "Manage content, validations, reminders, and payments",
        superAdminSubtitle: "Centralized super admin hub to manage admins, users, and contributions.",
        themeConfig: "Theme configuration",
        superAdminView: "Centralized super admin view",
        adminScope: "Admin scope",
        superAdminScopeDesc: "All languages and admin data are centralized on this dashboard.",
        adminScopeDesc: "Data and exports are limited to the languages you created.",
        noLanguageAssigned: "No admin language has been assigned to you yet. Admin views remain empty until a language belongs to you.",
        teamSize: "Admin team",
        teamSizeDesc: "{superAdmins} super admin, {admins} admins",
        managedLanguages: "Managed languages",
        managedLanguagesDesc: "{count} active languages",
        coveredCountries: "Countries covered",
        coveredCountriesDesc: "{count} active admin accounts",
        totalUsers: "Users",
        totalUsersDesc: "{active} active, {newUsers} new",
        scopedUsers: "Users",
        scopedActiveContributors: "Active",
        scopedTotalAudio: "Audio",
        radarTitle: "Overview",
        radarDescription: "Multidimensional performance of your admin scope: quality, coverage, engagement, moderation and reactivity.",
        statusDonutTitle: "Status Distribution",
        statusDonutDescription: "Audio distribution by validation status",
        adminsTitle: "Admin directory",
        adminsDescription: "Overview of the administrative team and their scopes.",
        viewManagement: "Open management",
        adminsByCountry: "Admins by country",
        adminsByCountryDescription: "Geographic distribution of the admin team.",
        noCountryData: "No country distribution available.",
        adminsCount: "{count} admins",
        adminsCountDesc: "{total} admins, {active} active, {languages} managed languages",
        languagesPerAdmin: "Languages per admin",
        languagesPerAdminDescription: "Language assignments for each team member.",
        langCount: "{count} languages",
        noAdminData: "No admin data available.",
        noLanguageAssignment: "No language assigned.",
        languageCoverage: "Admin language coverage",
        languageCoverageDescription: "Detail of languages and their admin assignments.",
        noLanguageData: "No language assignment available.",
        countryUndefined: "Country not defined",
        adminCount: "{count} admins assigned",
        usersAndLeaders: "Users and leaders",
        topContributors: "Top contributors",
        topValidators: "Top validators",
        contributionsLabel: "{count} contributions",
        validationsLabel: "{count} validations",
        noData: "No data available.",
        contributionsByLanguage: "Contributions by language",
        contributionsByLanguageDescription: "Contribution distribution across tracked languages.",
        globalRead: "Global read",
        globalReadDesc: "{languages} languages tracked, {pendingValidations} validations pending and {pendingContributions} contributions to process.",
        noLanguageLoaded: "No language loaded yet.",
        recentActivity: "Centralized recent activity",
        noActivity: "No recent activity.",
        actionOn: "Action on {target}",
        uploadsTitle: "Quick access",
        openAdmins: "View admins",
        openUsers: "View users",
        openAudios: "View audios",
        openLanguages: "View languages",
      },
      languageConfig: {
        badge: "Languages",
        title: "Languages",
        subtitle: "Manage the languages available in the application",
        description: "Configure, approve, and delete languages used in the application.",
        refresh: "Refresh",
        createdBy: "Created by",
        data: "Data",
        colIndicator: "Indicator",
        colCode: "Code",
        colName: "Name",
        colCreatedBy: "Created by",
        colData: "Data",
        colStatus: "Status",
        colApproval: "Approval",
        colActions: "Actions",
        readOnly: "Read only",
        pageSummary: "{count} language(s)",
        addLanguage: "Add language",
        availableLanguages: "Available languages",
        modulesCount: "{count} module",
        modulesCountPlural: "{count} modules",
        empty: "No language configured",
        indicator: "Indicator",
        code: "Code",
        displayName: "Display name",
        status: "Status",
        actions: "Actions",
        active: "Active",
        inactive: "Inactive",
        edit: "Edit",
        delete: "Delete",
        deleteConfirmTitle: "Confirm deletion",
        deleteConfirmDescription: "Are you sure you want to delete this language? This action cannot be undone.",
        editLanguage: "Edit language",
        addLanguageTitle: "Add language",
        editLanguageDescription: "Update the language information",
        addLanguageDescription: "Create a new language",
        codeLabel: "Language code *",
        codePlaceholder: "e.g. ewe, mina, fr",
        codeHint: "Format: 2-3 lowercase characters",
        nameLabel: "Language name *",
        namePlaceholder: "e.g. Ewe, Mina, French",
        countryLabel: "Associated country (ccTLD)",
        countryPlaceholder: "Select a country",
        noCountry: "None",
        countryHint: "The ccTLD will be prefixed to the display name (e.g. .tg Ewe)",
        displayNameLabel: "Display name *",
        displayNamePlaceholder: "e.g. .tg Ewe, .bj Mina",
        displayNameHint: "Can include a country indicator",
        flagLabel: "Country flag *",
        noCodeEntered: "Enter a language code to preview the flag",
        countryNotFound: "No country found for this language code",
        flagCode: "Code: {code}",
        flagHint: "The flag is automatically set from the language's country",
        activeLabel: "Active language",
        saving: "Saving...",
        validationTitle: "Validation",
        allFieldsRequired: "All fields are required",
        loadingError: "Error while loading",
        invalidIdentifier: "Invalid identifier for language {code}",
        updateSuccess: "Language updated successfully",
        createSuccess: "Language created successfully",
        saveError: "Error while saving",
        deleteSuccess: "Language deleted successfully",
        deleteError: "Error while deleting",
        createdByYou: "Only languages you have created are visible and editable here.",
        loadingPendingLanguages: "Loading pending languages...",
        pendingApprovalCount: "{count} language(s) pending super admin approval.",
        approvalStatus: {
          approved: "Approved",
          rejected: "Rejected",
          pending: "Pending",
        },
        approvalMessages: {
          approvalSuccess: "Language approved successfully",
          rejectionSuccess: "Language rejected successfully",
          approvalError: "Error updating approval status",
          loadingError: "Unable to load pending languages",
        },
        pendingApprovals: "Pending approvals",
        noPendingApprovals: "No pending approvals",
      },
      users: {
        badge: "Administration",
        title: "Users",
        description: "Browse, filter, and manage all user accounts, roles, and statuses across the platform.",
        totalUsers: "{count} user",
        totalUsersPlural: "{count} users",
        totalActive: "Active",
        totalSuspended: "Suspended",
        totalContributors: "Contributors",
        edit: "Edit",
        save: "Save",
        cancel: "Cancel",
        never: "Never",
        refresh: "Refresh",
        export: "Export",
        exporting: "Exporting...",
        filters: "Filters",
        searchPlaceholder: "Search by name or email...",
        allRoles: "All roles",
        allStatuses: "All statuses",
        resetFilters: "Reset filters",
        user: "User",
        email: "Email",
        role: "Role",
        status: "Status",
        contributions: "Contributions",
        registration: "Registration",
        actions: "Actions",
        loading: "Loading...",
        noUsers: "No users found",
        unavailableDate: "Unavailable",
        notAvailable: "N/A",
        unknownStatus: "Unknown status",
        idPrefix: "ID: {id}",
        successRoleUpdated: "Role updated successfully",
        roleUpdateForbiddenTitle: "Role update not allowed",
        roleUpdateForbiddenDescription: "An admin can only update moderator, collector, or user roles.",
        unavailableStatusTitle: "Status unavailable",
        unavailableStatusDescription: "Unable to change this user's status right now.",
        userActivated: "User activated successfully",
        userSuspended: "User suspended successfully",
        userDeleted: "User deleted successfully",
        unexpectedError: "An unexpected error occurred",
        suspend: "Suspend",
        activate: "Activate",
        delete: "Delete",
        pageSummary: "Page {page} of {totalPages} ({total} users)",
        previous: "Previous",
        next: "Next",
        phone: "Phone",
        phoneNotSet: "Not set",
        phoneUpdateSuccess: "Phone number updated",
        phoneDeleteSuccess: "Phone number deleted",
        confirmDeleteTitle: "Confirm deletion",
        confirmDeleteDescription: "Are you sure you want to delete user {username}?\n\nThis action cannot be undone and will also remove all contributions from this user.",
        confirmStatusSuspendTitle: "Suspend user",
        confirmStatusSuspendDescription: "Are you sure you want to suspend {username}? The user will not be able to log in until their status is reactivated.",
        confirmStatusActivateTitle: "Reactivate user",
        confirmStatusActivateDescription: "Are you sure you want to reactivate {username}? The user will be able to log in again.",
        confirm: "Confirm",
        abort: "Cancel",
        createUser: "Create user",
        createUserTitle: "New user",
        createUserDescription: "Create an account with a temporary password. The user will be notified via email or SMS.",
        createUsername: "Username",
        createName: "Full name",
        createEmail: "Email",
        createPhone: "Phone",
        createCountry: "Country",
        createGender: "Gender",
        createAge: "Age",
        createRole: "Role",
        createLang: "Notification language",
        createSubmit: "Create account",
        createSubmitting: "Creating...",
        createSuccess: "User created successfully",
        createSuccessDesc: "Notification sent via {channel}",
        createError: "Error creating user",
        createEmailOrPhone: "Email or phone required",
        createEmailUsed: "This email is already in use",
        createPhoneUsed: "This phone number is already in use",
        createUsernameTaken: "This username is already taken",
        usernameInvalid: "Username may contain only letters, numbers, dots, hyphens, or underscores.",
        phoneInvalid: "The phone number is incomplete.",
        genderMale: "Male",
        genderFemale: "Female",
        active: "Active",
        revoked: "Revoked",
        cannotActOnSelf: "You cannot perform this action on your own account",
        onlySuperAdmin: "Only a super admin can perform this action",
        country: "Country",
        language: "Language",
        allCountries: "All countries",
        allLanguages: "All languages",
        validationBlocked: "Blocked (validation)",
        validationBlockedProgress: "{done}/{required} validations",
        validationBlockedProgressUnknown: "{done} validations",
        validationBlockedOnly: "Blocked (validation)",
        unblockValidation: "Unblock",
        confirmUnblockTitle: "Unblock {username}?",
        confirmUnblockDescription: "{username} will be able to contribute again right away. Their contribution and validation counters will start over from zero.",
        unblocking: "Unblocking…",
        unblockSuccess: "{username} can contribute again.",
        scopeAction: "Managed languages",
        scopeTitle: "Languages managed by {username}",
        scopeDescription: "This admin only sees and edits the contributors and content of these languages. The collectors of a language are visible to them, read-only, only if you allow it.",
        scopeLanguage: "Language",
        scopeManaged: "Managed",
        scopeCollectors: "Can see collectors",
        scopeEmpty: "No language is available.",
        scopeNone: "No managed language",
        scopeSave: "Save",
        scopeSaving: "Saving…",
        scopeSuccess: "Languages of {username} updated.",
        statsAction: "Stats",
      },
      userStats: {
        badge: "Contributions",
        title: "{username}'s statistics",
        description: "Recorded time, audios and history for this contributor, across all periods.",
        refresh: "Refresh",
        loading: "Loading statistics…",
        error: "Could not load the statistics.",
        retry: "Retry",
        recordedTime: "Recorded time",
        recordedTimeHint: "Recorded phrases and spoken answers. Time spent in the app is not measured.",
        contributions: "Contributions",
        audiosAccepted: "Accepted audios",
        audiosRejected: "Rejected audios",
        audiosPending: "Pending audios",
        moderation: "Moderation actions",
        moderationHint: "Validations and rejections this user performed on other people's contributions.",
        moderationAudiosValidated: "Audios validated",
        moderationAudiosRejected: "Audios rejected",
        moderationTranscriptionsValidated: "Transcriptions validated",
        moderationTranscriptionsRejected: "Transcriptions rejected",
        reviews: "Moderated data",
        reviewsHint: "The recordings and transcriptions this account validated or rejected. Contributors stay anonymous.",
        reviewsAll: "All",
        reviewsValidated: "Validated",
        reviewsRejected: "Rejected",
        reviewsEmpty: "No moderation decision.",
        reviewsError: "Could not load the moderation decisions.",
        reviewsMore: "Show more",
        reviewsTargetTranscription: "Transcription",
        reviewsDecisionValidated: "Validated",
        reviewsDecisionRejected: "Rejected",
        reviewsDecidedAt: "Decided on {date}",
        reviewsRecordedAt: "Recorded on {date}",
        reviewsNoDate: "Time not recorded",
        reviewsReason: "Reason:",
        byLanguage: "By language",
        language: "Language",
        audios: "Audios",
        duration: "Duration",
        noLanguage: "No contribution yet.",
        history: "History",
        date: "Date",
        type: "Type",
        status: "Status",
        typeAudio: "Audio",
        typeText: "Text",
        statusValidated: "Validated",
        statusRejected: "Rejected",
        statusPending: "Pending",
        noHistory: "No contribution in the history.",
        historyError: "Could not load the history.",
        pageSummary: "Page {page} of {pages}",
        previous: "Previous",
        next: "Next",
        playContribution: "Play",
        stopContribution: "Stop playback",
        playRefused: "This recording cannot be played.",
        fileOrder: "File #",
      },
      importedFiles: {
        badge: "Imports",
        title: "Imported files",
        subtitle: "Text and image files imported from the upload manager. Download or delete them.",
        kindFilter: "File type",
        kindAll: "All",
        kindText: "Text",
        kindImage: "Images",
        languageFilter: "Language",
        allLanguages: "All languages",
        refresh: "Refresh",
        colFile: "File",
        colLanguage: "Language",
        colUploader: "Imported by",
        colSize: "Size",
        colDate: "Imported on",
        colActions: "Actions",
        scopeFilter: "Scope",
        scopeMine: "My imports",
        scopeAll: "All imports",
        scopeTrash: "Recycle bin",
        unknownUploader: "Deleted account",
        unknownDate: "—",
        validate: "Validate the import",
        validated: "Validated",
        rejected: "Rejected",
        pending: "Pending",
        reject: "Reject the import",
        rejectTitle: "Reject the import",
        rejectDescription: "The file is kept, with the reason of the rejection.",
        rejectReasonPlaceholder: "Why is this import rejected?",
        restore: "Restore the import",
        restoreUntil: "Restorable until {date}",
        actionError: "Unable to do this action.",
        validatedToast: "Import validated.",
        rejectedToast: "Import rejected.",
        restoredToast: "Import restored.",
        deletedToast: "Import moved to the recycle bin.",
        deletedPermanentlyToast: "Import deleted for good.",
        deleteRecoverable: "Move to the recycle bin",
        deleteRecoverableHint: "The file is kept and can be restored for {days} days.",
        deleteRecoverableDays: "30",
        deletePermanentWarning: "The deletion is immediate and irreversible: the file and its content are destroyed.",
        deletePermanentConfirm: "I understand that this deletion is irreversible.",
        deletePassword: "Your password",
        deleteToBin: "Move to the recycle bin",
        deleteImmediately: "Delete for good",
        colActions: "Actions",
        loading: "Loading files…",
        empty: "No imported file for these filters.",
        loadError: "Imported files could not be loaded.",
        retry: "Retry",
        download: "Download",
        downloadError: "The download failed.",
        delete: "Delete",
        deleteTitle: "Delete this file?",
        deleteDescription: "“{name}” and its stored content will be permanently deleted.",
        deleted: "File deleted.",
        deleteError: "The deletion failed.",
        cancel: "Cancel",
      },
      excelPhrases: {
        recordingsLoading: "Counting recordings…",
        neverRecorded: "Never recorded",
        recordingsLabel: "recordings",
        contributorsLabel: "contributors",
        recordingStatus: "validated {validated}, pending {pending}, rejected {rejected}",
        recordingsUnavailable: "The recordings per phrase could not be loaded.",
        neverRecordedSummary: "{count} of {total} phrases have no recording yet.",
        recordingSort: "Recordings",
        sortFile: "File order",
        sortMost: "Most recorded",
        sortLeast: "Least recorded",
        sortNever: "Never recorded",
        action: "Phrases",
        title: "Phrases of {file}",
        description: "Add or remove phrases in this file. Contributors see the change on their next load. Recordings already made are not affected.",
        loading: "Loading phrases…",
        error: "Could not read this file.",
        retry: "Retry",
        search: "Search a phrase",
        allDomains: "All domains",
        count: "{count} phrases",
        selected: "{count} selected",
        selectionLimit: "Selection is limited to 200 phrases per removal.",
        selectAllVisible: "Select visible phrases",
        selectPhrase: "Select this phrase",
        noMatch: "No phrase matches.",
        empty: "This file has no phrase.",
        addTitle: "Add a phrase",
        local: "Phrase in the national language",
        fr: "French equivalent",
        domain: "Domain (optional)",
        domainMissing: "Domain not provided",
        phraseIdMissing: "Phrase ID unavailable",
        phraseId: "Phrase ID",
        source: "Source (optional)",
        add: "Add",
        adding: "Adding…",
        added: "Phrase added.",
        addError: "The phrase could not be added.",
        importFile: "Add from a file",
        importingFile: "Importing file…",
        imported: "{added} phrase(s) added, {skipped} duplicate(s) skipped.",
        importError: "The file could not be added.",
        fileRequirements: "An .xlsx or .xls file containing the phrase columns used on the platform.",
        serverErrors: {
          DEFAULT: "The operation could not be completed.",
          VALIDATION_FAILED: "Check the details and the file format.",
          UNAUTHORIZED: "Your session has expired. Sign in again.",
          FORBIDDEN: "You do not have access to this action.",
          NOT_FOUND: "The file or some phrases no longer exist.",
          CONFLICT: "The file changed. Reload the phrases before trying again.",
          PAYLOAD_TOO_LARGE: "The file exceeds the allowed size.",
          UNSUPPORTED_MEDIA_TYPE: "Use a valid .xlsx or .xls Excel file.",
          PHRASE_SELECTION_STALE: "The file changed. Reload the phrases before trying again.",
          FILE_REQUIRED: "Select an Excel file.",
          NO_SUPPORTED_PHRASES: "The file contains no recognized phrases.",
          PHRASE_IMPORT_LIMIT_EXCEEDED: "The file exceeds the allowed phrase limit.",
          FORMULA_INJECTION_DETECTED: "The file contains an unsupported Excel value.",
          INTERNAL_SERVER_ERROR: "A server error occurred. Please try again later.",
        },
        remove: "Remove",
        removeSelected: "Remove selection",
        confirmSelected: "Confirm removal",
        cancelSelection: "Cancel",
        confirmRemove: "Remove?",
        removing: "Removing…",
        removed: "Phrase removed.",
        removedMany: "{count} phrase(s) removed.",
        removeError: "The phrase could not be removed.",
        onlyApproved: "Only approved files can be edited phrase by phrase.",
        previous: "Previous",
        next: "Next",
        pageSummary: "Page {page} of {pages}",
      },
      excelFiles: {
        workspaceTitle: "Themes and phrases",
        workspaceDescription: "Themes and their questions, adding a new theme and the phrase files to record, in one place.",
        themeImportsTab: "Themes and questions",
        newThemeTab: "Add a theme",
        phraseFilesTab: "Phrase files",
        title: "Phrase files",
        subtitle: "Track imported phrase files and manage active phrases.",
        importAction: "Import phrases",
        importTitle: "Import a phrase workbook",
        importDescription: "Select a language and an Excel workbook. An administrator import waits for super-administrator approval.",
        selectLanguage: "Select a language",
        noLanguages: "No authorized language is available.",
        fileRequirements: "Non-empty .xlsx or .xls file, up to 10 MB.",
        invalidFile: "Select a valid .xlsx or .xls Excel file no larger than 10 MB.",
        importing: "Importing...",
        importSubmit: "Import",
        importPendingSuccess: "Import submitted. It will become active after super-administrator approval.",
        importActiveSuccess: "Import activated and phrases added to the corpus.",
        importError: "Unable to import the phrase workbook.",
        loadError: "Unable to load import monitoring. Check your connection and try again.",
        retry: "Try again",
        totalImports: "Imports",
        pendingImports: "Pending",
        activeImports: "Active",
        filtersAndActions: "Filters and global actions",
        filterByLanguage: "Filter by language",
        allLanguages: "All languages",
        filterByStatus: "Filter by status",
        allStatuses: "All statuses",
        deleteAll: "Delete all ({lang})",
        confirmTitle: "Are you sure?",
        deleteAllDescription: "This action will permanently delete all Excel files for language \"{lang}\".",
        fileName: "File name",
        language: "Language",
        author: "Author",
        uploadDate: "Upload date",
        actions: "Actions",
        fileUnknown: "Unknown",
        loading: "Loading...",
        noFiles: "No files found.",
        updateFile: "Update file",
        excelFile: "Excel file",
        updating: "Updating...",
        update: "Update",
        deleteFileTitle: "Delete file?",
        deleteFileDescription: "This action cannot be undone. The file will be permanently deleted.",
        confirm: "Confirm",
        downloadError: "Unable to download the file.",
        updateSuccess: "File updated successfully.",
        updateError: "Unable to update the file.",
        deleteSuccess: "File deleted successfully.",
        deleteError: "Unable to delete the file.",
        deleteAllSuccess: "All files for language {lang} were deleted.",
        deleteAllError: "Unable to delete the files.",
        refresh: "Refresh",
        colFile: "File",
        colLanguage: "Language",
        colAuthor: "Author",
        colDate: "Date",
        colActions: "Actions",
pageSummary: "{total} file(s) total",
        status: "Status",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        approve: "Approve",
        reject: "Reject",
        rejectPrompt: "Enter the rejection reason",
        previewSummary: "Limited preview: {visible} rows shown out of {total}.",
        approveSuccess: "Import approved and activated.",
        approveError: "Unable to approve the import.",
        rejectSuccess: "Import rejected.",
        rejectError: "Unable to reject the import.",
        themes: {
          badge: "Themes and questions",
          title: "Theme imports",
          description: "Imported theme workbooks and created questions. The original workbooks are not kept.",
          totalImports: "Imports",
          activeImports: "Active",
          inactiveImports: "Inactive",
          importAction: "Import themes",
          refresh: "Refresh",
          filterBySector: "Filter by sector",
          allSectors: "All sectors",
          filterByStatus: "Filter by status",
          allStatuses: "All statuses",
          active: "Active",
          inactive: "Inactive",
          searchPlaceholder: "Search a theme or a file",
          colFile: "File",
          colTheme: "Theme",
          colSector: "Sector",
          colQuestions: "Imported questions",
          colAuthor: "Imported by",
          colDate: "Date",
          colStatus: "Status",
          colActions: "Actions",
          unknownAuthor: "Account unavailable",
          loadedCount: "{count} imports loaded",
          more: "Load more",
          loadingMore: "Loading...",
          loading: "Loading...",
          noFiles: "No theme Excel import to display.",
          loadError: "Unable to load the imports.",
          retry: "Try again",
          previewQuestions: "View questions",
          editQuestions: "Edit questions",
          updateQuestions: "Update from workbook",
          deleteTitle: "Deactivate this import?",
          deleteDescription: "This deactivates the import and removes its active questions from the corpus. Contributions and question IDs remain preserved.",
          delete: "Deactivate",
          cancel: "Cancel",
          deleteSuccess: "Import deactivated.",
          deleteError: "Unable to deactivate the import.",
          errors: {
            DEFAULT: "Unable to load the imports.",
            VALIDATION_FAILED: "The imports request is invalid.",
            UNAUTHORIZED: "Please sign in again.",
            FORBIDDEN: "You do not have access to these imports.",
            NOT_FOUND: "This history is not found.",
            IMPORT_INACTIVE: "This import is already inactive.",
            INTERNAL_SERVER_ERROR: "The service is temporarily unavailable.",
          },
          questions: {
            title: "Questions — {theme}",
            description: "Questions imported from this theme's Excel workbook.",
            editTitle: "Edit questions — {theme}",
            updateTitle: "Update questions — {theme}",
            editDescription: "Add a question or deactivate those that should no longer appear. Existing contributions keep their question IDs.",
            importTitle: "Add questions from a workbook",
            importDescription: "Excel .xlsx or .xls, at most 500 questions. The language entered below applies to new questions. Existing questions are preserved and active duplicates are skipped.",
            importFile: "Choose Excel workbook",
            importing: "Importing...",
            importSuccess: "{added} question(s) added, {skipped} duplicate(s) skipped.",
            invalidFile: "Choose a non-empty .xlsx or .xls workbook of at most 5 MiB.",
            invalidLanguage: "Enter a valid language code before importing.",
            addTitle: "Add a question",
            questionText: "Question in French",
            language: "Language",
            domain: "Domain",
            source: "Source",
            add: "Add",
            adding: "Adding...",
            addSuccess: "Question added to the import.",
            search: "Search questions",
            loadedSearchHint: "Search and filters apply to loaded questions. Use “Load more” to browse the rest.",
            allDomains: "All domains",
            selectAllVisible: "Select visible questions",
            selectQuestion: "Select question",
            selected: "{count} question(s) selected",
            selectionLimit: "Selection is limited to 200 questions.",
            deactivateSelected: "Deactivate selection",
            deactivateConfirmTitle: "Deactivate the selected questions?",
            deactivateConfirmDescription: "{count} question(s) will no longer be offered. Contributions remain intact, and you can reactivate these questions from the Deactivated view.",
            confirmDeactivate: "Confirm deactivation",
            cancelSelection: "Cancel",
            deactivateSuccess: "{count} question(s) deactivated.",
            deleteSelected: "Delete selection",
            deleteConfirmTitle: "Permanently delete these questions?",
            deleteConfirmDescription: "{count} question(s) will be permanently removed from the lists. Their IDs and historical data remain for existing contributions. This action cannot be undone.",
            deleteAcknowledge: "I understand that this deletion cannot be undone.",
            deletePassword: "Your current password",
            confirmDelete: "Delete permanently",
            deleteSuccess: "{count} question(s) deleted.",
            reactivateSelected: "Reactivate selection",
            confirmReactivate: "Confirm reactivation",
            reactivateSuccess: "{count} question(s) reactivated.",
            statusFilter: "Question status",
            activeView: "Active",
            inactiveView: "Deactivated",
            inactiveEmpty: "No deactivated questions for this theme.",
            loading: "Loading questions...",
            empty: "No active question for this theme.",
            retry: "Try again",
            more: "Load more",
            loadingMore: "Loading...",
            count: "{count} question(s)",
            error: "Unable to load the questions.",
            colText: "Question",
            colLanguage: "Language",
            colDomain: "Sector",
            colOrder: "Order",
            unknownLanguage: "Not specified",
            unknownDomain: "Not specified",
            questionDomainSource: "Question domain",
            themeDomainSource: "Theme domain",
            errors: {
              DEFAULT: "Unable to load the questions.",
              VALIDATION_FAILED: "The questions request is invalid.",
              UNAUTHORIZED: "Please sign in again.",
              FORBIDDEN: "You do not have access to these questions.",
              NOT_FOUND: "This import is not found.",
              IMPORT_INACTIVE: "This import is inactive and can no longer be edited.",
              QUESTION_CONFLICT: "The selection changed. Reload the questions.",
              REAUTHENTICATION_FAILED: "Incorrect password. No question was deleted.",
              INTERNAL_SERVER_ERROR: "The service is temporarily unavailable.",
            },
          },
        },
      },
      contracts: {
        badge: "Admin - Contract management",
        title: "Contracts",
        subtitle: "Create and manage contract templates for users",
        create: "Create contract",
        createTitle: "Create a new contract",
        createDescription: "Define the contract title and content. The content will then be customized for each user.",
        contractTitle: "Contract title",
        selectContractType: "Select a contract type",
        contentHtml: "HTML content",
        personalizationHint: "Use variables: {{name}}, {{email}}, {{user_id}} for personalization",
        contentPlaceholder: "Enter HTML content. Example: <h1>Contract with {{name}}</h1><p>Email: {{email}}</p>",
        pdfUrl: "PDF URL (optional)",
        pdfPlaceholder: "https://example.com/contract.pdf",
        creating: "Creating...",
        createAction: "Create contract",
        previewFallbackTitle: "Contract preview",
        previewDescription: "Preview of the contract content.",
        openPdf: "Open PDF",
        editTitle: "Edit contract",
        editDescription: "Update the contract title and content.",
        updating: "Updating...",
        saveChanges: "Save changes",
        createdContracts: "Created contracts",
        empty: "No contract created yet",
        createdOn: "Created on {date}",
        preview: "Preview",
        edit: "Edit",
        publish: "Publish",
        unpublish: "Unpublish",
        loadError: "Error loading contracts",
        titleRequired: "Title is required",
        htmlRequired: "HTML content is required",
        createSuccess: "Contract created successfully",
        createError: "Error creating contract",
        previewError: "Error loading preview",
        contractLoadError: "Error loading contract",
        titleAndHtmlRequired: "Title and HTML content are required",
        updateSuccess: "Contract updated successfully",
        updateError: "Error updating contract",
        publishSuccess: "Template published successfully",
        publishError: "Error publishing template",
        unpublishSuccess: "Template unpublished",
        unpublishError: "Error unpublishing template",
        contractWriteForbidden: "Only the super administrator can manage contract templates",
        colTitle: "Title",
        colStatus: "Status",
        colDate: "Date",
        colActions: "Actions",
        refresh: "Refresh",
        pageSummary: "{total} contract(s) total",
      },
      theme: {
        title: "Theme configuration",
        themeTitle: "Theme title",
        description: "Description",
        examples: "Example sentences (one per line)",
        reset: "Reset",
        save: "Save theme",
        titleRequired: "Title required",
        titleRequiredDescription: "Please enter a theme title.",
        savedTitle: "Saved",
        savedDescription: "Theme sent to backend and saved.",
        saveError: "Unable to create the theme",
        resetTitle: "Reset",
        resetDescription: "No active theme.",
      },
      themesManagement: {
        title: "Themes & Sectors Management",
        subtitle: "Manage themes, sectors, questions and validate user contributions",
        tabs: {
          themes: "Themes",
          sectors: "Sectors",
          excel: "Excel",
          contributions: "Validations",
        },
      },
      themesList: {
        title: "Themes Management",
        addNew: "New Theme",
        searchPlaceholder: "Search themes...",
        noResults: "No themes found",
        colTitle: "Title",
        colDescription: "Description",
        colExamples: "Examples",
        colDate: "Date",
        colActions: "Actions",
        createTitle: "Create New Theme",
        createDescription: "Create a new theme for your collection",
        editTitle: "Edit Theme",
        editDescription: "Edit theme details",
        labelTitle: "Title *",
        labelDescription: "Description *",
        labelExamples: "Examples (comma-separated)",
        titlePlaceholder: "E.g., Health vocabulary",
        descriptionPlaceholder: "Describe the theme...",
        examplesPlaceholder: "E.g., health, disease, medicine",
        cancel: "Cancel",
        save: "Save",
        saving: "Saving...",
        viewDescription: "Description",
        viewExamples: "Examples",
        viewCreatedAt: "Created at",
        deleteTitle: "Delete Theme",
        deleteDescription: "Are you sure you want to delete this theme? This action is irreversible.",
        deleteConfirm: "Delete",
        deleting: "Deleting...",
        pageSummary: "Page {page} of {totalPages}",
        successCreate: "Theme created successfully",
        successUpdate: "Theme updated successfully",
        successDelete: "Theme deleted successfully",
        errorLoad: "Error loading themes",
        errorCreate: "Error creating theme",
        errorUpdate: "Error updating theme",
        errorDelete: "Error deleting theme",
        requiredError: "Please fill in all required fields",
      },
      sectorsList: {
        title: "Sectors Management",
        addNew: "New Sector",
        searchPlaceholder: "Search sectors...",
        noResults: "No sectors found",
        colName: "Name",
        colDescription: "Description",
        colQuestions: "Questions",
        colDate: "Date",
        colActions: "Actions",
        createTitle: "Create New Sector",
        createDescription: "Create a new sector",
        editTitle: "Edit Sector",
        editDescription: "Edit sector details",
        labelName: "Sector Name *",
        labelDescription: "Description *",
        descriptionPlaceholder: "Describe the sector...",
        cancel: "Cancel",
        save: "Save",
        saving: "Saving...",
        viewDescription: "Description",
        viewQuestionsCount: "Number of questions",
        viewCreatedAt: "Created at",
        deleteTitle: "Delete Sector",
        deleteDescription: "Are you sure you want to delete this sector? This action is irreversible.",
        deleteConfirm: "Delete",
        deleting: "Deleting...",
        pageSummary: "Page {page} of {totalPages}",
        successCreate: "Sector created successfully",
        successUpdate: "Sector updated successfully",
        successDelete: "Sector deleted successfully",
        errorLoad: "Error loading sectors",
        errorCreate: "Error creating sector",
        errorUpdate: "Error updating sector",
        errorDelete: "Error deleting sector",
        requiredError: "Please fill in all required fields",
      },
      contributionsValidation: {
        title: "Contributions Validation",
        searchPlaceholder: "Search (user, phrase)...",
        filterStatus: "Filter by status",
        sectorPlaceholder: "Sector ID (optional)",
        all: "All",
        statusPending: "Pending",
        statusApproved: "Approved",
        statusRejected: "Rejected",
        statusUnknown: "Unknown",
        noResults: "No contributions found",
        colUser: "User",
        colPhraseFr: "Phrase (FR)",
        colLanguage: "Language",
        colStatus: "Status",
        colDate: "Date",
        colActions: "Actions",
        playAudio: "Play audio",
        viewTitle: "Contribution Details",
        labelUser: "User",
        labelPhraseFr: "Phrase (FR)",
        labelPhraseLocal: "Phrase (Local)",
        labelLanguage: "Language",
        labelDuration: "Duration",
        labelAudio: "Audio",
        labelCreatedAt: "Created at",
        labelStatus: "Status",
        durationNA: "N/A",
        audioUnsupported: "Your browser does not support audio.",
        validateTitle: "Validate Contribution",
        validateDescription: "Review and approve or reject this contribution",
        actionLabel: "Action *",
        actionApprove: "Approve",
        actionReject: "Reject",
        qualityScore: "Quality score ({score}%)",
        rejectReason: "Rejection reason",
        rejectPlaceholder: "Explain why you are rejecting this contribution...",
        cancel: "Cancel",
        processing: "Processing...",
        successApproved: "Contribution approved successfully",
        successRejected: "Contribution rejected successfully",
        errorLoad: "Error loading contributions",
        errorValidate: "Error during validation",
        durationSeconds: "{seconds}s",
      },
      uploads: {
        title: "{type} uploads",
        subtitle: "Drop files, configure their metadata, then start the transfer. All uploads are logged.",
        settings: "Settings",
        settingsDescription: "Define the target language and internal note.",
        targetLanguage: "Target language *",
        selectLanguage: "Select a language",
        internalNote: "Internal note",
        internalNotePlaceholder: "Context, source, instructions...",
        frenchTextOptional: "French text (optional)",
        frenchTextPlaceholder: "Matching text in French",
        localTranscriptionOptional: "Local language transcription (optional)",
        openKeyboard: "Click to open the keyboard...",
        acceptedFormats: "Accepted formats",
        importZone: "Upload zone",
        importZoneDescription: "Drag your files or browse your drive.",
        dropFiles: "Drop files here",
        browseComputer: "browse your computer",
        queueTitle: "Queue",
        queueSummary: "{count} file pending",
        queueSummaryPlural: "{count} files pending",
        queueEmptyDescription: "No file yet. Add items via the upload zone.",
        startAll: "Start all",
        clearCompleted: "Clear completed",
        resetQueue: "Reset",
        file: "File",
        language: "Language",
        description: "Description",
        progress: "Progress",
        status: "Status",
        actions: "Actions",
        emptyQueue: "No files in queue",
        notePlaceholder: "Note",
        start: "Start",
        cancelUpload: "Cancel",
        retry: "Retry",
        statsPending: "Pending",
        statsUploading: "Uploading",
        statsCompleted: "Completed",
        statsFailed: "Failed / Cancelled",
        loadLanguagesError: "Error while loading languages",
        extensionNotSupported: "Extension {extension} is not supported",
        missingExtension: "This file has no recognized extension",
        fileTooLarge: "File too large ({size} > {limit} MB)",
        cannotAddFile: "Cannot add {name}",
        addedTitle: "{count} file added",
        addedTitlePlural: "{count} files added",
        addedDescription: "Review the queue before starting the upload.",
        uploadFailed: "Upload failed",
      },
      models: {
        badge: "Models",
        title: "Models and performance",
        subtitle: "Overview of models and their metrics",
        refresh: "Refresh",
        modelsLabel: "Models",
        endpointsLabel: "Endpoints",
        evaluationsLabel: "Evaluations",
        loadError: "Unable to load models",
        loading: "Loading...",
        emptyTitle: "No {type} model found",
        emptyDescription: "Create a new model from the API Configuration page",
        supportedLanguages: "Supported languages",
        noLanguages: "No language configured",
        apiEndpoints: "API endpoints",
        noEndpoints: "No endpoint configured",
        auth: "Auth",
        performanceMetrics: "Performance metrics",
        evaluations: "{count} evaluation",
        evaluationsPlural: "{count} evaluations",
        mosDescription: "Mean Opinion Score - Perceived quality",
        cmosDescription: "Comparative Mean Opinion Score",
        werDescription: "Word Error Rate",
        cerDescription: "Character Error Rate",
        noEvaluation: "No evaluation available for this model",
        createdOn: "Created on {date}",
      },
      requests: {
        title: "Administrator access requests",
        loading: "Loading...",
        empty: "No requests",
        documents: "Documents: {count}",
        approve: "Approve",
        deny: "Reject",
        loadError: "Unable to load requests",
        approvePrompt: "Comment (optional)",
        denyPrompt: "Rejection reason (required)",
        approveTitle: "Approved",
        approveDescription: "Request approved.",
        approveError: "Unable to approve",
        denyTitle: "Rejected",
        denyDescription: "Request rejected.",
        denyError: "Unable to reject",
      },
      complaints: {
        badge: "Complaints",
        title: "Reports",
        subtitle: "Manage feedback, bugs and suggestions submitted by users",
        refresh: "Refresh",
        all: "All complaints",
        stats: "Statistics",
        empty: "No submissions at the moment.",
        anonymous: "Anonymous",
        noPage: "—",
        allTypes: "All types",
        allStatuses: "All statuses",
        clearFilters: "Clear filters",
        tableDate: "Date",
        tableType: "Type",
        tableUser: "User",
        tableMessage: "Message",
        tableStatus: "Status",
        tableActions: "Actions",
        statusNew: "New",
        statusInProgress: "In progress",
        statusResolved: "Resolved",
        typeBug: "Bug",
        typeSuggestion: "Suggestion",
        typeOther: "Other",
        markResolved: "Mark resolved",
        delete: "Delete",
        updated: "Status updated",
        updateFailed: "Update failed",
        deleted: "Complaint deleted",
        deleteFailed: "Delete failed",
        statsTotal: "Total",
        statsOpen: "Open",
        statsOverview: "Overview",
        statsResolutionRate: "Resolution rate",
        statsCategory: "Category",
        statsLabel: "Label",
        statsCount: "Count",
        statsPercent: "Share",
        statsByType: "By type",
        statsByStatus: "By status",
        statsDetailedBreakdown: "Detailed breakdown",
        chartByType: "Distribution by type",
        chartByTypeDesc: "Complaint profile by category",
        chartByStatus: "Distribution by status",
        chartByStatusDesc: "Complaint processing progress",
        chartTrend: "Complaints trend",
        chartTrendDesc: "Submission volume over the last 14 days",
        chartTrendTotal: "Period total",
        chartTrendPeriod: "Last 14 days",
        chartTrendPeak: "Daily peak",
        noData: "No data available",
        pageOf: "Page",
        viewMessage: "View message",
        viewFull: "Full message",
        replyTitle: "Reply",
        replyDescription: "Send a reply to the user",
        replyMessage: "Your reply",
        replyMessagePlaceholder: "Write your reply...",
        replyChannel: "Send via",
        replyViaEmail: "Email",
        replyViaSms: "SMS",
        replyNoContact: "No contact available",
        replySend: "Send",
        replySending: "Sending...",
        replySuccess: "Reply sent",
        replyFailed: "Failed to send reply",
        close: "Close",
        phone: "Phone",
      },
      panels: {
        uploadsTitle: "Content uploads",
        statsTitle: "Statistics",
        contributionsPerLanguage: "Contributions by language",
        contributionBreakdownTitle: "Contribution breakdown",
        textContributions: "Written answers to questions",
        audioTranslationContributions: "Transcribed audios",
        initialDataContributions: "Answers to questions",
        earningsPerLanguage: "Earnings by language",
        noData: "No data",
        remindersTitle: "Reminders",
        newReminder: "New reminder",
        noReminders: "No reminders sent yet.",
        reminderDialogTitle: "Send a reminder",
        reminderDialogDesc: "The reminder shows up in the recipients' notifications.",
        reminderDialogDescScoped: "The reminder is limited to the languages assigned to you.",
        reminderAudience: "Recipients",
        reminderTargetUsers: "Contributors",
        reminderTargetModerators: "Moderators",
        reminderTargetAdmins: "Administrators",
        reminderLanguages: "Languages",
        reminderAllLanguages: "No language selected: your whole scope.",
        reminderSelectedLanguages: "Restricted to the selected languages.",
        reminderTitleField: "Title",
        reminderTitlePlaceholder: "Reminder: this month's contributions",
        reminderMessagePlaceholder: "Explain what you expect from the recipients…",
        reminderMessageField: "Message",
        reminderSubmit: "Send",
        reminderSending: "Sending…",
        reminderSent: "Reminder sent to {count} recipient(s).",
        reminderMissingFields: "Title and message are required.",
        reminderError: "Sending the reminder failed.",
        reminderRecipients: "{count} recipient(s)",
        reminderReadCount: "{count} read",
        reminderChannels: "Channels",
        reminderChannelInApp: "In-app",
        reminderChannelSms: "SMS",
        reminderChannelEmail: "Email",
        reminderChannelsHint: "The in-app notification is always created; SMS and email are added for reachable recipients.",
        reminderActivity: "Activity",
        reminderActivityAll: "All",
        reminderActivityActive: "Active (14 d)",
        reminderActivityInactive: "Inactive",
        reminderGender: "Sex",
        reminderGenderAll: "All",
        reminderGenderFemale: "Women",
        reminderGenderMale: "Men",
        reminderGenderUnset: "Profile to complete",
        reminderCountries: "Countries",
        reminderCountriesPlaceholder: "Togo, BJ (empty = all)",
        reminderSectors: "Sectors",
        reminderSectorsHint: "Contributors who answered at least one question of the sector. Empty = all.",
        reminderSectorsUnavailable: "Sectors are unavailable right now.",
        reminderPlaces: "Collection places",
        reminderPlacesPlaceholder: "Search a city (e.g. Lomé)",
        reminderPlacesHint: "People who recorded or collected at least once in this place. Empty = anywhere.",
        reminderPlacesSearching: "Searching…",
        reminderPlacesNoResult: "No place found.",
        reminderPlacesUnavailable: "Place search is unavailable.",
        reminderPlaceRemove: "Remove {city}",
        reminderErrorNoRecipient: "No active contributor matches this targeting.",
        reminderErrorTargetRequired: "Choose at least one targeting criterion.",
        reminderErrorSendAt: "Invalid send date.",
        reminderErrorSendAtTooFar: "The send date is beyond the 90-day horizon.",
        reminderErrorNoScope: "No language is assigned to you: you cannot send.",
        reminderErrorOutOfScope: "One of the chosen languages is outside your scope.",
        reminderErrorAdminTarget: "Only a super admin can write to administrators.",
        reminderErrorInvalid: "The targeting contains an invalid value.",
        reminderSendAt: "Scheduled send",
        reminderScheduled: "Campaign scheduled for {date} ({count} recipient(s) with the current targeting).",
        reminderDelivery: "SMS: {sms} sent / Email: {email} sent.",
        reminderSendingExternal: "SMS and e-mails go out in the background: the result will show in Campaigns.",
        reminderAlreadySent: "This reminder already went to {count} recipient(s): it was not sent again.",
        reminderDeliveryInProgress: "SMS and e-mails being sent",
        reminderDeliverySms: "SMS: {sent} sent",
        reminderDeliveryEmail: "E-mail: {sent} sent",
        reminderDeliveryFailures: "{count} failed",
        reminderDeliveryStopped: "External sending stopped",
        campaignsTitle: "Campaigns",
        campaignsDescription: "Reminders sent to contributors and moderators, with their channels and the outcome of the sending.",
        campaignsSeeAll: "All campaigns",
        reminderTemplate: "Template",
        reminderTemplateNone: "No template",
        reminderTemplateSave: "Save as template",
        reminderTemplateName: "Template name",
        reminderTemplateSaved: "Template “{name}” saved.",
        scheduledTitle: "Scheduled campaigns",
        scheduledEmpty: "No scheduled campaign.",
        scheduledCancel: "Cancel",
        scheduledCancelled: "Schedule cancelled.",
        scheduledCancelError: "Could not cancel this schedule.",
        scheduledStatusPending: "Pending",
        scheduledStatusSent: "Sent",
        scheduledStatusFailed: "Failed",
        scheduledStatusCancelled: "Cancelled",
        paymentsTitle: "Payments",
        noPayments: "No pending payments.",
        status: "Status: {status}",
        markPaid: "Mark as paid",
        finalValidationTitle: "Final validation",
        noValidation: "No test ready for validation.",
        validate: "Validate",
        moderationTitle: "Test moderation",
        testsTab: "Tests",
        numerationTab: "Numbering request",
        noModeration: "No test pending moderation.",
        open: "Open",
        numerationDescription: "Request your numbering for payments.",
        amountPlaceholder: "Amount (XOF)",
        phonePlaceholder: "Phone number",
        notePlaceholder: "Note (optional)",
        sendRequest: "Send request",
        sending: "Sending...",
        myRequests: "My requests",
        noRequests: "No request found.",
        userNotConnected: "User not connected",
        enterPhone: "Please enter a phone number",
        invalidAmount: "Invalid amount",
        invalidAmountDescription: "Enter an amount greater than 0",
        requestSent: "Request sent",
        requestSentDescription: "Your request has been recorded.",
        requestError: "Unable to send the request.",
      },
      collectionOverview: {
        nav: "Collection overview",
        title: "Collection overview",
        description: "Everything the platform collected over the period, every contribution type, in your languages.",
        period: "Period",
        periods: { "7d": "7 days", "30d": "30 days", "90d": "90 days", "12m": "12 months", all: "All time" },
        language: "Language",
        allLanguagesOption: "All languages",
        refresh: "Refresh",
        exportCsv: "Export CSV",
        loading: "Loading the collection overview",
        errorTitle: "The collection overview cannot be shown",
        errors: {
          outOfScope: "This language is outside your scope. Choose one of your languages.",
          failed: "The server did not answer. Refresh in a moment.",
        },
        empty: "No contribution over this period.",
        totalLabel: "Contributions collected",
        vsPrevious: "against the previous {period}",
        noTrend: "No comparison over all time",
        hoursRecorded: "Hours recorded",
        validatedShare: "Share validated",
        composition: "Split by type",
        types: {
          phraseAudio: "Phrase recordings",
          spokenAnswer: "Spoken answers",
          writtenAnswer: "Written answers",
          transcription: "Transcriptions",
          translation: "Translations",
          image: "Images",
        },
        byTypeTitle: "By contribution type",
        byTypeNote: "Volume, change and validation of each type. Hours only apply to recordings.",
        colType: "Type",
        colTotal: "Total",
        colTrend: "Change",
        colStatus: "Validation",
        colHours: "Hours",
        colContributors: "Contributors",
        colLanguage: "Language",
        statusLine: "{validated} validated, {pending} pending, {rejected} rejected",
        openList: "Open the list",
        openListOf: "Open the list: {type}",
        allLanguages: "All languages",
        allLanguagesHint: "Images carry no language: this figure covers the whole platform.",
        trendTitle: "Collection over time",
        perDay: "Per day",
        perMonth: "Per month",
        measure: "Measure",
        measureCount: "Count",
        measureHours: "Hours",
        hoursNote: "Only phrase recordings and spoken answers have a duration.",
        languagesTitle: "By language",
        languagesNote: "What each language collected, type by type. Images carry no language and are not listed.",
        unknownLanguage: "Language not set",
        originsTitle: "Where the collection comes from",
        originsNote: "Sectors, places of collection and the people collecting, over the same period and in your languages.",
        sectorsTitle: "By sector",
        noSector: "No sector",
        placesTitle: "Places of collection",
        noPlace: "No place of collection over this period.",
        unknownPlace: "{count} contributions without a place of collection (recorded before places were asked, or without one).",
        collectorsTitle: "Most active collectors",
        noCollector: "No field collection over this period.",
        colCollector: "Collector",
        colItems: "Contributions",
        collectorFallback: "Collector #{id}",
        communityCodesTitle: "Community codes",
        targets: {
          title: "Goals",
          note: "Progress counts validated contributions, with the same definitions as the rest of the page.",
          add: "New goal",
          addFirst: "Set a first goal",
          empty: "No goal yet. Set a target per language or type, in contributions or hours, with a due date: the page follows the pace and the projection.",
          loadFailed: "Goals could not be loaded. The rest of the page is up to date.",
          scope: "{type}, {language}",
          allLanguages: "every language",
          allLanguagesOption: "Every language",
          allTypes: "All contributions",
          allRecordings: "All recordings",
          units: { count: "contributions", hours: "h" },
          statuses: { upcoming: "Upcoming", onTrack: "On track", behind: "Behind", done: "Reached", missed: "Missed" },
          paceMarker: "Expected pace today",
          expectedNow: "Expected today",
          projected: "Projected at due date",
          collected: "Collected overall",
          notYet: "not yet",
          window: "From {start} to {due}.",
          daysLeft: "{days} days left.",
          edit: "Edit goal",
          delete: "Delete",
          deleteTitle: "Delete this goal?",
          deleteDescription: "\"{name}\" will leave the page. Contributions are not affected.",
          deleteFailed: "Deletion failed. Try again.",
          newTitle: "New goal",
          editTitle: "Edit goal",
          formHint: "Only validated contributions move a goal forward.",
          metric: "Measure",
          metrics: { count: "Contributions", hours: "Hours" },
          valueCount: "Validated contributions",
          valueHours: "Validated recording hours",
          validatedOnly: "Pending or rejected contributions are shown apart and do not count.",
          language: "Language",
          type: "Type",
          startsOn: "Start",
          dueOn: "Due date",
          label: "Name (optional)",
          labelPlaceholder: "e.g. Ewe, year end",
          cancel: "Cancel",
          save: "Save",
          saving: "Saving…",
          formErrors: {
            value: "Enter a whole number above 0.",
            dates: "The due date must come after the start.",
            hoursType: "Hours only exist for recordings.",
          },
          serverErrors: {
            TARGET_HOURS_NEED_RECORDINGS: "Hours only exist for recordings.",
            TARGET_DATES_INVALID: "The due date must be at least one day after the start.",
            TARGET_LIMIT_REACHED: "50 goals at most: delete one before adding another.",
            TARGET_NOT_FOUND: "This goal no longer exists. Reload the page.",
            LANGUAGE_OUT_OF_SCOPE: "This language is not one you manage.",
            failed: "Saving failed. Try again.",
          },
        },
        sources: { phrase: "of which phrase recordings", initialAnswer: "of which spoken answers" },
        sourceValidated: ", {validated} validated",
        othersTitle: "Other activities",
        othersNote: "Counted apart: they are neither in the total nor in the charts above.",
        otherActivities: {
          imageAnnotation: {
            title: "Image annotations",
            hint: "Answers to annotation sessions, all languages",
            status: "correct {validated}, unanswered {pending}, wrong {rejected}",
            empty: "No annotation over this period.",
          },
          textCollection: {
            title: "Offline text collection",
            hint: "Texts sent from offline collection",
            status: "validated {validated}, pending {pending}, rejected {rejected}",
            empty: "No offline text over this period.",
          },
          qualificationTest: {
            title: "Qualification tests",
            hint: "Qualification tests taken by contributors",
            status: "validated {validated}, pending {pending}, rejected {rejected}",
            empty: "No test over this period.",
          },
        },
      },
      contributionStats: {
        nav: "Statistics",
        badge: "Contributions",
        title: "Contribution statistics",
        accuracyTitle: "Transcription accuracy",
        accuracyNote: "Acceptance: share of decided transcriptions that were validated. Agreement: share of decided transcriptions with at least 2 votes where every validator voted the same way.",
        accuracyOverall: "All languages",
        accuracyTotal: "Transcriptions",
        accuracyAcceptance: "Acceptance",
        accuracyAgreement: "Agreement",
        accuracyEmpty: "No transcription in this period.",
        accuracyError: "Unable to load transcription accuracy.",
        accuracySource: "Transcribed audios",
        accuracySourceAll: "All",
        accuracySourcePhrase: "Phrases",
        accuracySourceInitialAnswer: "Spoken answers",
        description: "Volumes by type, status, language and period. Figures follow the languages you manage.",
        period: "Period",
        p7d: "7 days",
        p30d: "30 days",
        p90d: "90 days",
        p12m: "12 months",
        pall: "All",
        allLanguages: "All languages",
        refresh: "Refresh",
        loading: "Loading…",
        error: "Could not load the statistics.",
        retry: "Retry",
        hoursPeriod: "Recorded hours",
        hoursInitialDataNote: "incl. {hours} of answers to questions",
        hoursValidatedAllTime: "Validated hours (all time)",
        texts: "Texts and translations",
        transcriptions: "Audio transcriptions",
        images: "Images",
        initialData: "Answers to questions",
        total: "Total",
        validated: "Validated",
        pending: "Pending",
        rejected: "Rejected",
        contributors: "Contributors",
        language: "Language",
        byLanguage: "By language",
        evolution: "Over time",
        perDay: "per day",
        perMonth: "per month",
        noData: "No contribution in this period.",
        textsNote: "One row per translated phrase, with the status of its best translation.",
        transcriptionsNote: "Every transcribed audio, including those still waiting for a validation.",
        imagesNote: "Images have no language: these figures cover the whole platform.",
        initialDataBySector: "Answers to questions by sector",
        initialDataNote: "Answers to questions, audio and text, by sector and language.",
        audiosBySector: "Collected audios by sector",
        audiosBySectorNote: "Recorded phrases by sector: volume, hours and validation progress. All periods.",
        sector: "Sector",
        noSector: "No sector",
        answers: "Answers",
        audio: "Audio",
        text: "Text",
        hours: "Hours",
        qualityTitle: "Audio quality by language",
        qualityNote: "All time. Acceptance rate of recordings and mean length.",
        acceptance: "Acceptance",
        avgDuration: "Mean length",
        recordings: "Recordings",
        openList: "Open the list",
      },
      contributionTimeByLanguage: {
        badge: "Time per language",
        title: "Recorded time per language",
        description: "Sum of the time recorded on phrases and on the spoken answers to questions, for the languages in your scope.",
        columnLanguage: "Language",
        columnContributors: "Contributors",
        columnAudios: "Recordings",
        columnDuration: "Total time",
        columnShare: "Share",
        totalRow: "Total",
        loading: "Loading the time per language…",
        empty: "No recording yet.",
        error: "The time per language could not be loaded.",
        retry: "Retry",
        refresh: "Refresh",
        missingDuration: "{count} recording stored without a duration|{count} recordings stored without a duration",
      },
      contributionsCommon: {
        badge: "Contributions",
        description: "View, filter and manage all audio contributions.",
        pageTitle: "Audio",
        totalContributions: "Contributions",
        uploadDate: "Upload date",
        validations: "Validations",
        rejections: "Rejections",
        date: "Date",
        language: "Language",
        phraseFr: "Phrase (FR)",
        phraseLocal: "Phrase (Local)",
        duration: "Duration",
        durationMs: "Duration (ms)",
        durationSeconds: "Duration (s)",
        gender: "Gender",
        blobName: "File",
        transcriptionRetenue: "Retained transcription",
        score: "Score",
        status: "Status",
        source: "Source",
        domain: "Domain",
        retained: "Retained",
        pending: "Pending",
        rejected: "Rejected",
        refresh: "Refresh",
        downloadAll: "Download all",
        exporting: "Export...",
        searchPlaceholder: "Filter by language",
        allLanguages: "All languages",
        allStatuses: "All statuses",
        resetFilters: "Reset filters",
        loading: "Loading...",
        noResults: "No audio contributions found",
        actions: "Actions",
        play: "Play",
        download: "Download",
        openLink: "Open link",
        previous: "Previous",
        next: "Next",
        pageSummary: "Page {page} of {totalPages} ({total} contributions)",
        downloadError: "Unable to download file",
        noAudioToDownload: "No audio to download",
        exportJsonError: "Unable to export as JSON",
        exportExcelError: "Unable to export as Excel",
        bulkDownloadError: "Unable to download files",
        downloadSuccess: "{count} file(s) downloaded",
        downloadPartial: "{success} downloaded, {failed} error(s)",
        downloadFailed: "Unable to download {count} file(s)",
        exportSuccess: "{count} contributions exported",
        fileOrder: "File #",
        fileOrderFilter: "File #",
        fileOrderPlaceholder: "All",
        noFileOrder: "—",
        openSourceRow: "Open the row in the file",
      },
      sourceFileRow: {
        title: "Row {row} of {file}",
        description:
          "The row of the record, in the file it was imported from. Read-only.",
        loading: "Loading the file...",
        error: "Unable to load the file",
        retry: "Try again",
        notFound: "This row does not exist in the file",
        columnNumber: "#",
        columnLocal: "Phrase (Local)",
        columnFrench: "Phrase (FR)",
        columnDomain: "Domain",
        empty: "The file holds no row",
      },
      initialData: {
        badge: "Initial data",
        title: "Answers",
        description: "View the initial contributions made by admins and super admins, filterable by type, sector, and language.",
        signalSectors: "Sectors",
        signalLanguages: "Languages",
        signalTotal: "Contributions",
        filtersBadge: "Filters",
        filtersDescription: "Results update as soon as a filter changes. Without a sector or a language, all your languages are shown.",
        type: "Type",
        audio: "Initial audio",
        text: "Initial text",
        sector: "Sector",
        selectSector: "All sectors",
        language: "Language",
        selectLanguage: "All languages",
        apply: "Apply filters",
        loadingFilters: "Loading filters...",
        resetFilters: "Reset filters",
        listBadge: "Contributions",
        listDescription: "Results for the chosen filters, paginated in batches of ten.",
        refresh: "Refresh",
        question: "Question",
        questionAudio: "Question audio",
        responseAudio: "Response audio",
        duration: "Duration",
        questionLocal: "Local question",
        responseLocal: "Local response",
        date: "Date",
        noAudio: "No audio",
        notAvailable: "N/A",
        loading: "Loading...",
        errorTitle: "Loading error",
        noResults: "No contributions match these filters",
        selectFiltersMessage: "Select a type, sector, and language, then click 'Apply filters' to view contributions.",
        signalHours: "Recorded hours",
        signalHoursMissing: "{count} audio(s) without a duration",
        signalHoursSuspect: "{count} duration(s) to check",
        signalAudioText: "Audio / text",
        status: "Status",
        statusDefault: "All but rejected",
        statusPending: "Pending",
        statusApproved: "Approved",
        statusRejected: "Rejected",
        statusAll: "All statuses",
        from: "From",
        to: "To",
        contributor: "Contributor",
        contributorPlaceholder: "Contributor ID",
        communityCode: "Community profile",
        communityCodePlaceholder: "Profile code",
        search: "Search",
        searchPlaceholder: "Search questions and answers",
        updating: "Updating...",
        contributorColumn: "Contributor",
        statusColumn: "Status",
        transcription: "Transcription",
        transcriptionWaiting: "Waiting for a transcription",
        transcriptionProposed: "{count} proposal(s) under review",
        transcriptionFinal: "Transcription accepted",
        transcriptionRejected: "Out of the queues",
        transcriptionNone: "Not in the transcription flow yet",
        durationMissing: "Unknown duration",
        durationSuspect: "Duration to check",
        approvedByVote: "Approved by vote",
        approvedByReview: "Approved by review",
        breakdownBadge: "Breakdown",
        breakdownDescription: "Contributions and recorded hours per sector and language, for the same filters (audio and text together).",
        breakdownSector: "Sector",
        breakdownLanguage: "Language",
        breakdownCount: "Contributions",
        breakdownAudio: "Audio",
        breakdownText: "Text",
        breakdownHours: "Hours",
        breakdownMissing: "No duration",
        breakdownEmpty: "No data for these filters",
        unknownSector: "Unknown sector",
        unknownLanguage: "Unknown language",
      },
      textContributions: {
        badge: "Text contributions",
        title: "Texts",
        description: "Browse, filter and manage text contributions from retained transcriptions for each audio.",
        totalLabel: "Total",
        refresh: "Refresh",
        exportCsv: "CSV",
        exportJson: "JSON",
        exportExcel: "Excel",
        exporting: "Exporting...",
        allLanguages: "All languages",
        resetFilters: "Reset filters",
        loading: "Loading...",
        noResults: "No text contributions found",
        date: "Date",
        phraseFr: "Phrase (FR)",
        phraseLocal: "Phrase (Local)",
        transcriptionRetenue: "Best transcription",
        validations: "Validations",
        rejections: "Rejections",
        status: "Status",
        score: "Score",
        actions: "Actions",
        previous: "Previous",
        next: "Next",
        pageSummary: "Page {page} of {totalPages} ({total} results)",
        contributor: "Contributor",
        language: "Language",
        lastActivity: "Last activity",
        detailTitle: "Transcription detail",
        detailDescription: "The displayed transcription is the best available result for this audio.",
        noSelection: "Select a contribution to view details.",
        sourceText: "Source text",
        localReference: "Local reference",
        bestTranscription: "Best transcription",
        sourceAudio: "Source audio",
        noAudio: "No audio available for this contribution.",
        createdAt: "Created",
        updatedAt: "Updated",
        pending: "Pending",
        retained: "Retained",
        rejected: "Rejected",
        searchPlaceholder: "Transcription, source phrase, user...",
        sortPlaceholder: "Sort by...",
        loadError: "Unable to load contributions",
        success: "Success",
        error: "Error",
        exportSuccess: "{count} contributions exported",
        exportJsonError: "Unable to export JSON",
        exportExcelError: "Unable to export Excel",
      },
      images: {
        badge: "Images",
        title: "Images",
        subtitle: "Identify the letters visible on each image before final validation.",
        refresh: "Refresh",
        totalLabel: "Total",
        pending: "To label",
        validated: "Validated",
        rejected: "Unreadable",
        resetFilters: "Reset filters",
        loading: "Loading...",
        noResults: "No contributions found",
        selectToBegin: "Select an image from the list to get started.",
        characterAttribution: "Character attribution",
        contributor: "Contributor",
        createdAt: "Created",
        currentLabel: "Label",
        noLabel: "Not assigned",
        characterLabel: "Character",
        characterPlaceholder: "Type the character",
        save: "Save",
        saving: "Saving...",
        approve: "Approve",
        reject: "Unreadable",
        delete: "Delete",
        rejectTitle: "Mark as unreadable",
        rejectDescription: "Briefly explain why the character cannot be recognized.",
        rejectPlaceholder: "e.g. Image too blurry / character missing",
        cancel: "Cancel",
        confirmReject: "Confirm",
        deleteTitle: "Delete image",
        deleteDescription: "This action is irreversible. The image will be permanently removed from the platform.",
        confirmDelete: "Delete",
    loadError: "Loading error",
    micAccessError: "Unable to access microphone",
    updateFailed: "Update failed",
        saveSuccess: "Label saved",
        saveSuccessDesc: "Character \"{character}\" has been assigned to the image.",
        saveError: "Unable to save",
        approveSuccess: "Image approved",
        approveSuccessDesc: "The contribution has been confirmed.",
        approveError: "Validation failed",
        rejectSuccess: "Contribution marked",
        rejectSuccessDesc: "The image has been marked as unreadable.",
        rejectError: "Action failed",
        reasonRequired: "Reason required",
        reasonRequiredDesc: "Please explain why the image is unreadable before confirming.",
        deleteSuccess: "Contribution deleted",
        deleteSuccessDesc: "The image has been removed from the queue.",
        deleteError: "Deletion failed",
        labelRequired: "Label required",
        labelRequiredDesc: "Select or type the recognized character before saving.",
        count: "{count} contribution|{count} contributions",
      },
      initialDataSession: {
        eyebrow: "Initial data",
        audioTitle: "Spoken answers",
        textTitle: "Written answers",
        audioSubtitle: "Read each question in French, then record the answer in your language, one question at a time.",
        textSubtitle: "Read each question in French, then write the answer in your language, one question at a time.",
        metricQuestions: "Questions",
        metricMinutes: "Estimated minutes",
        metricRemaining: "To do",
        prepareEyebrow: "Prepare the session",
        prepareTitle: "Language and sector",
        languageLabel: "Answer language",
        languagePlaceholder: "Choose the language",
        languagesLoading: "Loading languages…",
        languagesEmpty: "No language available",
        sectorLabel: "Sector",
        sectorQuestions: "{count} questions",
        sectorsLoading: "Loading sectors…",
        sectorsEmpty: "No sector available yet.",
        sectorsError: "Sectors could not be loaded.",
        instructionsTitle: "Guidelines",
        audioInstruction1: "Settle somewhere quiet.",
        audioInstruction2: "Read the question, then answer naturally, as in a conversation.",
        audioInstruction3: "Listen back and record again if needed before confirming.",
        audioInstruction4: "Your recordings stay on this device until they are sent.",
        textInstruction1: "Answer in the chosen language, not in French.",
        textInstruction2: "Use the language keyboard for special characters (ŋ, ɖ, ɛ, ɔ…).",
        textInstruction3: "A complete, natural answer beats a word-for-word translation.",
        textInstruction4: "You can skip a question and come back to it later.",
        back: "Back",
        start: "Start the session",
        sessionEyebrow: "Session in progress",
        questionXofY: "Question {current} of {total}",
        percentDone: "Completed",
        doneLabel: "Sent",
        questionEyebrow: "Question",
        questionFileOrder: "Workbook no.",
        frenchLabel: "In French",
        localVersionLabel: "Existing version",
        answerAudioEyebrow: "Your spoken answer",
        answerTextEyebrow: "Your written answer",
        answerIn: "Answer in {language}",
        audioHint: "Press Record, answer, then stop.",
        record: "Record",
        stop: "Stop",
        redo: "Record again",
        recordingLive: "Recording",
        recordingPause: "Pause",
        recordingResume: "Resume",
        recordingPaused: "Paused",
        pauseHint: "Paused time is not counted in the duration.",
        recorded: "Answer recorded",
        micError: "Microphone unavailable. Allow microphone access in your browser.",
        textPlaceholder: "Write the answer in {language}…",
        keyboard: "Keyboard",
        charCount: "{count} characters",
        translationToggle: "Suggest a translation of the question (optional)",
        translationPlaceholder: "The question in {language}…",
        previous: "Previous",
        skip: "Skip",
        submitNext: "Confirm and continue",
        submitting: "Sending…",
        alreadyDone: "An answer was already sent for this question.",
        submitted: "Answer sent",
        submitError: "Sending failed. Try again.",
        audioRequired: "Record an answer before confirming.",
        qualityMeasuring: "Checking the sound quality...",
        qualityOk: "Sound quality is fine.",
        qualityIssuesTitle: "This recording cannot be sent:",
        qualityRedoHint: "Record again in a quiet place, about 20 cm from the microphone.",
        qualityClipped: "the sound clips (too loud or too close to the microphone)",
        qualityMostlySilent: "the recording is almost entirely silent",
        qualityTooQuiet: "the voice is too quiet",
        qualityNoisy: "background noise covers the voice",
        qualityRejected: "Recording refused",
        textRequired: "Write an answer before confirming.",
        progressEyebrow: "Sector progress",
        legendCurrent: "Current",
        legendDone: "Sent",
        legendSkipped: "Skipped",
        legendWaiting: "Waiting",
        questionsLoading: "Loading questions…",
        noQuestionsTitle: "No question in this sector",
        noQuestionsBody: "This sector has no question for this language yet. Choose another one.",
        changeSector: "Choose another sector",
        loadErrorTitle: "Questions could not be loaded",
        retry: "Retry",
        completeEyebrow: "Session complete",
        completeTitle: "Thank you for contributing",
        completeBody: "{count} answer(s) sent during this session.",
        allDoneBody: "Every question of this sector already has an answer in this language.",
        skippedLeft: "{count} skipped question(s) are still available.",
        reviewSkipped: "Go back to skipped questions",
        newSession: "Choose another sector",
        pause: "Pause",
        pausedToast: "Session paused",
        pausedToastBody: "You can pick up where you left off.",
        resumeTitle: "Pick up where you left off",
        resumeProgress: "{answered} of {total} sent",
        resumeSkipped: "{count} skipped",
        resumePausedOn: "Paused since {date}",
        resume: "Resume",
        restart: "Start over",
      },
      initialAudio: {
        parameters: "PARAMETERS",
        chooseLanguageAndSector: "Choose submission language and work sector.",
        selectLanguageLabel: "Select language",
        selectLanguagePlaceholder: "Choose language",
        sectorLabel: "Sector",
        sectorPlaceholder: "Choose a sector",
        phrasesLabel: "PHRASES",
        availableLabel: "AVAILABLE",
        phrasePath: "Phrase path",
        phraseOrderDesc: "Phrases follow automatically the order of chosen sector.",
        noPhrasesAvailable: "No phrases available for this sector.",
        nextPhrase: "Next phrase",
        freeReading: "Free reading then response recorded on the same card.",
        alreadySubmitted: "You have already submitted a contribution for this phrase. You can add a new phrase by clicking on « Next phrase ».",
        promptLabel: "Reading (optional)",
        promptHint: "Read the phrase if you want to add an audio reference.",
        responseLabel: "Response (required)",
        responseHint: "Record the user's response for this phrase.",
        submitPhrase: "Submit this phrase",
        submitting: "Submitting...",
        loading: "Loading...",
        submitAll: "Submit all",
        recordingActive: "Recording active",
        stopRecordingMsg: "Stop recording before submitting.",
        incompleteBlocks: "Incomplete or already submitted blocks",
        verifyBlocks: "Verify that all blocks have response audio and are not already submitted.",
        incompleteBlock: "Incomplete block",
        recordResponseMsg: "Record response audio before submitting.",
        recordingInProgress: "Recording in progress: block {0} ({1})",
        frenchLabel: "FRENCH",
        localLabel: "LOCAL",
        alreadySubmittedMsg: "Already submitted",
        alreadySubmittedDesc: "You have already submitted a contribution for this phrase.",
        languageRequiredMsg: "Language required",
        languageRequiredDesc: "Please select a language.",
        sectorRequiredMsg: "Sector required",
        sectorRequiredDesc: "Please select a sector.",
        recordingInUseMsg: "Recording in use",
        recordingStopDesc: "Stop active recording before starting another.",
        micUnavailableMsg: "Microphone unavailable",
        micAccessDesc: "Allow microphone access to record.",
        directRecordingDesc: "Direct recording and automatic progression: phrase 1, then phrase 2, then phrase 3.",
        submissionSuccessMsg: "Submitted",
        submissionSuccessDesc: "{0} audio contribution(s) sent successfully.",
        errorMsg: "Error",
        submissionErrorDesc: "Unable to send contributions.",
        loadingMsg: "Loading...",
        noLanguagesAvailable: "No languages available",
        noSectorsAvailable: "No sectors available",
      },
      apiConfig: {
        badge: "Configuration",
        title: "API Configuration",
        subtitle: "Models & endpoints",
        description: "Configure TTS, ASR, and TEXT models along with their API endpoints.",
        refresh: "Refresh",
        newModel: "New Model",
        modelsLabel: "Models",
        endpointsLabel: "Endpoints",
        languagesLabel: "Languages",
        createdOn: "Created on",
        createModelTitle: "Create a new model",
        createModelDesc: "Configure a new model with its API endpoints",
        modelName: "Model name *",
        modelNamePlaceholder: "Ex: Umbaji TTS",
        version: "Version *",
        versionPlaceholder: "Ex: 1.0",
        modelType: "Model type *",
        descriptionLabel: "Description",
        descriptionPlaceholder: "Model description",
        supportedLanguages: "Supported languages *",
        addLanguage: "Add a language",
        apiConfiguration: "API Configuration *",
        apiName: "API name",
        apiNamePlaceholder: "Ex: tts, transcribe",
        method: "Method",
        url: "Endpoint URL",
        urlPlaceholder: "https://api.example.com/endpoint",
        authHeader: "Authentication header (optional)",
        authHeaderPlaceholder: "Authorization",
        authToken: "Token environment variable (optional)",
        authTokenPlaceholder: "TTS_API_KEY",
        addApi: "Add this API",
        cancel: "Cancel",
        createModel: "Create model",
        modelTypeLabel: "Model type:",
        loading: "Loading...",
        noModels: "No {type} models found",
        supportedLanguagesLabel: "Supported languages:",
        noLanguages: "No languages configured",
        apiEndpoints: "Configured API endpoints:",
        noEndpoints: "No endpoints configured",
        apiAdded: "API added",
        apiAddedDesc: "API configuration added successfully",
        fillFields: "Please fill in all required fields",
        success: "Success",
        modelCreated: "Model created successfully",
        error: "Error",
        loadModelsError: "Unable to load models",
        createModelError: "Unable to create model",
      },
      themeConfig: {
        badge: "Theme",
        title: "Theme Configuration",
        subtitle: "Manage themes and work domains",
        description: "Create themes manually or import questions from an Excel file.",
        refresh: "Refresh",
        tabs: {
          manual: "Manual entry",
          excel: "Excel import",
        },
        history: {
          tab: "History",
          title: "Theme Excel imports",
          description: "Imported filenames and created questions. Original workbooks were not retained for download.",
          loadedCount: "{count} imports loaded",
          file: "File",
          theme: "Theme",
          sector: "Sector",
          questions: "Questions",
          author: "Uploaded by",
          date: "Date (UTC)",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          unknownAuthor: "Account unavailable",
          loading: "Loading import history…",
          empty: "No theme Excel imports to display.",
          loadError: "Could not load the next page.",
          retry: "Retry",
          more: "Show more",
          errors: {
            DEFAULT: "Could not load import history.",
            VALIDATION_FAILED: "The history request is invalid.",
            UNAUTHORIZED: "Please sign in again.",
            FORBIDDEN: "You cannot access this history.",
            NOT_FOUND: "This history could not be found.",
            INTERNAL_SERVER_ERROR: "The service is temporarily unavailable.",
          },
        },
        manualForm: {
          themeTitle: "Theme title *",
          themeTitlePlaceholder: "Ex: Health",
          description: "Description *",
          descriptionPlaceholder: "Detailed description of the theme",
          examples: "Examples *",
          examplesLabel: "Examples (one per line)",
          examplesPlaceholder: "Example 1\nExample 2\nExample 3",
          save: "Save theme",
          saving: "Saving...",
          clear: "Reset",
        },
        excelForm: {
          title: "Theme title *",
          titlePlaceholder: "Ex: Health",
          description: "Description *",
          descriptionPlaceholder: "Detailed description",
          sector: "Sector",
          sectorPlaceholder: "Ex: health, education",
          language: "Language",
          languagePlaceholder: "Select a language",
          selectFile: "Select a file",
          selectFileButton: "Choose Excel file",
          downloadTemplate: "Download Excel template",
          fileSelected: "{filename} selected",
          preview: "Preview",
          upload: "Import",
          uploading: "Importing...",
          validationErrors: "Validation errors",
          noFile: "No file selected",
          fileEmpty: "Excel file is empty",
          fileFormatError: "Please select an Excel (.xlsx, .xls) or CSV file",
          rowError: "Line {line}: \"{field}\" is required",
          readError: "Error reading file: {error}",
          rowsFound: "{count} question(s) found in file",
          errorsFound: "{count} error(s) found in file",
          dragAndDrop: "Drag and drop a file or click to select",
          changeFile: "Change file",
          maxSize: "Maximum size: 10MB",
          excelFormatRequired: "Required Excel format:",
          questionFrRequired: "questionFr (required) - Question or dialogue line in French",
          previewTitle: "Data preview ({count} questions)",
          viewDetails: "View details",
          fileValid: "✓ Valid file",
          readyToImport: "{count} question(s) ready to import",
          errorsDetected: "Errors detected:",
          andMore: "...and {count} more",
          creatingInProgress: "Creating...",
          createAndImport: "Create Theme and Import Questions",
        },
        success: "Success",
        themeSaved: "Theme saved successfully",
        themeImported: "Theme imported successfully",
        error: "Error",
        saveError: "Error saving theme",
        importError: "Error importing theme",
        loading: "Loading...",
      },
    },

    // Premium African Keyboard
    keyboard: {
      quickHint: "Quick punctuation • Long-press keys for variants",
      toolbar: {
        expandMode: "Extended mode",
        compactMode: "Compact mode",
        help: "Keyboard help",
        close: "Close keyboard",
      },
      help: {
        title: "Premium Keyboard Guide",
        subtitle: "Complete feature guide",
        longPress: {
          title: "Long Press",
          description: "Press and hold any vowel or special character for 500ms to see all variants with diacritics.",
        },
        modes: {
          title: "Compact/Extended",
          description: "Toggle between compact view (essential characters) and extended view (all characters visible).",
        },
        layers: {
          title: "6 Keyboard Layers",
          african: "African special characters",
          basic: "Basic Latin alphabet",
          punctuation: "Numbers & symbols",
          diacritics: "Tonal marks",
        },
        punctuation: {
          title: "Quick Punctuation",
          description: "Fixed row at the bottom with instant access to common punctuation marks.",
        },
        characters: {
          title: "Supported Characters",
          vowels: "African Vowels:",
          consonants: "African Consonants:",
          digraphs: "Digraphs:",
          tones: "Tonal Marks:",
        },
        tips: {
          title: "Tips & Tricks",
          drag: "Drag the keyboard anywhere on screen using the grip handle",
          resize: "Resize keyboard width by dragging the right edge",
          shift: "Use Shift (⇧) to type uppercase letters",
          indicator: "Small orange dot on keys indicates long-press variants available",
          persistence: "Your preferences (width, mode) are automatically saved",
        },
        languages: {
          title: "Supported Languages",
        },
        footer: {
          version: "Premium Keyboard v2.0",
          powered: "Powered by Yodi",
        },
      },
    },

    // Mandatory cross-validation gate
    validationGateWarningTitle: "Cross-validation required soon",
    validationGateWarningDesc: "{remaining} contribution(s) left before you are blocked. Validate other contributors' work to reset your counter.",
    validationGateBlockedEyebrow: "Cross-validation required",
    validationGateBlockedTitle: "Contributions paused",
    validationGateBlockedDesc: "You submitted {threshold} contributions without validating anyone else's. Complete {required} cross-validations to resume contributing.",
    validationGateProgress: "{done}/{total} validations",
    validationGateRemaining: "{remaining} validation(s) left",
    validationGateGoValidateAudio: "Validate audio",
    validationGateGoValidateTranscription: "Validate transcriptions",
    validationGateWhyTitle: "Why this rule?",
    validationGateWhyDesc: "Cross-validation keeps the corpus accurate: every contributor reviews other people's work.",
    validationGateBlockedToastTitle: "Contribution refused",
    validationGateBlockedToastDesc: "Finish your cross-validations before contributing again.",
    validationGateUnlockedTitle: "Contributions unlocked",
    validationGateUnlockedDesc: "Thank you! You can submit contributions again.",
    validationGatePartialSubmit: "{count} contribution(s) saved before the block. The rest were not submitted.",
    validationGateBackToContribute: "Back to contributing",
    offline: {
      statusOffline: "Offline",
      statusPending: "{count} waiting",
      statusFailed: "{count} not sent",
      buttonLabel: "Sending contributions: {status}",
      panelTitle: "Sending contributions",
      online: "Online",
      offlineLine: "No network. Your contributions stay on this device and are sent as soon as the connection is back.",
      pendingLine: "{count} contribution(s) waiting to be sent",
      noPending: "No contribution waiting.",
      syncing: "Sending...",
      syncNow: "Sync now",
      stopAuth: "Sign in again to send the contributions waiting.",
      stopGate: "Cross-validation required: the contributions waiting will be sent once your validations are done.",
      stopServer: "The server is not answering right now. It will retry automatically.",
      stopOffline: "Network unavailable. It will retry automatically.",
      failedTitle: "Not sent",
      failedHint: "The server refused these contributions. Retry or delete them.",
      retry: "Retry",
      delete: "Delete",
      deleteConfirmTitle: "Delete this contribution?",
      deleteConfirmDesc: "It only exists on this device: it will be lost.",
      kindSpeak: "Recording",
      kindTranslate: "Translation",
      reasonInvalid: "Data refused by the server",
      reasonForbidden: "Not allowed for this account",
      reasonNotFound: "Phrase not found",
      reasonTooLarge: "File too large",
      reasonOther: "Refused by the server",
      savedTitle: "Kept on this device",
      savedDesc: "No network: the contribution will be sent automatically when the connection is back.",
      storageError: "This device could not keep the contribution (storage full or private browsing).",
      syncedTitle: "Contributions sent",
      syncedDesc: "{count} waiting contribution(s) were sent.",
      taskNoticeTitle: "You are offline",
      taskNoticeBody: "Keep going: each contribution is kept on this device and sent when the network is back.",
      reserveEmpty: "No phrases kept offline for this language. Connect again to load some.",
      directTranslationOnline: "Offline, a translation applied directly cannot be kept. Try again once online.",
      appUpdatedTitle: "New version available",
      appUpdatedDesc: "Reload the page whenever you like to use it.",
      reload: "Reload",
    },
  }
};

export type TranslationKey = keyof typeof translations.fr;

// Language configuration with metadata
export const languages = {
  fr: {
    code: 'fr',
    name: 'Français',
    flag: '🇫🇷',
    direction: 'ltr'
  },
  en: {
    code: 'en',
    name: 'English',
    flag: '🇬🇧',
    direction: 'ltr'
  }
} as const;

export type LanguageCode = keyof typeof languages;
